export const translations = {
  English: {},
  Hebrew: {
    gallery: "גלריה",
    information: "מידע מעולם הפטריות",
    header1: "ללימוד פטריות ישראל",
    logo: "פטרידע",
    developedBy: "פותח ע''י אלירן בוסקילה",
    about: "אודות",
    aboutText1:
      "שנים רבות של 'מרדף' אחר פטריות הבר בארצנו ובאירופה, איסוף תצפיות, הדרכה והוראה, העסיקו אותי בעניין רב.",
    aboutText2:
      "למדתי וליוויתי את פרופ' ניסן בנימיני ואת דר' זהרה הירשנזון מראשית העיסוק בפטריות הבר באוניברסיטת ת.א. יהי זכרם ברוך. כיום ממשיכה לטפל ולפתח את האוסף הלאומי הגדול והעשיר של פטריות ארצנו.",
    aboutText3:
      "הכרת סוגים ומינים, תוך לימוד מעמיק, הביאוני לגיבוש החומר שנצבר ולפרסומו ברשת האינטרנט. אתרי הראשון בשם 'פטריות שדה ויער' נסגר ועבר בעלים, מאייל ונונו ב'מן השדה', לאלירן בוסקילה מפתח אתרים החובב פטריות. האתר קיבל שם חדש ומבנה מתאים יותר וכל התוכן עובר עדכון עכשווי.",
    aboutText4:
      "נושאי הפטריות שבאתר מיועדים ללקטים וחובבים ברמה מתקדמת, ולשמש כלי-עזר לזיהוי ולימוד מינים מהסוגים של פטריות ישראל. הכתוב אינו תחליף לספר, לא למגדיר מדעי ולא לכל המידע המיקולוגי והגנטי אודות פטריות, לצורך זה נעזור בנתינת קישורים.",
    aboutWhatsInSite: "מה באתר?",
    aboutWhatsInSiteBullet1:
      "האתר בנוי ממדורים ללימוד והכרת מיני פטריות עילאיות בישראל, פעיל, מתחדש ומתעדכן. כל מדור כולל נושאים ותת נושאים שהגישה אליהם בדרך הבחירה בצורה נוחה ומובנת.",
    aboutWhatsInSiteBullet2:
      "מירב התוכן מוקדש להכרה בסיסית של סוגים ומינים אליו מגיעים בתפריט, תוך מיון על פי סימנים מורפולוגיים מוכרים, גם כשהפטרייה מוחזקת ביד ואיננו יודעים את שמה. בשלב ראשון לא נכנסו כל הסוגים אך מבטיחים להוסיף עוד ועוד עם הזמן ולעדכן מינים חדשים שנבדקו ופורסמו לקהילה המדעית.",
    aboutWhatsInSiteBullet3:
      "תמונות אופייניות מלוות את התוכן ברוב המינים בסוג, צולמו ע''י רבים שתרמו לאתר ושמם מופיע עם זכויות יוצרים. כל הסוגים מופיעים ברשימה אלפאבתית נפרדת שניתן לבחור ממנה שם רצוי וידוע ובתוכו רשומים המינים הידועים בארץ.",
    aboutWhatsInSiteBullet4: "השמות העבריים באתר מבוססים על מספר מקורות:",
    aboutWhatsInSiteBullet5:
      "בנימיני, שהקדיש יחס מיוחד לשפה העברית העשירה וחיבר את מרבית השמות, הכתובים בחמשת ספריו. שמות שהוצעו לאקדמיה ללשון העברית אך טרם הובאו לדיון ואישור. שמות שב- 2024 אושרו ע''י הוועדה, אך מהווים רק שליש מהמינים בישראל.",
    aboutWhatsInSiteBullet6:
      "המידע הכתוב באתר מתבסס על ספרות ומאמרים מקצועיים והכרות שלי ושל שותפיי במשך שנים. חלק נכבד מהידע נזקף לזכותו של מורי ומדריכי הנאמן, פרופ' ניסן בנימיני ז''ל.",
    aboutWhatsInSiteBullet7:
      "יסלחו מי שקיוו לקבל כאן מידע אודות אכילת פטריות ומתכונים, האתר לא עוסק בכך אך מפנה לקישורים בנושא.",
    aboutWhatsInSiteBullet8:
      "ממלכת הפטריות נפרדת מהריריות הנקראת בעברית גם פטריריות, ואינה מיוצגת באתר זה. בהמשך נוסיף קישור עם הסברים.",
    thanks: "תודות",
    thanksText1:
      "אני מביעה את תודתי העמוקה לתורמים לפיתוח, לקידום ולאיכות האתר:",
    thanksText2:
      "ללשונאים רינה ברוך, יונה בן דוד ויואל שדך, על הייעוץ הלשוני בכתיבת התוכן ובנתינת שמות חדשים לפטריות.",
    thanksText3:
      "למאיירת ליטל פאר על האיורים היפים והתאמתם לקטעי התוכן ולמפתח הסוגים.",
    thanksText4: "למאיירת עדי ברוקס על סמליל האתר – פיטרידע.",
    thanksText5:
      "לכל חברי חוג הפיטריותים התורמים רבות באיסוף מידע ודגימות מהשטח, ללימוד וחקר מיגוון מיני הפטריות בארץ.",
    thanksText6:
      "לצלמים המעשירים את מאגר התמונות המהוות תיעוד וכלי עזר לזיהוי הפטריות. שמם מופיע בצמוד לתמונות הכוללות סימן לזכויות שמורות.",
    thanksText7: "ולאלירן בוסקילה על פיתוח האתר.",
    aboutFinalText: "בברכה, ברוריה גל.",
    goBack: "חזרה למסך הקודם",
    folklore: "פולקלור",
    whereMushroomsGrow: "היכן גדלות פטריות",
    whereMushroomsGrowText1:
      "מקום-חיות הוא המושג הנכון להסביר מהי הנישה המיוחדת לחיי אורגניזם כלשהו בטבע, ומתאים יותר מהמושג בית-גידול שיכול להיות גם עציץ, חממה או אקווריום. מרתק בעולם הפטריות לראות צמיחתן במגוון עצום של מצע (סובסטרט) .כל מין במצע ספציפי או מצע מעורב.",
    whereMushroomsGrowText2:
      "יש שגדלות רק על חומר נרקב או שורש של צמח מסוים, לדוגמא-אזנית הכלך, כמהת השמשון.",
    whereMushroomsGrowText3:
      "על רקבובית ביער אלונים - אמניטת המוות, גושית השטן, הינומה יפהפיה.",
    whereMushroomsGrowText4:
      "על רקבובית ביער וחורש מעורבים - אחלמית ערומה, סיבית דוחה, משפכנית מלבינה.",
    whereMushroomsGrowText5:
      "על מחטים ועלים שנשרו מעצי אורן - פטרה לבנבנה, מעצי אלון - צנומה עלוית.",
    whereMushroomsGrowText6:
      "על גזעים וענפים כרותים נרקבים - דרדסית, שברירית צעיפית, שרועית אפרכסית.",
    whereMushroomsGrowText7: "על איצטרובלי אורן - פטרת האיצטרובל.",
    whereMushroomsGrowText8:
      "על איצטרובלי אורן - פטרת האיצטרובל על בלוטי אלון – עדינית",
    whereMushroomsGrowText9:
      "על קרקע עשירה בחומר אורגני בשטח פתוח וחשוף לאור - נרתיקנית נאה דביקה, פקועת השדה.",
    whereMushroomsGrowText10:
      "על דשאים מושקים - לבקנית/מטרינית האגוזים, ירוקת הדפים, חרוטית.",
    whereMushroomsGrowText11:
      "על שטח שעבר שריפה -קשקשנית פחומה, גמצוץ חרוטי, לוהבת טבורנית.",
    whereMushroomsGrowText12:
      "על קרקע חולית - דורנית, אמניטת האביב בין אלון התבור.",
    whereMushroomsGrowText13: "על גללים של בע''ח - גללית, שברירית, קרוחה.",
    whereMushroomsGrowText14:
      "מרישום התצפיות בארץ אנו למדים אודות הופעתן של פטריות מסוימות-רק באזורים מיוחדים, קשור לגבה מעל פני הים, לטמפרטורה, להרכב הקרקע ולסוג הצומח. בגולן, ביער אודם למשל, המאוכלס באלונים, נצפו פטריות שלא הופיעו במקום אחר בישראל.",
    whereMushroomsGrowText15:
      "במאמר של פרופ' בנימיני נכתב: ''במשך 7 שנים נבדקו 300 מינים מתוכם 210 היו בין עצי אלון, אלה, אקליפטוס וקזוארינה. 60 מינים בברוש ואורן, 25 בפארקים, שדות ומדשאות 5 בחולות ודיונות''.",
    whereMushroomsGrowImg1: "לבקנית האגוזים על דשא",
    whereMushroomsGrowImg2: "לוהבת טבורנית על שטח שרוף",
    structureAndTerms: "מבנה ומונחים",
    structureAndTermsText1:
      "בחינה יסודית של הפטריה וחלקיה השונים, מהווה בסיס לזיהוי והגדרה. בפרק זה נתייחס בנפרד לחלקי רגל הפטריה, חלקי הכובע ולבסוף לצורתן הכללית:",
    legParts: "חלקי הרגל",
    legPartsText1:
      "מאוד חשוב לבדוק את כל חלקיה של הרגל, כולל הבסיס בעומק האדמה. לצורך הגדרה מותר לעקור, והרי נשארו מירב חלקיה התת-אדמתיים - הוא התפטיר שמכסה שטח נרחב.",
    legPartsTextBullet1Title: "מידת אורך",
    legPartsTextBullet1: " - והיחס, בהשוואה לרוחב הכובע.",
    legPartsTextBullet2Title: "עובי",
    legPartsTextBullet2:
      " - והאם שווה לכל אורכה או יש התעבות באמצע או למעלה. הבסיס - גלילי ,מעובה,בולבוסי או צר.",
    legPartsTextBullet3Title: "צבע",
    legPartsTextBullet4Title: "מירקם",
    legPartsTextBullet4: " - שעירה, חלקה, מוצקה, חלולה, סיבית, עם חוטים ועוד.",
    legPartsTextBullet5Title: "טבעת",
    legPartsTextBullet5: " - אם נכרת- מה אורכה והאם יושבת כלפי מטה או מעלה.",
    legPartsTextBullet6Title: "נרתיק",
    legPartsTextBullet6:
      " - אם קיים-יושב בבסיס וחשוב להוציאו בזהירות לראות צבע וצורה.",
    legPartsText2:
      "הדעה הרווחת בין מלקטי הפטריות היא '' חתוך רק את הכובע והשאר את הרגל כדי שתצמחנה פטריות נוספות ''.האמת שרצוי לנהוג כך, ולא בגלל סיבה זו ,אלא מהסיבה שלא רצוי לאכול חלקי רגל כי היא מכילה כיטין - שמרכיב את דופן התא, לחיזוק והגנה. הכיטין (זה שבונה גם את כסוי החרק) קשה לעיכול בקיבת האדם ויש שחשים בחילות והקאות לאחר האכילה. על אף זאת - תרומת לעיכול כ- סיבים תזונתיים.",
    capParts: "חלקי הכובע",
    capPartsText1:
      "גוף הרביה של פטריות שונה בכל סדרה, הפעם נכיר את פטריית הכובע מתוך פטריות הבסיסה, שנחלקות, על פי שכבת יצור הנבגים, לפטריות דפיות, צנוריות ונקבוביות",
    capPartsText2:
      "במטרה להגדיר פטריה עלינו לבחור פרט בוגר במצב טוב, לבדוק בחלק העליון: צבע, יובש או לחות, ריריות, שערות חודים או קשקשים. לעקור, להפוך, ולבדוק מתחת לכיפה.",
    capPartsBulletTitle1: "דפים",
    capPartsBulletText1:
      " - מידת החיבור לרגל, ראה איור. דלילים או צפופים,דפי ביניים, צבע לפני הופעת הנבגים בהיותה צעירה, או אחרי הופעתם כשהדף נצבע מהם.",
    capPartsBulletTitle2: "ספוג",
    capPartsBulletText2:
      " - את פתחי הצנורות רצוי לבדוק בעזרת זכוכית מגדלת, עגולים או מצולעים, ומה הגוון.",
    capPartsBulletTitle3: "שיניים וזיזים",
    capPartsBulletText3: " - צורות מוזרות הקיימות בעיקר בפטריות עץ.",
    capPartsBulletTitle4: "בשר הפטריה",
    capPartsBulletText4:
      " - הרקמה שבין הקרום העליון לבין שכבת יצור הנבגים. לבדוק את העובי ואת הצבע, יציב או משתנה.",
    capPartsBulletTitle5: "שולי הכובע",
    capPartsBulletText5: " - האם מקופלים כלפי מטה, מתעגלים מעלה או ישרים.",
    capPartsBulletTitle6: "הפרשה",
    capPartsBulletText6: " - בחלק מהמינים נוטף נוזל בעת פציעה, יש לראות צבעו.",
    capPartsBulletTitle7: "ריח",
    capPartsBulletText7:
      " - אופייני לכל מין ומין,ראה רשימה נפרדת באתר. *ראה בנוסף -חלקי הרגל.",
    shapesOfMushrooms: "צורות של פטריות",
    shapesOfMushroomsText1:
      "היופי והמרתק שבעולם הפטריות מושך חובבים רבים לצאת ו''לצוד'', לראות ולצלם, גם אם לא לאוכל כוונתם. כאמור, הפטריות נחלקות למחלקות, סדרות ומשפחות שכל אחת מתאפיינת בצורה נבדלת. אציין את הצורות העקריות: כובע ורגל - כמו בחריפית, כובע ללא רגל - כמו בדרדסית, כובע עם בסיס - כמו באזנית, כדור עם פתח עליון - כמו באבקית, גוש פרוע -כמו בפסיפנית, כדור עגול ושלם - כמו בכדורנית, ראש איצטרובלי - כמו בגמצוץ וכישורית, ראש עם אוכף - כמו במרדעית, גוש רירי - כמו ברירית,  'סמרטוטי' -כמו בקרישית ואזנונית. כוסית וצלחית - כמו בפזיזה, כוכב - כמו באסתרית, מסמר או אלה - כמו באלתית וקרנית. מדף שטוח על גזעים - כמו בהוקית ומדפית. ועוד ועוד...",
    shapesOfMushroomsText2:
      "יש המופיעות בקבוצות, בבודדות ובמעגלים. יש על ענפים וגזעים, על מחטים עלים ואיצטרובלים, בעשביה, על גללי בע''ח ועוד. במפתח להגדרה נתונים אלה חשובים לציון.",
    whatIsMushroomText1:
      "פטריה, בצורה הקלסית, הנראית לעיננו, היא גוף פרי שמהווה רק חלק קטן ועונתי מאורגניזם גדול שאיננו רואים בעין, עשוי קורים של תאים הנקרא תפטיר. עיסוקנו בפטריות עילאיות אך בל נשכח את הפטריות המכונות עובש או מחלות, שחלקן גם מועילות ומשמשות ברפואה - פניצילין לדוגמא.",
    whatIsMushroomText2:
      "מערכת הפטריות מופרדת מצמחים ונפרדת מבע''ח, נחשבת פרימיטיבית משום אופן הרביה מנבגים ולא זרעים ומדרך השגת המזון לקיומה. פטריות אינן מטמיעות ואינן מייצרות מזון באופן עצמאי. הן סופגות מהסביבה בדיפוזיה-פיעפוע ולא ביניקה כמו צמחים. סוגים רבים של אנזימים משרתים פעולות אלה. קיים דמיון בין הפטריות לבין החיידקים בעובדה ששניהם נחשבים ה'מפרקים' של החומר המת בטבע.",
    whatIsMushroomText3: "מחלקים את כל הפטריות על פי אופן השגת מזונן:",
    whatIsMushroombulletTitle1: "פטריות רקב-ספרופיטיות - ",
    whatIsMushroombulletText1:
      "המפרקות חומר אורגני נרקב, פעולה בעלת חשיבות עצומה למחזור החיים בטבע. ממסובכות, הן הופכות את תרכובות החומרים לפשוטות, הזמינות לקליטה של צמחים חדשים.",
    whatIsMushroombulletTitle2: "פטריות טפיליות-פרזיטיות - ",
    whatIsMushroombulletText2:
      "המסיגות מזונן מצמחים ויצורים חיים. מהן ידועות מחלות רבות המזיקות לצמחים, בעיה בחקלאות, ולעולם החי הכולל אותנו. לדוגמא - החלדון והקמחון.",
    whatIsMushroombulletTitle3: "פטריות שותפות-סימביוטיות - ",
    whatIsMushroombulletText3:
      "בעיקר עם שורשי הצמחים. הן מספקות לצמח חומרים שאינו מייצר בעצמו ולוקחות חומרים הנחוצים להתפתחותן שלהן. מקבוצה זו מוכרים לנו האורן והאורנייה, או הכלך והאזנית. ראה רשימה נפרדת על מיקוריזה.",
    whatIsMushroomText4:
      "בטקסונומיה נחלקות הפטריות המעניינות אותנו, על פי דרך יצירת הנבגים: תת-מערכת פטריית הנאדית ותת מערכת פטריית הבסיסה, הכוללת את פטריית ההנומית ופטריית הכרס. הן נחלקות לסדרות, שנחלקות למשפחות, לסוגים ולמינים.",
    whatIsMushroomImg1: "עובש - פטריה, על פטריה נרקבת",
    whatIsMushroomImg2: "מחזור חיי הפטריה.",
    plantMushroomBond: "שותפות פטריה וצמח",
    plantMushroomBondTitle: "מיקוריזה - שותפות פטריה וצמח",
    plantMushroomBondText1:
      "המושג מיקוריזה הינו סוג של סימביוזה, המוכר לנו יותר, מיקו - פטריה, ריזה - שורש. בעבר המיקולוגים בארץ, שוחרי השפה העברית, קראו למיקוריזה -''פטרשרש''.",
    plantMushroomBondText2:
      "יחסי גומלין או הדדיות בין פטריות לשורשי צמחים היו ידועים שנים רבות ולאחרונה נחקרים בעיקר בהקשר לגידולים חקלאיים. קורי הפטריה הנקראים תפטיר - עוטפים את השורש והיונקות, מבחוץ עם חדירה חלקית זו אקטומיקוריזה, ידועה בעיקר בעצי מחט עם פטריית האורנייה. כאשר תאי הפטריה חודרים לתוך תאי השורש- זו אנדומיקוריזה, הידועה ברחבי עלים.",
    plantMushroomBondText21: "התרומה בין השניים חשובה ומשמעותית:",
    plantMushroomBondTextBold3: "הצמח לפטריה",
    plantMushroomBondText3:
      " - מספק חומרים שמייצר בפוטוסינטזה, כפחמימות וחלבונים.",
    plantMushroomBondTextBold4: "הפטריה לצמח",
    plantMushroomBondText4:
      " - מספקת, ע''י תהליך ביוכימי, תוספת מים ומנרלים שאינם זמינים לו בקרקע המסוימת. התפטיר מתפשט לשטח נרחב יותר מהשרשים וכך הניצול רב יותר לקליטה. הפטריה ממריצה את   השרשים לגדילה והסתעפות, עוזרת להתמודדות בתנאי עקה, בתנאי מליחות, בחמרי הדברה דישון ועוד.",
    plantMushroomBondText5:
      "כבר בשלב הנביטה 'נדבק' השורש בפטריה ולחלק מהצמחים זה התנאי להמשך הגידול. במשתלות ובחקלאות לומדים אודות היתרונות ו'מדביקים' באופן מלאכותי את השתילים בפטריה המתאימה ובכך מקבלים צימוח רב יותר, הקדמת פריחה ותוספת יבול. דוגמא מעניינת היא חקר גידולי הפלפל בערבה בו נמצא חסכון של יותר ממחצית כמות מים בהמצאות פטריה מיקוריטית בבית השרשים. גם בגידול סחלבים וצמחי נוי יש שימוש במיקוריזה. ",
    plantMushroomBondText6:
      "לסיכום, מסתבר שבהרבה מאוד עצים וצמחים חלה מיקוריזה באופן טבעי, והאדם לומד להשתמש בתופעה לתועלתו.",
    plantMushroomBondLinks: "קישורים:",
    plantMushroomBondLinkText1:
      "קישור למידע נוסף על מיקוריזה - באדיבות 'ביובי': ",
    plantMushroomBondLinkText2: "הפטרייה הנעלמה",
    plantMushroomBondLinkText21:
      " - כתבה בעברית - ממכון ויצמן - 2.7.2020 (כולל פרסומות)",
    plantMushroomBondLinkText3: "הפטריות שעוזרות לעצים",
    plantMushroomBondLinkText31: " - מתוך ''הידען'' זווית. 2.2022",
    plantMushroomBondLink: "מיקוריזה",
    plantMushroomBondImg1:
      "אורנייה – משתפת חייה עם אורן במיקוריזה. © יהודה מרטה",
    plantMushroomBondImg2: "פטריה עוטפת שורש",
    hebrewNames: "שמות עבריים",
    hebrewNamesTitle: "מקור השמות בעברית",
    hebrewNamesText1:
      "השמות המדעיים של הפטריות בעולם ניתנו בלטינית ובכל ארץ וארץ יש שמות עממיים מקומיים. בטקסונומיה של המינים, כמו בצמחים, החלוקה נקבעת ע''פ סולם הדרגות: מערכה, תת-מערכה, מחלקה, תת-מחלקה, סדרה, משפחה, סוג, מין, ותת-מין.",
    hebrewNamesText2:
      "השמות כוללים שתי מילים, קודם הסוג ואחריו המין. יש לציין שבמשך השנים הוחלפו והשתנו שמות, בעיקר בגלל שיטות המחקר החדישות, מיקרוסקופים משוכללים ובדיקות ד.נ.א. החוקרים גילו שייכות שונה מבעבר ולכן נאלצו להחליף את השם, באישור וועדה מדעית ולפרסם בעתון מדעי.",
    hebrewNamesText3:
      "את עיקר כתבי העת והספרים הראשונים בעברית כתבו רייס, רייכרט וזהרה הירשנזון / אביזוהר,והם אלה שנתנו את השמות העבריים הראשונים: גמצוץ, כמהה, פזיזה,זבובנית, נטופית, אחלמית,ישעור, סיבית, פקועית, נרתיקן, חלפית, ארנה ואזנונית.",
    hebrewNamesText4:
      "בשנת 1975 יצא ספרו של ניסן בנימיני ''פטריות הכובע בישראל'' שטרח רבות לעברת שמות בשיתוף עם 'האקדמיה ללשון העברית'. העיקרון בנתינת שם היה להסתמך על השם הלטיני ולתרגמו עד כמה שניתן בעברית. שמות מורכבים מצורות, צבעים, בתי גידול, תכונות,טעמים ריחות, שמות האנשים שגילו לראשונה, וכ''ו. מעט שמות חרגו בעברית מהלטינית כדי להקל על ציבור המשתמשים בהבנה ובזכירת השם.",
    hebrewNamesText5:
      "המילה 'פטריה' בעברית היא נקבה ולכן גם השמות ניתנו כך. נרתיקון תוקן לנרתיקנית, ישעור - לישעורית ורק הגמצוץ נשאר בזכר.",
    hebrewNamesText6:
      "במספר מינים ניתנו השמות הראשוניים בלטינית -  מהמקור העברי, או על שם אזור בישראל. לדוגמא: אזנונית יהודה, כרסנית הגליל וגושית השטן.",
    hebrewNamesText7:
      "בישראל מתגלים עוד ועוד מינים חדשים, מוגדרים ומזוהים ע''פ ספרות מדעית עם השם הלטיני, ואנו, כאן באתר ובצ'ק-ליסט, מציעים שמות עבריים בעיקרון הנ'ל, ומגישים לאקדמיה ללשון העברית לאישור.",
    hebrewNamesImg1: "ישעורית אפורה",
    whyIsItCalledAMushroom: "מהי, ולמה נקרא שמה פטרייה",
    whyIsItCalledAMushroomText1: "בתודה לכתב האורח - רפי מלכה.",
    whyIsItCalledAMushroomText2:
      "רבן גמליאל ישב ודרש לפני תלמידיו, מה יהא בעולם לעתיד לבוא, בגאולה (שבת ל, ע’’ב): 'וקא דריש עתידה ארץ ישראל שתוציא גלוסקאות וכלי מילת שנאמר [תהילים עב-טז] יהי פסת בר בארץ' היה שם תלמיד אחד עז פנים שלגלג על דברי רבו 'ואמר אין כל חדש תחת השמש אמר ליה בא ואראך דוגמתן בעולם הזה נפק אחוי ליה כמהין ופטריות'. גלוסקאות הן לחמים, ועל כן מפרש רש’’י: 'כמהין ופטריות. שיוצאין כמות שהן בלילה אחד ורחבין ועגולין כגלוסקאות'. פטריות נזכרות פעמים רבות בדברי חז’’ל, אך אין למצוא את שמן במקרא. מה משמעות השם פטריה? מאיזה שורש נגזר השם?",
    whyIsItCalledAMushroomText3:
      "כתב שלמה המלך (משלי י''ז, י''ד): 'פּוֹטֵר מַיִם רֵאשִׁית מָדוֹן וְלִפְנֵי הִתְגַּלַּע הָרִיב נְטוֹשׁ'. מהו 'פּוֹטֵר מַיִם'? נעזר שוב ברש''י 'פוטר מים ראשית מדון' - המתחיל במריבה הוא כפותח חור בגדרי אגפי אמת המים, והמים יוצאין בו, והחור הולך ומרחיב. כן המדון, הולך וגדל תמיד'. כלומר 'פוטר' הוא 'פותח'.",
    whyIsItCalledAMushroomText4:
      "אחרי שיצאו ממצרים מצווים בני ישראל (שמות י''ג, ב'): 'קַדֶּשׁ-לִי כָל-בְּכוֹר פֶּטֶר כָּל-רֶחֶם בִּבְנֵי יִשְׂרָאֵל בָּאָדָם וּבַבְּהֵמָה לִי הוּא'. מה במשמעות פתיחה יש פה?",
    whyIsItCalledAMushroomText5:
      "רש''י מבאר ''פטר כל רחם' שפתח את הרחם תחלה'. כל בכור, מבני האדם ומן הבהמה, הפותח ראשון את רחם אמו, נקרא בשם 'פֶּטֶר', מלשון פתיחה.",
    whyIsItCalledAMushroomText6:
      "משורש פ.ט.ר נגזר ככל הנראה גם הצירוף 'פְטוּרֵי צִצִּים' הנזכר באשר לקישוטים שהיו מגולפים בלוחות הארזים בבית המקדש (מלכים א ו', י''ח) 'וְאֶרֶז אֶל הַבַּיִת פְּנִימָה מִקְלַעַת פְּקָעִים וּפְטוּרֵי צִצִּים הַכֹּל אֶרֶז אֵין אֶבֶן נִרְאָה'. הרלב''ג (רבי לוי בן גרשום, אף הוא פרשן מן האסכולה הצרפתית) מסביר: 'והטעם שכבר הי' מצוייר בארזים מבפנים בדמיון הוצאת הצמחים ואל הפקעים בעת אשר הם מתחילים להציץ ציץ כי בראשונה יהיו כמו פקעים והם כמו ביצים ששני ראשיהם חדים ואחר זה יפריח מהשרש כמו גביעים משוקדים ומתוכם יצא הפרח ...' דהיינו, שגולפו בעץ הן הפקעים, הם הפרחים לפני פתיחתם, והן פטורי הציצים, הם הפרחים שנפתחו. נאמר מעתה שורש פ.ט.ר בלשון העברית, משמעותו פתיחה.",
    whyIsItCalledAMushroomText7:
      "מכאן נבוא אל היער, אל הפטריות, אלו השייכות לקבוצת פטריות הכובע, שהן המוכרות והמבוקשות לאבותינו מאז, ועד ימינו. כידוע פטריות 'יוצאין כמות שהן בלילה אחד' כפי שפירש רש''י, אך מכירי הפטריות יודעים לספר כי באותו הלילה מתרחש תהליך שכזה: מתוך התפטיר, הולך ומתעבה הפטריה, עטופה בצעיף דמויית ביצה. ככל שתנקופנה השעות, תתרומם רגל הפטריה, הנושאת את כובע הפטריה, עד שתבצבץ מן האדמה, תקרע את הצעיף ותזדקף. בבסיס הרגל תיוותר שארית הצעיף (היא הנרתיק), ועל שולי הכובע, יש ויוותרו קרעי צעיף. יציאת הפטריה מתוך הצעיף שעטף אותה, תוך קריעת הצעיף, הרי היא כפתיחת הצעיף, ועל כן נקרא שמה פטריה – זו הפותחת צעיפה, ומציצה מתוכו.",
    nutritionalValueInAMushroom: "ערך תזונתי של פטריות",
    nutritionalValueInAMushroomText1:
      "פטריות טובות לנו: אפס שומן, מעט קלוריות, מעט פחמימות, נתרן נמוך וללא כולסטרול.",
    nutritionalValueInAMushroomText2:
      "פטריות טריות הינן מקור לויטמינים, מינרלים וסיבים תזונתיים. מחקרים רפואיים מגלים את ערכן התזונתי והבריאותי של הפטריות. הפטריות הן דלות שומן ונתרן, ערכן הקלורי נמוך וערכן התזונתי גבוה. בנוסף לטעמן הנהדר הן מכילות ויטמינים, אנטיאוקסידנטים ומינרלים חיוניים, כגון: ריבופלבין, ניאצין וחומצה פנטיטנית, אבץ אשלגן, זרחן, תיאמין, ויטמין  B6, ברזל ומגנזיום.",
    nutritionalValueInAMushroomText3: "ויטמינים:",
    nutritionalValueInAMushroomText4:
      "4-5  פטריות שמפיניון בגודל בינוני (100 g) תורמות תרומה חשובה לדרישה היומית של:",
    nutritionalValueInAMushroomText5Bold: "ריבופלבין (B2 ויטמין):",
    nutritionalValueInAMushroomText5:
      "24% מהדרישה היומית (0.4 mg). ריבופלבין הינו אנזים חיוני למטבוליזם של פחמימות, חומצות אמיניות וליפידים. הוא גם תומך בהגנה אנטיאוקסידנטית.",
    nutritionalValueInAMushroomText6Bold: "ניאצין (B3 ויטמין):",
    nutritionalValueInAMushroomText6:
      "18% מהדרישה היומית (3.6 mg). ניאצין פועל כקו-אנזים במטבוליזם של פחמימות וחומצות שומן, והוא נדרש למטבוליזם של אנרגיה.",
    nutritionalValueInAMushroomText7Bold: "חומצה פנטוטנית (B5 ויטמין):",
    nutritionalValueInAMushroomText7:
      "15%  מהדרישה היומית (1.5 mg). לחומצה מספר תפקידים חיוניים במטבוליזם של אנרגיה ובמטבוליזם של חומצות שומן.",
    nutritionalValueInAMushroomText8Bold: "B6 ויטמין:",
    nutritionalValueInAMushroomText8:
      " 5% מהדרישה היומית (0.1 mg). ויטמין B6 עוזר ביצירת כימיקלים בגוף כמו אינסולין, המוגלובין וגופיפים אשר נלחמים בזיהומים.",
    nutritionalValueInAMushroomText9Bold: "תיאמין (B1 ויטמין):",
    nutritionalValueInAMushroomText9:
      "5% מהדרישה היומית (0.1 mg). תיאמין משחק תפקיד חיוני במטבוליזם של פחמימות.",
    nutritionalValueInAMushroomText10Bold: "פולאט Folate:",
    nutritionalValueInAMushroomText10:
      "4% מהדרישה היומית (16 mcg). פולאט שותף בבניית תאים עם DNA ו- RNA, והוא שותף ביחד עם ויטמין B12 ליצירת המוגלובין",
    nutritionalValueInAMushroomText11Bold: "חומצה פנטוטנית (B5 ויטמין):",
    nutritionalValueInAMushroomText11: "15%",
    nutritionalValueInAMushroomText12Title: "מינרלים:",
    nutritionalValueInAMushroomText12:
      "4-5  פטריות שמפיניון בינוניות (100 g) מספקות מינרלים חשובים, חיוניים לגוף בריא וסגנון חיים פעיל. כמות הנתרן בפטריות היא טבעית נמוכה.",
    nutritionalValueInAMushroomText13Bold: "נחושת:",
    nutritionalValueInAMushroomText13:
      "נחושת היא מיקרואלמנט חיוני אשר משחק תפקיד ביצירת ההמוגלובין. כמו כן הוא מעורב ביצירת אנרגיה.",
    nutritionalValueInAMushroomText14Bold: "סלניום:",
    nutritionalValueInAMushroomText14:
      "סלניום מתפקד כאנטי אוקסידנט ביחד עם ויטמין E.",
    nutritionalValueInAMushroomText15Bold: "אשלגן:",
    nutritionalValueInAMushroomText15:
      "אשלגן עוזר לשמור על לחץ הדם, ולווסת את מאזן הנוזלים בתאי הגוף. הוא חשוב להתכווצות שרירים ולמעבר של פולסים עצביים.",
    nutritionalValueInAMushroomText16Bold: "זרחן:",
    nutritionalValueInAMushroomText16:
      "זרחן הינו מרכיב עיקרי בעצמות ובשיניים. מרכיב בתרכובות אשר מווסתות גדילת תאים, תיקונם והחומציות שלהם.",
    nutritionalValueInAMushroomText17Bold: "ברזל:",
    nutritionalValueInAMushroomText17:
      "כ- 70% מהברזל נמצא בהמוגלובין, וכ-25% נמצא בכבד, בטחול ובעצם. מרכיב במספר אנזימים.",
    nutritionalValueInAMushroomText18Bold: "אבץ:",
    nutritionalValueInAMushroomText18:
      "אבץ הוא מרכיב במספר אנזימים, חלבונים ואינסולין ויש לו פקטור חיסוני.",
    nutritionalValueInAMushroomText19Bold: "מגנזיום:",
    nutritionalValueInAMushroomText19:
      "מיקרואלמנט אשר 50% ממנו נמצא בעצם ו-50% נוספים בתוך תאי הגוף. משמש כחלק חשוב של יותר מ-300 אנזימים. עוזר גם לתחזק תאי עצב ושרירים.",
    nutritionalValueInAMushroomText20: "* באדיבות חוות השמפיניון",
    allrightsReservedTo: "כל הזכויות שמורות ל",
    bruria: "ברוריה גל",
    gamtzutz: "גמצוץ",
    finit: "פינית",
    finitStartsAsAgg: "פינית מתחילה כביצה",
    edible: "אכילות",
    hazardous: "לא אכילות",
    Lethal: "קטלניות",
    typesAndSpecies: "סוגים ומינים",
    typesAndSpeciesText1:
      "מדור זה מהווה בסיס מרכזי באתר. בחרנו לעצב אותו כמפתח ולא כמגדיר המקובל בספרים, באופן שיתאים למי שפטרייה בידו, אינו מכיר את שמה ומתבונן בסימנים החיצוניים/מורפולוגיים שלה.",
    typesAndSpeciesText2:
      "במקביל קיימת האפשרות למי שחושב או יודע את שמה, לבחור בה מתוך הרשימה, ללחוץ ולקבל את המידע. העריכה הינה על פי סוגים ובסוג כתובים כל המינים הידועים בישראל. החומר מתעדכן כל הזמן ומתווספים סוגים ומינים. נדאג לצרף קישורים להרחבת הידע.",
    typesAndSpeciesSubtitle:
      "ניתן לצפות בדף המידע של הסוג הרצוי על ידי הקלדת שמו בשדה הבחירה באם ידוע, בחירתו מתוך אפשרויות השדה (פתיחת רשימת הסוגים בלחיצה על החץ שבתוך השדה), או בביצוע חיפוש במפתח המינים מטה - על פי מאפייני הסוג המבוקש.",
    mushroomsAfterFire: "פטריות לאחר שריפה",
    mushroomsAfterFireText1:
      "תופעה מעניינת חלה בעולם הפטריות בשטחים שעברו שריפה. ידועים מינים מאפיינים שמתפתחים רק על גזעים או בשטחים שרופים. לאחרונה מתקיימים מחקרים בנושא ונבדקות השאלות כדלקמן:",
    mushroomsAfterFireText2:
      "האם החום כתוצאה מהשריפה הוא התנאי לנביטת הנבג והתפתחות התפטיר?",
    mushroomsAfterFireText3: "האם החומר האורגני השרוף מהווה מזון לפטריה?",
    mushroomsAfterFireText4: "כמה זמן עובר עד להופעת גופי הפרי?",
    mushroomsAfterFireText6: "דוגמא למינים מייצגים:",
    mushroomsAfterFireText7:
      "גמצוץ חרוטי- Morchella conica - הצורך בחום גבוה הינו לנביטת הנבג. לאחר התפתחות התפטיר ימשיך לחיות בלי תלות בחום רב ויצמיח גופי פרי.",
    mushroomsAfterFireText8:
      "קשקשית פחומה - Pholiota carbonaria - מצאנו קבוצות גדולות בחניונים בהם עשו מנגל. בבקורינו שנה אחר שנה באותו מקום - הופיעה במלוא יופיה, בגוון ברונזה.",
    mushroomsAfterFireText9:
      "קופסית פחומה Geopyxis carbonaria - קטנטנות המופיעות בקבוצות,צמודות לקרקע.",
    mushroomsAfterFireText10:
      "קופסית פזיזה סגלגלה – Peziza violacea נפוצה למדי בארצנו.",
    mushroomsAfterFireText11:
      "לצערנו חווינו בארץ שריפות רבות ומעניין יהיה לבדוק ההשפעה ואלו מינים יופיעו.",
    mushroomsAfterFireText12: "* ראה מידע נוסף במדור סוגים - שלהבת טבורנית.",
    mushroomsAfterFireImg1: "© ברוריה גל",
    mushroomsInOdemForest: "פטריות ביער אודם/מסעדה, בגולן",
    mushroomsInOdemForestText1:
      "יער אודם הוא שמורת הטבע הצפונית ביותר בארצנו. הוא נמצא בגולן בגובה 1000 מ' מעל פני הים, סמוך לעיירה מסעדה. העצים השולטים בשמורה הם אלון תולע ואלון מצוי. הגובה מסביר את העובדה שעפ'ר הגשמים יורדים מוקדם בעונה ובכמות מרובה בהשוואה לשאר אזורי הארץ. מיד לאחר כיבוש הגולן והחרמון עלו חוקרים לבדוק את המגוון הביולוגי וביניהם המיקולוגים הירשנזון ובנימיני. בדצמבר 1969 יצאתי עם הנ''ל וקבוצת סטודנטים לבדוק ולאסוף פטריות. ההרגשה היתה שאנו נמצאים באירופה, וכך גם מגוון המינים שאספנו. כל פרט שראינו היה חדש עבורנו ורק כעבור מספר שנים המינים זוהו ופורסמו בספר ובמאמרים.",
    mushroomsInOdemForestImg1: "ברוריה גל ©",
    mushroomsInOdemForestText2:
      "הפרט הנדיר והמיוחד שהרמתי ממרגלות עץ אלון היה אמניתת המוות – Amanita phalloides ‏, כנראה הפרט היחיד שזוהה עד כה בארץ (ראה תמונה מס' 454 מאוסף אוניברסיטת ת.א).",
    mushroomsInOdemForestImg2:
      "אמניתת המוות, Amanita phalloides באוסף אונ' ת''א. © בנימיני",
    mushroomsInOdemForestText3:
      "בין חובבי הפטריות יש שמתמקדים במשפחת הגושיות ומצפינים מדי שנה, לאחר גשם ראשון, לחפש ולמצוא  מינים נדירים, ובעיקר את ה-גושית נאכלת – Boletus aereus ‏ או Edulis ‏.B‏  שלא נמצאה כל שנה, שמה העממי בארופה –פורצ'יני. מין נדיר נוסף – גושית מפוארת – B.premagnificus,‏ שנראה רק מעט ומרשים בצבע האדום העז.",
    mushroomsInOdemForestImg3: "גושית מפוארת, B.premagnificus   © אראלה",
    mushroomsInOdemForestText4:
      "המרשימה ביותר בכמות,ביופי ובגודל – מטרנית גדולה – Macrolepiota procera‏  המגיעה לקוטר ראש אדם ממש כמטריה, והקטנה ממנה – מ. הפיטם –.mastoidea‏.M‏.",
    mushroomsInOdemForestImg4: "מטרנית הפיטם. © רפי מלכה.",
    mushroomsInOdemForestText5:
      "סוגים נוספים עם מינים נדירים: גושית-מכמה מינים, ציצנית מכמה מינים בכמויות גדולות, אסימונית מכמה מינים, דפונית, פקועה, הינומה, פטרה ועוד. היער מהווה יעד לביקורים ופיקניקים, מלוכלך מאוד ועלינו לקוות שישמר ולא יקלוט עדרי בקר.",
    mushroomsInOdemForestImg5: "גידמית הדורה, על גדם אורן. © ברוריה גל",
    mushroomsInTheGilboa: "פטריות בהר הגלבוע",
    mushroomsInTheGilboaText1:
      "לאורך הדורות מייחסים לגלבוע את נושא הפטריות ולראיה - מכנים את ההר בערבית - ג'בל פקועה והכפר הפלסטיני שלמורדותיו נקרא 'כפר פקועה'. השם פקועה מהווה הכללה של כל סוגי הפטריות.",
    mushroomsInTheGilboaText2:
      "מושג פטרייה נקשר בד''כ לגשם, אך כבר בתנ''ך, בספר שמואל, נכתב אודות הגלבוע - ''אל טל ואל מטר עליכם'', והנה הוא מזוהה כשופע פטריות, הכיצד?",
    mushroomsInTheGilboaText3:
      "תפטיר הפטרייה הגדל מתחת לפני הקרקע, רדום ברוב חדשי השנה ועם רדת הגשמים מתעורר, מתפתח ומוציא גופי פרי למשך שבועות בודדים. בשנים מסוימות השפע כה מרשים וזכור למי שחי או מבקר במקום.",
    mushroomsInTheGilboaText4:
      "בעבר היה כל ההר, הנמצא בחבל הים-תיכוני חשוף אך מכוסה בצומח השייך ל'בתה עשבונית', ובמאה האחרונה ניטעו בו עצים בעיקר אורנים. עובדה זו השפיעה על מגוון הפטריות והצומח בכלל.",
    mushroomsInTheGilboaText41:
      "נפריד בין מיני הפטריות שבשטח הפתוח, לאלה המופיעים בתת היער.",
    mushroomsInTheGilboaText5:
      "ברשימת הצמחים שבהר ברקן מודגש הכלך בשטח החשוף והמואר, שבזכותו צומחת הפטריה",
    mushroomsInTheGilboaText5Bold: " 'אזנית הכלך' ",
    mushroomsInTheGilboaText6:
      "המרשימה והנחשבת כמעדן לאוכליה. הכלך אינו נאכל ע'י צאן ובקר, כי מכיל חומרים רעילים ועובדה זו מסבירה את הישרדותו ותפוצתו הרבה לאורך השנים.",
    mushroomsInTheGilboaText7:
      "האזנית ניזונה מחלקי הצמח המתים שבקרקע, שרידי החלקים שיבשו לכלך הרב שנתי. מזאת נבין ששוב ושוב תצמחנה אוזניות באותה חלקה, אך הכמות תלויה בכמות המשקעים. האזנית נחשבת 'אוהבת חום' ולכן הגלבוע מתאים לגידולה. בהרי יהודה ובצפון הנגב, הסובלים מימי-קרה, מצוי כלך  אך פחות פטריות תצוצנה.",
    mushroomsInTheGilboaText8:
      "בין עצי האורן מצויים מיני פטריות בדומה לשאר יערות המחטניים בארץ:  פקועה ממספר מינים, אחלמית ערומה, אורנייה, ישעורית אפורה, פטרת האיצטרובל, נטופה ערבה, מספר מיני סיבית, ועוד.",
    mushroomsInTheGilboaText9:
      "בקרחות ובשולי היער, בקרקע עשירה בחומר אורגני, מצויות נרתיקנית דביקה, פקועה, מטריינית ועוד.",
    mushroomsInTheGilboaImg1: "© עירית צוק",
    similarButDifferentText1:
      "הדמיון בין פטריות ממינים ומסוגים שונים מהווה בעיה קשה למנסים לזהות. טעות בזיהוי יכולה להסתיים באסון אם הפטריה נכנסה לצלחת ולקיבה, להבדיל מעיסוק בזיהוי פרחים או ציפורים. החלטנו להקדיש מספר קטעי פטרידע להציג תמונות ולפרט מהם ההבדלים, אך לא תמיד זה אפשרי. ידוע וברור שהגדרה מקצועית של מיני פטריות חייב להיעשות ע''י בדיקה מיקרוסקופית של נבגים ורקמות ועד בדיקת ד.נ.א. החובבים בארצנו אינם עושים זאת, לעומת ידידינו באירופה המצוידים איש איש במיקרוסקופ, בכימיקלים ובספרי הגדרה ספציפיים.",
    similarButDifferentText2Bold: "שברירית צעיפית (Psathyrella candolleana)",
    similarButDifferentText2: " דומה מאוד ל",
    similarButDifferentText3Bold: "דיואית משחירה (Coprinus atramentarius)",
    similarButDifferentText3:
      "ושתיהן גם לקטיפנית וסיבית. שתיהן גדלות בקבוצות, הגוון חום בהיר והדפים כהים עד שחורים. מופיעות הרבה בגינות, לרגלי עצים חלשים או מתים, ולעיתים מעל גדם הקבור מתחת לפני הקרקע. אז מהו ההבדל ? דיואית משחירה מאוד עם ההזדקנות ונמסה עד יצירת 'דיו'. השברירית נשארת חומה ומתפוררת בנקל. לכן, אם פגשנו בקבוצה צעירה - נבקר שוב לאחר יום-יומיים ונדע.",
    similarButDifferentImg: "שברירית מול דיואית. © ב.ג, יהודה מ",
    photographingMushrooms: "צילום פטריות",
    photographingMushroomsText1:
      "צלום פטריות הוא תחביב נפוץ וכמעט כולנו מצוידים כיום במצלמה קטנה ויעילה. הצורות והצבעים מאוד מגוונים ומפתים לצלם מכל הזוויות ולקבל תמונות יפות עד אומנותיות. אבל - אם חשוב לנו שהתמונה תאפשר זיהוי של הסוג והמין - יש לדאוג ולצלם את החלקים הנבדלים ומהווים סמני-זיהוי:",
    photographingMushroomsBullet1: "המראה מלמעלה, ללא הבהק מואר מדי.",
    photographingMushroomsBullet2: "המראה מלמטה, דפים, ספוג, שיניים וכו'.",
    photographingMushroomsBullet3:
      "הבסיס לכל אורכו, רגל כולל החלק שבתוך הקרקע, טבעת, נרתיק וכו'. בפטרייה שוכבת על הקרקע.",
    photographingMushroomsBullet4:
      "בפטרייה דמויית כדור חשוב לחתוך לרוחבה כדי לראות את צבע הרקמה הפורייה",
    photographingMushroomsBullet5:
      "לצרף סימן להשוואת גודל, מטבע מוכר כמו 10 אגורות, עפרון והטוב ביותר - סרגל.",
    photographingMushroomsText2:
      "* בצילום עם פלש מתקבל הבהק והצבע מעוות, הדבר מאוד משמעותי, לכן יש לבדוק זאת.",
    photographingMushroomsText3:
      "* אם מצויה רק פטריה אחת, יש לצלמה במספר תמונות הכוללות את הנ''ל, או לעשות חתך אורך ולצלם את שני החלקים במהופך.",
    photographingMushroomsText4:
      "* אם מצויות מספר פטריות בקבוצה - יש להוציא אחת או שתיים, להפוך ולצלם באותה תמונה.",
    photographingMushroomsText6: "בהצלחה.",
    photographingMushroomsImg1: "© דליה ב",
    eatingMushrooms: "אכילת פטריות",
    eatingMushroomsText1:
      "המילה הנרדפת לפטריה, בשפת הרחוב, היא: רעל, מפחיד, מסוכן, זהירות וכו'. הדבר נובע מנסיון רב-שנים וכלל עולמי של פגיעה בבני אדם, כולל תמותה. מכאן נבין מדוע התפתחו אמונות טפלות רבות שברובן חסרות כל יסוד מדעי. ",
    eatingMushroomsText2:
      "בכל התרבויות בעולם פטריות קשורות למיסטיקה, סיכון, חשדנות ופחד. סוגי הרעל שבפטריות אינו נמצא בעולם החי והצומח ולכן אינו ידוע מספיק ושמותיהם כשם הפטריה: אמניתין, פלואידין, מוסכרין ועוד.",
    eatingMushroomsText3:
      "בלתי אפשרי לזהות אם הפטריה רעילה או לא ! אין צבע, אין ריח ואין צורה היכולים להעיד על רעל כלשהו. צריך להכיר היטב עשרות או מאות מינים, ולהעזר בספרים המציינים את דרגת הרעילות או האכילות של כל מין ומין. עיסוק או תחביב שכזה דורש זמן ממושך של יציאה לשדה וליער ולימוד מעמיק.",
    eatingMushroomsText4:
      "כשאדם נפגע לאחר אכילת פטריות, לרופאים יש קושי לטפל אם אין זיהוי מדויק של המין ובעיקר מהסיבה שהחולה מגיע מאוד באחור. השפעת הרעל ניכרת לאחר יום, יממה או שתיים ומשייכים את הפגיעה למזון שאכלו לאחרונה.",
    eatingMushroomsText5:
      "'לא הגון' מצד הטבע לייצר מינים כל כך דומים במראה אך שונים מאוד בהרכב הכימי, מרעל ועד מעדן, ולנו יש לקבל עובדה זו ברצינות.",
    eatingMushroomsText6:
      "הלבנות הגדולות והבשרניות שיכולות למלא את הסלים והסירים שלנו, מהן עלינו להיזהר במיוחד. בסוגים פקועה, מטרינית ואמנית יש מינים דומים מאוד מאוד וביניהם הרעילות ביותר, אך גם הטובות ביותר (ראו בטבלאות הסוגים).",
    eatingMushroomsText7:
      "מחלקים את הפטריות האכילות למצוינת, טובה, לא טעימה או נעימה לחיך, חייבת בישול ארוך, חייבת השריה ושפיכת המים מספר פעמים. יש מינים שאסור לשלב בארוחה אלכוהול ויש שאין לאכול כמות גדולה ואין לאכול טריה. בכל מקרה אין לאכול פטריות זקנות או ששהו זמן לאחר הקטיף.",
    eatingMushroomsText8:
      "את הרעילות מחלקים על פי השפעתן או פגיעתן בגופנו, רעילה או ממיתה. האברים הנפגעים הם בעיקר כליות, כבד, מערכת העצבים ולצערנו - כולם יחדיו המביאים למוות. בנוסף יש מינים הגורמים להזיות ושבוש בתפקוד. נכון, בקטע זה אינני מפרטת שמות מינים רעילים או טובים,ולא פרוט הרעלים, אכתוב בקטע נפרד.",
    eatingMushroomsText9: "ברצוננו לחזור ולהדגיש:",
    eatingMushroomsText10: "* אין שום סימן חיצוני המעיד על רעילות.",
    eatingMushroomsText11: "* שנוי צבעים - אינו סימן מבדיל בין טוב לרע.",
    eatingMushroomsText12: "* חיה ששרדה לאחר אכילה - אינה מעידה על טיב הפטריה.",
    eatingMushroomsText13:
      "* גידול ביער, חורש ,דשא או שדה - לא ישמש לנו כסימן.",
    eatingMushroomsText14:
      "המסקנה - יש להכיר היטב כל מין ומין ולהיעזר במומחים !",
    eatingMushroomsText15: "מי שרעב לאכול פטריות עליו ללמוד או לקנות בחנות !",
    eatingMushroomsText16: "טבלאות הסמנים שבאתר נועדו לעזור וללמוד !",
    eatingMushroomsText17: "בהצלחה.",
    eatingMushroomsImg1: "אזנונית יהודה - לא טעימה.",
    eatingMushroomsImg2: "אזנית הכלך - מצוינת.",
    eatingMushroomsImg3: "גושית - רעילה.",
    glowingInMushrooms: "זוהר בפטריות",
    glowingInMushroomsText1:
      "עולם הפטריות מרתק ומזמן לנו צורות, צבעים ותופעות מיוחדות ומוזרות. אחת התופעות המאתגרות אותנו לצפייה היא פטריות היוצרות זוהר. מי לא יצא בחושך לחפש אור ביער ולרוב התאכזב? התופעה לא קורית באופן רציף אלא במחזוריות שאיננו יודעים לקבוע זמנה. הפקת האור נעשית במקום לח על חלקי עצים נרקבים.",
    glowingInMushroomsText2:
      "לאורך השנים האדם נחשף לתופעה זו ביצורים חיים שונים כמו דגים, פטריות, גחליליות, חיידקים ורבות הדעות והאמונות התפלות אודות סיבותיה. אצל החרק גחלילית הסיבה המוסברת כיום היא הפצת אור למשיכה בין הזוויגים למטרת רבייה.",
    glowingInMushroomsText3:
      "בפטריות נבדקו עשרות מינים בעלי תופעת הזוהר וסבורים שהסיבה היא משיכת חרקים להפצת הנבגים. הסוגים הידועים כמפיקי אור שייכים לסדרת הפקועיים כמו דיבשית, טבורית, צבעונית ופטרה.",
    glowingInMushroomsText4:
      "מקור האור הוא פעולת מולקולות של חומרים כימיים, חמצן ואינזים בשם לוציפראז. שם התופעה העממי הוא 'אש השועל' –,Foxfir במדע שמה ביולומינסנציה. בפטריות הפעולה מתבצעת בשעות החושך, עת הזוהר ניכר ובולט יותר, בצבעים ירוק וכחול. עוצמת האור שונה, חלשה או חזקה וידועה בעולם באזורים לחים וחמים.",
    glowingInMushroomsText5: "קישורים:",
    glowingInMushroomsLink1: "על פטריות זוהרות",
    glowingInMushroomsLink1Text: " - מאמר באנגלית ארוך ומפורט",
    glowingInMushroomsLink2: "פטריות זוהרות",
    glowingInMushroomsLink2Text: " - מכון דוידסון ומכון ויצמן למדע",
    successionInMushrooms: "סוקסציה בפטריות",
    successionInMushroomsText1:
      "המושג סוקסציה מתפרש ומשמש בביולוגיה לכמה נושאים הקשורים בחילוף, כאן נעסוק ב - ",
    successionInMushroomsText2Bold:
      "'סדר ההופעה של מיני פטריות הכובע במשך העונה'.",
    successionInMushroomsText3:
      "כידוע, התפתחות גופי הפרי בפטריות מותנית ברטיבות בקרקע, בלחות באויר ובטמפרטורה מסוימת.",
    successionInMushroomsText4Bold: "מיד לאחר גשם ראשון - ",
    successionInMushroomsText4:
      "באוקטובר או בנובמבר. יש מינים 'זריזים' המופיעים ראשונים עם גופי הפרי. בגולן ובגליל, העשירים בכמויות גשם, הן הגושיות. מעניין שהראשונות הן בעלות נבגים אדומים ורעילות, ולא ידוע הסבר לעובדה זו. הלבדיות אחריהן, ואח''כ החרירית, מאותה משפחה.",
    successionInMushroomsText5Bold: "בחודשים דצמבר עד פברואר - ",
    successionInMushroomsText5:
      " מופיעים מירב המינים באזורי 500 מ''מ גשם ויותר ובטמפ' של 10-24  מעלות. = מעניינת ההופעה של מינים בסוג פקועה, במועדים שונים. הראשונות היו הרעילות ובהמשך פקועת השדה ופקועה מצויה הטובות למאכל. נתון זה מסתמך על מאמר של פרופ' בנימיני ב1981, בו ניתח את נתוני התצפית והאיסוף שעשה במשך שבע שנים במרכז ובצפון הארץ.",
    successionInMushroomsText6Bold: "לקראת האביב - ",
    successionInMushroomsText6:
      "קורה שיש שרב והטמפ' מגיעה עד 32 מעלות צלזיוס ואף על פי כן ידועות פטריות 'אוהבות חום' הצומחות כה מאוחר. אמניתת האביב מופיעה גם לאחר המלקוש בצמוד לאלון תבור, בקרקע חולית, שהגיע כבר לפריחה. הדבר מסוכן למלקטים שהורגלו לאכול בחורף לבקנית האגוזים ופקועה מצויה, והנה עוד לבנה דומה שכדאי לאסוף.",
    successionInMushroomsImg1: "© חרירית ערמונית. בנימיני",
    taxonomyText1:
      "החלוקה בעולם הפטריות - להלן המדרג הטקסונומי :  ממלכה, מערכה, מחלקה, סדרה, משפחה, סוג. מין, תת-מין.",
    taxonomyText2: "את מערכת הפטריות מחלקים לשתי תת מערכות:",
    taxonomyText3:
      "א. תת מערכת פטריות נאדית - Ascomycotina  בה הנבגים נוצרים בתוך נאדיות ונמצאים עד הבשלתם. מתחלקת למחלקות:",
    taxonomyBullet1: "פטריות נאדית חצויה - Hemiascomycetes",
    taxonomyBullet2: "פטריות משזר- Pectoycetes",
    taxonomyBullet3: "פטריות אגסיות- Pyrenomycetes",
    taxonomyBullet4: "פטריות חרקים - Laboulbeniomycetes",
    taxonomyBullet5: "פטריות מסד - Loculoascomycetes",
    taxonomyBullet6: "פטריות אגניות -Discomycetes",
    taxonomyText4:
      " הסדרה מתחלקת לתת - סדרה - inae ואז למשפחות עם סיומת aceae. תת משפחה - oidae לסוג והמין במשפחה אין סיומת קבועה. כל מחלקה מתחלקת לתת מחלקה עם סיומת mycetidea ואז לסדרה עם סיומת ales.",
    taxonomyText5:
      "ב. תת מערכת פטריות בסיסה - Basidiomycotina בה הנבגים נוצרים וגדלים על בסיסה באופן חיצוני.  מתחלקת למחלקות:",
    taxonomyBullet7:
      "פטריות אפילות - Teliomycetes - רובן טפילות והנבגים מפוזרים ברקמת הפונדקאי.",
    taxonomyBullet8:
      "פטריות כרס - Gasteromycetes - בהן הבסיסות בחללים עם המסה  של הנבגים.",
    taxonomyBullet9:
      "פטריות הינומית - Hymenomycetes - הגדולה שבמחלקות וכוללת את פטריות הכובע, את דמויות האצטבה, דמויות אלמוגים ועוד.",
    taxonomyText7: "* הסיומת בשם הלועזי מסבירה את השייכות.",
    taxonomyText8:
      "למעונינים בנושא - מומלץ להאזין ולצפות בתכנית פודקאסט ''פה ושם בא''י'' פרק טקסונומיה לינארית באדיבות יפתח מזור.",
    radioactivity: "פטריות סופגות חומרים מסוכנים",
    radioactivityText1:
      "ספיגת רדיואקטיביות ע''י פטריות ידועה ומסוכנת בעיקר לאחר אסון צ'רנוביל ב 1987. הקרינה נדדה בענני טיפות מים לכוון ארצות אירופה וחדרה לקרקע במספר ארצות. תפטיר הפטריה החי לאורך שנים קולט מהחומרים המסוכנים, אוגר, ומעבירם לגוף-הפרי אותו בני האדם ובע''ח אוהבים לאכול.",
    radioactivityText2:
      "נבדקו מיני פטריות ונמצא שריכוז הרדיואקטיביות גבוה בעשרות אחוזים מאשר בקרקע ! לדוגמא - בקמרונית דביקה נאגר היסוד הרדיואקיבי 'צזיום 137' פי עשרות אלפים ממה שמצוי בקרקע.",
    radioactivityText3:
      "נטופה ערבה ולבדית זהובת בשר, הידועות לנו, נבדקו בצרפת 15 שנים לאחר אסון צ'רנוביל ונמצאות בראש רשימת הסיכון. בצרפת פירסמו לציבור, מתוך רשימת הפטריות האכילות, את המינים שנבדקו ונאסר לאוכלם, כ''כ דאגו לפרסם גם את אלה שאינן בסיכון.",
    radioactivityText4:
      "בשוויץ פירסם איגוד הציידים הוראה לא לאכול מבשר חזירי הבר שנוהגים לאכול פטריות רבות.",
    radioactivityText5: "* המידע נאסף ותורגם ממאמר שוויצרי.",
    radioactivityImg1: "קמרונית דביקה",
    mushroomsInIsrael: "פטריות בארץ ישראל",
    literatureText1: "להלן רשימת ספרים נבחרים בנושא פטריות:",
    literatureText2: "בשפה העברית",
    literatureBullet1:
      "ניסן בנימיני. 1975. פטריות הכובע בישראל. הוצאת הקבוץ המאוחד.",
    literatureBullet2:
      "ניסן בנימיני.1984. פטריות עילאיות בישראל. הוצאת רמות אוניברסיטת ת.א.",
    literatureBullet3:
      "ניסן בנימיני. 1992. הפטריריות בישראל. הוצאת הקבוץ המאוחד.",
    literatureBullet4: "ניסן בנימיני. 1987. עולם הפטריות. הוצאת הקבוץ המאוחד.",
    literatureBullet5: "רייס ורייכהרט. 1952. כמהין ופטריות. הוצאת ספרי תרשיש.",
    literatureBullet6:
      "רייכהרט ואביזוהר הישנזון. 1964. פטריות מאכל ופטריות רעילות בישראל. ספריית השדה.",
    literatureBullet7:
      "עזריה אלון, החבל'הט, 1985. החי והצומח של א''י, אינציקלופדיה שמושית, כרך 9, הוצאת משרד הבטחון.",
    literatureBullet8:
      "י. ויזל, ש.כהן, נ.בנימיני. 1977. צמחי רעל בישראל. הוצאת המדור לאקולוגיה בע''מ.",
    literatureBullet9:
      "דליה לוינסון. 2008. מדריך כרטא לפטריות מאכל ורעל בישראל. הוצאת כרטא.",
    literatureText3: "בשפה האנגלית",
    literatureBullet10:
      "R.Phillips. 1981. Mushrooms of Great Britain & Europe. Pan Macmillan. London.",
    literatureBullet11:
      "M.Lange &F.Bayard hora. 1963. Collins Guide to Mushrooms & Toadstools. Collins.London.",
    literatureBullet12: "Loizides. 2011. Edible & Toxic Fungi of Cyprus.",
    literatureBullet13:
      "S.Wasser. 2002. Agaricaceae of Israel mycobiota. Ruggell. Germany.",
    literatureBullet15:
      "R.Courtecuisse & B.Duhem. 1995. Mushrooms & Toadstools of Britan and Europe. HarperCollinsPublishers.",
    literatureBullet16:
      "J.Breitenbach / F.Kranzlin. 1991. Fungi of Switzerland. 3 volume. Mykologia Lucerne.Switzerland.",
    literatureBullet17:
      "Courtecuisse & Duhen 1955. Mushrooms&Toadstools of Britan&Europe. Collins Field Guide.",
    literatureBullet18:
      "European BOLETES - M.Mikisik. M.Gelardi. G.Simonini' FUNGI PRESS.",
    sharonShfela: "פטריות בשרון ובשפלה",
    sharonShfelaText1:
      "את ינואר פתחנו בסדנה בהר מירון, ראה סיכום, ובשבוע שאחריו הולבנו ההרים משלג יפה ורב.",
    sharonShfelaText2:
      "הטמפרטורה צנחה מטה ולפטריות היתה 'תרדמה קפואה'. כתוצאה מכך נוצרו צורות מעניינות ועיוותים בפרטים רבים, מה שהפריע לזהותם, ונעצר גידול של מחזור חדש. בחרנו לסייר באזור נמוך יותר, בשרון ביער אילנות, בשמורת קדימה ובאזור מודיעין.",
    sharonShfelaText3Bold: "אילנות",
    sharonShfelaText3:
      " - היתה חווה לאיקלום עצים ועתה משמשת בחלקה כגן בוטני ובצדו נבנה מוסד סיעודי לנגמלי סמים. שנים רבות נסרק השטח ונרשמו הפטריות במגוון מעניין משום מגוון העצים בו. הפעם נחרדנו לראות השתלטות הצמח חמציץ בצפיפות עצומה, שמפריעה להתפתחות הפטריות. השקענו מאמץ בחיפוש בתוך העשביה ומצאנו מעט מהמינים שהכרנו מהעבר: שחרחרית קצרת רגל, אדומית, אבקית רכה, נרתיקנית דביקה, אחלמית ערומה, פיטרירית, צנומה והמענינת – פקועה אדמדמה או ארגמנית.",
    sharonShfelaText4Bold: "שמורת קדימה",
    sharonShfelaText4:
      "– עם עצי אלון תבור, היוותה תמיד מקור למינים מיוחדים. זה ביקורנו השני לאחר 3 שבועות. נצפו: אסימונית האלון, משפכנית ריחנית,  משפכנית לבנה, דיואית צחורה, פקועה ב.מ. לא מצאנו סימן לפטריה החדשה (בין לבקנית לאמנית) שתוארה בסיור הקודם.",
    sharonShfelaText5Bold: "מצפה מודיעין",
    sharonShfelaText5:
      " - יער רחב ידיים המצורף ליער בן שמן ובו בעיקר עצי אורן בגילים שונים. כאן הכסוי היה בעיקר של רקפות. הכרנו דפופית מאוגדת, כישורית מרושתת, שרועית אפרכסית שצמחה על שארית מערמת 'קצץ'. על גזע מת ראינו דפופית המחטניים ובתוך שטחי העשב- צבעונית, בעלת הכינוי 'חצי ביצה'.",
    sharonShfelaImg1: "© ברוריה גל",
    sharonShfelaImg2: "© ברוריה גל",
    sharonShfelaImg3: "© ברוריה גל",
    binyaminaMeddow: "פטריות אחו בנימינה",
    binyaminaMeddowText1: "סיכום סיור ינואר 2017:",
    binyaminaMeddowText2:
      "אחו בנימינה מהווה בית גידול ייחודי בהיותו ביצתי, רטוב, ומאכלס עדר בקר הממלא בהפרשותיו חלק גדול מפני הקרקע. עצי האיקליפטוס הנטועים בו עוברים כריתות ומספקים ענפים וזרדים יבשים – מצע טוב לסוגי פטריות. לאחר חודש של גשמים השטח בוצי מאוד, עם שלוליות קטנות והלחות גבוהה על פני הקרקע, הענפים והגדמים.",
    binyaminaMeddowText3Bold: "חלוקת מגוון המינים לפי סוגי מצע:",
    binyaminaMeddowBullet1Bold: "על ענפים יבשים, גדמים וגזעי עצים: ",
    binyaminaMeddowBullet1:
      "גידמית חודרנית, פטרה דממנית, דרדסית משתנה*, מצילת הגבעול.",
    binyaminaMeddowBullet2Bold: "על גללים של בקר: ",
    binyaminaMeddowBullet2: "נאדנית הגללים, מצילת הגללים, ועוד קטנטנות.",
    binyaminaMeddowBullet3Bold: "על הקרקע: ",
    binyaminaMeddowBullet3Title: "מקבוצת האבקתיים: ",
    binyaminaMeddowBullet3: "אבקית מאפירה, אבקית רכה, פרגודית נפוצה, כדורנית.",
    binyaminaMeddowBullet31Title: "מפטריות הכובע: ",
    binyaminaMeddowBullet31:
      "נרתיקנית נאה דביקה, אחלמית ערומה, מטרנית Macrolepiota phaeodisca, שחרחרית קצרת-רגל, שברירית כהה/חרוטית, צנומה, אסימונית, משפכנית שיבנית, סוככית קשקשית, דפונית ועוד.",
    binyaminaMeddowBullet32Title: "מהפטריריות: ",
    binyaminaMeddowBullet32: "קפיצית, ועוד מינים שלא עסקנו בהגדרתם.",
    binyaminaMeddowText4:
      "תודות - לכל מי שצילם והעביר לי תמונות נפלאות, תודה מיוחדת לרותי טלמור שמתמידה בדיווחים מהמקום.",
    mushroomsWorkshopInMountMeron: "סדנת פטריות בהר מירון",
    mushroomsWorkshopInMountMeronSubtitle: "סיכום תצפיות מתאריך 2.1.2015:",
    mushroomsWorkshopInMountMeronText1:
      "פתחנו את השנה הלועזית החדשה במפגש עם חובבים ועם פטריות באזור הר מירון שבגליל. בעזרת ניר יבגי וחבורתו, שמגיעה להם תודה,אספנו מינים רבים והכנו תצוגה עשירה ומגוונת בכיתת לימוד מרווחת ומחוממת בבית ספר שדה. רק בהצגת המינים יחדיו ניתן להבחין וללמוד את ההבדלים בין מין דומה לשני, ואכן זה הוכח כנכון. לאחר בדיקה קפדנית של כל פרט,שעד אליה הושמע קולי - ''לא למשמש'' כדי לא לפגוע בקשקשים,בטבעת וכו', ניתן האות – ''כן למשמש'', להריח, לחתוך ולפרק, וכך להכיר היטב את סמני הזיהוי.",
    mushroomsWorkshopInMountMeronText2:
      "הכרנו כ 50 מינים שונים ביניהם מעניינים וחדשים לרשימותינו וביססנו את שהיה ספק בזיהוים. סיירנו בין גשם לגשם ביערות אלונים ויערות מעורבים עם אורנים - מה שהעשיר את מגוון המינים. אציין מספר מינים מיוחדים:",
    mushroomsWorkshopInMountMeronBullet1Bold:
      "גושנית נאה- Leccinum lepidum‏‏‏: ",
    mushroomsWorkshopInMountMeronBullet1:
      "שייכת לגושיתיים עם שם עברי חדש, בחתך משתנה הצבע בחלק התחתון של הרגל.מאוד דומה ללבדית.",
    mushroomsWorkshopInMountMeronBullet2Bold:
      "פקועה אדמדמה - Agaricus semotus‏‏‏‏: ",
    mushroomsWorkshopInMountMeronBullet2:
      "דומה לפטריה ארגמנית ולפטריה בהטית. נחשבת לנדירה.",
    mushroomsWorkshopInMountMeronBullet3Bold:
      "חרירית ערמונית - Gyroporus castaneus‏: ",
    mushroomsWorkshopInMountMeronBullet3:
      "שייכת לגושיתיים, מין נדיר שהעונה נראה במספר מקומות. נבדל מגושית בצבע הלבן של פתחי הצנורות ובמבנה הרגל. היא האחרונה המופיעה בעונה ,לאחר הגושיות והלבדיות שכמעט סיימו.",
    mushroomsWorkshopInMountMeronBullet4Bold:
      "נטופה ערבה - Lactarius deliciosus ‏: ",
    mushroomsWorkshopInMountMeronBullet4:
      "מופיעה בעיקר ביערות אורנים, גדולה ומסתתרת מתחת למצע המחטים. שימחה מאוד את האספנים, להעשרת התפריט בבית, והרי האסורות והבלתי ידועות לאכילה רבות יותר.",
    mushroomsWorkshopInMountMeronBullet5Bold:
      "משפכנית גדולה/בשרנית - Clitocybe geotropa/giganteus‏: ",
    mushroomsWorkshopInMountMeronBullet5:
      "הופיעה בכמויות ובגודל מרשים .(שני השמות מתייחסים לאותו מין, הוגדרו ונקבעו ע''י מומחים בחו''ל).",
    mushroomsWorkshopInMountMeronText3:
      "כאמור, היו כחמישים מינים גדולות וקטנות, מוכרות ופחות מוכרות - וההצלחה היתה גדולה. התחזית להמשך השבוע - חורף אמיתי, וידוע שהקור יעצור את החגיגה שהיתה לנו עד כה.",
    mushroomsWorkshopInMountMeronImg1: "פקועה אדמדמה ©ב.ג",
    mushroomsWorkshopInMountMeronImg2: "גושנית ©ב.ג",
    mushroomsWorkshopInMountMeronImg3: "גושנית מכחילה בחתך ©ב.ג",
    mushroomsWorkshopInMountMeronImg4: "חרירית ערמונית © לאה ד.",
    mushroomsInTheCarmel: "פטריות הכרמל",
    mushroomsInTheCarmelText1:
      "הכרמל הוא שלוחה הררית המתנשאת עד לגבה 550 מ', מים התיכון במערב ועד עמק יזרעאל במזרח",
    mushroomsInTheCarmelText2:
      "מחלקים את הכרמל לכמה חלקים: צפוני, דרומי ומרכזי. פארק הכרמל הינו גן לאומי ושמורת טבע. רמת מנשה הנכללת בכרמל מהווה מקום עשיר במקורות מים ובמיני פטריות. השבילים ודרכי הגישה הנוחים תורמים להגעה גם בימי גשם. כמות הגשם בממצע -  650 מ''מ בשנה.",
    mushroomsInTheCarmelText3:
      "הצמחייה עשירה בצומח ים תיכוני, בעצים מהסוגים אלון מצוי והתבור, אלה אטלנטית וארץ-ישראלית, אורן הצנובר שבעבר היה שמו אורן הסלע ואורן ירושלים – מין נטוע ע''י האדם.",
    mushroomsInTheCarmelText4:
      "העיר חיפה והישובים בית אורן, עוספייה ודלית-אל-כרמל יושבות בתוך הכרמל ורבים מתושביהם נהגו ונוהגים כיום ללקט פטריות למאכל. המיקום במרכז הארץ מכתירים אותו כאתר פטריות מועדף.",
    mushroomsInTheCarmelImg1: "© אמנית ביצתית. אראלה הרי",
    mushroomsInTheCarmelImg2: "© חריפית אדומת-רגל. דן רוסק",
    mushroomsInTheCarmelImg3: "© פקועה הדורה. רענן פרומן",
    mushroomsInTheCarmelText5Bold: "הסוגים והמינים השכיחים:",
    mushroomsInTheCarmelText6: "בעיקר בחורשות אלונים.",
    mushroomsInTheCarmelBullet1Bold: "חריפית",
    mushroomsInTheCarmelBullet1:
      " – ח.יבשה/חרבה, ח.נאה, ח.מררית - מצויות בכל חלקי הכרמל.",
    mushroomsInTheCarmelBullet2Bold: "גושית",
    mushroomsInTheCarmelBullet2:
      " - ג.הזאב, ג.וורודת פס, ג.צהבהבה, ג.מעורקת, ג. קלטי. נדירות ובודדות – ג.נאכלת, ג.השטן.",
    mushroomsInTheCarmelBullet3Bold: "קמרונית",
    mushroomsInTheCarmelBullet3:
      " - ק.אדמדמה, רק במקומות מסוימים מופיעה במספר רב.",
    mushroomsInTheCarmelBullet4Bold: "נטופה",
    mushroomsInTheCarmelBullet4:
      " - נ.דורית - רבות וענקיות, יותר משהכרנו בעבר. נ.ערבה - בין אורנים.",
    mushroomsInTheCarmelBullet5Bold: "אמנית",
    mushroomsInTheCarmelBullet5:
      "- א.ביצתית, א.כוזבת, א.חדודה, א.מקושטת ועוד. רעילה וקל להתבלבל אם הכוונה לאכול. א. הנרתיק-מיוחדת בפספוס שבהקף הכובע.",
    mushroomsInTheCarmelBullet6Bold: "פקועה",
    mushroomsInTheCarmelBullet6:
      " – פ.מצהיבה, פ.יערית, פ.מצויה פ.הדורה – מיוחדת ופחות מצויה, בעלת ריח שקדים, גדלה בקבוצות, מצהיבה בשפשוף.",
    mushroomsInWestGalil: "פטריות בגליל המערבי",
    mushroomsInWestGalilText1:
      "הסיור במערב הגליל ,ביום נעים וחמים,הניב למעלה מחמישים מינים.לא הספקנו למיין ולהגדיר בשטח את כולן אך צילום ואיסוף בקופסא איפשר לבדוק בבית ולרשום אותן.",
    mushroomsInWestGalilText2:
      "הסיור במערב הגליל, ביום נעים וחמים, הניב למעלה מחמישים מינים. לא הספקנו למיין ולהגדיר בשטח את כולן אך צילום ואיסוף בקופסא איפשר לבדוק בבית ולרשום אותן.",
    mushroomsInWestGalilText3:
      "אציין את החשובות מבינהן, מיער אלונים ויער אורנים, ואצרף תמונות.",
    mushroomsInWestGalilBullet1Bold: "פקועה",
    mushroomsInWestGalilBullet1:
      " - נמצאו המינים -פקועהיערית, פקועה מצויה, פקועה אדמדמה אחת (עם כפה ורדרדת)",
    mushroomsInWestGalilBullet2Bold: "חריפית",
    mushroomsInWestGalilBullet2:
      " - שפע בכמות ושפע מינים: חריפית יבשה/חרבה קשה לזהות בינהן ללא מיקרוסקופ ולפני שיש הדפס. נבגים, חריפית נאה, עם כפה בצבע אדום-וורוד ורגליים מלבן עד וורוד עז. חריפית מררית, עם כפה חום-כתום.",
    mushroomsInWestGalilBullet3Bold: "אמנית",
    mushroomsInWestGalilBullet3:
      " - אמנית מקושטת. אמנית ביצתית, אמנית 'אחות הביצתית' -a. proxim ,אמנית קשקשית.",
    mushroomsInWestGalilBullet4Bold: "משפכנית",
    mushroomsInWestGalilBullet4:
      " - משפכנית ריחנית, דומה לטבורית הזית. משפכנית מלבינה.",
    mushroomsInWestGalilBullet5Bold: "דיואית",
    mushroomsInWestGalilBullet5: " - דיואית מחורצת.",
    mushroomsInWestGalilBullet6Bold: "פיטרה",
    mushroomsInWestGalilBullet6:
      " - פיטרה האצטרובל, על איצטרובלי אורן בלבד. פיטרה לבנה.",
    mushroomsInWestGalilBullet7Bold: "סיבית",
    mushroomsInWestGalilBullet7: " - סיבית מאדימה, סיבית משיינית, ועוד מינים.",
    mushroomsInWestGalilBullet8Bold: "ספוגיות",
    mushroomsInWestGalilBullet8:
      " - גושית מעורקת, גושית ב.מ, אורנייה מצויה, לבדית מאדימה, לבדית זהובת בשר.",
    mushroomsInWestGalilBullet9Bold: "פטריות הכובע",
    mushroomsInWestGalilBullet9:
      " - צנומה שומית, חרוטית, טבורית הזית, נטופה אטלנטית-הוגדרה לאחרונה, כינינו אותה ''כתומה''. קמרונית מאדימה, אסימונית החמאה,נטופה ערבה, שחרחרית שחרחרה.",
    mushroomsInWestGalilBullet10Bold: "פטריות כרס",
    mushroomsInWestGalilBullet10:
      " - פינית מבאישה, בשלב ה'ביצה'. אבקית, כדורנית, כוכבנית, עורית, כרסנית הגליל, פקועית. ועוד שונות :אזנונית יהודה, שיננית וכמה 'פספוסות'.",
    mushroomsInWestGalilImg1: "נטופה אטלנטית",
    mushroomsInWestGalilImg2: "חריפית יבשה",
    yehudaAndModiin: "פטריות באזור יהודה ומודיעין",
    sharonShfelaDate: "ינואר 2015",
    binyaminaMeddowDate: "ינואר 2017",
    yehudaAndModiinDate: "ינואר 2013",
    mushroomsInWestGalilDate: "ינואר 2012",
    mushroomsInTheCarmelDate: "דצמבר 2012",
    yehudaAndModiinText2:
      "שלא בדומה לאזורים בצפון הארץ - כמות הגשמים היתה מועטה ומאוחרת יותר בהרי יהודה, והניבה פחות פטריות.",
    yehudaAndModiinText3Bold: "בשדות עשב",
    yehudaAndModiinText3:
      " - היו נרתיקנית דביקה, שהשנה הכמויות הגיעו בארץ לשיאים ונמכרות בשווקי הכפרים הערביים, כמו במנדא, ב- 40 ש''ח לקילו.",
    yehudaAndModiinText4Bold: "ביערות האורן",
    yehudaAndModiinText4:
      " - אורנייה, סיבית מכמה מינים, משפכנית מכמה מינים, נטופה דורית, דיואית משחירה ועוד.",
    yehudaAndModiinText5Bold: "ביערות מעורבים",
    yehudaAndModiinText5:
      " - חריפית יבשה, פקועה מצויה, פקועה אדמדמה, לבדית פלומתית. טבורית הזית, דרדסית ועוד.",
    yehudaAndModiinText6:
      "התיחסנו הפעם במיוחד לערמות ושאריות ''קצץ'' שקק''ל מכינה לחפוי בנטיעות חדשות (ומכנה זאת 'רסק', שלדעתי המילה אינה מתאימה) ביערות בית שמש. מבין פטריות הכובע והעילאיות יש מינים צפציפיים שגדלים רק על קליפות וקצץ של עצים, כל פטריה על סוג עץ מסוים. הקליפות נירקבות עם הזמן בעזרת מים ופטריה, המפרקת את החומרים האורגניים שבה.",
    yehudaAndModiinText7:
      "בחפשנו אחר גמצוצים, שלא נמצאו הפעם, מצאנו הרבה שרועית אפרכסית, שברירית חרוטית, דרדסית, נקבובנית חרפית, כישורית מרושתת - קבוצה בת פרטים רבים, כמו בוקעת מביצים. מיני פטריות עציות וגם מקבוצת הקרומיות.",
    yehudaAndModiinImg1: "© שרועית אפרכסית ב.ג",
    yehudaAndModiinImg2: "© כישורית מרושתת ב.ג",
    menasheMountains: "פטריות בהרי מנשה",
    menasheMountainsDate: "דצמבר 2012",
    menasheMountainsText1:
      "רשימת התצפיות ואלבום התמונות טופחים ומשמינים מנחת והטיפול בהם - ממלא ימים ולילות.מהדיווחים עד היום עושה רושם שכל המינים שנרשמו בארץ ושמופיעים בספרים - ייוצגו השנה בשטח, ועוד חדשים שטרם נבדקו טקסונומית.",
    menasheMountainsText2:
      "מקו ת''א וצפונה ניכר עושר גדול בהרבה מאשר בהרי יהודה וירושלים, ומאומה בדרום-בהשפעת כמות הגשם. שפע המים במקומות הנמוכים ובנחלים הצמיח מרבדי-טחבים ממינים שונים ועליהם מצאנו פטריות זעירות, להן התייחסנו הפעם. גם את הגזעים והענפים ספוגי הלחות, קישטו פטריות קטנות ויפיפיות מהסוג דרדסית. ההרגשה היתה כמו להיות ב'מדינת הגמדים'.",
    menasheMountainsText3:
      "בין הטחבים חיפשנו במיוחד את הכומתית ''ביצתית'' (ב' בחיריק) שנמצאה בשנה שעברה לראשונה, אך לא הפעם. פגשנו מהסוגים צנומה, צנומית,עדינית, פטרה, חרוטית, אדומית, אסימונית, סוככית ועוד.",
    menasheMountainsText4:
      "מרשימה במיוחד היתה קבוצה של פטריות כהות שהכנוי 'פופיקית' או 'קורקבנית' מתאים להן, תרגום מלטינית - omphalina או myxomphalina,ראו תמונה מצורפת.",
    menasheMountainsText5: "משפכנית ריחנית בלטה בריח האניס האופיני לה.",
    menasheMountainsText6:
      "בנוסף, גם פטריות גדולות וענקיות בחרו בביוטופ שכזה: אחלמית ערומה,ישעורית סדוקה, מרה ואפורה, אורנייה, פקועה, סיבית ועוד.",
    menasheMountainsText7:
      "ביער אורנים נדהמנו משפע החריפיות, בעיקר וורודת רגל. המינים יבשה, מררית ,מחוטבת ונאה - בסיום המחזור.",
    menasheMountainsText8:
      "מקבוצת הפ' העציות הובאה מהגולן פטריה קשה שנראתה כמו עפץ גדול וקשה וזוהתה כמין השייך לסוג עציונית Xylaria' מצורפת תמונתה.",
    menasheMountainsText9:
      "סיכום זה הוא רק 'טיפה בים' מהמצוי החודש בארצנו ועוד נמשיך ונסייר.",
    menasheMountainsImg1: "'קורקבנית'",
    shomron: "פטריות בשומרון",
    shomronDate: "דצמבר 2012",
    shomronText1: "בסיורנו נרשמו מעל 30 מינים, אציין מהנבחרים שבינהם.",
    shomronText2:
      "מדרום ומזרח לאום-אל-פאחם שרדו חלקות יער של אלון מצוי ואלון תולע, בהם אנו מקיימים תצפיות מספר שנים ונהנים ממבחר הפטריות.",
    shomronBullet1Bold: "גושית",
    shomronBullet1: "- זאב, אדומת רגל ,צהבהבה.",
    shomronBullet2Bold: "לבדית",
    shomronBullet2: " - זהובת בשר, אדמדמת, פלומתית.",
    shomronBullet3Bold: "חריפית",
    shomronBullet3:
      " - יבשה, בכמויות אדירות, אותה אוספים למאכל ערבים מהאזור. חריפית נאה ועוד.",
    shomronBullet4Bold: "סיבית",
    shomronBullet4: " - אדמדמת, משיינית ועוד.",
    shomronBullet5Bold: "מטרנית",
    shomronBullet5: " - גדולה.",
    shomronBullet6Bold: "טבורית",
    shomronBullet6: " - הזית, במגוון מרשים של צורות וגדלים.",
    shomronBullet7Bold: "אמנית",
    shomronBullet7: " - מקושטת, ביצתית, הנרתיק (יפיפיה).",
    shomronBullet8Bold: "הינומה",
    shomronBullet8: " - כותנתית ,סגולת דפים.",
    shomronBullet9Bold: "ובנוסף",
    shomronBullet9:
      " - ישעורית סבונית, לחלחת השנהב, כרסנית הגליל, נטופה, משפכנית ועוד.",
    shomronAttention:
      "לתשומת לב ! ידיעה חשובה שהגיעה סמוך למועד כתיבת שורות אלו מאזור ירושלים: אדם שאסף פטריה לבנה, כנראה אמנית, שמר אותה מספר ימים במקרר, בתקווה לקבל ממישהוא זהוי בטוח, לא התאפק ואכל ממנה בתאבון. כתוצאה מכך, אושפז בבי''ח עם כליות פגועות. נאחל לו החלמה ונלמד להזהר ולהזהיר.",
    shomronImg1: "אמניתת הנרתיק",
    shomronImg2: "ישעורית סבונית",
    aznonitYehuda: "אזנונית יהודה - Hirneola auricula-judae",
    aznonitYehudaText1:
      "בתקופת החורף הגשומה, כשלחות גבוהה מצויה ביער, כדאי לנסות ולהרים ענפים וחלקי-עץ מתים מהקרקע ולגלות הפתעות. אחת שכזו היא הפטריה אזנונית יהודה - Hirneola auricula-judae הנגלית בצורתה המוזרה, אפרכסת של אוזן אדם, בצבע חום-אדמדם עד ארגמן ובאור שמש נראית שקופה.",
    aznonitYehudaText2:
      "הפטרייה הוגדרה מדעית באזורנו וקיבלה פרשנות וספורים כגון - 'אוזנו של יהודה איש קריות שבגד בישו הנוצרי', או - 'פטריה שנמצאה על העץ ממנו הוכן הצלב לישו'. לאחרונה פורסם שבארצות המזרח, בהן מגדלים זן דומה, נכתב על קופסאות השימורים השם - 'אוזן היהודי' מה שגרם לתגובה חריפה כנגד האנטישמיות (מיסכן מי שתרגם בתמימות).",
    aznonitYehudaImg1: "© מירי א",
    aznonitYehudaImg2: "© רותי טלמור",
    aznonitYehudaText3:
      "נצפו פרטים מעניינים בגוון בהיר באותו מקום בו גדלה א.יהודה. יש לבדוק אם זו תופעת אלביניזם או תת-מין.",
    aznonitYehudaImg3: "© א. כהן",
    amanitas: "אמנית - Amanita ",
    amanitasText2: "משפחת האמניתיים - Amanitaceae",
    amanitasText3: "בעבר היו מינים חסרי טבעת שקיבלו שם סוג נפרד – Amanitopsis.",
    amanitasText4:
      "לסוג אמנית יש חשיבות רבה בעולם הפטריות. מגוון המינים גדול כולל מינים רעילים ומסוכנים, מינים אכילים ומינים לשימוש רפואי.",
    amanitasText5:
      "האמניתות יפות וגדולות, רובן בצבע לבן ויש מעט מינים צבעוניים. חלקן דומות למינים בסוגים מטרנית ופקועה ולכן הזיהוי חשוב ביותר.",
    amanitasText6:
      "המבנה (של כל המינים בסוג) – פטריית דפים, בשרנית, הכובע בקוטר 5-20 ס''מ, גוף הפרי בוקע מהקרקע עטוף ב'צעיף' ותוך יום-יומיים עולה מעלה. הצעיף נקרע באופן שונה בכל מין  ומהווה סימן לזיהוי:",
    amanitasText6Bullet1: "•	נשאר קרום בבסיס הרגל, המכונה נרתיק.",
    amanitasText6Bullet2:
      "•	נשאר קרום סביב החלק העליון של הרגל המכונה טבעת, צרה או רחבה.",
    amanitasText6Bullet3: "•	נשארים שרידים על פני הכיפה או שרידים בשולי הכיפה.",
    amanitasText7:
      "הרעלים בגוף הפטרייה הם אמניתין ופאלואידין שאינם ניכרים בצבע, בטעם או בריח ולכן הסיכון משמעותי אם טועים בזיהוי.",
    amanitasText8:
      "שימו לב ! היו מקרים בארץ שמלקטים לא בדקו סמן חשוב בבסיס הרגל, טעו ואכלו אמנית כוזבת במחשבה שהיא אמנית ביצתית, וסיימו באשפוז ארוך בבית החולים.",
    amanitasText9:
      "אודות רעילות – ראו נושא במדור 'מידע בעולם הפטריות' באתר זה.",
    amanitasText10: "יערן בקק'ל הורעל - טקסט להורדה",
    amanitasText11:
      "את כל המינים והסימנים המבדילים כתבנו בקיצור בטבלת אקסל המצורפת כאן בקישור:",
    amanitasImg1: "© אמניתת הנרתיק. ברוריה גל",
    amanitasImg2: "© בבדיקה – אמנית אצטרובלית. ברוריה גל",
    amanitasImg3: "© אמנית ביצתית. אראלה הרי",
    amanitasImg4: "© אמנית המוות. איילת שוסטר",
    amanitasImg5: "© אמנית חדודה. ניצן אלסר",
    amanitasImg6: "© אמנית כוזבת. עירית צוק",
    amanitasImg7: "© אמנית מנומרת. בר סונין",
    amanitasImg8: "© אמנית מקושטת. ניצן אלסר",
    amanitasImg9: "© אמנית קשקשית. אור בן דור",
    amanitasImg10: "© אמניתת האביב. ברוריה גל",
    orania: "אורנייה - Suillus",
    oraniaText0: "שייכת למשפחת האורניתיים - Suillaceae.",
    oraniaText1:
      "הסוג אורנייה נחשב הנפוץ והידוע ביותר בישראל. בתקופת המנדט הבריטי ניטעו שטחים נרחבים בכל הארץ במיני אורן שהותאמו לקרקעות ולמזג האויר.",
    oraniaText2:
      "כל הסוג חי במיקוריזה (שותפות שורש פטרייה) ולא נמצא אותה בסוגי עצים אחרים. העץ מספק לה חומרי מזון והיא עוזרת לו באמצאות אינזימים יחודיים לקלוט מים ומינרלים ולחדור טוב יותר לקרקע.",
    oraniaText3:
      "במאגרי המידע בארץ לא הודגש מין העץ לידו נמצאה הפטרייה ולכן לא ידוע באילו מהם יש יותר או פחות אורניות.",
    oraniaText4:
      "התפטיר של הארנייה גדל בעיקר על קצות השורש, מכאן שנמצא גופי פרי במרחק רב מהגזע. אורן ירושלים בעל שורשים שטחיים, עד 20 מטרים אורכם, ואורן הצנובר (הסלע) בעל שורש שיפודי.",
    oraniaText5:
      "בארץ ידועים מספר מינים של אורנייה, מה שלא ידענו בעבר, וכולם כונו בשם ארנייה מצויה. עד היום מהווה שיא בסלי המלקטים ממנה למאכל.",
    oraniaText6:
      " לצורך זיהוי המין יש לבדוק: צבע הבשר, צבע התפטיר (בעקירה מבוקרת), פספוס או ניקוד על הרגל, גוון הכובע, השוליים ואופן קילוף קליפתו. הריח מאוד אופייני.",
    oraniaText7Bold: "ארנייה מצויה – Suillus granulatus",
    oraniaText7:
      "ניכרת בפספוס העדין על פני הרגל, בגוון החום-צהוב של הכפה ובבשר הצהוב (נראה בחתך). יש מיקולוגים הטוענים שיש לה תת-מין-ארנייה ים תיכונית S.mediterraneensis ויש שהפרידו ביניהן. ההבדל קשה לזהוי.",
    oraniaImg1: "© יהודה מרטה",
    oraniaText8Bold: "אורנייה קמורה - Suillus collinitus",
    oraniaText8: "צבע הכפה חום כהה, הרגל חסרת פספוס, הקליפה מתקלפת בקושי.",
    oraniaImg2: "© ברוריה גל",
    oraniaText9Bold: "אורניית בליני - Suillus bellini",
    oraniaText9:
      "גוון הכובע  בהיר יחסית ושוליו לבנים. בחתך נראה שהבשר בהיר מאוד.",
    oraniaImg3: "© ברוריה גל",
    gvionit: "גביעונית – Cantharellus",
    gvionitText0: "שייכת למשפחת הגביעוניתיים - Cantharellaceae.",
    gvionitText1:
      "הגביעונית שייכת לפטריות הנאדית - Ascomycotina אע''פ שנראית כפטריית כובע עם דפים. שמה העממי – שנטרל, ממקור השם המדעי.",
    gvionitText2:
      "נחשבת כאחת היוקרתיות ביותר מבין הפטריות הידועות כמעדן גסטרונומי, ולרוב נמכרת לאחר ייבוש. הכינוי שלה - ''פטריית היהודים'' מהסיבה שאין בה חשש כשרות כי נקייה מחרקים בזכות חומר דוחה שמצוי ברקמותיה.",
    gvionitText21: "בישראל ידוע המין ",
    gvionitText22Bold: "גביעונית נאכלת  - Cantharellus cibarius.",
    gvionitText23:
      " דמויית משפך ומעין דפים (דף כוזב) גולשים לכל אורכה עד הבסיס. השוליים העליונים גליים או מקומטים, בלתי סימטריים. כל גוף הפרי בצבע צהוב, מחלמון ועד בהיר, תלוי בקרקע ובלחות, גדלה בקבוצות צפופות. הריח בעל ארומה של פרי מתוק והטעם חריפי במעט. צבע הנבגים שניכר בהדפס על גבי נייר לבן – הנו קרם-צהבהב, כזה גם צבע הבשר.",
    gvionitText4:
      "כמו בסוגים כמהה וגמצוץ, גם אותה מנסים במעבדות רבות להרבות ולתרבת. במחקר כימי נמצא בגביעונית חומר המונע פגיעה מחרקים, תכונה שמשמחת את הסוחרים והאוכלים.",
    gvionitText5:
      "בית הגידול של הגביעונית ביערות צפופים של עצים רחבי-עלים מכמה סוגים, בתנאי לחות גבוהה. בישראל נחשבת נדירה וידועה בין עצי אלון מצוי בצפון. יש מלקטים שמשקיעים שעות רבות למצאה. בעונה רווית גשמים, כמו חרף 2015 ו 2024, נאספו כמויות גדולות מהממצע.",
    gvionitText6:
      "עד כה הוגדר בארץ רק מין אחד בסוג ואולי מין נוסף שלא נבדק. באירופה יש שבעה, צהובות ושחורות. קיימים מינים דומים לה ולכן יש להיזהר בליקוט למאכל. אצלנו טבורית הזית הרעילה מטעה במראה.",
    gvionitImg1: "© ברוריה גל",
    gvionitImg2: "© ניצן אלסר",
    gidmit: "גידמית – Gymnopilus – (Flamula)",
    gidmitText1: "שייכת למשפחת האבנטיתיים – Strophariaceae",
    gidmitText2:
      "השם מבהיר את המקום עליו צומחת, גדמים של עצים ושורשים עבים שמתחת לפני הקרקע. פטרייה מרשימה בצבעה הצהוב עז גדלה על גדמי עצים, בארץ בעיקר על אקליפטוס.",
    gidmitText3Bold: "גדמית הדורה – Gymnopilus junonius",
    gidmitText4:
      "גודלה מגיע עד 30 ס''מ. צבע הכפה הרגל והדפים צהוב. נבדלת מגדמית חודרנית  בהופעת טבעת על הרגל. מכילה חומר נרקוטי בשם Neurotoxic oligoisoprenoid gymnopilin.",
    gidmitImg1: "© על אקליפטוס, צילם יאיר אור.",
    gidmitText5Bold: "גדמית חודרנית – Gymnopilus sapineus",
    gidmitText6: "צומחת מתוך גדמים, בעיקר מאקליפטוס.",
    gidmitImg2: "© דן רוסק",
    gidmitImg3: "© יאיר אור",
    gidmitImg4: "© רותי טלמור",
    gidmitText7: "שני מינים נצפו וצולמו בארץ ובקרוב יבדק הזהוי הנכון:",
    gidmitText8Bold: "גידמית  הקוקוס",
    gidmitText9:
      "נתגלתה בתוך חממות ועציצים בהם המצע מיובא מהמזרח ומכיל שבבי קוקוס. נמצאו גם פרטים בגינון, ליד עצים, ובבדיקה יסודית הסתבר שהשתילים הגיעו ממשתלות בדליים שהכילו מצע קנוי. בפטריות שאספנו היו כנראה שני מינים דומים או תת-מינים.",
    gidmitImg5: "© ברוריה גל",
    gidmitText10Bold: "גידמית ארגמנית",
    gidmitText11: "נצפתה במרכז הארץ ליד אקליפטוסים.",
    gidmitVelehavitText5:
      "דומה ללהבית, קוטר כובע גדול יותר, צבעו כתום עז, משתנה בהתאם ללחות. נאספו בארץ פרטים בגודל רב ועצום –ראה תמונה. הדפים צהובים ומכהים בהבשלה, הנבגים בצבע חלודה. הרגל בצבע מעט חיוור מהכובע. צומחת על גדמי עצים, בארץ - בעיקר על איקליפטוס. הסוג אינו נפוץ.",
    gidmitVelehavitText6: "בארץ ידועים שני מינים:",
    gidmitVelehavitText6Bullet1Bold: "הדורה – G.spectabilis",
    gidmitVelehavitText6Bullet1:
      " – ידועה  גם ממיני עצים נוספים. נבדלת בהופעת טבעת על הרגל.",
    gidmitVelehavitText6Bullet2Bold: "חודרנית – G.penetrans",
    gidmitVelehavitText6Bullet2:
      " – נבדלת מגידמית הדורה בהעדר טבעת על הרגל. ראה כתבה ''אחו בנימינה''.",
    gidmitVelehavitTextImg1: "© רותי טלמור",
    gidmitVelehavitTextImg2: "© יאיר אור",
    gidmitVelehavitTextImg3: "© דליה בונס",
    gidmitVelehavitTextImg4: "© יאיר אור",
    gamtzuz: "גמצוץ חרוטי",
    gamtzuzText1:
      "במרץ 2009 נתגלו עשרות גמצוצים במחצבה ישנה בדרום. מקום זה שימש בעבר כמטווח ועבר שריפה. עובדה זו מעניינת משום שמין זה גדל ומתפתח לאחר שהנבגים עברו חום רב.",
    gamtzuzText2:
      "מאז, במשך החורפים עד 2016 לא הופיעו גמצוצים בכלל. נחכה בסבלנות לראות מה יקרה בחורפים הבאים.",
    largeWhiteMushrooms: "סוגי פטריות לבנות גדולות",
    largeWhiteMushroomsText1: "למשפחת",
    largeWhiteMushroomsText1Bold: " הפקועתיים - Agariceae ",
    largeWhiteMushroomsText12Bold:
      "מפטריות הכובע, שייכים סוגים בעלי דפים לבנים הדומים למדי וקשים לזיהוי על פי מראה.",
    largeWhiteMushroomsText2:
      "לאחרונה המשפחה נחקרה בעולם, נבדק ד.נ.א וחלו שינויים בטקסונומיה (לדוגמא -  בארץ הכרנו את מטריינית האגוזים שעתה עלינו להתרגל לשם לבקנית האגוזים).",
    largeWhiteMushroomsText3:
      "אציג מספר סוגים (ללא פרוט המינים) עם הסימנים המורפולוגיים שיעזרו לנו למיין ולזהות. לא כללתי את הסוגים אזנית פקועה ואמנית, שיקבלו כתבות נפרדות. חשוב לדעת שבדיקת מעבדה חיונית לזיהוי בטוח.",
    largeWhiteMushroomsText4Bold: "מטריינית – Lepiota ",
    largeWhiteMushroomsText4:
      " - מגוון המינים בסוג מגיע בארץ, ליותר מעשרה, עם צבע כיפה לבן, אדמדם ועד חום בהיר. חלק או עם קשקשים, הגודל מקטן ועד גדול. הרגל מרכזית, עם טבעת צרה, רחבה, נושרת או חסרה. לחלק יש לאורכה מעין פתיתים. הסוג כולל מינים רעילים וגם ממיתים ! לעומת ערבים למאכל – סיבה להיזהר מאוד בזיהוי ולא ללקט למאכל.",
    largeWhiteMushroomsText5Bold: "ירוקת הדפים - Chlorophyllum",
    largeWhiteMushroomsText5:
      " - הופרדה מהסוג מטריינית. נבדלת בהבשלה בצבע הנבגים הירקרק. פטרייה רעילה הגדלה בעיקר על דשאים מושקים בעונת הקיץ.",
    largeWhiteMushroomsText6Bold: "מטרנית - Macrolepiota",
    largeWhiteMushroomsText6:
      " - מספר המינים בארץ לפחות חמישה ועוד תתי-מין קשים לזיהוי. הפטריות גדולות עם גוונים וכתמים בכיפה, עם או בלי פיטם. רגל גבוהה עם טבעת ניכרת והתעבות בבסיס .הנבגים בצבע לבן עד ורדרד.",
    largeWhiteMushroomsText7Bold: "לבקנית –Leucoagaricus",
    largeWhiteMushroomsText7:
      " - בעבר נכללה בסוג מטריינית. 2 מינים בארץ. הטבעת ניכרת, צרה עד רחבה במינים השונים. צבע הנבגים לבן עד ורדרד.",
    largeWhiteMushroomsText8Bold: "ליבנית – Leucoprinus",
    largeWhiteMushroomsText8:
      " - בארץ ידועים יותר מחמישה מינים ואחת - ליבנית בירנבאום – ''עציצית'' למעשה אינה בטבע בארצנו.",
    largeWhiteMushroomsText9Bold: "סידית – Limacella",
    largeWhiteMushroomsText9:
      " - מאוד דומה לנ''ל , שייכת לאותה סידרה אך קרובת משפחה לאמנית. הכפה בגוון חום-אפרפר. הרגל דקה עם טבעת צרה- בינונית. הכרנו מין אחד רק בשנים האחרונות.",
    largeWhiteMushroomsText10Bold: "*בנוסף – הסוג משפכנית – Clitocybe",
    largeWhiteMushroomsText10:
      " - פטריות לבנות, מינים גדולים וגם קטנים, ראה כתבה נפרדת.",
    largeWhiteMushroomsImg1: "© סידית – Limasella. עפרי סגלי",
    largeWhiteMushroomsImg2: "© סידית - Limacella .וילבאוט",
    largeWhiteMushroomsImg3: "© מטרנית – Macrolepiota. יובל פורת",
    largeWhiteMushroomsImg4: "© מטרנית-Macrolepiota .רפי מלכה",
    largeWhiteMushroomsImg5:
      "© לבקנית האגוזים – Leucoagaricus naucinus .ברוריה גל",
    largeWhiteMushroomsImg6: "© לבקנית ב.מ Leucoagaricus sp .ברוריה גל",
    largeWhiteMushroomsImg7:
      "לסיכום - סידית או לבקנית ? גוון הכפה שונה, האם זה סימן להחליט סוג?",
    yafanit: "יפענית - Terena",
    yafanitBlue: "יפענית כחולה - Terena caerulea",
    yafanitFamily: "משפ' הקרומיתיים, סדרת פט' עציות.",
    yafanitText1:
      "כשהראש כפוף מטה והעיניים מחפשות בקרקע, לעיתים ניתן לראות כתמי צבע כאילו נשפכו למישהו ביער. לא רגל, לא כובע, אלא קרום עם פתיתים צבעוניים. כן, גם זו פטריה.",
    yafanitText2:
      "על הר מירון, בשולי החורש, נגלה לנו צבע סגול עז על ענף זרוק ויבש. במבט מקרוב תוך גרוד הקרום הצבעוני ובעזרת זכוכית מגדלת, ראינו את ההינומית (שכבה הנושאת נבגים) עם תאי הבסיסה המכילים נבגים (הם ייראו רק מבעד לעדשת המיקרוסקופ).",
    yafanitImg1: "© ברוריה גל",
    kumtit: "כומתית - Galerina",
    kumtitText0: "שייכת למשפחת ההינומתיים - Cortinariaceae.",
    kumtitText1:
      " הכומתית ידועה לשימצה בגלל הרעילות הפוגעת בכבד ובכליות וללא טיפול מהיר נגרם מוות.",
    kumtitText2:
      "צבע הכובע כקינמון ובהתאם ללחות גם כתום וצורתו כיפתית. המין שבתמונה נראה עם רגל מקושטת בפספוס בהיר לאורכה.",
    kumtitText3:
      "בית הגידול הוא שטח ביצתי עם כבול וטחבים, מה שאצלנו לא מצוי ביותר, אלא בפינות לחות במיוחד כמו בין טחבים. בארץ ידועים שני מינים בסוג, וכנראה יש נוספים שטרם נבדקו גנטית (2023).",
    kumtitBold1: "כ. חלולת רגל - G.heterocystis",
    kumtitText4:
      "כובע קמור בצבע כתום, עם פיטם זעיר, קוטרו עד 3 ס''מ. הרגל דקיקה עם פתיתים",
    kumtitBold2: "כ. טחבית - G.mniophila",
    kumtitText5:
      "פחות מצויה, הגוון בהיר יותר מהשנייה. גדלה בשטח עשבוני לח ובין טחבים.",
    kumtitImg1: "© יהודה מרטה",
    kmehit: "כמהית אפריקנית / צחורה - Tirmania nivea",
    kmehitText1:
      "השם המדעי - החלף מספר פעמים .Tirmania Africana -1892. Terfezia pinoyi – 1906. T.p.maire – 1973 Tirmania nivea – 1973",
    kmehitText2:
      "השם העממי – בכל ארץ הכמהין נקראות שונה, אך מאותו מקור, והשם הלטיני נגזר מהמקומיים.",
    kmehitText3:
      "בישראל-כמהה, ברבים כמהין. במרוקו,אלג'יר וטוניס - טרפש. בעיראק- קימה. בכווית – פאגה. בארופה – טרפאל. בתורכיה – דומלאן.",
    kmehitText4:
      " תפוצה – ארצות צפון אפריקה, ערב הסעודית, עיראק, אירן, ישראל ושכנותיה.",
    kmehitText5:
      "חיה באקטומיקוריזה עם הצמח מהסוג שמשון Helianthemum ,בעיקר מהמין ש.יושב, ועוד מינים שנמצאים בבדיקה. באותו שטח כמו כמהת השמשון – Terfezia leonis",
    kmehitText6:
      "מקום-חיים – חולות באזורים מדבריים חשופים, עם בני-שיח רב שנתיים וצומח חד שנתי. בעולם כלולה ב'רשימה אדומה' (נדירה ומוגנת) בעיקר מהסיבה שאין עליה הרבה  פרסומים מדעיים, ולדעתי לא בגלל שנדירה בשטח.",
    kmehitText7:
      "תאור – הגדולה מבין הכמהין, מגיעה לקוטר עד15 ס''מ, צבע הבשר לבן עד צהבהב, בנויה מאונות בגדלים שונים. לעיתים קרובות נמצאת מעל פני הקרקע, להבדיל מכ. השמשון. נראית לעיתים כמו אבן. הריח והטעם פחות חזקים מהשניה.",
    kmehitText8:
      "בישראל – ידועה שנים רבות, פרופ' בנימיני כתב בספרו ואסף בנגב בשנות השישים, ובשנת 1980, לאחר צאת ספרו, חידש את המידע במאמר.",
    kmehitText9:
      "גדלה באזור חולות הנגב, היכן שגדל השמשון, בקו רוחב מדימונה עד רביבים, צאלים וגבול רצועת עזה. לכוון דרום עד ניצנה.",
    kmehitText10:
      " רביה – הפצת הנבגים נעשית ע''י בעלי חיים המריחים וחופרים לצורך מאכל, אין הפצה באוויר כמו בפטריות כובע ועילאיות. לכן איסוף הפטרייה בשלמותה, ע''י בני האדם מקטין מאוד את פוטנציאל הרבייה. ובנוסף, החפירה גורמת לחדירת יובש הפוגע במערכת השורשים של הצמח והתפטיר הצמוד אליהם.",
    kmehitImg1: "© ברוריה גל",
    behukit: "בהוקית – Ganoderma",
    behukitText1:
      "פטרייה השייכת לסדרת העציות, משפחת הנקבובניתיים וקבוצת פטריות מדף.",
    behukitText2:
      "הבהוקית הינה רב שנתית, גוף הפרי קשה הצומח באופן שטוח במאוזן על גזעי עצים מסוגים שונים. בכל שנה מתווספת בהיקף שכבה חדשה רכה ולבנה, בעלת נקבים קטנים בחלק התחתון  ובהמשך מתייבשת והצבע הופך לחום אדמדם או אפרפר. אבקת הנבגים בצבע חום.",
    behukitText3:
      "הבהוקית נחשבת ספרופיטית וגם פרזיטית. התפטיר מתפתח וניזון בתוך הרקמות הפנימיות של הגזע או השורש, עפר' בעץ חלש או מת של סוגי עצים שונים. גורמת לרקבון אט אט עד לנפילת העץ.",
    behukitText4: "הבהוקית מאוד נחשקת ע''י בני האדם לשימושים שונים:",
    behukitBullet1: "שימשה להסקה, מכאן מקור שמה – בהוקית.",
    behukitBullet2:
      "בארצות המזרח משמשת כחומר רפואי לאחר טחינתה לאבקה מהחלק היבש, לטיפולים שונים ומגוונים (לא אפרט כי איני מוסמכת לתת הנחיות בנושא). שמה המסחרי ריישי.",
    behukitBullet3:
      "במטבח - יש המבשלים את החומר העצי והקשה לקבלת נוזל בעל ארומה ייחודית.",
    behukitBullet4:
      "באומנות - כיון שנשמרת שנים רבות, אמנים חורטים עליה יצירות רבות על השכבה הבהירה.",
    behukitText5:
      "נפוצה וידועה בכל חלקי תבל (לא באנטרקטיקה ,כמובן) לאורך כל חדשי השנה.",
    behukitText6: "המינים הידועים בארץ:",
    behukitText7Bold: "בהוקית שטוחה – G.lupsiense (applanatum)",
    behukitText7:
      "הגודל תלוי במספר שנות חייה ומגיע עד לקוטר קיצוני של 100 ס''מ ! (באוסף המוזיאון בת.א יש לנו פרט בקוטר 75 ס''מ)",
    behukitText8Bold: "בהוקית מבריקה - G.lucidum",
    behukitText8:
      "קטנה, מבריקה ויפה יותר. החלק העליון יושב על מעין עמוד, שלא כמו השטוחה.",
    behukitText9Bold: "בהוקית אדמונית - Ganoderma mbrekobenum",
    behukitText9:
      "המין תואר בעולם בשנת 2016 ובישראל נמצא וזוהה לראשונה רק ב 2023 ע''י דליה בונס למרגלות עץ פיקוס. נלקחה דגימה ונבדקה במעבדה מולקולרית במוזאון הטבע. (ראה באתר במדור 'מה חדש' במאמר על פרסום מינים חדשים בישראל).",
    behukitText10:
      "מין זה אינו מתפתח על גזעים וענפים כמו המינים האחרים בסוג אלא על שרשים או חלקי גזע הקבורים בקרקע ואינם נראים לעיננו. *עד עתה צולמה פעמים רבות אך זיהו אותה כבהוקית מבריקה.",
    behukitText11:
      "קוטר גוף הפרי מופיע במידות שונות, הפרט שנאסף היה בקוטר 30 ס''מ. הצבע ערמוני ומופיע בקשתות מגוונות על פני הפטרייה השטוחה, במירקם מבריק כשעווה.",
    behukitText12:
      "כמו שאר המינים בסוג יש לה ערך רפואי והכינוי של כלם הוא 'ריישי'. ראה באתר בנושא 'ערך תזונתי ורפואי'. דומה מאוד ל Phaeolus schweinitzii. גדלה על הקרקע, יוצאת משורש העץ.",
    behukitImg1: "© בהוקית שטוחה, ענקית. עירית צוק",
    behukitImg2: "© בהוקית שטוחה בשלב גידול שכבה צעירה. דליה בונס",
    behukitImg3: "NANCY KORSLIN © ציור על בהוקית",
    behukitImg4: "© ניצן אלסר",
    behukitImg5: "© בהוקית מבריקה. מילנה ק.",
    behukitImg6: "© בהוקית מבריקה, דבורה שיצר",
    behukitImg7: "© דליה בונס",
    behukitImg8: "פרט צעיר",
    metzila: "מצילה- Cyathus",
    metzilaText2:
      "המתבונן מטה בעיניים פקוחות על היצורים הקטנים שבטבע, יגלה בעונת החורף 'פעמונים' קטנים המופיעים על ענפים נרקבים על פני קרקע היער, או בתוך עציצים שבביתנו.",
    metzilaText1: "שייכת לפטריות הכרס, משפחת הקניתיים - Nidulariaceae.",
    metzilaText3:
      "המצילה מופיעה בקבוצות צפופות, מתפתחת על קרקע עשירה בחומר אורגני, על גבעולים וענפים יבשים.",
    metzilaText4:
      "בתוך כל 'פעמון' גדלים כדורים קטנטנים הנראים כביצים בתוך ''קן של צפור'',וזה הכנוי שלה.",
    metzilaText5:
      "המצילה גדלה בקבוצות ללא רגל. ה'ביצים' צמודות לדופן ה'פעמון'. אלו מנבגים, בתוכם מתפתחים הנבגים, פיזורם נעשה ע'י טיפות הגשם המקפיצות אותם החוצה.",
    metzilaText6: "המינים בארצנו:",
    metzilaText7Bold: "Cyathus olla - מצילת גבעול",
    metzilaText8Bold: "Cyathus stercoreus - מצילת גללים",
    metzilaText8:
      " - פחות נפוצה. דומה לשנייה אך אינה פשוקת דפנות, גדלה גם על גללים.",
    metzilaImg1: "מצילת גללים",
    metzilaImg2: " © אמנון בוימל",
    levadit: "לבדית - xerocomus",
    levaditText1: "משפחת הגושיתיים - Boletaceae",
    levaditText2: "השם המדעי עבר שנוי טקסונומי במינים, אך השם העברי נשאר.",
    levaditText3:
      "הסוג מתאפיין במירקם לבדי של כיפת הכובע, ומכאן שמו. הלבדית דומה לגושית בת משפחתה, קטנה ממנה ונבדלת בספוג בו הנקבוביות גדולות ומצולעות. הרגל דקה בעובי אחיד לכל אורכה.",
    levaditText4:
      "רוב המינים צבעוניים בגווני אדום, כתום וצהוב. בשפשוף משתנה הצבע לכחול.",
    levaditText5: "*את שמות המינים ותיאורם פרטנו בטבלה המצורפת בקישור:",
    levaditImg1: "© פתחי הצנורות בלבדית. טלמור",
    levaditImg2: "© לבדית סילברי. אשוט",
    levaditImg3: "© לבדית אדמדמת. דליה בונס",
    levaditImg4: "© לבדית פלומתית. מונזה",
    levaditImg5: "© לבדית אלון. רותי טלמור",
    levaditImg6: "© לבדית אפרסקית. מונזה",
    levaditImg7: "© לבדית זהובת-בשר. ברוריה גל",
    lahit: "לחית – Hygrocybe + Chuphophyllus",
    lahitText0: "שייכת למשפחת הלחלחתיים - Hygrophoraceae.",
    lahitText1:
      "סוג זה הופרד מהסוג לחלחה – Hygrophorus וכולל מספר מינים בישראל. בחרתי להחליף את השם ללחית, שאושר גם ע''י האקדמיה ללשון העברית. לאחרונה, בעידן בדיקות D.N.A, קיבלו חלק מהסוג שמות חדשים ע''י מיקולוגים מוסמכים אך בעברית נשארו כמקודם.",
    lahitText3:
      "תרגום השם מאנגלית הוא ''כיפת שעווה''. באמריקה הכינוי – ''כובע המכשפה''.",
    lahitText4:
      "כל המינים צבעוניים ומרשימים בהופעתם בשדות ירוקים ולחים, ביוטופ שלרוב לא מצוי בארצנו. ראינו את כל המינים בביוטופ זהה.",
    lahitBulletTitle1: "לחית אחו – Hygrocybe pratensis",
    lahitBullet1: "פטרייה קטנה ונדירה שנצפתה וצולמה בדצמבר 2009 בקרני חיטים.",
    lahitBullet11:
      "מעט פרטים של סוג זה נצפו בארץ וככל שנוספים חובבים סקרנים, נוסף ידע למאגר הנתונים הישראלי.",
    lahitBullet12: "יש מיקולוגים ששייכו את הסוג לCophophyllus.",
    lahitBulletTitle2: "לחית חרוטית – Hygrocybe conicus",
    lahitBullet2:
      "הלחית גדלה בעשבייה בעלת לחות גבוהה ובקרחות יער של עצי אלון. בולטת בשטח וקלה להבחנה. בעבר לא הייתה מוכרת ונחשבה נדירה.",
    lahitBullet21:
      "הכובע חרוטי הנפתח עם הגיל, בגודל עד 10 ס''מ, צבעו כתום – אדום המשחיר עם התבגרותה, או במגע ושפשוף. במין יש תתי-מין גם בצבעים צהוב וכתום עז. הדפים צהבהבים, עבים ודלילים. הרגל עבה יחסית בצבע בהיר.",
    lahitBulletTitle3: "לחית חדת כפה – Agrocybe korandii",
    lahitBullet3: "המתאר - Haller Aar-1955",
    lahitBullet31:
      "במשך שנים זיהו אותה בארץ כווריאנט של לחית חרוטית. כיום הסתבר שהיא מין נפרד. (טרם פורסמה מדעית בישראל- 2013)",
    lahitBullet32: "צבעה צהוב והכובע חרוטי ומחודד בקצהו.",
    lahitBulletTitle4:
      "לחית צחורה –Chuphophyllus (Agrocybe) virgineus (niveus)",
    lahitBullet4: "כולה בצבע לבן. לאחרונה שם הסוג הופרד מהאחרות.",
    lahitImg1: "© עפרי סגלי",
    lahitImg2: "© יאיר אור",
    lahitImg3: "© דן רוסק",
    lahitImg4: "© ניצן אלסר",
    dafdefanit: "דפדפנית – Gloeophyllum",
    dafdefanitText1: "משפחת הדפדפניתיים",
    dafdefanitText2: "המתאר - Murrill 1908",
    dafdefanitText3: "*הוצע לשנות לדפופנית.",
    dafdefanitText4:
      "פטריית מדף קטנה חסרת רגל הצומחת בעיקר על ענפי וגזעי עצים מתים מעצים מחטניים. גורמת לפגיעה ורקבון חום. נחשבה בעבר לחלק ממשפחת הנקבוביתיים – Polyporales  והופרדה לסדרה ומשפחה משלה.",
    dafdefanitText5:
      "מבנה השכבה הפורייה נראה כדפים עם הסתעפויות, שונה מפטריות הכובע ונחשב 'דמוי דף'",
    dafdefanitText6: "בארץ ידועים 3 מינים:",
    dafdefanitBulletBold1: "דפדפנית המחטניים – G.abietinum",
    dafdefanitBullet1: "בעיקר על עצי אורן.",
    dafdefanitBullet12: "המתאר – Karst 1879",
    dafdefanitImg1: "© אראלה הרי",
    dafdefanitBulletBold2: "דפדפנית קרנית – G.trabeum",
    dafdefanitBullet2: "המתאר - Murrill 1908",
    dafdefanitBullet21: "פירוש שם המין = שייך לגדמי עצים.",
    dafdefanitBulletBold3: "דפדפנית המסוכות (גם משוכות) – G.sepiarium",
    dafdefanitBulletBold31: "המתאר - Karst 1882",
    dafdefanitBulletBold32:
      "טרם נבדקה ופורסמה בישראל - 3.2024. רשומה ברשימת Tura",
    dafdefanitBulletBold33: "פירוש sepia – צבע כהה, או גדר/מסוכה.",
    dafdefanitBulletBold34:
      "כוללת כמה תתי מין הנבדלים בעיקר בצבע. כמו הערמונית = G.s var subferrugineum.",
    dafdefanitBulletBold35:
      "הצבע בחלקה העליון בגווני חום-אדום והשוליים כתום-צהוב. מצויה באזורים יבשים יחסית לאחרות.",
    dafdefanitImg3:
      "הגדילו  התמונה ושימו לב למבנה המיוחד של הצד התחתון. אלו ' דמוי דף' בצורה יחודית, עליהם מתפתחים הנבגים. תמונה מלמעלה - ארנון ©. מלמטה - גוגל.",
    lohevet: "לוהבת טבורנית - ascomycotina",
    lohevetText1:
      "לאחר מספר שריפות בכרמל נמצאה פטריה כתומה ומרשימה בצורת כתמים קרומיים על פני הקרקע השרופה.",
    lohevetText2:
      "הלוהבת (תרגום שלנו לשם הלטיני) שייכת לתת-מערכת פטריות הנאדית -ascomycotina ,בעלות תא - אם היוצר את הנבגים ונראה כשקיק. היא ידועה בספרות בארצנו ממאמר של נמליך + אביזהר מ-1976 אז - לא קיבלה שם עברי. כדי להבין כיצד שורדת בשטח שעבר שריפה חשוב להבין שבטמפרטורה של 800 מעלות לערך - אין חדירת חום גבוה למתחת למספר סנטימטרים, והתפטיר אינו נפגע.",
    lohevetText3:
      "כנראה התפתחותה דווקא בקרקע שרופה נובעת מהחומרים שבאפר המשמשים לה מזון ראה הסבר נוסף במדור מידע מעולם הפטריות - ''לאחר שריפה''.",
    lohevetImg1: "לוהבת טבורנית",
    metzilat: "מצילת הגבעול - Cyathus olla",
    metzilatText1:
      "המתבונן מטה בעינים פקוחות, על היצורים הקטנים שבטבע, יגלה בעונת החורף 'פעמונים' קטנים המופיעים על ענפים נרקבים על פני קרקע היער, או בתוך עציצים שבביתנו.",
    metzilatText2:
      "בתוך כל 'פעמון' גדלים כדורים קטנטנים הנראים כביצים בתוך ''קן של צפור'', ולכן הכנוי.",
    metzilatText3:
      "הפטרייה שייכת לסדרת הקניתאים - Nidulariales שבפטריית הכרס - Gasteromycetes. גוף הרבייה צמוד לקליפות עץ או לכל חומר אורגני מת, כולל הכבול הקנוי, בו מגדלים צמחי-בית שונים.",
    metzilatText4:
      "המצילה גדלה בקבוצות ללא רגל, ה'ביצים' צמודות לדופן ה'פעמון'. אלו מנבגים, בתוכם מתפתחים הנבגים. פיזורם נעשה ע''י טיפות הגשם המקפיצות אותם החוצה.",
    metzilatImg1: "מצילת הגבעול",
    metzilatImg2: "© אמנון בוימל",
    niranit: "נירנית – Agrocybe / Cyclocybe",
    niranitText0: "משפחת האבנטיים Strophariaceae - ",
    niranitText1:
      "הסוג נירנית כולל מיני פטריות הצומחות על הקרקע, מכאן שם הסוג, וגם מינים על גזעים, בד''כ באזור נחלים. בארץ ידועים ארבעה מינים הגדלים בשדות, בשטחים פתוחים ומין נוסף על גזעי עצים.",
    niranitText2Bold: "נירנית קשתית – Agrocybe pediades",
    niranitText2:
      "קוטר הכובע עד 3 ס''מ, צבע הכפה צהוב אוקר ובמרכז כהה יותר. הקרום פרנכימטי. הדפים בצבע קינמון-חום. רגל בהירה מהכובע, לעיתים רואים טבעת צרה. בעלת התעבות קלה בבסיס.",
    niranitImg1: "ג. וילבוט ©",
    niranitText3Bold: "נירנית מוצקה (נוקשה) - Agrocybe dura / molesta",
    niranitText3:
      "כובע הפטרייה מגיע לקוטר 10 ס''מ, המבנה קמור עגלגל, צבעו לבן עד בז'. הדפים בגוון אפור חום. הרגל בהירה בעלת טבעת הנושרת במהרה. מופיעה מאוחר בעונה, בעשבייה שבשדות לחים ובגנים.",
    niranitText5Bold: "נירנית ערב – Agrocybe / Cyclocybe erebia",
    niranitText5:
      "שם המין ממקור יווני – כהה, מוצל. הכובע בצבע חום ומתבהר במצב של יובש, הכהה מבין מיני הנירניות. קוטרו עד 7 ס''מ. בהשפעת לחות מקבל הכובע גוון אדום – חום עמוק. הרגל נעשית צרה בבסיסה, עם גוון בהיר בחלקה העליון, וטבעת ניכרת בצבע לבן. גדלה ברקבובית העלים של שיחים ועצים נשירים. נדירה ונבדלת בצבע הכהה ובמבנה הנבג.",
    niranitText4Bold:
      "נירנית הצפצפה (גלילית) - Agrocybe / Cyclocybe cylindracea / aegerita",
    niranitText4:
      "נתגלתה לאחרונה על עץ צפצפה שחורה ומכאן שם המין. ידועה על עצים נוספים ממשפ' הערבה ועוד מעצים רחבי-עלים. יש לה מספר כינויים: פטריית הערמון, פיופיני ועוד. הרגל גדלה בקשת, כי יוצאת בצד הגזע ומתרוממת מעלה. בחלקה העליון, ניכרת בה טבעת צרה. הכפה מעוגלת וחלקה, בקוטר עד 15 ס''מ. בצעירותה הגוון בצבע דבש כהה ועם הגדילה מלבינה ובמרכז נשאר הגוון הכהה. מענינת העובדה שהיא שוחרת אור, כמו שראינו בעוד פטריות על גזעים.מתחת לכובע הדפים יושבים בצפיפות, בצעירותם הגוון בהיר ובהמשך ערמוני. באטליה ויוון תירבתו אותה והפיתוח עבר רחוק עד יפן. קיבלה את השם פיופינו pioppini וגם בארצנו החלו לגדלה ומשווקת בחנויות. טעמה חזק ומיוחד והריח ארומטי, בעלת ערך מזוני עשיר וגם ברפואה כל הומאופט ממליץ עליה.",
    niranitImg2: "יאיר אור ©",
    niranitImg6: "ברוריה גל ©",
    niranitImg4: "עירית צוק ©",
    nakvuvanit: "נקבובנית –Lentinus/Cerioporus / Polyporus",
    nakvuvanitText1: "שייכת למשפחת הנקבובניתיים – Polyporaceae.",
    nakvuvanitText2:
      "כריבוי מיקולוגים ומעבדות בעולם – כך ריבוי החלפת שמות מדעיים.",
    nakvuvanitText3:
      "הכובע שטוח ובצדו התחתון נקבים מצולעים שלא כמו בפטריות הספוגיות, כמו הארנייה, בה פתחי הצינורות נראים כנקבים מעוגלים. צומחות בדומה לפטריות מדף מאותה משפחה. ניזונות מחלקי עץ נרקבים.",
    nakvuvanitText4: "המינים בסוג:",
    nakvuvanitText5: "בישראל נצפו מינים נוספים בסוג שטרם נבדקו ופורסמו רישמית.",
    nakvuvanitText6Bold: "נקבובנית חרפית – Lentinus (Polyporus) brumaly",
    nakvuvanitText6:
      "השם המדעי הוחלף ועתה הסוג שייך לגמישנית (לא מובן לי מדוע) פטרייה קטנה, כ- 5 ס''מ קוטר, היוצאת מתוך חלקי עץ שבקרקע ומעליה. לעיתים קשה לנתקה מהקרקע מהסבה שמחוברת לחומר העצי שבתוכה. המרקם יבש וקשה.",
    nakvuvanitText7Bold: "נקבובנית קשקשית – Cerioporus (Polyporus) squamosus",
    nakvuvanitText7:
      "השם המדעי של הסוג מופיע בספרות בשני השמות. פטרייה גדולה, שטוחה, מחוברת בצורת מדף לגזע עץ עם בסיס-רגל קצר ועבה. גוון החלק העליון צהוב-חום. גדלה בעיקר על עצים רחבי-עלים שמצבם חלש.",
    nakvuvanitImg1: "עירית צוק ©",
    nakvuvanitImg2: "עירית צוק ©",
    nakvuvanitImg3: "ברוריה גל ©",
    nakvuvanitImg4: "ברוריה גל ©",
    nakvuvanitImg5: "Wikimedia (free)",
    sadanit: "סדנית - Podaix",
    sadanitText1: "בארץ מצוי מין יחיד",
    sadanitText2Bold: "סדנית מצויצת - Podaxis pistillaris",
    sadanitText2: "שייכת לפטריות הכרס, משפחת הפקועתיים - Agaricaceae.",
    sadanitText3:
      "נחשבת לפטרייה פרימיטיבית מהפקועתיים. בעבר שייכו אותה למשפחת האבקתיים או כמשפחה נפרדת. באנגלית מכנים אותה - Desert shagy mane.",
    sadanitText4:
      "גוף הרבייה חסר דפים ובנוי כמעין שקית מאורכת בגובה עד 20 ס''מ, בה מתפתחים הנבגים. המבנה נראה כחיקוי לפטריית שק עם מעטה השומר על הנבגים. יושבת על עמוד מעין רגל שבסיסה בולבוסי. המעטה בצבע לבן ושופע בקשקשים גסים. כמות הנבגים עצומה, צבעם שחור ומכאן שהשתמשו בפטרייה לצביעת בדים או שיער. במראה ראשון דומה לדיואית מצויצת.",
    sadanitText5:
      "ידועה בעיקר לאחר גשמים ושיטפונות בשטחים חוליים בנגב אך מופיעה גם בחולות בקרבת הים. בישובי הערבה מצויה בשדות חקלאיים מושקים.",
    sadanitText6:
      "בחיפושי אחר תצפיות וותיקות שלה, הופתעתי לגלותה באוסף המיקולוגי המיובש שבלונדון עם תווית משנת 1946שנאספה בחולות רביבים. (כן, הבריטים ששלטו בארץ עשו עבודת אספנות מרשימה).",
    sadanitImg1: "© מורי חן",
    sadanitImg2: "© מורי חן",
    sadanitImg3: "© מורי חן",
    sadanitImg4: "© בני שלמון",
    limonit: "עציצית למונית/לבקנית - Leucocoprinus flos-sulfuris / birnbaumii",
    limonitText1:
      "פטריה נחמדה זו 'נכנסה' לנו בשנים האחרונות, לבתים ולגינות וגרמה לסקרנות רבה. עשרות תצפיות דווחו לנו עד כה, ממשתלות ומעציצים של צמחי-בית, והשם/.כנוי שקבלה מבטא זאת היטב.",
    limonitText2:
      "היא איננה פטריית-בר בארצנו אלא מגיעה כיבוא סמוי מחו''ל בתוך הומוס – אדמת עציצים עשירה.",
    limonitText3:
      "רוב הפרטים שנצפו היו בחודשי הקיץ, בגוון לימוני-עז ופחות בגוון בז', שמהווים מופעים באותו מין.",
    limonitText4:
      "אם טיפלתם בעציץ בו צמחה הפטריה, כדאי שתעתיקו את הכתובת שעל השק ונדע מהיכן הגיעה, כנבג או תפטיר כמובן.",
    patara: "פטרה – Atheniella + Hemimycena+ Mycena",
    pataraText1: "משפחת Mycenaceae",
    pataraText2:
      "משפחה מפטריות הכובע רבת סוגים ומינים. שם הסוג פוצל לאחרונה לכמה סוגים בשם שונה אך בעברית נשאר המקור.",
    pataraText3:
      "הכובע חרוטי או כיפתי מעוגל. צבע המינים מבז' עד ורדרד עם מעט ברק . דפים נוגעים ברגל. רגל דקה ושבירה. בסוג יש מינים רבים שחלקם דומים והזיהוי קשה.",
    pataraText4Bold: "פ. האצטרובל - M.seynii",
    pataraText4:
      "הכובע חרוטי- עגלגל, דפים דלילים, צבע אוקר- ורדרד, בדומה לפטרה ריחנית-ורדרדה. תמיד מתפתחת באצטרובל, יש לבדוק גם אם טמון מתחת לפני הקרקע. במצב ללא קשר לאצטרובל – נראית כפטרה ריחנית.",
    pataraImg1: "© רפי מלכה",
    pataraImg2: "© דן רוסק",
    pataraText5Bold: "פ. דממנית - M.haematopoda",
    pataraText5:
      "צבע הכובע אדום ייני עד חום. הדפים בהירים. בפציעת הרגל ניתן להבחין בטיפות נוזל אדום כדם. בבסיס הרגל ניכר חלק מהתפטיר הנראה כשורשונים. גדלה על גזעים וענפים כרותים. דומה לפ. ריחנית.",
    pataraImg3: "© רותי טלמור",
    pataraImg4: "© דן רוסק",
    pataraText6Bold: "פ. ריחנית - M.pura",
    pataraText6:
      "כובע ורדרד עד סגלגל, דפים דלילים בגוון הכובע. ריח של צנון בשפשוף. קיים תת מין נוסף - פ.ריחנית ורדרדה M.p.var rosea. המופיעה בספרות גם כמין נפרד. דומה מאוד לאחלמית, הגדולה ממנה, ולפטרת האיצטרובל.",
    pataraImg5: "© ברוריה גל",
    pataraImg6: "© ברוריה גל",
    pataraText7Bold: "פ. אפרורית - M.cinerella",
    pataraText7:
      "פטרייה קטנה, הכובע כ 1.5 ס''מ, כיפתי בצבע אפור-חום עם שוליים בהירים יותר ומפוספסים. הדפים לבנים. גדלה על עלים שנשרו.",
    pataraImg7: "© אראלה הרי",
    pataraText8Bold: "פ. שורשית - M.niveipes ",
    pataraText8:
      " הכובע קמור/פעמוני בצעירותו ונפתח מעט בהמשך. הצבע לבן אפרפר עם מרכז מעט כהה ופסים ניכרים לאורכו. רוחב הכובע מגיע עד 7 ס''מ. הדפים עבים ודלילים בצבע לבן עד אפרפר. הרגל באורך כמו קוטר הכובע, עם בסיס דק במיוחד הנראה כשורש (מכאן שמה). נחשבת נדירה, מופיעה לרוב על גזעים כרותים.",
    pataraImg8: "© ענבל הלל",
    pataraText9Bold: "פ. חרפית - M.hiemalis",
    pataraText9:
      "פטרייה קטנטנה הכובע כחצי ס''מ, צבעו בז' בעל שוליים מפוספסים. גדלה על גזעי עצים.",
    pataraImg9: "© אישי טלמון",
    pataraText10Bold: "פ. חלבית - Mycena/Hemimycena lactea",
    pataraText10: " פטרייה קטנטנה, כ 1 ס''מ, בצבע לבן. גדלה על מחטי אורן.",
    pataraImg10: "© יהודה מרטה",
    pataraText11Bold: "פ. מלבינה - M.mucor",
    pataraText11:
      "פטרייה קטנטנה כ 3 מ''מ, גוונית מלבן ועד חום, גדלה על עלים וחלקי עץ.",
    pataraImg11: "© יהודה מרטה",
    pataraText12Bold: "מינים נוספים",
    pataraText12:
      "קטנות וזעירות בצבעי לבן, בז' עד כתמתם. גדלות על גזעי עצים, עלים ומחטים שנשרו, ואצטרובלים. פ.נימית M.capillaripes ,פ.שברירית M.vitrea/sepia, פ.לבנבנה Mycena /Atheniella flavoalba, פ.לבנה M.alba, פ.אלקלית M.alcalina .פ.מתקלפת M.epipterygia. נצפתה וטרם נבדקה (3.2024) – M. acicula פטרה מחטנית, בצבע כתום.",
    patririot: "פטריריות",
    patririotText1:
      "אורגניזמים קטנטנים, גדלים על עצים או עלים נרקבים, האם הם בעלי חיים, צמחים או פטריות? האם זו הפרשה או קיא של בע'ח, האם רוק של אדם או קצף של חרקים? שאלה זו מטרידה את הההולכים ביער עם עינים סקרניות הסוקרות את המצוי על הקרקע, וגם את הבוטנאים והמיקולוגים.",
    patririotText2:
      "גוש ריר פלזמטי צמוד לענף נרקב,כך נראה השלב הראשוני של ה'יצור המוזר ' שמהווה את גופה של ה'פטרירית'. בהשוואה לגוף הפטריה המכונה תפטיר- הריר נקרא פלסמודיון ואינו בנוי מקורים של תאים עם דופן. הוא נע על פני המצע הרטוב, סופג מזון נוזלי וגם חלקיקים מוצקים בדומה לבע''ח ירודים כמו אמבות למשל.",
    patririotText3:
      " בשלב הבא שבהתפתחותו, יופיעו אברי הרביה - המינבגים, בצורת אשכולות ובצבעים שונים. כדורונים, עם או בלי עמודונים, בצורות יפיפיות כנרות צבעוניים, כסיכות תפירה או חרוזים. הנבגים יפוצו כפי שקורה בצמחים ירודים, טחבים שרכים או פטריות כדי לבדוק ולהתרשם - יש להצטייד בזכוכית מגדלת פי 10 לפחות.",
    patririotText4:
      "בעבר היו ששייכו קבוצה חריגה זו לחד-תאיים וכינוהה ''בעלי חיים דמויי צמחים'' - פרוטוזואה, ואחרים שייכוה למערכת המיקסומיקוטה, למחלקת המיקסומיסטס - פטריריות. כיום יש שמשייכים אותה לקבוצה בפני עצמה - slime molds - ''עובש רירי'' או ''מיקטוזואה'' שפרושה - שילוב בין המילה פטריה ביוונית = מיקו, וזואה = ניידות.",
    patririotText5:
      "קבוצה זו גרמה חודשים רבים ב 2012 לוויכוחים בעיתונות, עת פורסם המאמר ב'כלכליסט' בשם ''מה פטריות חושבות'' על שום תנועתן לכוון חומרים כימיים מסוימים, כדוגמת 'בועתית רב קודקודית' - Physarum polycephalum.",
    patririotText6:
      "הספר המיוחד לקבוצה ,''הפטריריות בישראל'' מ- 1992, של פרופ' ניסן  בנימיני מונה 70 מינים מ-21 סוגים שהוגדרו בארצנו, (שויכו אז לפטריות) וניתנו להם שמות עבריים. ",
    patririotImg1: "נולית שחומה בהגדלה",
    patririotImg2: "© gilbert",
    patririotImg3: "© gilbert",
    pinit: "פינית - Phallus",
    pinitText1: "שייכת למשפחת הפיניתיים - Phallaceae.",
    pinitText2: "בישראל הסוג כולל שלושה מינים:",
    pinitText3Bold: "פינית מבאישה – P. impodicus",
    pinitText4:
      "תחילת חייה ככדור לבן המציץ עם פני הקרקע או שקוע בתוכה, במרקם ג'לטיני עם קרום עבה היושב על מעין שורשון דק. כעבור זמן קצר 'בוקעת הביצה' ומזדקר ממנה עמוד עבה בגבה עד 8 סמ' שבראשו חרוט מרושת גומות גומות שראשו  שטוח וצבעו בהיר המשתנה לשחור. נפוצה ומופיעה בבודדים או בקבוצות בקרקע עשירה בחומר אורגני בבתי גידול שונים. הפטרייה נודעת בתופעת הסירחון העז והמבאיש המופץ ממהנה בעת ההבשלה. תפקידו בטבע למשוך חרקים המגיעים ללקק מה'פגר'. מעניין שעל אף שמה מלקטים נוהגים לאסוף מה 'ביצים' לאכילה.",
    pinitText5: "באנגלית שמה Stinkhorn.",
    pinitImg1: "© יהודה מרטה",
    pinitImg2: "© חתך בביצה. עירית צוק",
    pinitImg3: "© זבובים אורחים. ג'אק פיליפ",
    pinitText5Bold: "פינית ורודה ¬ P.hadriani",
    pinitText6:
      "מאוד דומה למבאישה אך פחות נפוצה. נבדלת בצבע הוורוד של קרום הביצה והריח פחות חזק.",
    pinitImg4: "© שרה סילברט",
    pinitText7Bold: "פינית מרושתת",
    pinitText8:
      "נצפתה בגליל ובגולן וטרם נבדקה גנטית. כנראה Phallus impdicus var togatus.",
    pinitImg5: "© עמית אבן עזרא",
    pinitText9Bold: "פינית כומתית - Itajahya / phallus galericulata",
    pinitText10:
      "פטרייה דומה למינים המוכרים בסוג, נבדלת בחלק העליון של גוף הפרי.",
    pinitText11:
      "מתחילה כביצה בקוטר 3 ס''מ ומתפתחת לעמוד עד גבה של 8 ס''מ. בקצה העליון ניכרת הרקמה הפורייה glebba - בצבע שחור עם משטח לבן בראשה, מעין כומתה. נגלתה ונאספה לראשונה, בשטח עשבוני פתוח בת.א ע''י סטודנט מחו''ל שהכיר אותה מהודו. ידועה בעולם מאזורים חמים ויבשים יותר מהמינים האחרים.",
    pinitText12: "נבדקה וזוהתה גנטית במוזיאון לטבע באוניברסיטת ת.א.",
    pinitImg6: "© Inaturalist",
    pinitVekishurit: "פינית וכישורית",
    pinitVekishuritText1:
      "משפחת הפיניתיים -Phallaceae, שייכת לפ' הכרס - Gasteromycetes, כוללת סוגים בעלי תופעה מעניינת בה הפטרייה בוקעת מ''ביצה''.",
    pinitVekishuritText2Bold:
      "פינית מבאישה Phallus impodicus ו- כישורית מרושתת udinosusColus hir",
    pinitVekishuritText3:
      "בשלב ראשוני מתפתחת מהתפטיר מעין ביצה או כדור ג'לטיני לבן מתחת לפני הקרקע, בעל פתילים הנראים כשורשים. תוך זמן קצר נבקעת הביצה ועולה מעין עמוד ובקצהו חרוט עם שקעים.",
    pinitVekishuritText4:
      "בפינית העמוד נראה כרגל גבוהה ובכישורית עולים מספר זרועות אדומות. החלק העליון עשוי משקעים וגומות ובתוכם בעת ההבשלה מתפתחים הנבגים הטבולים בריר כהה שריחו מצחין מאוד. הריח נועד למשוך חרקים שידאגו להפצת המין. בסוג פינית יש בארץ מין נוסף - ",
    pinitVekishuritText4Bold: "פינית ורדה -Phallus hadriani",
    pinitVekishuritText5: "השמות נקבעו על פי הצורה האופיינית לפטריות אלה.",
    pinitVekishuritImg1: "פינית מבאישה © יורם ג",
    pinitVekishuritImg2: "כישורית מרושתת © ב.ג",
    pinitVekishuritImg3: "ביצי פינית © ב.ג",
    pkua: "פקועה - Agaricus",
    pkuaText1: "משפחת הפקועתיים - Agaricaceae.",
    pkuaText2:
      "המשפחה עשירה ביותר בסוגים ומינים השייכים לפטריות בעלות דפים. ההיסטוריה המשפחתית קשורה בקשר הדוק לאדם. עשרות שנים למדו, חקרו וגידלו מינים ממנה בנסיון לפתח זנים איכותיים הטובים למאכל. אכן נוצרו ונוצרים מינים וזנים חדשים השונים בצורה, גודל וטעם, על פי ההעדפה הקולינרית. הפקועות בעלות תכונות מוצלחות כמו גודל, בשרניות, עמידות בחיי מדף, טעמים, הסתגלות לחיים בבתי גידול שונים ומגוונים, הופעה במספרים גדולים ועוד.",
    pkuaText3:
      "ערך מיוחד יש למין פקועה דו-נבגית ממנה טיפח האדם את המינים ה'תרבותיים' שמפיניון ופוטובלו המצויים על כל מדפי החנויות.",
    pkuaText4:
      "מבנה כל המינים בסוג הינו דומה: פטרייה גדולה, בינונים או קטנה. 3-12 ס''מ, עבה ובשרנית הן הכובע והן הרגל. הכובע קמור ומתיישר בבגרותו, הכפה במירקם משיי, חלק או קשקשי. הדפים בצבע וורוד בצעירותם, משחימים ומשחירים בבגרותם והנבגים שחורים. הרגל עבה, קצרה או ארוכה, ישרה או מתעבה בבסיס. שאריות הצעיף החלקי משאירים טבעת, רחבה או צרה, יציבה או נושרת, בחלק הרגל העליון או באמצע.",
    pkuaText5:
      "סימן זיהוי חשוב הוא שנוי צבע כאשר נחתוך, נשפשף או נפצע את הרגל. מתקבלת תגובה של צבע צהוב, צבע אדום או שאין שנוי. לרוב הופעת הצהוב מעידה על רעלן ואסורה למאכל.",
    pkuaText6: "ריח הפטרייה שונה בין המינים, יש ריח אניס, שקדים, מרציפן ויוד.",
    pkuaText7:
      "בישראל ידועים כ 50 מינים בסוג אך ניתן לזהות בוודאות רק את בעלות הסימנים הניכרים ביותר. לחובבים מתחילים כדאי להימנע מאכילה של כל סוגי הפטריות הלבנות, גדולות כקטנות.",
    pkuaText8:
      "*לא נפרט כאן את כל עשרות המינים אלא את הנפוצים מביניהם והניתנים לזיהוי.",
    pkuaText9: "ראה בקישור - ",
    pkuaText10: "טבלת המינים.",
    pkuaImg1: "© פקועה הדורה. דליה בונס",
    pkuaImg2: "© פקועה מאדימה. סיון מבוא",
    pkuaImg3: "© פקועה בהטית. רפי מלכה",
    pkuaImg4: "© פקועה מצהיבה. עירית צוק",
    pkuaImg5: "© פקועה 'ברזילית'. ערן לוין",
    pkuaImg6: "© פקועה יערית. ברוריה גל",
    pkuaImg7: "© פקועת השדה. יהודה מרטה",
    pkuaImg8: "© פקועת ארנים. ברוריה גל",
    pkuaImg9: "© פקועה כפולת טבעת. מרטין",
    cordyceps: "פרזיטית על חרקים - Cordyceps",
    cordycepsText1:
      "בעולם הפטריות קיימת תופעה מוזרה ומעניינת -'פטריה גדלה בגוף נמלה'. הנבג נצמד, חודר דרך הטרכיאה (פתח נשימה בחרקים) ונובט על ראש הנמלה. בשלב הגידול בו מתפתח גוף הרביה - הפטריה חודרת למוח הנמלה, מפרישה כימיקלים הגורמים לנמלה לעלות לגובה הצמח, שם תנוח וכעבור 4-10 ימים תסיים חייה כשעל ראשה עמודונים נאים של הפטריה. פיזור הנבגים ייעשה בסביבה הקרובה ומחזור חדש יצמח על נמלים חדשות.",
    cordycepsText2:
      "סוג הפטריה - Cordyceps ובו כ- 400 מינים, הצומחים על פונדקאים שונים, מחרקים ועד פטריות ממינים אחרים. בתמונה המצורפת צילמתי בשווצריה Cordyceps capitata על מין של כמהה.",
    cordycepsText3:
      "קבוצת פטריות כזו נקראת אנטומופאגית ותפקידה בטבע להגביל את אוכלוסיות החרקים, מה שחשוב לחקור לצורך הדברה בחקלאות. גם דבורים וחרקים מועילים נפגעים מפטריות ובזאת נגרם נזק לכלכלת האדם.",
    cordycepsText4:
      "האתר קטן מלהכיל את כל המידע המעניין, לכן אציע למתעניינים לגלוש באינטרנט לשם הסוג, ולקרוא. מומלץ גם לראות את הסרטון המעניין של דיויד אטנבורו. מין מסוים שבסוג זה מכונה ''פטריית הזחל'' ומשמש לטפולים רפואיים רבים ומוצלחים. ראו כתבה של סילביה בלומנפלד, חברת מיקוליביה הישראלית, העוסקת בהכנת תוספי-מזון מפטריות. מומלץ להכנס לאתר שלהם, בשם החברה.",
    cordycepsText5:
      "תופעה נוספת של קשר בין פטריה וחרק, ידועה כ'גני-פטריות' בה הנמלים מעודדות גידול פטריות כדי להיעזר בעיכול. אחסוך תרגום רב כי יש הרבה חומר לקריאה באינטרנט, רובו באנגלית.",
    cordycepsImg1: "הפטרייה על חרק",
    cordycepsImg2: "© ברוריה גל",
    cordycepsImg3: "הפטרייה על עכביש",
    tznuma: "צנומה - Marasmius Gymnopus",
    tznumaText1: "משפחת הצנומתיים - Marasmiaceae.",
    tznumaText2:
      "שמה נובע מגודל הפטרייה. (יש הטוענים שהשם נחשב שם תואר ומציעים שם - צנימית). בעבר הוצע השם חלפית על פי העובדה שמחליפה מצב – ממצב יבש חוזרת למצב קודם לאחר הרטבה.",
    tznumaText3:
      "הצנומה שייכת לפטריות הדפים הקטנות והזעירות. קוטר הכובע מ 0.5 עד 5 ס''מ, והצבעים לבן, בז', חום, חום-אדמדם וחום בהיר. כיפת הכובע דקה וגמישה, חלקה, קמחית או מכוסה פלומה. בחלק מהמינים קיים פיטם במרכז. השוליים מפוספסים מעט או יותר. הדפים יושבים, דלילים בצבע לבן כמו גם צבע הנבגים. הרגל דקה, חלקה, קטיפתית או מכוסה בקשקשים. האורך יותר מקוטר הכובע. הצבעים ברגלי המינים בצנומה מהווים סימן מבדיל, כהה ובהיר והחלוקה ביניהם לאורך הרגל.",
    tznumaText4:
      "הצנומה גדלה על גבעולים, ענפים, גזעים, עלים או על קרקע עשבונית. הסוג דומה מאוד לסוג צנומית וגם את המינים שבסוג לא קל לזהות בוודאות.",
    tznumaText5:
      "בישראל ידועים 5 מינים: (לאחר בדיקות וזיהוי יתכנו מינים נוספים.)",
    tznumaText6Bold: "צנומה שומית – Marasnius scorodonius",
    tznumaText7:
      "מיוחדת בריח החזק של שום הבולט תוך שפשוף. הכובע בקוטר עד 4 ס'מ בצבע בהיר ובמרכז חום-אדמדם. בעל שוליים מעט מפוספסים. הרגל חלקה, מבריקה עם צבעי חום אדום בחלק התחתון ובהיר בעליון.",
    tznumaText8: "גדלה בקבוצות קטנות המחוברות בבסיסן בין עצים מחטניים.",
    tznumaImg1: "© יהודה מרטה",
    tznumaImg2: "© ברוריה גל",
    tznumaText9Bold: "צנומה עלווית - Marasmius epiphyllus",
    tznumaText10:
      "המבדיל אותה מהאחרות הוא הגודל הזעיר ומקום הגידול – על עלים של עצים רחבי עלים. הפטרייה זעירה, לבנה והכובע כיפתי בקוטר כ 1 ס''מ. הרגל דקיקה בגוון לבן למעלה ואדמדם בחלק התחתון.",
    tznumaImg3: "© גבי אדם",
    tznumaText11Bold: "צנומה מאוגדת - Marasmius cohaerens",
    tznumaText12:
      "הכובע קמור ונעשה שטוח, צבעו לבן עד קרם, מעט קימחי  והקוטר עד 4 ס''מ. הדפים חופשיים, דלילים וצבעם צהבהב. הרגל בצבע כהה בחלק התחתון ובהיר בעליון.",
    tznumaImg4: "© אראלה הרי",
    tznumaText13Bold: "צנומה כיפתית - Marasmius wynneae",
    tznumaText14:
      "השם המדעי נקבע על שמו של המתאר. קוטר הכובע עד 5 ס'מ בצבע לבן עד אפרפר, תלוי ביובש. השוליים מפוספסים והדפים דלילים בגוון אפרפר. הרגל קמחית, הצבע לבן בחלק העליון וחום צהבהב בתחתון.",
    tznumaText15: "גדלה בקבוצות בין עלי שלכת ביערות מעורבים.",
    tznumaImg5: "© אראלה הרי",
    tznumaText16Bold: "צנומה מוזרה - Marasmius anomalus",
    tznumaText17:
      "הכובע פעמוני בעל שוליים מפוספסים וצבעו בז' כתמתם. קוטר הכובע כ 1 ס''מ, הדפים דלילים מרווחים למדי בגוון קרם. הרגל בהירה למעלה וכהה למטה.",
    tznumaText18: "גדלה בשטחים עשבוניים.",
    tznumaImg6: "© יאיר אור",
    tznumaText19Bold: "צנומת כרוב – Gymnopus brassicolens",
    tznumaText20: "השם באנגלית – Cabbage parachute נובע מהריח החמוץ של כרוב.",
    tznumaText21:
      "פטרייה דומה מאוד לנבובית מלפפון ולצנומה שומית. הכובע בגוון חום ,אדמוני עד שחור בעל שוליים בהירים. צבע הדפים לבן עכור עד בז'. הרגל בגווני הכפה וחלקה העליון בהיר יותר.",
    tznumaImg7: "© עירית צוק",
    tznumaImg8: "© עירית צוק",
    truffle: "כמהין",
    shitaki: "שיטאקי",
    shimaji: "שימאג'י",
    porchini: "פורצ'יני",
    deathAmanita: "אמניתת המוות",
    amanit: "אמניט זבובנית",
    aznonit: "אזנונית",
    nolit: "נולית",
    whatIsMushroomPresentationDownload: "קישור להורדת מצגת - ''עולם הפטריות''",
    matranitTableDownload: "© טבלת זיהוי למינים בסוג מטרנית-מטריינית",
    amanitTableDownload: "© טבלת זיהוי למינים בסוג אמנית",
    levaditTableDownload: "© טבלת זיהוי למינים בסוג לבדית",
    harifitTableDownload: "© טבלת זיהוי למינים בסוג חריפית",
    shcharcharitTableDownload: "© טבלת זיהוי למינים בסוג שחרחרית",
    gushitTableDownload: "© טבלת זיהוי למינים בסוג גושית",
    hinomaTableDownload: "© טבלת זיהוי למינים בסוג הינומה",
    shavririt: "שברירית - Psathyrella",
    shavriritText1: "משפחת השבריריתיים - Psathyrelaceae, לשעבר – דיואיתיים.",
    shavriritText2:
      "פטרייה קטנה או בינונית, שייכת לפטריות הדפים, נפוצה ומופיעה בקבוצות צפופות. הכובע דק-בשר, צורתו פעמונית, חרוטית שאינו נפתח, או נפתח למצב שטוח בגיל בגרות. קוטר הכובע  3-10 ס''מ, מופיע בהרבה גוונים  מבז', אפרפר, חום עד חום כהה ובחלק מהמינים הגוונים מעורבים בהשפעת הלחות, תכונה הנקראת Hygrophanous .בחלק מהמינים, בגיל צעיר ניכרים שאריות צעיף תלויים בשוליים ובחלק השוליים מפוספסים. הדפים בגוון אפרפר נוטה לסגול או חום ארגמני. יושבים או גולשים מעט על הרגל. הרגל בהירה, דקה וארוכה, חסרת טבעת ונרתיק, עם או בלי כסוי של פתיתים, זיפים או רק בחלק ממנה.",
    shavriritText3:
      "השברירית ניזונה מחלקי עלים, גבעולים ועצים בשלבי סבל או מוות. ידועה בשטח טבעי, בגינות, ובפארקים. יש דמיון וקושי לזהות בינה לבין הסוג דיואית הנבדלת בהתמוססות הכובע למעין דיו. ניתן לבדוק זאת במגע אצבע.",
    shavriritText4:
      "מספר המינים רב וקיים קושי בזיהוי בעיקר בגלל ריבוי הצורות, הגדלים והצבעים המשתנים. שמות המינים עוברים כיום שינויים בהסתמך על בדיקת ד.נ.א , השם המדעי מוחלף אך בעברית נשאר כשהיה. להלן המינים הנפוצים עם הסמנים לזיהוי:",
    shavriritText5Bold:
      "שברירית צעיפית - Candolleanus candollenyces (Pshathyrella)",
    shavriritText6:
      "השם המדעי נקרא על שם הבוטנאי Candolle. הכובע קמור הנפרש בהמשך הצמיחה, קוטרו כ 8 ס''מ והגוון בז'. בשולי הכובע נותרים שרידים של הצעיף הניכרים בפרטים צעירים. הכיפה חלקה בצבע חום אדמוני המשתנה עם הגיל לבהיר יותר. הרגל בגוון חום-ורדרד, מפוספסת בגבה כ 7 ס''מ. שכיחה, גדלה בשטח עשבוני או בחורשות, בקבוצות קטנות.",
    shavriritImg1: "© סיון ביטון",
    shavriritImg2: "© דליה בונס",
    shavriritText7Bold: "שברירית כהה-חרוטית - Psathyrella (conopilea) canoceps",
    shavriritText8:
      "ידועה בשם נוסף בסוג דיואית – Parasola conopilea הכובע בצורת חרוט או פעמון, קוטרו כ 5 ס''מ, בצבע חום עד חום כהה אדמוני. הצבע משתנה בהתאם ללחות. הכפה מכוסה סיבים עדינים בגוון חום זהוב הנראים בעזרת זכוכית מגדלת. הרגל בהירה בחלק התחתון וקמחית כהה בעליון. גדלה בשטחים פתוחים בין עשבים ועל שבבי עץ.",
    shavriritImg3: "© דליה בונס",
    shavriritImg4: "© רותי טלמור",
    shavriritText9Bold: "שברירית חולות - Psathyrella (Psilocybe) ammophila",
    shavriritText10:
      "שם המין קרוי כשם הצמח 'ידיד חולות'. הכובע פעמוני הנפרש לשטוח עם התבגרותו, קוטרו כ 5 ס''מ וצבעו בהיר חולי. הרגל בגבה עד 7 ס''מ בצבע בז'. מתעבה בבסיס. גדלה באזור חולות ודיונות.",
    shavriritImg5: "© רותי טלמור",
    shavriritImg6: "© זהבה סיגל",
    shavriritText11Bold: "ש. חומה-אפרפרה - Psathyrella spadiceogrisea",
    shavriritText12:
      "ידועה בשם נוסף - Homopharon spadiceum. הכובע פעמוני ונפרש למצב שטוח, קוטרו עד 9 ס''מ וצבעו חום, אפרפר עד חום כהה אדמוני, תלוי בתנאי הלחות. שולי הכובע מפוספסים לעיתים ובמרכזו פיטם נמוך. הרגל בגבה עד 10 ס''מ בגוון לבנבן. גדלה בין עצים שונים וגם על ענפים כרותים, בקבוצות קטנות.",
    shavriritImg7: "© ברוריה גל",
    shavriritText13Bold: "ש. נוטפת - Psathyrella / Lacrymaria lacrymabunda",
    shavriritText14:
      "הכנוי שלה – אלמנה בוכייה. פטרייה נדירה ומיוחדת הנבדלת ממיני השברירית וקיבלה שם מדעי נפרד. בישראל נצפתה פעמים בודדות בלבד. קוטר הכובע עד 12 ס''מ, צבעו צהבהב-חום-אוקר מכוסה בשערות. הדפים מיוחדים בצבע חום המשחיר בהבשלה. בצעירותה ניכרים שרידי הצעיף בשולי הכובע ונוטפות מהדפים טיפות שחורות (ראה תופעת 'דמיעה' במדור מידע באתר). הרגל בגבה כ 10 ס''מ וצבעה כצבע הכפה. נמצאה בגליל בין עצי אלון ואחת נבדקה באותו מקום מספר שנים.",
    shavriritText141Bold: "ש. דו-עורית - Psathyrella bipellis",
    shavriritText142:
      "תרגום pellis - עור. שם נרדף – .P.sacchariolens. טרם פורסמה בישראל אך יש לא מעט תצפיות (טרם נכנס לצ'ק ליסט).",
    shavriritText143:
      "פטרייה קטנה עם רגל ארוכה וכובע חרוטי דומה למינים נוספים בסוג. קוטר הכובע עד 6 ס''מ, בצבע חום סגלגל ובלחות גבוהה ניכר צבע סגול חזק. הדפים נוגעים לרגל בצבע אפור ייני. הבשר דק ורך בצבע לבנבן. הדפס נבגים סגול-חום. הרגל חלקה באורך עד 10 ס''מ בצבע ורוד-סגלגל, כהה יותר בחלק העליון. גדלה ביערות, חורשות ושטח עשבוני, על חומר אורגני ובקרקע גירית.",
    shavriritImg144: "© איור קיבבי",
    shavriritImg145: "© אתר חינמי",
    shavriritImg146: "© אתר חינמי",
    shavriritImg8: "© נר יבגי",
    shavriritImg9: "© ניר יבגי",
    shavriritText15Bold: "מינים נוספים:",
    shavriritText16ListItem: "ש.לבנת רגל - P.prona f.albidula",
    shavriritText17ListItem: "ש. שרשית - P.caudata",
    shavriritText18ListItem: "ש.מתפצלת - P.fatua",
    shavriritText19ListItem: "ש.קודרת - P.melanthina",
    shavriritText20ListItem: "ש. פעמונית - P.marcescibilis",
    shavriritText21ListItem: "ש.קמחית - P.atomata",
    shavriritText22ListItem: "ש.אביבית - P.sphinctrinus",
    shavriritImg10: "© עירית צוק",
    shavriritImg11: "© טל גזית",
    type1: "פטריות כובע בעלות דפים",
    type2: "פטריות כובע בעלות דפים",
    type3: "פטריות כובע בעלות דפים",
    type4: "פטריות כובע בעלות ספוג",
    type5: "פטריות בעלות שיניים",
    type6: "פטריות בעלות נקבוביות",
    type7: "פטריות עציות-מדף על גזעים",
    type8: "פטריות בעלות 'ראש' מקומט או מחורר",
    type9: "פטריות דמויות כוסית, קערית או קפלים",
    type10: "פטריות כדור או שקית",
    type11: "פטריות קרומיות או קרישיות",
    type12: "פטריות דמויות אלמוג או אלה",
    find: "אנא בחר את מאפייני הפטרייה הרצויים עד למציאת סוג הפטרייה.",
    structure: "מבנה",
    size: "גודל",
    platform: "מצע",
    types: "סוגים",
    missingType1: "המידע שחיפשת חסר כרגע באתר.",
    missingType2: "מבטיחים לעדכן בקרוב...",
    typesKey1: "מפתח לזיהוי סוגים",
    typesKey2: "יש לבחור במבנה הרצוי להמשך תהליך הזיהוי",
    lehavit: "להבית – Flammulina",
    lehavitText0: "משפחת Physalacriaceae.",
    lehavitText1: " בסוג ידוע בארץ מין נדיר, יחיד בלבד.",
    lehavitText2Bold: "להבית צמירת רגל – Flammulina velutipes",
    lehavitText2:
      "הלהבית בעלת כובע קמור הנעשה שטוח בבגרותו בקוטר עד 7 ס''מ. צבעו צהבהב עד כתום ומשתנה בהתאם ללחות. הדפים צפופים בצבע לבן-צהבהב, (בכך נבדלים מהסוג גידמית).",
    lehavitText3:
      "הרגל חומה בחלקה התחתון ונעשית בהירה כלפי מעלה. קטיפתית /קמחית מהבסיס ומעלה. גדלה בקבוצות על גדמי עצים.",
    lehavitText4:
      "בארץ נמצאה בחורשות אורנים ובעולם ידועה בעצים רחבי עלים. הסוג נחשב נדיר בארצנו. (אין לי תמונות מישראל) המין משמש לגידול תרבותי והשם המסחרי - אניוקי.",
    lehavitImg1: "© מכאל קיו",
    lehavitImg2: "© ברטל",
    lehavitImg3: "אניוקי, הגדל למאכל",
    dardasit: "דרדסית – Crepidotus + Symocibe",
    dardasitText0: "שייכת למשפחת הדרדסיתיים - Crepidotaceae.",
    dardasitText1:
      "פטרייה קטנה בצורת צדף, מניפה או כלייה, עם דפים דלילים המזדקרת ללא רגל מגזעי עצים או ענפים חלשים או מתים.",
    dardasitText2:
      "גדלה בקבוצות. גווני המינים בהירים, מלבן, בז', צהבהב ועד חום בהיר.",
    dardasitText3:
      "בגלל השנויים של גוון הכובע, עם הגיל, קשה לתת זיהוי מדויק ונדרש מבט בעזרת מיקרוסקופ.",
    dardasitText4Bold: "דרדסית בעלת רגלית – Simocybe haustellaris",
    dardasitText5: "Watling 1981 המתאר.",
    dardasitText6:
      "Simo = שטוח אף. Cybe  = כובע של פטרייה. הופרדה לסוג נפרד, בעבר - דרדסית – Crepidotus rubi.",
    dardasitText7:
      "פטרייה קטנה בקוטר כסנטימטר, בצורת מניפה עם דפים מרווחים ובגוון צהבהב. נבדלת ממינים אחרים של דרדסית בהיותה בעלת רגל קצרצרה וכפופה הצמודה לענפים או גזעי עצים. אינה מופיעה בכל הספרים או האתרים. נמצאת באוסף בנימיני 1968 מאזור מירון, בין אורנים, מס' 86.377 (מישהי הציעה שם נעצית מניפתית - שם סוג הקיים לאחרת)",
    dardasitImg1: "© דוד האוזן",
    dardasitText8Bold: "דרדסית משתנה – Crepidotus variabilis",
    dardasitText8:
      "הצבע של הכפה משתנה מבהיר לכהה יותר. השוליים מעט מקופלים בצעירותה.",
    dardasitText9Bold: "דרדסית עגולת נבגים – /sphaerosporus C.cesatii",
    dardasitText9:
      "צבע הכפה לבן והדפים צהבהב עד כתום. קשה להבדיל מ ד. משתנה , נדרשת בדיקת מעבדה.",
    dardasitText10Bold: "דרדסית צהבהבה – C.luteolus",
    dardasitText10: "הכפה בצבע צהבהב עם מירקם שעיר.",
    dardasitText11Bold: "דרדסית רכה – C.molis",
    dardasitText11:
      "הכפה בצעירותה בגוון לבן ובהמשך נעשה צהוב עד כתמתם וחום בהיר.",
    dardasitImg2: "© רותי טלמור",
    kaduriot: "פטריות דמויות כדור",
    kaduriotText1:
      "משפחת האבקתיים – Lycoperdaceae שייכת לפטריות הכרס, כוללת סוגים בהם גוף הרבייה הינו דמוי כדור העשוי משכבה דקה או עבה המכסה את הגלבה, {רקמת ייצור הנבגים}.",
    kaduriotText2:
      "החיבור לקרקע ישיר, עם קורים או עם גבעולון קצר. אופן פיזור הנבגים נעשה ע''י מים או גשם המצליף על הפתח של מאגר הנבגים בעת הבשלתם.",
    kaduriotText3:
      "ההבדל המורפולוגי בין הסוגים ניכר במספר מאפיינים : מירקם המעטה החיצוני,חלק או בעל חידודים. החיבור לקרקע, ישיר או כדור מעל גבעולון עבה. צורת הפתח של המעטה בחלקו העליון.",
    kaduriotText4:
      "חשוב לדעת: יש מיקולוגים שמחליפים שמות בין הסוגים פרגודית ואבקית. אנו מסתמכים על אתר מקצועי בשם מיקובנק ובעברית לא נחליף השמות הוותיקים. השם העממי - Puffball mushroom",
    kaduriotText5Bold: "אבקית – Lycoperdon",
    kaduriotText5:
      "דומה לעורית ופרגודית. יש מיקולוגים שמחליפים שמות בין הסוגים פרגודית ואבקית. אנו מסתמכים על אתר מקצועי בשם מיקובנק.",
    kaduriotText6:
      "הכדור עם גלבה ספוגית בצבעים לבן עד חום, העטופה במעטה פנימי ומעטה חיצוני עם פתח עגול בחלקו העליון, לפיזור הנבגים. יש מינים שהמעטה חלק ויש עם עוקצים קטנים הנושרים בהבשלה.",
    kaduriotList1: "המינים בסוג:",
    kaduriotList2: "אבקית רכה – Lycoperdon molle",
    kaduriotList3: "אבקית סגולה – Lycoperdon atropurpureum",
    kaduriotList4: "אבקית מאפירה – Lycoperdon spadiceum / lividum",
    kaduriotImg1: "© אראלה הרי",
    kaduriotImg2: "© רותי טלמור",
    kaduriotText7Bold: "פרגודית נפוצה – Vascellum pratense",
    kaduriotText7:
      "*יתכן ותמצאו מין זה בשיוך לאבקית. דומה לאבקית ועורית אך הבליטות על המעטה החיצוני בולטות יותר והפתח סדוק ונקרע בהבשלה. צבע בחתך חום-חאקי. החלק התחתון של הכדור מאורך יחסית.",
    kaduriotImg3: "© רותי טלמור",
    kaduriotImg4: "© רותי טלמור",
    kaduriotText8Bold: "עורית – Scleroderma",
    kaduriotText8:
      "דומה לאבקית ופרגודית וההבדל באופן קריעת המעטה החצוני בחלק העליון לצורך פזור הנבגים.",
    kaduriotText9List: "המינים בסוג:",
    kaduriotText9: "עורית מעורקת – S. verrucosum",
    kaduriotText10: "עורית ים-תיכונית – S.meridionale",
    kaduriotImg5: "© דן רוסק",
    kaduriotImg6: "© ברוריה גל",
    kadur: "פטריות דמויות כדור 2",
    kadurText1:
      "שייכת לפטריות הכרס – Gasteromycetes. משפחת הפקועתיים – Agaricaceae (בעבר שוייכה למשפחת האבקתיים – Lycoperdaceae)",
    kadurText2:
      "כוללת סוגים בהם גוף הרבייה הינו דמוי כדור העשוי משכבה דקה או עבה המכסה את הגלבה, (רקמת ייצור הנבגים). חיבור לקרקע ישיר, עם קורים או עם גבעולון קצר.",
    kadurText3Bold: "כדורנית – Bovista",
    kadurText3:
      "צבע הגלבה בגווני ירקרק-חום. המעטה החיצוני לבן בצעירותו והפנימי אפרפר. הפתח קטן ועגול. בבסיס יש מעין קורים החודרים לאדמה.",
    kadurText4Bold: "כדורנית זעירה – B.pusilla",
    kadurText4:
      "פטרייה כדורית בצבע לבן, בקוטר עד 3 ס''מ. בראש הכדור נוצר פתח קטן להפצת הנבגים. החלק הפנימי בגוון חאקי. גדלה על פני הקרקע באזורים חוליים. אינה שכיחה.",
    kadurText5Bold: "כדורנית מאפירה – B.plumbea",
    kadurText5:
      "דומה מאוד בכל התאור לכדורית זעירה. בעלת שכבה חיצונית בצבע עופרת (תרגום שם המין) ,נושרת עם התרחבות הכדור. נפוצה במגוון רחב של בתי גידול וקרקעות.",
    kadurText6Bold: "כדורית גמלונית – Calvatia gigantea",
    kadurText6:
      "השם העממי – Giant puffball כדור גדול מאוד בגוון לבן או צהבהב המחובר במעין שורשון לקרקע. לעיתים נמצאו בקוטר גדול מ 50 ס''מ. מובן שזמן הגדילה מסתכם ב כמה שבועות. בצעירותה הצבע הפנימי לבן ובהמשך משתנה לחום זיתני. רקמת הנבגים כה גדולה שמעריכים את מספרם בטריליונים.",
    kadurImg1: "© ספי הרי ז''ל",
    kadurImg2: "© ספי הרי ז''ל",
    kadurImg3: "© איילת דג",
    kadurText7Bold: "פחוסית עגולה – Disciseda bovista",
    kadurText7Text:
      "כדור פחוס בקוטר עד 4 ס''מ עם מעטה חיצוני דק בגוון אפרפר עד חום חוור, נושר /מתפרק בהבשלה וחלקו נשאר מחובר לבסיס כתושבת בצורת צלחת. לכן נחשבה בעבר כשייכת לכוכבניות. הגלבה בגוון חום.",
    kadurImg4: "© מרטין",
    karsanit: "כרסנית – Macowanites",
    karsanitText1:
      "המשפחה עודכנה לאחר חקירה גנטית ועתה שייכת לחריפתיים – Russullaceae.",
    karsanitText2: "בארץ מצוי רק מין יחיד.",
    karsanitText3Bold: "כרסנית הגליל – Russula/Macowanites galileensis",
    karsanitText3:
      "מין שנגלה ופורסם לראשונה בעולם בישראל ביערות הכרמל, בשנת 1972 ע''י פרופ' בנימיני, ד''ר זהרה הירשנזון עם מיקולוג אורח מאוסטרייה בשם Moser. ב1977 הוחלף לה שם הסוג לחריפית, ובעברית נשאר המקור.",
    karsanitText4:
      "המיוחד בסוג זה היא התופעה שבאבולוציה הוא עבר התפתחות חריגה ומורכב מפטריית כרס ופטריית דפים באותו גוף פרי. נראית ככדור נוקשה בלתי סימטרי, בקוטר כ 8 ס''מ המחובר למעין רגל עבה. צבעה לבן ומעט פרטים נמצאו בגוון אדום ואדמדם בכסוי מלא או חלקי (יש לבדוק זיהוי למין נפרד הידוע בחו'ל). בחתך ניכרת רקמה בגוון צהבהב המוקפת ברקמה לבנה עם מירקם שונה.",
    karsanitText5: "הכרסנית מאוד נפוצה בכרמל ובגליל.",
    karsanitImg1: "© עירית צוק",
    karsanitImg2: "© דליה בונס",
    karsanitImg3: "© ניצו אלסר",
    karsanitImg4: "© פרט אדום, בחתך (אולי מין אחר) - ארנון שדמי",
    hysterit: "היסטרית – Hystrerangium",
    hysteritText1: "שייכת למשפחה כשם הסוג - Hysteragiceae.",
    hysteritText2: "בישראל מין יחיד.",
    hysteritText3Bold: "היסטרית גלדנית – Hystrerangium coriaceum",
    hysteritText3:
      "נתגלתה לראשונה ב1990 בחורשת אקליפטוס בראש העין ונאספה לאוסף בנימיני באוניברסיטת ת.א. דומה מאוד לכמהות יער קטנות נבדלת בנבגים ובצבע הגלבה שבחתך ניכרת בצבע ירוק, בגווניו השונים, בהתייחס לגיל. המעטה החיצוני בצבע לבן-בג'.",
    hysteritText4:
      "שנים רבות לא עסקו בלחפש מתחת לשכבת העלים ולאחרונה הפך עיסוק זה לשוחרי המזון - כתחביב ייחודי.",
    hysteritImg1: "© ארנון שדמי",
    hysteritImg2: "© איינטורליסט",
    dioit:
      "דיואית – Coprinus + Coprinellus + Coprinopsis + Parasola + Xerocoprinus",
    dioitText1: "משפחת השבריריתיים - Psathirellaceae",
    dioitText2:
      "מאז 1800 היו קבועים שמות הסוגים ושם המשפחה הדיואיתיים – Coprinaceae. בשנת 2001 ישבה קבוצת מיקולוגים, חקרה, בדקה והחליטה לשנות את הטקסונומיה בכל המשפחה, ועברה לשבריריתיים ולפקועתיים. המשפחה כוללת הרבה מאוד סוגים ומינים, שרק חלקם נבדק ופורסם בארץ.",
    dioitText3:
      "הסוג Coprinus פוצל לארבעה סוגים הנבדלים בשמותיהם המדעיים, אך בעברית נשאר לכולם השם דיואית כבעבר. רוב המינים בסוג זה בצבע לבן והפטריות הופכות לשחורות בהתבגרותן, תוך המסה נוזלית של הכובע, ובכך מתקיימת הפצת הנבגים. עובדה זו והספור שפעם הנוזל השחור שימש לעבודת הדפוס, קבעה לה כנוי  Inkcapואת השם בעברית דיואית.",
    dioitText4:
      "הכובע חרוטי או פעמוני ונפרש עם ההבשלה, המתקיימת בזמן מאוד קצר. אורכו 2-15 ס''מ. הדפים לבנים בתחילה והופכים לשחורים או חומים כהים כצבע הנבגים שהתפתחו עליהם. המרקם דק ושביר. חסרת ריח מאפיין. הרגל מרכזית, גלילית ואורכה עד 30 ס''מ. חלקה או שעירה, צרה או מורחבת בבסיס. במעט מינים מופיעה טבעת צרה הנושרת בקלות. גדלה בקבוצות צפופות בשטח עשיר אורגנית, על זבל של בע''ח, בחלקי עץ מתים או נרקבים וברקבובית של עלי צמחים שונים. נפוצה בהרבה נופים כמו יערות, גינות, שדות, פארקים ועוד.",
    dioitText5:
      "הפטרייה מכילה חומר בשם קופרין הנחשב רעיל לאדם בעת שתיית אלכוהול.",
    dioitImg1: "© יהודה מרטה",
    dioitText6: "המינים בסוג:",
    dioitText7:
      "לא תמיד נבדיל לפי סימנים חיצוניים ותידרש בדיקה מיקרוסקופית או גנטית.",
    dioitText8Bold: "דיואית זהובת קודקוד - Parasola auricoma",
    dioitText8:
      "פטרייה קטנה בגוון חום אפרפר ובראשו משטח צהבהב. הרגל ארוכה, דקיקה וחלקה.",
    dioitImg2: "© אראלה הרי",
    dioitImg3: "© ווליבאוט",
    dioitText9Bold: "דיואית זבל – Coprinellus hepthemerus",
    dioitText9:
      "הקטנה ביותר מהמינים המצויים בישראל, גודל הכפה 1 ס''מ וגם חייה - הקצרים ביותר. גדלה על זבל של בע''ח.",
    dioitImg4: "© אמיר פרלברג",
    dioitImg5: "© גלעד שביד",
    dioitText10Bold: "דיואית מחורצת – Parasola plicatilis",
    dioitText10:
      "הכובע דקיק בצורת מטרייה עדינה עשויה כמעין קפלים (מקור שם המין), צורתו עגלגלה ונפתח לאורך עד 8 ס''מ. הדגם הזה מצוי בעוד מינים בסוג.",
    dioitImg6: "© אראלה הרי",
    dioitImg7: "© זלמן באומבול",
    dioitText11Bold: "דיואית מחוספסת נבגים - Coprinopsis alopecia",
    dioitText11:
      "הכובע באורך עד 7 ס''מ, מעוגל, אפרפר, בעל שוליים סדוקים בגוון כהה יותר. מכוסה פתיתים בצעירותו, שהם שאריות הצעיף, הקודקוד בגוון חום אפרפר. הרגל לבנה, סיבית בחלקה התחתון וחלקה בעליון.",
    dioitImg8: "© Aranzadiz",
    dioitText12Bold: "דיואית מצויצת – Coprinus comatus",
    dioitText12:
      "מין זה עבר למשפחת הפקועתיים והסוג נשאר בשמו הקודם. הכובע באורך עד 15 ס''מ, הגדול מבין המינים בסוג, צבעו לבן המכוסה בקשקשים מפותחים. גדלה בשטחים פתוחים עם צומח עשבוני, בגינות, פארקים וצידי דרכים. הרגל גבוהה ועליה טבעת צרה הנושרת במהלך הגדילה.",
    dioitText13:
      "בשלב הצעיר נחשקת וטובה למאכל, בתנאי שלא תלווה בשתיית אלכוהול.",
    dioitImg9: "© אראלה הרי",
    dioitImg10: "© רותי טלמור",
    dioitText15Bold: "דיואית משחירה – Coprinopsis atramentaria",
    dioitText15:
      "הכובע באורך עד 6 ס''מ ,צבעו לבן עכור ובעל חריצים עדינים. הרגל באורך עד 12 ס''מ חלקה ובעלת טבעת צרה. גדלה על שברי ענפים וגדמים מתים במגוון שטחים, כולל מופרעים.",
    dioitImg11: "© חוה להב",
    dioitImg12: "© יהודה מרטה",
    dioitText16Bold: "דיואית נציצית – Coprinnellus micaceus",
    dioitText16:
      "שם המין תורגם מהשם המדעי, שמבטא את המינרל נציץ - Mica. הכובע באורך עד 4 ס''מ, צבעו בז' בעל חריצים עדינים ומכוסה בנקודות רבות, המהוות סימן זיהוי ברור. גדלה בקבוצות צפופות.",
    dioitImg13: "© דליה בונס",
    dioitImg14: "© דן רוסק",
    dioitText17Bold: "דיואית עקודה – Coprinopsis picaceus",
    dioitText17:
      "המרשימה שבין המינים בסוג. הכובע באורך עד 8 ס''מ. צבעו מחום שחרחר ועד שחור עורב ומכוסה בקשקשים ארוכים בצבע לבן ורדרד. הקשקשים לעיתים הופכים למעין כתמים. הרגל סיבית גבוהה מאוד, עליה טבעת צרה הנושרת בנקל. נחשבת נדירה בסוג, גדלה בחורשות ויערות.",
    dioitImg15: "© משה גלעדי",
    dioitImg16: "© ברוריה גל",
    dioitText18Bold: "דיואית צהובת שיער – Coprinellus xanthothrix",
    dioitText18:
      "הכובע בגובה עד 3 ס''מ, ביצתי עד חרוטי בגוון צהבהב עם שוליים סדוקים. פתיתים זעירים בהירים יושבים על חלקי הכובע. צבע מרכז הכפה בגוון חום. רגל עד 8 ס''מ , לבנה עם התעבות עם סבך תפטיר בבסיסה בצבע חלודי. גדלה על קצץ ענפים או על שכבת עלים נרקבים.",
    dioitImg17: "© דימיטרי",
    dioitImg18: "© דן רוסק",
    dioitText19Bold: "דיואית קורנת – Coprinellus radians",
    dioitText19: "דומה לחלוטין לצהובת השיער ונבדלת רק בגודל וצורת הנבגים.",
    dioitImg19: "© רותי טלמור",
    dioitText20Bold: "דיואית צחורה – Coprinopsis niveus",
    dioitText20:
      "פטרייה קטנטנה, עד 2.5 ס''מ, בצעירותה הצבע לבן כשלג ההופך לאפרפר. פני הכובע מכוסים בבליטות, שאריות הצעיף. גדלה על גללים של בע'ח.",
    dioitImg20: "© טליה אורון",
    dioitImg21: "© ניצן אלסר",
    dioitText21Bold: "דיואית שעירת רגל – Coprinopsis lagopus",
    dioitText21:
      "תרגום שם המין - שיער הארנבת, המבטא את רגלה השעירה. פטרייה קטנטנה באורך עד 5 ס''מ, צבעה שחור עם כסות של פתיתים בהירים הנושרים בנקל. נפתחת כמטרייה דקיקה. צומחת על קצץ ענפים וקומפוסט.",
    dioitImg22: "© משה גלעדי",
    dioitImg23: "© ווליבאוט",
    dioitImg24: "© ארנון שדמי",
    dioitText25Bold: "דיואית נגבית - Xerocoprinus arenarius",
    dioitText26:
      "הפטרייה הופרדה לסוג ומין מונוטיפיים (בלעדיים) וקיבלה שם מדעי חדש. בעברית נשאר השם דיואית.",
    dioitText27:
      "הפטרייה דומה למצויצת, נבדלת בצורת הכובע הכדורי לעומת המאורך ורגל קצרה יותר. אוהבת חום וגדלה בשטחים פתוחים יבשים וחמים. גוף הפרי בשרי בצבע לבן עכור, אינו מכיל נוזלים כשאר הפטריות.",
    dioitText28:
      "בעולם ידועה מצפון אפריקה ,מאזור יבש בספרד ובחבל הים-תיכוני. נחשבת נדירה ואין עליה הרבה מידע. בארץ מוכרת זמן רב במחוז באר שבע, בגבעות ובשטחים חשופים עם כמות גשם מועטה. בעבר החשבנו אותה כתת-מין של המצויצת.",
    dioitImg30: "© ברוריה גל",
    dioitImg31: "© ברוריה גל",
    dioitImg32: "© ברוריה גל",
    dioitImg33: "© ברוריה גל",
    shalhofit: "שלחופית Hydronocybe",
    shalhofitText1: "בארץ מצוי מין יחיד",
    shalhofitText2Bold: "שלחופית מקופלת – Hydronocybe piligera",
    shalhofitText2: "המתאר- Tul 1844",
    shalhofitText3: "משפחת Pyronemateaceae סדרת Pezizales",
    shalhofitText4:
      "בעבר שויכה למשפחת הכמהין ובעברית היה שמה כמוהה לבנה. לכן שיניתי את שמה / ברוריה גל.",
    shalhofitText5:
      "פטרייה קטנה הנראית כגוש בעל קפלים דחוסים בקוטר כ-2 סנטימטר וצבעה בהיר. כסות הקפלים בסיבים זעירים מאוד. בצעירותה הריח חזק. גדלה מעט מתחת לפני הקרקע ומעליה, בקבוצות קטנות. נמצאה בין עצי אלון וגם אורן.",
    shalhofitText6:
      "בארץ נחשבת נדירה, כנראה כי לא שמו לב לקטנטונת. תועדו מספר תצפיות ממקומות שונים: בגליל עליון – בנימיני. באוסף שלו נמצאים 4 פרטים. בצומת דמון - כרמל, 2012 במזרח ראש העין – 2.2024 ביער קנדה – 2.2024",
    shalhofitImg1: "© בנימיני",
    shalhofitImg2: "© ארנון שדמי - 2.2024",
    shalhofitImg3: "© אסף סבג - 2.2024 יער קנדה",
    backToTop: "חזרה מעלה",
    krishit: "קרישית – Tremella",
    krishitText1: "משפחת הקרישיתיים - Tremellaceae",
    krishitText2:
      "הפטרייה נראית כקפלים מלוכדים מעין מוח ג'לטיני בקוטר עד 12 ס''מ בתנאי לחות גבוהה. הקרומים מפתחים את הנבגים. גדלה על ענפים וגזעי עצים ממינים שונים של רחבי עלים, חיים או מתים וחודרת לתוכם כטפילה. בעת יובש הקרומים מתייבשים ונותרים עם יכולת התעוררות בקבלם רטיבות מגשם.",
    krishitText3: "המינים בישראל:",
    krishitText4Bold: "קרישית זהובה – T.mesenterica",
    krishitText5:
      "בעלת כנויים בכמה שפות – מח המכשפה וחמאת המכשפות. מופיעה בגוונים בין צהבהב לכתום עז. נחשבת הגדולה מבין המינים הקרישיתיים.",
    krishitText6:
      "הגודל עד 13 ס''מ רוחב וגובה, בולטת בשטח וקל לזהותה. ידוע מופע בגוונים של חום לבן ואדום, יתכן שבבדיקה עתידית יאובחנו כמינים נפרדים.",
    krishitImg1: "© דן רוסק",
    krishitImg2: "© עירית צוק",
    krishitText6Bold: "קרישית ציצנית – T. foliacea / fimbriata",
    krishitText7:
      "נבדלת מהזהובה בצורה העלעלים, צפיפותם וגודלם הקטן יותר. הצבע חום קינמון וביובש הופך לשחור. אינה שכיחה ונמצאה לעיתים על תפטירים של הפטרייה קשיחית.",
    krishitText8: "נחשבת טפילה על תפטיר של סוגים אחרים.",
    krishitImg3: "© על קשיחית -  דליה בונס",
    krishitImg4: "© ג'ון וילב",
    klonsit: "כלונסית – Battarrea",
    klonsitText1: "שייכת למשפחת הפומיתיים - Tulostomataceae",
    klonsitText2: "המינים בישראל:",
    klonsitText3Bold: "כלונסית חולות – Battarrea stevenii",
    klonsitText4:
      "פטרייה גבוהה הנראית כעמוד עצי מוצק הנושא בראשו מעין שקית אבקתית. גובהו עד 40 ס''מ לאורכו תלויים מעין פיסות קרעים. בבסיס העמוד ניכר תפוד גדול. ראש הפטרייה כדורי בצעירותו ועטוף בשכבה בהירה הנושרת ומגלה את הגלבה השופעת נבגים חלודיים.",
    klonsitText5:
      "גדלה במגוון בתי גידול בשטחים חמים ופתוחים. השם כלונסית חולות – משום שנגלתה לראשונה באזור חולי. ידועה בארצות הים תיכון ופחות בארופה.",
    klonsitImg1: "© בוגרת, יהודה מרטה",
    klonsitImg2: "© ''בקיעה'', עירית צוק",
    klonsitImg3: "© בקיעה מהקרקע – אמנון בוימל",
    klonsitText6Bold: "כלונסית פינית – Battarrea phalloides",
    klonsitText7:
      "דומה מאוד לכלונסית חולות, קטנה יותר ובעלת פחות קרעים על הרגל.",
    klonsitText8:
      "נבדלת גם בגודל הנבגים ונדירה יותר בארצנו. נהוג בציבור להתייחס למין זה ככלונסית חולות.",
    tzmadit: "צמדית – Hymenopellis",
    tzmaditText0: "שייכת למשפחת Physalacriaceae.",
    tzmaditText1: "בארץ ידוע מין יחיד:",
    tzmaditText2Bold: "ארוכת רגל (שורשית) – Hymenopellis radicata",
    tzmaditText3:
      "שייכת למשפחת Physalacriaceae .השם הקודם – Megacollybia radicata .פרוש שם המין-שורשי ,(והיו שמות נוספים בשנים קודמות) הכנוי – Rooting Shank",
    tzmaditText4:
      "לאחרונה נבדקה וזוהתה גנטית בפונגריום שבמוזיאון הטבע באוניברסיטת תל אביב ושמה העברי והמדעי עודכנו.",
    tzmaditText5:
      "דומה מאוד לאסימונית בצורה ובצבעים ולכן לא קיבלה התייחסות מיוחדת. מופיעה בספרו של דר' בנימיני אך כנראה בשם לועזי ישן. בנימיני נתן את השם העברי צמדית. נבדלת מהאסימונית ברגל הדקה, הארוכה והמרשימה.",
    tzmaditText6:
      " אורכה עד 20 ס''מ, מחודדת וכהה בבסיסה, קמחית במעט. שקועה עמוק בקרקע וצמודה בה לחלקי עץ ושרשים יבשים. הכובע בקוטר עד 9 סמ' בצבע בג' כתמתם, הדפים דלילים בגוון לבן. גדלה בין אלונים ולרוב צמודה לגזעים כרותים. נדירה בארץ, נצפתה בעיקר בגולן ומעט בכרמל.",
    tzmaditImg1: "© דליה בונס",
    tzmaditImg2: "© ניצן אלסר",
    tzmaditImg3: "© יאיר אור",
    scientificCollection: "אוסף מדעי מהו, ואודות מיקולוגים בישראל",
    recommendedSites: "אתרים מומלצים לעיון ולימוד",
    mushroomGrowing: "גידול פטריות ביתי ומסחרי",
    similarButDifferent: "דומות אך שונות, סימני זיהוי",
    partnership: "חיי שותפות",
    taxonomy: "טקסונומיה בפטריות",
    collectingAndPhotographing: "ליקוט, איסוף וצילום",
    structureAndPartsOfTheMushroom: "מבנה וחלקי הפטרייה",
    glossaryOfTerms: "מילון מונחים",
    habitates: "מקום חיים (בתי גידול)",
    literature: "ספרות",
    nutritional: "ערך תזונתי ורפואי לאדם, המינים האכילים והמרפאים",
    mushroomsValue: "ערך הפטריות בעולם הטבע",
    folkloreAndArt: "פולקלור, באומנות ואמונות תפלות",
    whatIsMushroom: "פטרייה, מהי",
    toxicity: "רעילות: חומרים, המינים הרעילים והנחייה לטיפול",
    variousPhenomena: "תופעות שונות",
    observations: "תצפיות נבחרות ונדירות",
    sceintificCollectionValue: "אוסף אוניברסיטת תל-אביב",
    sceintificCollectionMicology: "אוסף פטריות לשירות מדע המיקולוגיה",
    geneticalTests: "בדיקות גנטיות לקביעת מינים",
    micologists: "אודות המיקולוגים בישראל לאורך שנותיה",
    micologistsText1:
      "חקר החקלאות בישראל החל בפלסטינה, לפני קום המדינה, ומבין החוקרים היו שטיפלו במחלות צמחים. פטריות מהוות גורם רציני לנזקי צמחים ועצים ומי שעסק בתחום זה, נקרא מיקולוג (מיקו = פטרייה) .בנוסף לקבוצת הפטריות הפתוגניות בדקו גם פטריות עילאיות וכתבו עליהן בכתבי-עת עבריים שהיו בימים ההם.",
    micologistsText2:
      "המוסדות שעסקו בנושא היו הפקולטה לחקלאות, אגף של האוניברסיטה העברית ומכון וולקני של משרד החקלאות. נציין בקצרה וניתן את הכבוד הראוי למיקולוגים העיקריים שאינם איתנו עוד. *מידע נוסף ניתן לקרוא בויקיפדיה.",
    micologistsImg1:
      "מימין - חנה נמליך, זהרה הירשנזון וניסן בנימיני – בקור ראשון בגולן.",
    micologistsText3Bold: " ישראל רייכרט 1891-1975",
    micologistsText4:
      "נחשב חלוץ חקר הפיטריות ופתולוגיה בישראל. הקים את המחלקה לפתולוגיה של צמחים ב 1921. חתן פרס ישראל בשנת 1955. עשה עבודת דוקטורט בגרמניה על הפטריות במזרח התיכון.",
    micologistsImg2: "",
    micologistsText5Bold: "טשרנה רייס 1890-1965",
    micologistsText6:
      " היתה חוקרת פטריות ואצות. ב 1934 עלתה מרומניה לישראל ונקלטה באוניברסיטה העברית. כתבה ביחד עם רייכרט ספרון בשם ''כמהין ופטריות'' ב 1951 שנחשב נכס היסטורי עבורנו.",
    micologistsText7Bold: "זהרה אביזוהר-הרשנזון 1910-1994",
    micologistsText8:
      "נולדה בשוויץ, עלתה לארץ ב 1920 השלימה את הגימנסיה העברית, למדה באוניברסיטה העברית המשיכה בפריז והשתלמה בארה'ב. ב 1938 הצטרפה כחוקרת במחלקה למחלות צמחים. התעניינה ופרסמה אודות פטריות מאכל ורעל בישראל, חלק בשיתוף עם חנה נמליך ועם ניסן בנימיני.",
    micologistsImg3: "",
    micologistsText9Bold: "ניסן בנימיני 1930-2017",
    micologistsText10:
      " גדל בילדותו בירושלים, למד באוניברסיטה העברית בירושלים וברחובות ובהמשך עבד בחקר מחלות צמחים. החל מ 1959 עבד לימד והרצה באוניברסיטת תל אביב, אסף והגדיר מאות מינים מקבוצות שונות, ייבש והקים אוסף המכיל מעל 6000 פרטים, עם מידע מפורט ומדויק, המהווה עתה אוסף לאומי עשיר (ראה במדור זה - ''אוסף אוניברסיטת תל-אביב'').",
    micologistsText11:
      "ניסן השתלם בשוויץ, בדנמרק, באוסטרליה ועוד. כתב מאמרים מדעיים על פטריות ישראל ונתן שמות עבריים רבים.",
    micologistsText12:
      "פירסם 5 ספרים המלמדים ומדריכים את הציבור הישראלי עד היום.",
    micologistsText13: "בגיל 69 יצא לגמלאות בתואר פרופ' במחלקה לבוטניקה.",
    micologistsImg4: "צילמה אלינער שביט 1987",
    generalSites: "אתרים בנושאים כלליים מעולם הפטריות",
    taxonomySites: "אתרים טקסונומיים על סוגים ומינים, באנגלית, בשמם המדעי",
    howToGrowMushrooms: "כיצד נגדל פטריות מאכל בבית",
    howToGrowMushroomsText1:
      "גידול פטריות ביתי נכנס כטרנד ההולך ומתפתח בארץ. הציבור למד להבין את ערכן התזונתי של הפטריות ורואה זאת כאתגר מעניין. מי שמעונין להתנסות ולחוות חוויה מרתקת, חשוב שייקרא וילמד אודות מחזור חיי הפטרייה, מושגים בסיסיים של המבנה המיוחד ושמות מינים המתאימים לגידול.",
    howToGrowMushroomsText2:
      "נדרשת מנת סבלנות לא קטנה, התמדה ודייקנות בבצוע הפעולות לפי הסדר הנכון. קיימות מספר אפשרויות מורכבות יותר או מורכבות פחות:",
    howToGrowMushroomsText3:
      "1. הכנת המצע, קש או נסורת, טיפול משלב ראשוני, איסוף נבגים מפטרייה טרייה, הנבטת תפטיר, שתילתו בתוך המצע במיכלים או בשקי פלסטיק מיוחדים. מכאן – ממתינים לגידול גופי הפרי תוך דאגה ללחות יומיומית.",
    howToGrowMushroomsText4: "2. כנ''ל, אך קניית מזרע עם תפטיר מוכן.",
    howToGrowMushroomsText5:
      "3. קניית ערכה מוכנה ושמירתה במקום עם תנאים מתאימים והתזת מים לעיתים תכופות.",
    howToGrowMushroomsText6:
      "* באתר זה לא ניכנס לעומקו של הנושא אך נעזור בהפנייה למקורות זמינים באינטרנט, ביוטיוב ובאתרים מקצועיים. לאורך הזמן נוסיף ונעדכן.",
    howToGrowMushroomsImg1:
      "אורן דואניאס © - גופי פרי צצים מחורי שקיות הפלסטיק. ",
    howToGrowMushroomsImg2: "© לאה דרום",
    howToGrowMushroomsText7: "להלן קישורים להדרכה:",
    howToGrowMushroomsText8:
      "להקליד בגוגל שאלה - 'כיצד לגדל פטריות בבית' או משפטים דומים. יש חומר רב בעברית ופרסום אודות קורסים לימודיים בארץ.",
    howToGrowMushroomsText9Link: "https://www.youtube.com/watch?v=l6yavIWHmeM",
    howToGrowMushroomsText10Link: "https://www.facebook.com/growmushroomathome",
    whereToBuy: "היכן נקנה חומרים ומזרע",
    growingForMedicine: "גידול פטריות מסחרי למאכל ולרפואה",
    growingForMedicineText1:
      "שוק הפטריות מתפתח מאוד בישראל בשנים האחרונות מאז שלתרבות האכילה והמסעדנות נכנסו הפטריות להשבחת טעמים וארומה בתבשילים רבים.",
    growingForMedicineText2:
      "מבין הגידולים החקלאיים יש יתרונות לגידול פטריות בכך שלא נדרש שטח אדמה גדול. בבתי הגידול מנצלים את הגובה לבניית מדפים, כמו ערוגות גידול, ובכך גם ניתן לחסוך במים. הטכנולוגיה והבקרה מאפשרים התאמה לגידול רוב מיני הפטריות וגידול בכל חודשי השנה.",
    growingForMedicineText3:
      "תחילת גידול הפטריות בישראל החל במאה הקודמת ע'י חובבים בתוך מערות עם מצע של זבל סוסים או קומפוסט. הציבור לא היה רגיל להשתמש בפטריות טריות במטבח, אלא מקופסאות שימורים, והיה צריך לשכנעו לקנות מהמגדלים.",
    growingForMedicineText4:
      "בחלוף השנים והעליה מברית מועצות הביקוש עלה ומשרד החקלאות החל לקדם את הנושא אט אט. כיום יש מגדלים רבים מהגליל ועד הנגב.",
    growingForMedicineText5:
      "*	באתר זה לא נרחיב בהסברים אלא ניתן קישורים לכתבות מגוונות. הקישו ברשימת היוטיוב את המילה פטריות ותמצאו חומר עשיר ורב.",
    growingForMedicineText6Bold: "פטריות בגידול ובמכירה בישראל:",
    growingForMedicineText7Bold: "קבוצה א' - למאכל ולתוספי מזון",
    growingForMedicineText8:
      "1. שמפיניון = פקועה דו נבגית                            Agaricus bisporus",
    growingForMedicineText9:
      "2. פורטובלו = פקועה חומה                                          Agaricus sp.",
    growingForMedicineText10:
      "3. שיטאקי = גמישנית                                         Lentinula edodes",
    growingForMedicineText11:
      "4. אנוקי /שימאג'י                                                               Shimeji     ",
    growingForMedicineText12:
      "5.שינוקי                                                      Haixiam mushroom",
    growingForMedicineText13:
      "6. מלך היער = זן של אזנית הכלך                    Pleurotus erengii ssp",
    growingForMedicineText14:
      "7. חצוצרה זהובה = גביעונית                                   Cantharellus sp",
    growingForMedicineText15:
      "8. שימאגי                             Hypsizigus marmoreus /tessellatus",
    growingForMedicineText16:
      "9. אלמוג היער = אזנית               Pleurotus salmoneo - stamineus",
    growingForMedicineText17Bold: "קבוצה ב' - להפקת תוספי מזון ומרפא",
    growingForMedicineText18:
      " 1. ראיישי = בהוקית מבריקה ושטוחה                  Ganoderma {lingzi",
    growingForMedicineText19:
      "2. צ'אגה = קישוטית                                                     Inonotus sp.",
    growingForMedicineText20:
      "3. מאיטקה = נקבובנית                        Grifolia / Polyporus frondsa",
    growingForMedicineText21:
      "4. טרמטס = מדפית ססגונית                              Trametes versicolor",
    growingForMedicineText22:
      "5.קורדיספס = פטריית הזחל הסינית                    Cordyseps sinensis",
    growingForMedicineText23:
      "6.היריסיום = רעמת האריה                             Hericium erinaceum",
    growingForMedicineText24:
      "7 מאיטקה –כנוי פ' המרקדת           Grifola frondosa                         ביפנית-  Hui Shu Hua",
    growingForMedicineText25Bold: "קישורים: (לחץ על הטקסט למעבר לקישור)",
    growingForMedicineText26: "כתבה מפורטת, בעברית",
    growingForMedicineText27: "על בישול פטריות, באנגלית",
    growingForMedicineText28:
      "דלוקים על פטריות - עם גיא דגן וטל – חברת מיסליום - 2.2022 ",
    growingForMedicineImg1: "* 'באדיבות משפ. אלינסקי חוות 'פטריות ערד",
    betweenMushroomsAndTrees: "בין פטריות לצמחים ועצים",
    mycorrhizae: "מיקוריזה - שותפות פטריה וצמח",
    whatIsTaxonomy: "מהי טקסונומיה",
    hebrewNames: "השמות העבריים והמדעיים - מי וכיצד נקבעים",
    scientificNames: "השמות המדעיים - מי וכיצד נקבעים",
    collectingRules: "הכללים לליקוט נכון בטבע",
    collectingRulesText1:
      "הפטריות היו, ועדיין גורמות לעניין רב אצל בני האדם. איסוף פטריות בטבע ידוע שנים רבות וככל שנוספים מלקטים צריך לתת דעת על תפקידן במערכת האקולוגית ועל שמירת מגוון המינים.",
    collectingRulesText2:
      "יציאה ליער או לשדה מהווה חוויה מהנה בתרבות הזמן הפנוי, הרפתקנית ומפתיעה. נעשית ביחידות או בחברה ויחד עם זאת מתגמלת בנושא הקולינרי.",
    collectingRulesText3:
      "בהשוואה לתחביבים אחרים, בנושא הפטריות יש סיכון של טעות בזיהוי ומפגש מסוכן עם רעלים בלתי נראים ומוכרים. חשוב ורצוי לצאת בפעמים ראשונות עם בעלי ידע ונסיון, לרכוש ידע בסיסי והכרת מינים בבטחה.",
    collectingRulesText4:
      "אימרה חשובה ומתאימה אומרת – 'אם יש ספק' (בזיהוי) - 'אין ספק' (לא לאכול).",
    collectingRulesImg1: "ניצן אלסר ©",
    collectingRulesText5Bold: "כללים עיקריים בליקוט:",
    collectingRulesList1:
      "איסוף פטריות אסור בשמורות טבע. כדאי להימנע מאיסוף בשולי כבישים, סמוך למפעלי תעשייה ובמקומות חשודים בזיהום.",
    collectingRulesList2:
      "לאחר עקירת הפטרייה יש לכסות את הגומה באדמה למען הגנה מיובש של התפטיר החשוף.",
    collectingRulesList3:
      "לאסוף רק פטריות עם זיהוי בטוח, ואם האיסוף נועד לזיהוי בהמשך- יספיק פרט אחד במצב טוב.",
    collectingRulesList4:
      "לבחור פטריות בגיל בינוני, לא צעירות מדי ולא זקנות, בהן כמות הנבגים גדולה, יהיה קושי בעיכול או שנגועה בזחלי חרקים.",
    collectingRulesList5:
      "ללקט כמות ריאלית אותה נהיה מסוגלים להכין ולבשל. יצר הצייד המפעם דורש איפוק.",
    collectingRulesList6:
      "לאסוף לסל בו הפטריות מונחות שלמות, ולא בשקית פלסטיק בה הן נדחסות ונשברות.",
    collectingRulesList7:
      "להניח בנפרד פטריות מוכרות, המיועדות למאכל, ולחוד פטריות בלתי מוכרות.",
    collectingRulesList8:
      "לשיטה לחתוך עם סכין ללא הרגל יש סיבה – לא שמירת טבע, אלא הקושי בעיכול רקמת הרגל המכילה הרבה תאית.",
    collectingRulesText6Bold: "ציוד מומלץ לליקוט:",
    collectingRulesText7:
      "סל עם תחתית שטוחה. סכין. נעליים סגורות. כסות מפני גשם, אם מופיע. ספר הדרכה או אתר לזיהוי מינים בטלפון הנייד, כמובן מומלץ אתר זה. מעטפה או דפי נייר לעטיפת פטרייה אם נועדה להעברה לבדיקה במעבדה. מקל, למתקשים בהליכה בסבך או לצורך פינוי ענפים וגבעולים קוצניים שבדרך.",
    collectingRulesText8: "קישור לסרטון הסבר של ניצן אילסר-מדריך ליקוט: ",
    collectingRulesText9: "https://www.youtube.com/shorts/iUhYqYFKjRo",
    collectingRulesText10: "תודה על תרומתו לנו בתצפיות ותמונות.",
    collectingAndDrying: "איסוף ויבוש למאכל",
    collectingForScientificCollection: "איסוף לאוסף – מדעי",
    howToPhotographAMushroom: "כיצד לצלם פטריה למטרת זיהוי",
    shapesAndPartsCap: "צורות וחלקי פטריות הכובע, צורות כובע ורגל",
    shapesAndParts: "צורות וחלקי פטריות מסדרות אחרות",
    inHebrewAndEnglish: "בעברית ולועזית (מסודר לפי א'-ב')",
    habitatesOfGrowth: "באילו אזורים צומחות פטריות בארצנו",
    mediumOfGrowth: "על איזה מצע גדלות הפטריות",
    weatherConditions: "תנאי מזג אוויר",
    recommendedBooks: "שמות ספרים מומלצים",
    linksForArticles: "קישורים למאמרים בעברית ואנגלית",
    substances: "מהם החומרים ודרך השפעתם ברפואה",
    substancesText0: "מיקוליביה פטריות מרפא - Mycolivia Medicinal Mushrooms",
    substancesText1:
      "מחקרים רבים הוכיחו שפטריית קורדיספס מסייעת בהתאוששות ממחלות, שיפור הנשימה ותפקוד הריאות והכליות, העלאת הליבידו, איזון המערכת החיסונית ועוד ועוד.",
    substancesText2:
      "הפטרייה נמצאת בשימוש במשך אלפי שנים ברפואות המסורתיות וידועה בתכונות האדפטוגניות שלה, כלומר, ביכולתה לסייע להתמודדות בזמנים של מתח (סטרס) ומכאן שהפטרייה משפרת את הסיבולת הגופנית והחוסן הרגשי, מפחיתה עייפות ומעלה את רמת החיוניות הכללית.",
    substancesText3:
      "מיקוליביה היא החברה הוותיקה בישראל לתוספי תזונה מבוססי פטריות מרפא ומביאה לארץ את פטריית קורדיספס סיננסיס.(Cordyceps sinensis) זהו הזן החשוב והנחקר ביותר של פטריית קורדיספס, עם הוכחות מחקריות ואלפי שנים של שימוש מסורתי בקרב עמי המזרח הרחוק לצורכי רפואה ושיפור הבריאות, כמו גם הגברת העמידות הנפשית והגופני. הכמוסות של מיקוליביה מכילות מיצוי גבוה במיוחד של הפטרייה. העניקו לגופכם את מתנת פטריות המרפא ובוא ליהנות מפירות הטבע - 100% פטריות מרפא ללא חומרים משמרים וללא תופעות לוואי.",
    adibles: "פטריות מאכל בישראל",
    mako: "קישור - פרטיות, Mako",
    importance: "חשיבותן ותפקידן של הפטריות",
    smellAndTasteOfMushrooms: "טעם וריח בפטריות",
    smellAndTasteOfMushroomsText1:
      "בניסיוננו להגדיר ולזהות מין פטריה יש חשיבות לטעם ולריח. ברור שלא נכניס לפה פטריה שאיננו מכירים, ואם כן מכירים ורוצים לדעת טעם - יש לירוק את החלקיק שנגסנו בקצה הלשון.",
    smellAndTasteOfMushroomsText2:
      "טעמן של פטריות מיוחד לכל מין ומין, יש מרות, אותן משרים במים ושוטפים מספר פעמים. יש תפלות, טעימות ומצוינות.",
    smellAndTasteOfMushroomsText3:
      "נושא הריח ברור יותר כסמן-זיהוי, חשוב להריח פטרייה מיד כשנקטפת פן תזדקק ותקבל ריח בלתי מאפיין - ריח של רקב. לפטריות מיובשות ריח עז יותר. מגוון הריחות כמעט אינסופי, מנעים ועד מחריד. בנתינת השמות לפטריות נעשה לעיתים שימוש בסוג הריח. חשוב לדעת שלרעל אין ריח משלו ופטרייה בעלת ריח נעים יכולה להיות רעילה למדי.",
    smellAndTasteOfMushroomsText4:
      "להלן מינים נבחרים בעלי ריח ספציפי המומלץ לזכור ולהיעזר בו לשם זיהוי:",
    smellAndTasteOfMushroomsText5Bullet:
      "משפכנית ריחנית, פקועה יערית ופקועת השדה - ריח עדין ונעים של אניס.",
    smellAndTasteOfMushroomsText6Bullet: "כמהין וגמצוץ - ריח ניכר 'פטרייתי'.",
    smellAndTasteOfMushroomsText7Bullet: "פקועה הדורה,סיבית שקדית - ריח שקדים.",
    smellAndTasteOfMushroomsText8Bullet:
      "גביעונית נאכלת,חריפית יבשה - ריח פרי מתוק.",
    smellAndTasteOfMushroomsText9Bullet: "ציצנית שטוחה - ריח צנון.",
    smellAndTasteOfMushroomsText10Bullet: "קשקשית פחומה - ריח אדמה.",
    smellAndTasteOfMushroomsText11Bullet: "ישעורית סבונית - ריח סבון.",
    smellAndTasteOfMushroomsText12Bullet:
      "מטריינית/לבקנית האגוזים - ריח אגוזים.",
    smellAndTasteOfMushroomsText13Bullet: "סיבית קינמונית - ריח קינמון.",
    smellAndTasteOfMushroomsText14Bullet:
      "פינית מבאישה - סירחון עז שנועד למשיכת חרקים להפצת הנבגים.",
    smellAndTasteOfMushroomsText15:
      "ובנוסף - יש בעלות ריח שום, גז בישול, דג מלוח, מלפפון, פישפש, קמח, פילפל חריף  ועוד.",
    folkloreArtAndSuperstitions: "פולקלור, באומנות ואמונות תפלות",
    folkloreText1:
      " המושג פולקלור פרושו 'ידע עם', עוסק במנהגים ומסורות עממיות בתחומים של תרבות, אמנות, לבוש, מאכלים, שירה וסיפורים עממיים ועוד. הדגש הוא על עממיות ולא על תרבות גבוהה אך בהחלט השפיע עליה. ",
    folkloreText2:
      "בכל עם ובכל חבל ארץ בנוף שונה התפתח פולקלור משלו. נוצרו אמונות, ספורים, שירים אימרות והרגלים יחודיים למקום. בעבר הם עברו מדור לדור בעל פה ובימינו אלה בחומר כתוב.",
    folkloreText3:
      "פטריות היו תמיד נושא הקשור למיסטיקה ולאמונות טפלות מהסיבה שהן גרמו לתופעות קיצוניות ובלתי מוסברות לאדם ולא היה ידע מדעי להסבירן.",
    folkloreText4:
      "אספנו כאן מעט מהאמונות והסיפורים אודות פטריות ובהמשך הזמן נמשיך להוסיף קטעים מעולם הפטריות המרתק.",
    folkloreText5:
      "ניתן לעבור בין קטעי הפולקלור השונים באמצעות החיצים ימינה ושמאלה.",
    mushroomsInArt: "פטריות באומנות",
    StoriesAndBeliefs: "פטריות באמונות ובאגדות",
    toxinsInMushrooms: "הרעלנים בפטריות ספיגתם ואופן השפעתם",
    listOfPoisonous: "רשימת פטריות רעילות בישראל",
    whatToDo: "מה עושים במקרה של פגיעה או הרעלה",
    witchCircles: "מעגלי המכשפה",
    witchCirclesText1: "ראה מידע במדור פולקלור בנושא ",
    witchCirclesLink: "'מעגלי הפיות'",
    tearDropsInMushrooms: "דמיעה בפטריות",
    colorChanges: "שינויי צבע, חיצוניים ופנימיים",
    successionInFungi: "סוקסציה בפטריות",
    albinoMushroom: "פטריות לבקניות",
    albinoMushroomText1:
      "תופעת הלבקנות / אלביניזם ידועה בכל מערכות החי והצומח כולל האדם והפטריות. זו הפרעה גנטית בה קיים חוסר בצבען / פיגמנט בשם מלנין והצבע לבן. הלבקנות אינה נחשבת מחלה ועוברת בתורשה. קורה שהלבקנות נגרמת כתוצאה ממוטציות גנטיות שמשפיעות על ייצור הפיגמנטים, כמו שקורה בבעלי חיים. חשוב להבין שיש פטריות לבנות ולא כתוצאה מחוסר מלנין.",
    albinoMushroomText2:
      "בעולם ובארץ ידועות תצפיות של מינים לבקנים, ולאחרונה נאספו לאוסף אוניברסיטת ת.א מספר מינים:",
    albinoMushroomText3:
      "בקבוצה של ישעורית אפורה נאספו מספר פרטים לבנים (י.גולדרינג) וביער אורנים נמצאה אורנייה מצויה (א.שדמי). כדי לוודא שאין זה מין מסוים בלתי מוכר – בדקנו ד.נ.א והזיהוי אומת. מסתבר שהגן האחראי על האלבינזם לא מתבטא בבדיקה רגילה.",
    albinoMushroomText4:
      "חשוב לציין שהסוג בשם לבקנית בארץ אינו נובע מהתופעה אלא מצבעו הלבן והצעתי התקבלה רישמית להחליפו בעברית ל עציצית.",
    albinoMushroomText5:
      "בעולם פורסמו כמה מאמרים של חוקרי פטריות-מאכל המנסים לטפח ולגדל מינים אלביניסטים, כדוגמת המאייטקה.",
    albinoMushroomImg1: "ישעורית אפורה אלבינית. יורם גולדרינג © ",
    albinoMushroomImg2: "ישעורית אפורה אלבינית - נורית הרץ © ",
    tlvCollection: "אוסף הפטריות במוזיאון הטבע, אוניברסיטת תל אביב",
    tlvCollectionText1:
      "במשך שנים נאספו פטריות ע''י חוקרים במוסדות שונים בארץ ולאחרונה חלה התקדמות, עדכון ופיתוח הנושא.",
    tlvCollectionText2:
      "פטריות נאספות בטבע, מקבלות תווית זיהוי של המין, תאריך, מקום מדויק,  מצע, צמחייה, שם האדם האוסף, ומספר סידורי באוסף. אזי עוברות טיפול למספר ימים בהקפאה לצורך חיטוי ממזיקים כולל ביצי חרקים שהטילו בתוכה, ונכנסות לתנור יבוש מיוחד.",
    tlvCollectionText3:
      "קיימות מספר שיטות לשימור, המותאמות לצרכים ומטרת האוסף:",
    tlvCollectionText4:
      "פטריות שלמות לאחר שטופלו במכשיר בוואקום, לתצוגה ולימוד, על אף שהצבע אובד והגודל מצטמצם. נשמרות בקופסאות סגורות.",
    tlvCollectionText5:
      " בצנצנות אטומות עם חומר משמר. פרוסות יבשות של כל חלקי הפטרייה, מוכנסות למעטפות מנייר מיוחד ומאוחסנות במגרות. שמירת רקמות בצלחות פטרי, שמירת דגימות זעירות במבחנות לבדיקות די אן איי, שמורות בהקפאה עמוקה, ויש שמירת הדפס-נבגים במעטפות נייר.",
    tlvCollectionText6:
      "בכל השיטות הנ''ל דואגים לאחסון החומר בארונות וחדרים עם בקורת של ניקיון, לחות וטמפרטורה מתאימים.",
    tlvCollectionText7:
      "אוסף הפטריות משמש כאוסף משווה למחקרים מדעיים ומסייע בהכנת קטלוגים של מיני פטריות מקומיים ואזוריים כמו כן, האוסף מהווה מאגר גנטי.",
    tlvCollectionText8:
      "האוסף נמצא במוזיאון לטבע ע''ש שטיינהרט. מכיל יותר מ –5500 פרטים, מעל 850 מינים של פטריות כובע, עילאיות ופיטריריות.",
    tlvCollectionText9:
      "החומר נאסף במשך 40 שנה ע''י פרופ' ניסן בנימיני וממשיך שנים נוספות ע''י ברוריה גל.",
    tlvCollectionText10:
      "לאחר פטירתו של פרופ' בנימיני נכנסתי לטפל באוסף שדרש טיפול רציני: ניקוי, חיטוי, אריזה, אחסנה, רישום והפיכתו למאגר דיגיטלי. התאמתי אותו להעברה למוזיאון החדש בתנאים מודרניים.",
    tlvCollectionText11:
      "לאחר ההעברה העלנו את רמת האוסף בכך שנלקחות דגימות מכל פטרייה טרייה: הדפס נבגים,  מבחנה עם רקמה לבדיקה מולקולרית, מדידת קוטר כובע, גבה ועובי של הרגל, צילום כל פטרייה  מזוויות שונות ותיעוד עם המספר הקטלוגי. במעבדה המולקולרית של המוזיאון נבדקות פטריות בדגש של אלה שטרם פורסמו בישראל ונכתב מאמר לפרסום עולמי.",
    tlvCollectionText12:
      "כל המינים שנבדקו מדעית, המתועדים במוזיאון ובעוד מוסדות רשמיים בארץ – נרשמים בצ'ק ליסט לפרסום בכתב-עת בינלאומי.",
    tlvCollectionText13:
      "*בקרוב נוסיף כאן את המספרים המדויקים של כל קבוצות המינים, וקישור למאמרים.",
    tlvCollectionText14:
      "בחודשי החורף נערכים סיורים ללימוד ואיסוף בעזרת חובבים חרוצים המעשירים את האוסף ומגלים מינים חדשים לישראל. מכאן נשלחת להם תודה גדולה.",
    mediumOfGrowthText1:
      "מקום-חיות הוא המושג הנכון להסביר מהי הנישה המיוחדת לחיי אורגניזם כלשהו בטבע, ומתאים יותר מהמושג בית-גידול שיכול להיות גם עציץ, חממה או אקווריום. מרתק בעולם הפטריות לראות צמיחתן במגוון עצום של מצע (סובסטרט) כל מין במצע ספציפי או מצע מעורב.",
    mediumOfGrowthText2:
      "יש שגדלות רק על חומר נרקב או שורש של צמח מסוים, לדוגמא-אזנית הכלך, כמהת השמשון.",
    mediumOfGrowthText3:
      "על רקבובית ביער אלונים - אמניתת המוות, גושית השטן, הינומה יפהפיה.",
    mediumOfGrowthText4:
      "על רקבובית ביער וחורש מעורבים - אחלמית ערומה, סיבית דוחה, משפכנית מלבינה.",
    mediumOfGrowthText5:
      "על מחטים ועלים שנשרו מעצי אורן - פטרה לבנבנה, מעצי אלון - צנומה עלוית.",
    mediumOfGrowthText6:
      "על גזעים וענפים כרותים נרקבים - דרדסית, שברירית צעיפית, שרועית אפרכסית.",
    mediumOfGrowthText7:
      "על איצטרובלי אורן - פטרת האיצטרובל על בלוטי אלון – עדינית.",
    mediumOfGrowthText8:
      "על קרקע עשירה בחומר אורגני בשטח פתוח וחשוף לאור - נרתיקנית נאה דביקה, פקועת השדה.",
    mediumOfGrowthText9:
      "על דשאים מושקים - לבקנית/מטריינית האגוזים, ירוקת דפים קיצית, חרוטית.",
    mediumOfGrowthText10:
      "על שטח שעבר שריפה - קשקשנית פחומה, גמצוץ חרוטי, לוהבת טבורנית על גללים של בע''ח - גללית, שברירית, קרוחה.",
    mediumOfGrowthText11:
      "מרישום התצפיות בארץ אנו למדים אודות הופעתן של פטריות מסוימות - רק באזורים מיוחדים, קשור לגבה מעל פני הים, לטמפרטורה, להרכב הקרקע ולסוג הצומח. בגולן, ביער אודם למשל, המאוכלס באלונים, נצפו פטריות שלא הופיעו במקום אחר בישראל.",
    mediumOfGrowthText12:
      "במאמר של פרופ' בנימיני נכתב: ''במשך 7 שנים נבדקו 300 מינים מתוכם 210 היו בין עצי אלון, אלה, אקליפטוס וקזוארינה. 60 מינים בברוש ואורן, 25 בפארקים, שדות ומדשאות 5 בחולות ודיונות''.",
    mediumOfGrowthImg1: "© לבקנית האגוזים על דשא – ברוריה גל.",
    mediumOfGrowthImg2: "© לוהבת טבורנית על שטח שרוף – ברוריה גל.",
    StoriesAndBeliefsText1:
      "כבר בעת העתיקה התייחסו לפטריות בחשד ופחד, ומכאן צמחו אמונות טפלות ואגדות. לתופעות שהאדם לא ידע להסבירן הומצאו הסברים שונים ומשונים, כמו גם בנושא עטלפים, עופות לילה ונחשים. גורם ההפתעה של ינשוף או של נחש, שפעילים בלילה הפחיד במיוחד   את אוכלוסיות האדם חסרות ההשכלה והידע. בפטריות - הרעלים ומגוון ההשפעות על מי שאכלן הולידו אגדות וספורים במיוחד בגלל תופעת ההזיות.",
    StoriesAndBeliefsText2: "נחלק את האמונות למספר קטגוריות:",
    StoriesAndBeliefsText3Bold: "מקום הצצת פטריות",
    StoriesAndBeliefsText4: "",
    StoriesAndBeliefsText5:
      "כשסוסים דוהרים בין העצים ויוצא להם מהפה קצף מעורב בדם - שנה לאחר מכן צומחות פטריות באותו מקום. אדומות עם נקודות לבנות (אמנית זבובנית).",
    StoriesAndBeliefsText6:
      ".במקום שצבאים הזדווגו, צורת ביציהם המוזרות וריחן דוחה - צצות פטריות שצורתן פאלית (פינית מבאישה).",
    StoriesAndBeliefsText7:
      "היכן שזקנה הלכה בשדה ופגשה בשטן - צצות פטריות 'מקומטות' כעור זקן (גמצוץ).",
    StoriesAndBeliefsText8:
      "בחורף, עת הופיעו ברקים ורעמים, האנרגיה התפזרה מסביב, אזי צצות פטריות במעגל.",
    StoriesAndBeliefsText9:
      "במקום בו רקדו פיות – צמחו פטריות במעגל. ראה בהמשך*",
    StoriesAndBeliefsText10:
      "הופעת ברקים בחורף הם הגורם המבקיע את קרום הקרקע ומתחת לסדק מתחבאת פטריה (כמהין).",
    StoriesAndBeliefsText11: "במקום שכלב השתין - למחרת צצות פטריות.",
    StoriesAndBeliefsText12:
      "מסתבר ש''ידע והבנה - מונעים פחד'' ובנושא הפטריות זו חובה. להוכחה, בימינו ככל שלומדים וחוקרים יותר, לא נוספות אמונות טפלות.",
    StoriesAndBeliefsText13Bold: "אמונות על מינים מסוימים",
    StoriesAndBeliefsText14:
      "השימוש בפטריות, בעיקר בשבטים קדומים, עבר במסורת מדור לדור. הם הכירו את תכונותיהן המזיקות, כמו גם המועילות.",
    StoriesAndBeliefsText15:
      "א- אמנית זבובנית - המשקה הנרקוטי הפופולרי אצל האסקימוסים היה שתן של אדם שאכל ממנה. הויקינגים אכלו מעט ממנה לקראת קרבות אכזריים הזו. ההשראה לתלבושתו של סנטה קלאוס, בצבעי אדום לבן - באה מהפטרייה היפה",
    StoriesAndBeliefsText16:
      "ב- פטריות רעילות שימשו את הציידים ע'י מריחתן על קצה החץ לגרום לטשטוש החיה.",
    StoriesAndBeliefsText17:
      "ג- קרוחה – החומר פסילוסיבין המצוי בה גורם להזיות קשות ולצערנו האדם בן זמננו משתמש בה למטרותיו.",
    StoriesAndBeliefsText18Bold: "מעגלי הפיות, השדים והמכשפות",
    StoriesAndBeliefsText19:
      "מאז המאה ה 13 ידועה תופעה מרשימה שהעסיקה רבים - פטריות הצצות בסדור מעגלי בחורש, ביער, בעשבייה ובדשאים. הסיבה שלא היה הסבר לתופעה הולידה אגדות, אמונות וספורים שונים ומוזרים, מתקופות קדומות ועד ימינו. בכל ארץ או קהילה האמינו באופן שונה ומיסטי שניתן לראות ביצירות אמנות עתיקות. המוטיב המרכזי נסוב על ריקוד מעגלי שבוצע במקום ע''י מכשפות, פיות או שדים שהצמיח פטריות הבאות ונעלמות תוך זמן קצר. מהדוגמאות שנאספו ניתן להבחין שבאנגליה הייתה זו פייה, בגרמניה מכשפה ובהולנד שד.",
    StoriesAndBeliefsText20: "מה אומרים המיקולוגים?",
    StoriesAndBeliefsText21:
      "ידועים כ 60 מיני פטריות היוצרים מעגלים בקוטר של 10-20 מטרים ובמקרה נדיר נמדדו 600 מ' במקום מסוים שנמשך מאות שנים. המעגל לא בהכרח מושלם בצורתו, יש גם קשת או קווים אלכסוניים. מדי שנה מתרחב המעגל בממצע של 20 ס''מ עד שניתקל בגורם מפריע כגון מעגל של מין אחר או שינוי במרכיב הקרקע שאינו מתאים לו. מינים ספציפיים הנכללים בתופעה שייכים לסוגים פקועה, אמנית, ישעורית, משפכנית ועוד. בישראל מוכרת למדי ירוקת הדפים על דשאים בסוף הקיץ, ומשפכנית גדולה ביער בחרף. ",
    StoriesAndBeliefsText22:
      "כיצד נוצר מעגל? נבג נובט בקרקע, מתפתחים תאים ברשת קורים, הנקראים תפטיר. במינים מסוימים גדל התפטיר רק לכוון אחד כלפי חוץ ובכל שנה מת החלק הוותיק. כך, עם השנים, הולך ומתרחב המעגל. חומרי המזון מנוצלים בקרקע עד תום והתפטיר ממשיך לחלק מזין שבשוליים. במועד ובתנאים המתאימים צומחים גופי הרבייה, הן הפטריות הנראות מעל פני השטח.",
    StoriesAndBeliefsText23:
      "לאחר שנים המקום שהיה דל במזון יכול להתחדש. גננים, המגדלים חלקות דשא נהנים אמנם מהמראה היפה של מעגל הפטריות אבל מודאגים וסובלים מהתוצאה. אם יש צפיפות יתר של תפטיר חל נוון ומוות של הדשא. הפתרון הוא אוורור המקום בכלים אגרוטכניים.",
    StoriesAndBeliefsText24:
      " לסכום - אם ראיתם מעגל שכזה - בידקו  בשנה הבאה באותו מקום וראו מה קוטרו.",
    scientificHebrewNames:
      "שמות הפטריות - עבריים ומדעיים / לועזיים ושמות של פעם",
    scientificHebrewNamesText1Bold: " השמות המדעיים ",
    scientificHebrewNamesText2:
      "של הפטריות בעולם ניתנו בלועזית בעיקר ממקור יוונית ולטינית על ידי המתאר הראשון שגילה ופרסם אותן. בכל ארץ וארץ יש שמות עממיים מקומיים שלא בהכרח תלויים במדעיים ואינם משתנים בעקבות שינויים של חוקרים. ראשית החלוקה היתה ע''י לינאוס בשנת 1735.",
    scientificHebrewNamesText3:
      "בטקסונומיה של המינים, כמו בצמחים, החלוקה נקבעת ע''פ סולם דרגות ושם כל מין כולל שתי מילים, קודם הסוג ואחריו המין ואם יש גם תת-מין. יש לציין שבמשך השנים הוחלפו והשתנו שמות בעיקר בגלל שיטות המחקר החדישות, מיקרוסקופים משוכללים ולאחרונה בדיקות ד.נ.א שהשפיעו דרמטית על תוספות ושינויי מינים.",
    scientificHebrewNamesText4:
      "קורה שהחוקרים מגלים שייכות שונה לסוג או למשפחה ולכן נאלצים להחליף את השם באישור וועדה מדעית, ולפרסם בעתון מדעי מוכר.",
    scientificHebrewNamesText5Bold: " השמות העבריים ",
    scientificHebrewNamesText6:
      "חוברו החל משנות הארבעים של המאה הקודמת בידי המיקולוגים החלוצים בארץ רייכרט, רייס והירשנזון שפרסמו בכתבי עת ובספרים בודדים. דוגמאות נבחרות: גמצוץ, כמהה, פזיזה, נטופית, ישעור, חלפית, נרתיקן, ארנת האקליפטוס ועוד.",
    scientificHebrewNamesText7:
      "בשנת 1975 יצא ספרו של המיקולוג פרופסור ניסן בנימיני ''פטריות הכובע בישראל'' שטרח לעברת שמות למילים עשירות בשפה העברית ובשיתוף עם 'האקדמיה ללשון העברית'. הייתה זו תרומה גדולה, חשובה ומכובדת. העיקרון בנתינת שם היה להסתמך על השם המדעי ולתרגמו לעברית עד כמה שאפשר. שמות מורכבים מצורות, צבעים, בתי גידול, תכונות, טעמים ריחות, שמות האנשים שגילו לראשונה וכו'. מעט שמות חרגו בעברית מהלועזית כדי להקל על ציבור המשתמשים  בהבנה ובזכירת השם. המילה 'פטרייה' בעברית היא בלשון נקבה ולכן גם השמות ניתנו כך. נרתיקון תוקן לנרתיקנית, ישעור לישעורית ורק הגמצוץ נשאר בזכר. במספר מינים ניתנו השמות המדעיים על פי מילים מהשפה העברית, או על שם אזור בישראל לדוגמא: אזנונית יהודה, כרסנית הגליל וגושית השטן.",
    scientificHebrewNamesText8:
      "בישראל מתגלים עוד ועוד מינים חדשים, מוגדרים ומזוהים בשמות מדעיים ואנו מציעים שמות עבריים על פי העקרון הנ''ל ומגישים לאקדמיה ללשון העברית לאישור. חשוב לציין שהשמות בעברית נשארים ולא מוחלפים, גם אם הוכח שהפטרייה שינתה שם ושייכות במדע.",
    scientificHebrewNamesImg1: "© ישעור אפור = ישעורית אפורה. בנימיני.",
    scientificHebrewNamesText9Bold: "שמות פטריות מפעם",
    scientificHebrewNamesText10:
      "רייכרט והירשנזון חיברו שמות ראשונים בימי פלסטינה:",
    scientificHebrewNamesText11: "נטוּפית – לנטופה בת זמננו.",
    scientificHebrewNamesText12: "חרוּפה – לחריפית.",
    scientificHebrewNamesText13: "יְרכית הסוככים –לאזנית הכלך.",
    scientificHebrewNamesText14: "פטוּרה טהורה – לפטרה ריחנית.",
    scientificHebrewNamesText15: "אומצֶניה –לישעורית.",
    scientificHebrewNamesText16: "סיבָניה –לסיבית. ",
    scientificHebrewNamesText17: "נכה – לדרדסית.",
    scientificHebrewNamesText18: "גלולית – לשרועית.",
    scientificHebrewNamesText19: "משפכנית אגוּדית – למשפכנית שיבנית.",
    scientificHebrewNamesText20: "דבקה רירית – לקמרונית דביקה. ",
    scientificHebrewNamesText21: "ארנת האקליפטוס – ללבדית סילבר.",
    scientificHebrewNamesText22: "ארנה אדומת הנבגים – לבדית קלטי.",
    scientificHebrewNamesText23: "פקועית המאכל – לפקועה מצויה.",
    scientificHebrewNamesText24: "זבובנית – לאמניתה.",
    toxicityInMushrooms: "רעילות בפטריות",
    toxicityInMushroomsText1:
      "פטריות תמיד מפחידות את האדם מהסיבה שאין כל סימן המזהה רעל, והדרך היחידה להימנע מהרעלה היא לימוד והכרת המינים. מי שמלקט פטריות צריך ללמוד ולהכיר היטב את שאסף ולזכור את האימרה ''אם יש ספק-אין ספק''. בטעות חושבים שאם הפטרייה רעילה- טעמה לא טוב ולאכילות יש טעם וריח טובים.",
    toxicityInMushroomsText2:
      "חלק מהפטריות נחשבות ממיתות, כמו אמנית המוות, אמנית האביב,מטריינית ארגמנית. לעומת רעילות שניתן להציל",
    toxicityInMushroomsText3:
      "ללא קשר לרעל – יש אנשים שאלרגים לאכילת מיני פטריות. הפטריות מכילות חומרים ואינזימים שאינם נקלטים בקלות בגוף בני אדם מסוימים. ידוע על גמישנית, והמתורבתת שלה שיטאקי, שהשפיעו קשה על חלק מאוכליה ואפילו לאורנייה יש אנשים אלרגים.",
    toxicityInMushroomsText4:
      "פטרייה מבוגרת מכילה הרבה מאוד נבגים שאינם טובים לעיכול ולכן רצוי לאכול רק צעירות וטריות. חשוב לדעת שבבישול הרעלנים אינם מתפרקים.",
    toxicityInMushroomsText5: "בארץ היו מקרי מוות והרבה מקרי הרעלה.",
    toxicityInMushroomsText6Bold: "הרעלנים בפטריות:",
    toxicityInMushroomsText7:
      "- אגריטין – מצוי במינים של פקועה.יש סברה שמשפיע באכילת פטריות טריות ללא בישול או טיגון.",
    toxicityInMushroomsText8:
      "- פלואידין – מצוי באמנית המוות ואמנית האביב, יחד עם הרעלן אמניטין. פוגע בתאי הכבד והכליות וגורם למוות.",
    toxicityInMushroomsText9:
      "- מוסקארין – חומר דומה לאצטילכולין, נקרא על שם הפטרייה. מצוי באמנית זבובנית (אינה בישראל) הדומה לה – אמנית מנומרת, במספר מינים שבסוג סיבית, משפכנית מלבינה ועוד. פוגע לאחר כ-3 שעות במערכת העצבים הפרה-סימפתטית, מוריד את קצב הלב ולחץ הדם. גורם להפרשות מוגברות של זעה, רוק ודמעות. משפיע כמו סם עם הזיות והתקפים פסיכוטיים.",
    toxicityInMushroomsText10:
      "- אלפא-אמניטין – מצוי באמנית המוות ואמניתת האביב. נקרא על שם הפטרייה. פוגע בכבד שאינו מסוגל לייצר חלבונים ולנטרל רעלים. יש לדעת שמשפיע רק אחרי 12 שעות ויותר.",
    toxicityInMushroomsText11:
      "- פסילוסיבין מצוי בקרוחה, חרוטית וצבעונית. פוגע במוח, גורם להופעת הזיות וחוויות מיסטיות, עלייה בלחץ הדם וקשיי נשימה.  משמש גם ברפואה בטיפול של דיכאונות, אך במינון מסוים. חומר זה מעניין מאוד את חוקרי המח האנושי ולאחרונה הוקמו לא מעט מעבדות מחקר, גם בישראל.",
    toxicityInMushroomsText12:
      "- קופארין – מצוי במינים בסוג דיואית, גושית עמומה, מיני משפכנית ועוד. פוגע בשילוב של אכילה עם שתיית אלכוהול וגורם להקאות ושלשולים, דופק לב מואץ וכאבי בטן.",
    toxicityInMushroomsText13:
      "- קוראטין – מצוי במינים של הינומה. פוגע בפעילות הכליות, גורם לשלשולים והקאות. משפיע לאחר יותר מיממה.",
    toxicityInMushroomsText14:
      "- גירומיטרין - מופיע בסוג גירומיטרה עם הכינוי 'גמצוץ מדומה', אינו מופיע בישראל.",
    toxicityInMushroomsText14Bold: "עזרה ראשונה",
    toxicityInMushroomsText15:
      " מיד לאחר האכילה והופעת סימני הרעלה יש לגרום להקאה, אפשר ע''י שתיית מים עם מלח. אם המצב קשה יש לפנות למ.ד.א, ליעוץ - למרכז ההרעלות הארצי הנמצא בבית החולים רמב''ם בחיפה. מומלץ תמיד לפני הבישול להשאיר פטרייה אחת שלמה וטרייה למקרה ו... בתקווה שנאכל בתאבון מבלי שניפגע.",
    Kochvanit: "כוכבנית - Geastrum",
    KochvanitText1: "שייכת לפטריות הכרס, משפחת הכוכבניתיים - Geastraceae.",
    KochvanitText2:
      "מבנה וצורת הפטרייה יפים ומיוחדים. גוף הפרי כדורי שבתוכו הרקמה הפורייה, בשם גלבה – Gleba, העטופה בשתי שכבות מעטפת הנפתחות בעת ההבשלה בכמה דרכים. בכל מין פתיחת המעטפת נעשית ע''י קריעה לאונות או קרניים המתקפלות כלפי חוץ, נראות ככוכב ומספרן מאפיין את המין. מביניהן יש המתכווצות ביובש ונפתחות במצב של לחות.",
    KochvanitText3:
      "הכדור מחוספס או חלק ובראשו הפתח - Peristome לשחרור הנבגים, בצורות של פיטמה בולטת, שטוחה, ארוכה או קצרה. החיבור בין המעטה והכדור, בשם Stalk, נראה כצוואר או רגלית באורכים וברוחב שונה. אלו מהווים סימן לזהוי המין. מצורפים איורים של ארבעה מינים מתוך המצויים בישראל עם פרוט והסבר ברור.",
    KochvanitText4: "בישראל ידועים כעשרה מינים:",
    KochvanitText5Bold: "כוכבנית מחורצת - G.striatum",
    KochvanitText6Bold: " כוכבנית פקטינית - G.pectinatum",
    KochvanitText7Bold: "כוכבנית הסלסילה - G.fornicatum",
    KochvanitText8Bold: "כוכבנית גמדית - G.schmidelii",
    KochvanitText9Bold: "כוכבנית גדולה / תפוחה - G.saccatum",
    KochvanitText10Bold: "כוכבנית מאדימה - G.fibriatum",
    KochvanitText11:
      "מינים נוספים:  כ.משתנה, G.floriforme כ. מצויצת, G.pseudolimbatum .החולות, G.corollinum כ.זעירה, G. minimum",
    KochvanitImg1: "© אראלה הרי",
    KochvanitImg2: "© טליה אורון",
    KochvanitImg3: "© דליה בונס",
    KochvanitImg4: "© יאיר אור",
    yerukatDapim: "ירוקת דפים קיצית – Molybdites Chlorophyllum",
    yerukatDapimText1: "שייכת למשפחת הפקועתיים.",
    yerukatDapimText2:
      "פטרייה לבנה וגדולה, הכובע לבן עם מעט קרומים בגוון חום בהיר בקוטר עד 20 ס''מ, דפים לבנים בתחילה ונצבעים בהמשך הגידול לצבע ירוק זיתי עד ירוק כהה. הרגל מוצקה וארוכה עם טבעת צרה חופשייה הנושרת בהמשך. מעובה בבסיסה.",
    yerukatDapimText3:
      "המיוחד בה הוא מועד הופעתה בחדשי הקיץ בעיקר על מדשאות מושקות, המסביר את התלות במים להזנתה. דומה לבני המשפחה הלבנות והאכילות כמו מיטרניית האגוזים הגדלה גם כן במדשאות. ניכרת ובולטת בשטח ולפיכך מסוכנת למלקטים. הטועים בזיהוי ואוכלים ממנה בתאבון. מכילה רעל הגורם להרעלת קיבה, הקאות וסחרחורות. בישראל ידועים מאות מקרים בהם נפגעו בעיקר ילדים. ידועה בתכונה של יצירת 'מעגלי מכשפה', (ראה במדור מידע)",
    yerukatDapimImg1: "© ברוריה גל",
    yerukatDapimImg2: "© יורם גולדרינג",
    yerukatDapimImg3: "© דליה בונס",
    kishurit: "כישורית - Colus",
    kishuritText1:
      " שייכת לפטריות הכרס, משפחת הפיניתיים - Phallaceae. בישראל ידוע מין אחד - ",
    kishuritText1Bold: "כישורית מרושתת - Colus hirudinosus.",
    kishuritText2:
      "הכישורית מתפתחת מהתפטיר בצורת ביצה לבנה השקועה בקרקע או סמוך לפני הקרקע. בהמשך בוקעת הביצה ועולים מספר זרועות אדומות. החלק העליון בגבה כ 5 סמ', עשוי משקעים וגומות שבתוכם יתפתחו הנבגים. השכבה הפורייה רירית בצבע זיתי כהה ומצחינה. הריח נועד למשוך חרקים שידאגו להפצת המין. דומה לבנות משפחתה הפינית והפיפית.",
    kishuritText3: "נפוצה באסיה ובארצות הים תיכון, ובארופה רק בדרום.",
    kishuritImg1: "© דן רוסק",
    kishuritImg2: "© אראלה הרי",
    kishuritImg3: "© ברוריה גל",
    achlamit: "אחלמית - Lepista",
    achlamitText0: "שייכת למשפחת המשפכניתיים - Clitocybaceae.",
    achlamitText1: "מקור השם אחלמית מאבן חן סגולה בשם אחלמה - Amethyst..",
    achlamitText2:
      "פטריית דפים נפוצה מאוד, גדלה בין עצי אורן ועצים נוספים. חשוב לא לטעות עם מין של הינומה שצבעיה דומים, ראה תמונה.",
    achlamitText3: "בארצנו ידועים מינים:",
    achlamitText4Bold: "אחלמית ערומה - L. nuda",
    achlamitText5:
      "בתנאים שונים של לחות באוויר ורטיבות בקרקע, ניכר שנוי צבע מסגול ועד חום בהיר. בעלת ריח אופייני המזכיר ריח צנונית. בגולן נגלים פרטים מאוד גדולים, בהשוואה לאזורים אחרים בארץ, ובעלי רגל עבה יותר.",
    achlamitText6Bold: "אחלמית מנוקדת – L. panaeolus / luscina",
    achlamitText7:
      "מין שזוהה לאחרונה, שנחשב עד כה דפונית. צבעה אפרפר ועל הכובע או בשוליו כתמים או נקודות כהים יותר. שונה מהשתיים בהעדר צבע סגול. נבדקה גנטית וזוהתה במעבדת המוזיאון לטבע - מס. 23.036",
    achlamitImg30: "© ברוריה גל",
    achlamitText8Bold: "אחלמית עכורה - L. (Colybia) sordida",
    achlamitText9:
      "קשה ומסובך להבדיל מורפולוגית בין זו לבין הערומה, והרי הצבעים דומים מאוד. בספרות נמצאו תאורים שאינם מספקים. על פי מאמר וותיק של פרפ' הירשנזון ז'ל ניכר הבדל המפורט בקטע המצורף:",
    achlamitImg1: "© א. ערומה, אראלה הרי",
    mitranit: "מטרנית – Macrolepiota",
    mitranitText1: "משפחת הפקועתיים – Agaricaceae.",
    mitranitText2:
      "ביטוי השם – עם קמץ באות ר' לעומת מטריינית – עם חיריק ב ר' וקמץ באות י'. החשש מבלבול בשמות הייתה הסיבה שהציעו לשנות את שמה ל שמשיינית.",
    mitranitText3:
      "*כיוון שבספרות המקצועית ובאוספים השם מופיע מטרנית - אינני מחליפה לה ולאחרות לשם ההצעה החדשה .(אולי ישמש את הדורות הבאים) .הסוג עשיר במינים ודומה לסוגים לבקנית, ליבנית, מטריינית, ירוקת דפים ועוד. חשוב ללמוד היטב את הסימנים המבדילים של כל פטריות הכובע הלבנות שביניהן יש מינים רעילים.",
    mitranitText4:
      "המטרנית שייכת לפטריות הדפים הגדולות, קוטר כובע בין 8 ל 15 ס''מ והגדולה ביותר מעל 20 ס''מ. הכפה חלקה, קמחית או בעלת קשקשים לבנים עד מעט כהים. במרכז הכפה ניכרת בליטה הנראית כפיטם שצבעו כהה. לעיתים הכפה נסדקת. הדפים חופשיים בצבע לבן ההופך לקרם עם הגיל. כל מין והסימנים שלו.",
    mitranitText5:
      "הרגל ארוכה כקוטר הכובע, מעט סיבית או קמחית ומתרחבת בבסיסה. בחלקה העליון מופיעה טבעת צרה או רחבה בגוון של שני צבעים, נושרת או משתחררת בהתבגרותה ונשארת תלויה על הרגל.",
    mitranitText6:
      "בין המינים יש נפוצים ויש נדירים, גדלים בשולי יערות שונים ויש בשטחים פתוחים.",
    mitranitText7:
      "בישראל 4 מינים בסוג הידועים בוודאות ועוד נוספים שנצפו, מחכים לבדיקת מעבדה אך טרם פורסמו לקהילה המדעית. נדווח עליהם באתר כשהזיהוי יפורסם.",
    mitranitText8Bold: "מטרנית גדולה – M.procera",
    mitranitText9:
      "המין הינו הגדול והמרשים בסוג והדמיון למטרייה היווה את מקור השם. קוטר הכובע כ 25 ס''מ, בצבע קרם עם קשקשים מעט כהים. הכיפה בעלת פיטם כהה. הרגל באורך יותר מ 25 ס''מ, מתרחבת ובולבוסית בחלקה התחתון ובעליון יש טבעת רחבה בעלת שני גוונים המשתחררת על הרגל ונשארת תלויה. הריח נעים וטעמה ערב לחיך.",
    mitranitImg1: "© ירון זיו",
    mitranitImg2: "© אראלה הרי",
    mitranitText10Bold: "מטרנית מתקלפת – M.excoriata",
    mitranitText11:
      "שמה המחודש – שמשיינית קליפת-שוליים. פטרייה מהגדולות בסוג, קוטר הכובע כ 10 ס''מ, בצבע קרם ועל הכפה פיטם זעיר הבולט מבין חתיכות קרום מעין קרעים. הרגל צרה באורך כ12 ס''מ מכוסה קשקשים עדינים, מתרחבת בבסיסה. הטבעת צרה בעלת שני גוונים, נעלמת עם התבגרותה. גדלה בשטחים פתוחים עם צמחייה נמוכה, בשוליים ובקרחות יער ופארקים.",
    mitranitImg3: "© ברוריה גל",
    mitranitText12Bold: "מטרנית פיטם – M.mastoidea",
    mitranitText13:
      "במין זה ידוע תת-מין בשם M.m.konradii ( לפי מיקובנק אינו מין נפרד) .דומה למ.מתקלפת ונבדלת בגודל הפיטם וכסות הכפה במעין פתיתים . קוטר הכובע כ 12 ס''מ,      הרגל צרה באורך כ 14 ס''מ, עם קשקשים עדינים. הטבעת רחבה משתחררת בבגרותה.",
    mitranitImg4: "© מטיו גלארדי",
    mitranitImg5: "© רותי טלמור",
    mitranitText14Bold: "*מטרנית כהת-דיסק - Macrolepiota phaeodisca",
    mitranitText15:
      "המין מעט מוכר בארץ אך לא מצאנו סימוכין לבדיקתו המולקולרית. נחשבת כמטרנית קטנה בסוג, דומה למ. פיטם ונבדלת בכפה ובפיטם הכהים מהאחרות. ככל שמתקרבים לשוליים הצבע בהיר יותר. קוטר הכובע כ9 ס''מ, הרגל באורך כ 12 ס''מ, הטבעת צרה יחסית ונעלמת בהתבגרותה. גדלה בשולי חורש ויער באזור חולי ותפוצתה באזור הים-תיכון.",
    natufa: "נטופה – Lactarius",
    natufaText1: "הנטופה שייכת למשפחת החריפתיים – Russullaceae.",
    natufaText2:
      " הנטופות גדלות על הקרקע בין המחטים של עצי אורן או ביער מעורב. מקור שמה הוא הנוזל המופרש מבין הדפים שבכובע. באנגלית שמה Milk cap. בסוג יש מינים בגודל שונה, מגדול ועד בינוני. הרגל והכובע עבים ובשרניים, בצבעים מצהוב ועד כתום עז. לכל מין בסוג נוטף בעת פגיעה או פציעה נוזל בצבע אופייני המאפשר לנו זיהוי מדויק.",
    natufaText3Bold: "נטופה ערבה – Lactarius deliciosus",
    natufaText4:
      "שם המין מבהיר אודות הטעם לחיך, לאחר בישול כמובן. הנפוצה מבין המינים הגדולים, עד כ 15 ס''מ, צבעה כתום ובחתך הרגל ניכרת מעין טבעת כתומה. אם נחרוץ בדפים יחל לנטוף נוזל צהוב. בשפשוף יהפוך המקום לצבע נחושתי/ירקרק המופיע גם בהזדקנותה.",
    natufaText5: "גדלה בקבוצות ונחבאת מתחת לשכבת מחטים ביערות אורנים.",
    natufaImg1: "© עירית צוק",
    natufaImg2: "© ניר יבגי",
    natufaText5Bold: "נטופה דורית – Lactarius zonarius",
    natufaText6:
      "מהנטופות הגדולות, בגוון צהוב בהיר, בשונה לנטופה ערבה והנוזל המופרש הינו בצבע לבן. דומה לסוג חריפית בגודל ובצורה.",
    natufaImg3: "© חוה להב",
    natufaText7Bold: "נטופה דמית - Lactarius sanguifuuls",
    natufaText8:
      "מהנטופות הגדולות, דומה מאוד לנטופה ערבה וצבעה נוטה לאדום. בחתוך הרגל ניכרת מעין טבעת אדומה. הנטף בצבע אדום ייני. נצפתה, נאספה, נבדקה גנטית במוזיאון לטבע אוניברסיטת ת.א וזוהתה כמין נפרד שבעבר נחשב תת-מין של הערבה. נדירה יחסית, ידועה בשנים האחרונות ביער בן שמן.",
    natufaImg4: "נטופה דמית לצד ערבה",
    natufaImg5: "© ניצן אלסר",
    natufaText9Bold: "נטופה זהובת נטף – Lactarius chrysorrheus",
    natufaText10:
      "דומה לנטופה ערבה, הרגל בהירה והנוזל בצבע לבן המשתנה לאחר מעט זמן לזהוב.",
    natufaImg6: "© ארנון שדמי",
    natufaImg7: "© ארנון שדמי",
    natufaText11Bold: "נטופה חלבית – Lactarius ilicis",
    natufaText12:
      "מתוארת לראשונה ע''י Sarnari (באתר מיקובנק) 1993. דומה לנטופה דורית אך עדינה יותר. מופיעה בגוונים בהירים שונים. נחשבת נדירה. מעט תצפיות ידועות מהכרמל והגליל. נבדקה גנטית במוזיאון לטבע אוניברסיטת ת.א.",
    natufaImg8: "© נ. זילברמן",
    natufaText13Bold: "נטופת מאיירי / צמירה – Lactarius mairei",
    natufaText14:
      "בגודל בינוני .שולי הכובע מקופלים פנימה. מכוסה בשערות על פני הכובע. מטיפה נוזל לבן.",
    natufaImg9: "© איילה מאיר",
    natufaImg10: "© דליה בונס",
    natufaImg101: "© וילבאוט",
    natufaText15Bold: "נטופה ריחנית – Lactarius camphoratus",
    natufaText16:
      "קטנה בגוון כתום עז. ביבוש ניכר ריח מיוחד. דומה מאוד לאטלנתית. נצפתה בגליל מערבי.",
    natufaImg11: "© יהודה מרטה",
    natufaImg12: "© יהודה מרטה",
    natufaText17Bold: "נטופה אטלנתית / שעירת בסיס – Lactarius atlanticus",
    natufaText18:
      "קטנה בגוון כתום אדום, גדלה בקבוצות צפופות. בבסיס הרגל ניכרות מעין שערות. נפוצה ביערות הגולן ומעט גם בגליל. נבדקה גנטית במוזיאון לטבע אוניברסיטת ת.א.",
    natufaImg13: "© ניר יבגי",
    natufaImg20: "© דן רוסק",
    madafit: "מדפית - Trametes",
    madafitText1:
      "שייכת למשפחת הנקבובניתיים - Polyporaceae, סדרת העציות. כינויה - Turkey tail.",
    madafitText2:
      "נכללת בקבוצת פטריות המדף שפרושה צורת החיבור לגזעי עצים. בקבוצה זו יש סוגים רבים הדומים בצבע ובגודל ולשם זיהוי יש להתבונן בצד התחתון במבנה הנקבים של הצינוריות בהן מתפתחים הנבגים.",
    madafitText3:
      "הסוג מדפית מופיע בקבוצה צפופה של גופי פרי שטוחים הנראים כפרח, כצדף גדול או מדף קטן מעוגל. העובי שונה בכל מין שבסוג. במשך הגידול הופכת מגמישה לקשה ועצית והצבע מתכהה.",
    madafitText4:
      "הפטרייה גדלה בעיקר על עצים רחבי-עלים  פגועים, מתים ויבשים. בעזרת האינזימים שמפרישה מפרקת את התאית והליגנין שבתאי העץ, הם הופכים לחומרים פשוטים הנמסים במים וזמינים להזנת הפטרייה. בפעילות זו נגרמת התפוררות העץ.",
    madafitText5: "בישראל ידועים 2 מינים עם תת מינים:",
    madafitText6Bold: "מדפית ססגונית -  T. versicolor",
    madafitText7:
      "מדפית יושבת בצמוד לגזע ומתפתחת כלפי חוץ בדורים לא סימטריים ובמגוון צבעים: צהבהב, חום, שחרחר סגלגל וכחלחל. המדף דק ונראה כמניפה צבעונית. הקרום העליון שעיר. בצד התחתון בולטות הצנוריות באורך עד 2 מ''מ.",
    madafitImg1: "© דליה בונס",
    madafitImg2: "© ניצן אלסר",
    madafitText8Bold: "מדפית זהובה / דורית – T. ochracea /zonata.",
    madafitText9:
      "סימן הזהוי העקרי הם גווני הצהוב, הבהיר והכהה, אוקר או כתמתם של הדורים. הצנוריות באורך או עומק עד 2 מ''מ. פחות נפוצה מהססגונית.",
    madafitText10: "*יש תת-מין בשם ",
    madafitText10Bold: "מדפית שעירה – T hirsula ",
    madafitText11:
      "שמחשיבים אותו כתת מין של הזהובה. פני המדף שעירים בגוון אפרפר.",
    madafitImg3: "© First nature",
    tzmudit: "צמודית - Fuscoporia",
    tzmuditText1: "שמות קודמים :Phellinus, Fomitiporia.",
    tzmuditText2: "משפחת זיפניתיים/קישוטיתיים – Hymenochhaetaceae.",
    tzmuditText3:
      "פטריית עץ קשה דמוית אצטבה/מדף ופרוש שמה מצורת החיבור לגזעי עצים. הגוונים חום, ערמוני, קינמון ואפרפר. פני המדף בכסות קטיפה, או סדקים. השוליים הצעירים עבים וגליים. גוף הפרי בקוטר עד 25 ס''מ ועובי עד 10 ס''מ. בצד תחתון הרקמה הפורייה בנויה מצינוריות עם פתחים/נקבים, בעיקר מצולעים ובחלק עגולים. לפיהם ניתן לזהות את המינים השונים. הבשר בעובי וצבע שונה בכל מין. הפטרייה רב-שנתית ובמשך הגידול הופכת מגמישה לקשה, עצית וצבעה מתכהה. הפטרייה אינה מתפוררת ונשארת כלוחית עצית למשך זמן ארוך וכך משמשת כבסיס לגידול אצות וטחבים. גדלה בעיקר על ענפים יבשים וגזעים כרותים.",
    tzmuditText4:
      "קל מאוד לטעות בזיהוי עם סוגים דומים הגדלים כמדף על גזעים, כמו בהוקית, קשוטית, מדפית נקבובנית ואבוקית. מעט מידע קיים אודות סוג זה בספרות, ובישראל טרם נאסף במאגרי המידע.",
    tzmuditText5Bold: "המינים הידועים:",
    tzmuditText6Bold: "צ. שטוחה - F.contigua",
    tzmuditText7:
      "שם קודם – Phellinus contiguous. גוף הפרי בקוטר עד 20 ס''מ ועובי כ 5 ס''מ. החלק העליון מעט צימרי בצבע חום עם שוליים בהירים. בצד תחתון הצינוריות באורך 2-4 מ''מ בצבע דבש והדופן חום –אפרפר. פתחי הצינוריות מעוגלים או מצולעים. גדלה על ענפים מתים של אורן או על עצים רחבי-עלים.",
    tzmuditImg1: "© רעות בן אלישר",
    tzmuditText8Bold: "צ. נקודה – F.punctatus",
    tzmuditText9:
      "קוטר הפטרייה עד 25 ס''מ והעובי כ 2 ס''מ. החלק העליון בצבע חום-אפרפר או ערמוני והתחתון חום. הצינוריות באורך עד 5 מ''מ עם נקבים מצולעים או עגולים והבשר בעובי כ 2 ס''מ בגוון מזהוב ועד חום. גדלה על ענפים וגזעים יבשים של עצים ושיחים ממינים שונים.",
    tzmuditText10Bold: "צ. אשונה – F.torulosus",
    tzmuditText11:
      "גוף הפרי בקוטר עד 25 ס''מ ועובי כ 8 ס''מ, פני המדף סדוקים ואינם חלקים בצבע חום אדמוני עד שחרחר. השוליים עבים וגליים בצבע כתמתם. הבשר בעובי כ 3 ס''מ בצבע חלודי. הצינוריות באורך 4 מ''מ בצבע חום. גדלה על גזעים, ענפים כרותים ויבשים של עצים שונים.",
    tzmuditImg2: "© ידענטבע",
    tzmuditText12Bold: "צ. הדוקה – F.robustus",
    tzmuditText13:
      "גוף הפרי בקוטר עד 30 ס''מ עבה מאוד (דומה לאבוקית). פניו קטיפתיים או סדוקים, בצבע חלודי ובהתבגרות עד אפור. הצינוריות באורך כ 3 מ''מ בצבע צהבהב-חכלילי עם פתחים מצולעים או עגולים בגוון חכלילי. עובי הבשר כ 3 ס''מ וצבעו חלודי בגוונים שונים. גדלה על גדמים וגזעי עצים של רחבי-עלים. יחסית בסוג - אינה נפוצה.",
    tzmuditImg3: "© FoestPlsts.eu (באישור)",
    tzmuditText14: "*בארץ רשומים שמות נוספים של מינים, חסרי בדיקה או תיאור.",
    zifanit: "זיפנית - Crinipellis",
    zifanitText1: "שייכת למשפחת הצנומיתיים - Marasmiaceae.",
    zifanitText2: "בסוג זה יש מעט מינים ומין אחד בלבד בישראל.",
    zifanitText3Bold: "זיפנית הגבעול - C. scabella",
    zifanitText4: "שם קודם – C.stipitarius.",
    zifanitText5:
      "פטריית כובע קטנטנה, קוטר הכובע כ 1 ס''מ בצבע חום בהיר עם מרכז חום כהה. הדפים לבנים. הרגל בצבע חום כהה, זיפים ופספוס מעטרים אותה לכל אורכה. מיוחדת מאוד בגידול על עשבים, זרדים וגבעולים דקים ונסתרת מעיננו.",
    zifanitText6:
      "* שם סוג זה בעברית נכתב בטעות גם בספר בנימיני 'פטריות עילאיות' לסוג אחר. יש להחליפו.",
    zifanitImg1: "© יאיר אור",
    zifanitImg2: "© אראלה הרי",
    glalit: "גללית - Bolbitius",
    glalitText1: "שייכת למשפחת הגלליתיים - Bolbitiaceae.",
    glalitText2:
      "פטריית כובע  קטנה בקוטר עד 6 ס''מ, חרוטית בצעירותה, מקומטת, סדוקה, מחורצת ודביקה במעט. רגל חלולה ושבירה בגוון צהבהב. דומה מאוד לסוג חרוטית.",
    glalitText3: "מקום הגידול הוא עשבייה ושדות לחים ומדושנים.",
    glalitText4:
      "בישראל ידועים 2 מינים שנבדקו ועוד מין בצבע כתום הממתין לבדיקה.",
    glalitText5Bold: "Bolbitius lacteus - גללית  חלבית",
    glalitText6: "השם המדעי החלף ב 1998 ל-Conocybe albipes.",
    glalitText7:
      "הכובע בצבע לבן חלבי לעיתים עם כתמים צהובים המקבל גוון כהה בבגרותו. הדפים בצבע קש. נחשבת עדינה ונדירה.",
    glalitImg1: "© אראלה הרי",
    glalitText8Bold: "B.titubans - גללית צהובה",
    glalitText9: "שם קודם – B.vitellinus.",
    glalitText10:
      "הכובע מחורץ ומפוספס בצבע צהוב-כתום המקבל גוון כהה בהבשלה. הדפים בצבע קש. חייה קצרים ומלווים בהתמוססות.",
    glalitImg2: "© ג'ון",
    glalitImg3: "© אבישג סודקוב",
    kashkeshanit: "קשקשנית - Pholiota",
    kashkeshanitText1: "שייכת למשפחת האבנטיים - Strophariaceae.",
    kashkeshanitText2:
      "שם הסוג מבטא את הופעת הקשקשים על פני הרגל ובחלק מהמינים גם על הכובע. (Polis ביוונית פרושו קשקש). פטריית דפים בגודל בינוני עד גדול ודומה לסוגים נוספים במשפחה. הסוג גדל בארצות עם אקלים ממוזג.",
    kashkeshanitText3: "בישראל ידועים 2 מינים ואחד נוסף הגדל בתרבות.",
    kashkeshanitText4Bold: "קשקשנית פחם – P. carbonaria",
    kashkeshanitText5: "השם הקודם היה קשקשנית פחומה ותוקן בוועדה ללשון העברית.",
    kashkeshanitText6:
      "גודל הפטרייה בינוני או גדול, קוטר הכובע עד 9 ס''מ, הכפה חלקה, מבריקה ובמצב של לחות באוויר – דביקה. הצבע חום ערמוני והשוליים בהירים יחסית. צבע הדפים חלודי. הרגל עבה ומכוסה קשקשים חלודיים לכל אורכה.",
    kashkeshanitText7:
      "המיוחד וסימן הזיהוי במין זה, שגדלה בקבוצות במקום שעבר שריפה. אין הוכחה מדעית שהאפר מהווה מקור להזנתה. הסיבה היא שהנבג זקוק לחום גבוה כדי לנבוט! לאחר שהתפתח התפטיר בקרקע יישאר ויתפתח במקום למשך שנים, יעלו גופי פרי ויתכן שלא נראה כל סימן של שריפה.",
    kashkeshanitImg1: "© צעירה עם הצעיף בשולי הכובע – דליה בונס",
    kashkeshanitImg2: "© ברוריה גל",
    kashkeshanitText8Bold: "קשקשנית לוהבת – P.flammans",
    kashkeshanitText9:
      "הכובע בצבע צהוב לימוני, בקוטר עד 9 ס''מ, מכוסה בקשקשים מחודדים. השוליים מקופלים מעט פנימה. בצעירותה ניכרים שאריות הצעיף סביב הכובע וגם על הרגל, מה שנראה כטבעת.",
    kashkeshanitText10: "מופיעה בקבוצות צפופות בעיקר על גדמי עצי מחט.",
    kashkeshanitText11:
      "המין נפוץ בארצות רבות עם אקלים ממוזג בעולם. בישראל נדירה, נאספה ופורסמה במאמר בנימיני 1984. *מין נוסף שאינו גדל בטבע הישראלי, אלא בגידול מסחרי.",
    kashkeshanitText12Bold: "קשקשנית תרבותית / ערמונית – P.adiposa",
    kashkeshanitText13: "השם המסחרי – Chesnut musroom.",
    kashkeshanitText14:
      "הכובע עם קשקשים לבנים בוהקים ועם ההבשלה הכובע נראה עם כתמים. קטנה מהמינים הנ''ל. מקובלת בין המגדלים למאכל, עדינה מאוד.",
    kashkeshanitImg3: "© אורן דואניאס",
    kashtanit: "קשתנית - Daldinia",
    kashtanitText1: "שייכת למשפחת העציוניתיים - Hypoxylaceae.",
    kashtanitText2: "בישראל ידוע מין אחד:",
    kashtanitText3Bold: "קשתנית טבעתית - Daldinia concontrica",
    kashtanitText4:
      "לפטרייה צורת כדור נוקשה חסר רגל הצמוד לקליפת עצים וענפים מתים. גודלה עד 7 ס''מ קוטר. לרוב מופיעה בקבוצה. הצבע חום כהה או בורדו ובהתבגרותה הופך לשחור שנותן לה מראה של גוש פחם. פניו חלקים, מבריקים או מגובששים.",
    kashtanitText5:
      "בחתך הכדור מבחינים בחלק הפנימי בשכבות בהירות וצפופות הנראות כטבעות או קשתות, ומכאן שמה. כיון שהחומר של הקשתנית  עצי, היא נשארת במצב יבש זמן ארוך ומשמשת כחומר בערה, והכינוי ''כדור פחם''.",
    kashtanitImg1: "© רותי טלמור",
    kashtanitImg2: "© דן רוסק",
    kashtanitImg3: "© אראלה הרי",
    avnatit: "אבנטית - Stropharia",
    avnatitText1: "משפחת האבנטיים Strophariaceae.",
    avnatitText2:
      "השם נלקח מהמילה אבנט שהיא חגורה רחבה ומאפיין את מבנה הרגל והטבעת שעליה. הפטרייה שייכת לפטריות כובע בעלות דפים.",
    avnatitText3:
      "בישראל ידועים כמה מינים בצבעים שונים ובביוטופ שונה. שלושה נמצאו וצולמו בעשור האחרון ונמצאים בבדיקת מעבדה. נפרסמם כאן לאחר האישור בפרסום המדעי.",
    avnatitText4Bold: "אבנטית עטורה – Stropharia coronilla",
    avnatitText5:
      "כובע כיפתי בקוטר עד 5 ס''מ בגוון צהוב-תפוז ופניו חלקים, עם מעט ברק. הדפים רחבים עם מפרץ קטן בחיבור לרגל, הגוון בצעירותה חום-סגלגל המשתנה לחום כהה עם ההבשלה. צבעים אלו גורמים לבלבול בזיהוי עם הינומה.",
    avnatitText6:
      "הרגל בהירה מהכובע בגובה עד 6 ס''מ, בעלת קשקשים קטנים ועליה טבעת לבנה, צרה בחלקה העליון הנושרת בקלות. גדלה בעיקר בקרחות ושולי יער, בשדות פתוחים ועשבוניים.",
    avnatitText7:
      "ידועה בחומרים הכימיים שמשמשים לרפואה. יש מינים טובים למאכל ויש רעילים.",
    avnatitImg1: "© אראלה הרי",
    avnatitImg2: "© יאיר אור",
    avnatitText8Bold: "א' קשקשית – Leratiomyces squamosus",
    avnatitText9:
      "פטרייה קטנה, קוטר הכובע 3 ס''מ, הכיפה בצבע חום צהבהב. הרגל באורך 7 ס''מ, בחלקה התחתון קשקשים בהירים ובמרכז טבעת צרה. נמצאה בגולן ביער אלונים. נבדקה גנטית במוזיאון לטבע, אוניברסיטת ת.א",
    avnatitImg3: "© ניצן אילסר",
    edibleSpeciesInIsreal: "פטריות מאכל בישראל",
    edibleSpeciesInIsrealText1:
      "גידול ואכילת פטריות לא היו מקובלים בישראל שנים רבות ועם הזמן התפתחו וגדלו להפליא. משנה לשנה נוספו מומחים בגידול וכך גם מינים חדשים לשימושים קולינריים ורפואיים. שפים למדו את טעמן וריחם המיוחד המעשירים מאוד את המנות, משמשות  כתבלין, להכנת רטבים, מרקים, מלוי במאפים ועוד.",
    edibleSpeciesInIsrealText2:
      "ייבוש פטריות נפוץ בתעשייה ןגם במטבח הפרטי ונמכר במגוון שונה של מינים בצורת אבקה או חתיכות שטעמן מרוכז וקל להכנה. המקובלות לייבוש הן כמהה שחורה הנקראת טרופל, פקועה נקראת שמפיניון, גושית נקראת פורצ'יני וגמישנית נקראת שיטאקי הן הנמכרות ביותר. נאמר שקילוגרם אחד יבש שווה לעשרים טריות. לפני השימוש יש להשרותן במים.",
    edibleSpeciesInIsrealText3:
      "מבחינה קולינרית מבדילים בין פטריות מצוינות, טעימות מאוד, טעימות ועד ללא טעימות. מבין חלקי הפטרייה, הנאכל העיקרי בפטריית כובע הוא הבשר המכוסה בקוטיקולה ובתחתיתו מתפתחת שכבת הרבייה בעלת דפים או צינוריות. עם ההתבגרות נפתח הכובע, מתפתחים נבגים ומשתנים הצבעים שמהווים לנו סימן להימנע מאכילה. הרגל פחות מומלצת לאכילה בגלל התאית המרובה הקשה לעיכול.",
    edibleSpeciesInIsrealText4:
      "בפטריות כרס החלק הנאכל הוא השכבה הפורייה שהיא החלק הגדול המרכיב את גוף הפרי ובה מתפתחים הנבגים, מכאן שלא נאכל פטרייה זקנה.",
    edibleSpeciesInIsrealText5:
      "ריח הפטרייה אופייני לכל מין ומהווה סימן זיהוי. קיימים ריחות שאנו יכולים לזהות כריח המוכר לנו מצמחים או פירות. במבחר הריחות המיוחדים נמצא ריח קינמון, ריח אניס, ריח שקדים, ריח אפרסק, ריח צנון, ריח קמח, ריח יוד, ריח שום ועוד.",
    edibleSpeciesInIsrealText6Bold: "המלצות ואזהרות:",
    edibleSpeciesInIsrealText7List:
      "אל ניטעה ונחשוב שאם בע'ח מסוים אכל מהפטרייה סימן שטובה גם לנו. לכל חיה יש חילוף חומרים שונה ואנטי-טוקסיים או אינזימים שמפרקים את הרעל ואינם משפיעים על בריאות גופם.",
    edibleSpeciesInIsrealText8List:
      "אכילת פטריות בלתי מבושלות ממינים רבים נחשבת קשה לעיכול במיוחד לאנשים רגישים. מינים אכילים מהסוגים חריפית, אמנית וגושית אין לאכול טריות.",
    edibleSpeciesInIsrealText9List:
      "אם אכלתם פטרייה בפעם ראשונה –איכלו אך מעט וראו מה ההשפעה. השאירו אחת טרייה לחרום, אם נפגעתם ויש להראות לרופאים.",
    edibleSpeciesInIsrealText10List:
      "בארוחה הכוללת פטריות – אל תשתו משקה אלכוהולי, יש מינים שגורמים לתגובה קשה.",
    edibleSpeciesInIsrealText11List:
      "להעצמת הטעם כדאי לצרוב בחום גבוה. אם מבשלים במים גורמים להתמוססות מולקולות הטעמים.",
    edibleSpeciesInIsrealText12List:
      "פטריות מתפתחות ויוצרות נבגים גם לאחר שנקטפו ומונחות בקרור. לפיכך אין להחזיקן יותר מיומיים במקרר או כאלה שחיכו על המדף בחנות.",
    edibleSpeciesInIsrealText13List:
      "יש להיזהר בזיהוי ואכילת פטריות בצבע לבן מהסיבה שמביניהן יש דומות מאוד, רעילות מול משובחות, בעיקר מהסוג אמניתה ופקועה שסמני הזיהוי בצעירותן קשים לאבחנה.",
    edibleSpeciesInIsrealText14List:
      "הסובלים מאלרגיות או נשים בהריון – רצוי שימנעו מאכילת פטריות.",
    edibleSpeciesInIsrealText15Bold: " מינים טובים וטעימים למאכל:",
    edibleSpeciesInIsrealText16Underlined: "פטריות כובע:",
    edibleSpeciesInIsrealText17:
      "ארנייה, פקועה דו-נבגית, פקועה מצויה, פקועת השדה, נטופה ערבה, מטריינית האגוזים, אחלמית ערומה, אזנית הכלך, קמרונית, שחרחרית, ישעורית אפורה, נרתיקנית דביקה ועוד.",
    edibleSpeciesInIsrealText18Underlined: "פטריות אחרות:",
    edibleSpeciesInIsrealText19:
      "גמצוץ, כמהין, גביעונית, נקובית מצהיבה, שיננית שטוחה, אבקית רכה, כדורנית ואזנונית.",
    edibleSpeciesInIsrealText20Bold: "הערה:",
    edibleSpeciesInIsrealText21:
      "ראו בנוסף באתר זה אודות ערך תזונתי וגידול פטריות. איננו כוללים מתכונים המצויים בשפע באינטרנט.",
    atzitzit: "עציצית { ליבנית } - Leucocoprinus",
    atzitzitText0: "שייכת למשפחת הפקועתיים - Agaricaceae.",
    atzitzitText1:
      "הסוג קיבל שם נוסף מאז התפשט בארץ שלא בדרך הטבע. המינים ניזונים מרקב ברמה גבוהה של חומרי הזנה המצויים מעט ביערות והרבה מאוד במצע שהאדם מייצר לגידולי צמחים בחממות ובעציצים.",
    atzitzitText2:
      "המינים שייכים לפטריות דפים, גודל קטן, 3-7 ס''מ, כובע דק-בשר, כפה מכוסה קשקשים עדינים והשוליים מחורצים. רגל ארוכה מקוטר הכובע ובחלקה העליון טבעת צרה.",
    atzitzitText3:
      "בישראל ידועים 5 מינים מהתקופה שלארץ נקנה ביבוא מצע המורכב מתערובת של חומרים אורגניים כמו שבבי קוקוס, כבול הומוס ועוד. בתוך התערובת היו נבגים או קורי תפטיר עוד לפני שהגיעו לארץ וכאן קיבלו מים בשקייה והצמיחו גופי פרי.",
    atzitzitText4Bold: "עציצית לימונית - Leucocoprinus birnbaumii",
    atzitzitText5:
      "בערך בשנת 2000 נתגלתה הפטרייה הראשונה בארץ ובהמשך היו עוד ועוד תצפיות ממשתלות ובתים פרטיים. בהעדר זיהוי ושם למין יפה ומעניין שכזה - אני, ברוריה גל,  נתתי לה שם עממי 'עציצית לימונית' ובישיבת האקדמיה ללשון העברית ב 2023  שכנעתי לאמץ שם זה כשם רישמי.",
    atzitzitText6:
      "מין זה הינו היחידי בצבע צהוב עז בסוג. השם ליבנית ניתן לסוג במאה הקודמת, כאשר היה ידוע בארץ רק מין בצבע לבן.",
    atzitzitImg1: "© דן רוסק",
    atzitzitImg2: "© דן רוסק",
    atzitzitText7Bold: "עציצית בת-עין - Leucocoprinus Brebissonii",
    atzitzitText8:
      "נקראת על שמו של המתאר הראשון של מין זה בשנת 1874 ששייך אותה לסוג מטריינית וב 1943 הוחלף השם לפי בדיקות גנטיות. דומה לע.לימונית במקומות הגידול, בגודל ובצורה אך הצבעים שונים. כפה ורגל בצבע לבן עכור עם גוון חום במרכז הכפה.",
    atzitzitImg3: "© יואב כהן",
    atzitzitImg4: "© ליאור אלמגור",
    atzitzitImg5: "© ליאור אלמגור",
    atzitzitText9Bold: "עציצית/ליבנית גירית - Leucocoprinus cretaceus",
    atzitzitText10:
      " הגדולה בסוג, קוטר כובע 9 ס''מ. כולה ,כולל הרגל, מכוסה קשקשים או יבלות גדולות ובולטות בצבע לבן צחור. גדלה בעיקר בחממות ועציצים אך בארופה יש מעט תצפיות מערמות של רקבובית, קש או קומפסט שעמדו זמן רב במקום רטוב.",
    atzitzitImg6: "צעירה. © דן רוסק",
    atzitzitImg7: "בוגרת. © עמית דולב",
    atzitzitText11Bold: "מינים נוספים מרשימות בישראל:",
    atzitzitText12:
      "ליבנית בצלית Leucocoprinus sepistipes/בנימיני. בעלת כתמים קטנים צהובים על הכפה הלבנה ופיטם בצבע חום.",
    atzitzitText13:
      "ליבנית קש Leucocoprinus straminellus/בנימיני. קטנה, לבנה עם גוון צהוב רק במרכז הכפה.",
    dfunit: "דפונית – Lyophyllum",
    dfunitText1: "משפחת הדפוניתיים Lyophyllaceae",
    dfunitText2:
      "סוג זה מתאפיין במירקם בשרני עבה ויבש. כאשר נכופף את גוף הפרי - לא ישבר, בגלל גמישותו.",
    dfunitText3:
      "הכובע בקוטר עד 12 ס''מ, חלק או קמחי בצבעי חום אפרפר עד שחרחר המושפע מתנאי הלחות. הדפים רחבים מפורצים או גולשים מעט על הרגל, בצבעים בהירים יותר מאשר בכובע. השוליים מעט גליים בהתבגרות. הרגל עבה, הגבה עד 8 ס''מ צבע בין חום בהיר לאפרפר.",
    dfunitText4:
      "ברוב המינים גופי הפרי יוצאים מנקודה אחת והמראה כגוש צפוף למדי.",
    dfunitText5:
      "מקום הגידול מגוון למדי, חורשות ויערות של עצים שונים, גינות ופארקים בקרקעות שונים.",
    dfunitText6:
      "בסוג דפונית קיימים בישראל 5 מינים ידועים ועוד נוספים הפחות מצויים ולא נבדקו מולקולרית. רשומים אצל בנימיני והזיהוי ביניהם לא תמיד ברור, מתמקד בעיקר בגוונים.",
    dfunitText7Bold: "דפונית מאוגדת - Lyophyllum decastes",
    dfunitText8:
      "דומה למין ימתיכוני בשם L. littoralis אך עדיין לא נבדק מולקולרית בישראל.",
    dfunitText9: "הנפוצה מבין הדפוניות, מקושטת בכתמים או נקודות על פני הכפה.",
    dfunitImg1: "© ברוריה גל",
    dfunitImg2: "© ברוריה גל",
    dfunitImg3: "© משה גלעדי",
    dfunitText10Bold: "דפונית צהובת דפים - Lyophyllum hypoxanthus",
    dfunitText11:
      "מין זה טרם זוהה מולקולרית בישראל אך ניתן לזהותו בנקל על פי הדפים הצהובים. הכפה בהירה ותמיד מלוכלכת בעפר.",
    dfunitText12:
      " לא היתה מוכרת בשנים עברו ולאחרונה יותר ויותר ניגלת למלקטים.",
    dfunitImg4: "© טל מיטל",
    dfunitImg5: "© טל מיטל",
    dfunitImg55: "© ארנון שדמי",
    dfunitText13Bold: "דפונית פחם - Lyophyllum anthracophila",
    dfunitText14: "שמה הקודם Tephrocybe carbonaria - אפורית פחומה.",
    dfunitText15:
      "קטנה יחסית לבני סוגה, כובע עד 5 ס''מ צבעו ב'ג עד חום. גדלה על שטחים שעברו שריפה, מכאן שמה.",
    dfunitText16:
      "קשה לקבוע האם מצויה או נדירה מהסיבה שדומה לאפורית ולא מדווחת מספיק.",
    dfunitText17Bold: "דפונית תפוחת-רגל - Lyophyllum rhopalopodium",
    dfunitText18:
      "המין עדיין לא נבדק מולקולרית בישראל. קל לזהותו על פי הרגל המעובה בבסיסה.",
    dfunitText19: "ידועה רק במעט תצפיות בארץ.",
    dfunitImg6: "© ניצן אילסר",
    dfunitText20Bold: "דפונית עבת דפים - Lyophyllum crassifolium / eustygium",
    dfunitText21:
      "הכובע בקוטר עד 6 ס''מ בגוון אפרפר בהיר או צבע קרם. הדפים מפרצים.",
    dfunitText22: "רגל דקה בגבה עד 8 ס''מ צרה בבסיסה בגוון אפור. אינה מצויה.",
    sarafit: "שרפית - Laccaria",
    sarafitText1: "משפחת Hydnangiaceae (בעבר נכללה  בישעוריתיים).",
    sarafitText2:
      "* כנראה קיימים מספר מינים בישראל שניצפו וצולמו אך טרם פורסמו בדיקות מולקולרית שלהן.",
    sarafitText3: "המין הידוע:",
    sarafitText4Bold: "שרפית בשרית - Laccaric laccata/proxima",
    sarafitText5:
      "הפטרייה בולטת בצבעה האדום-כתום, המושפע מהלחות באויר, ובקיבוציות של פרטים רבים יחדיו. הגודל קטן או בינוני, פני הכובע חלקים ובמרכז מעט שעיר. קוטר הכובע עד 8 ס''מ. השוליים סימטריים או גליים עם פספוס. הדפים עבים ודלילים, יושבים על הרגל, בצבע וורוד עד בשרי. הרגל באורך עד 10 ס''מ בצבע כהה מהכובע, לעיתים צרה בבסיסה. דומה מאוד לנטופה ריחנית ונטופה שעירת בסיס/אטלנתית.",
    sarafitImg1: "© דליה בונס",
    sarafitImg2: "© ברוריה גל",
    sarafitImg3: "להשוואה – נטופה שעירת בסיס - דן רוסק ©",
    nakuvit: "נקובית - Laetiporus",
    nakuvitText1: "משפחת הנקבובניתיים Polyporaceae",
    nakuvitText2: "המין היחיד בסוג:",
    nakuvitText3Bold: "נקובית מצהיבה / כרבולתית - Laetiporus sulphureus",
    nakuvitText4:
      "הכנוי הנפוץ בעולם – Chicken of the woods על שום המרקם והטעם של המאכל שעושים ממנה, הערב לחיך כמו פרוסות עוף.",
    nakuvitText5:
      " שייכת לפטריות המדף, צומחת בעצים וגופי הפרי הגדולים והשופעים גדלים על קליפת הגזע. התכונה המאפיינת מין זה היא צפיפות גופי הפרי המשווה לה צורת זר מניפות המגיע לרוחב עד 40 ס''מ. בולטת מאוד בשטח בגלל הצבע הצהוב-חלמוני הניכר לעיננו ממרחק.",
    nakuvitText6:
      "בתחילת ההתפתחות נראית ככדור בלתי סימטרי בגוון לבן ובהמשך גדל למניפה בקוטר עד 8 ס''מ. על פי תנאי הלחות באוויר משתנה הצבע מצהוב-כתום ועד צהבהב. על ה'מניפה' ניכרים דורים בכמה צבעים. שולי ה'מניפות' בהירים יותר עד צבע לבן. בצעירותה המירקם רך וספוגי ובהמשך מתקשה.",
    nakuvitText7:
      "השכבה הפורייה, בה מתפתחים הנבגים, מצויה בצד התחתון ונראית כשכבת נקבים מצולעים וצפופים, מקור שמה.",
    nakuvitText8:
      "מעניינת העובדה שהיא מתפתחת בחודשים החמים בארצנו, בעיקר בסתיו, והרי ניזונה מנוזלי פנים הגזע ולא תלויה בגשם בלבד.",
    nakuvitText9:
      "גדלה על מגוון עצים, בעיקר רחבי-עלים, בארץ ידועה על חרוב, אקליפטוס ועוד. חשוב לדעת שהטעם מושפע מסוג העץ ולא תמיד טעים.",
    nakuvitImg1: "© רותי טלמור",
    nakuvitImg2: "© רוני גולדשטיין",
    nakuvitImg3: "© ארנון שדמי",
    haririt: "חרירית - Gyroporus",
    hariritText1: "משפחת הגושיתיים Boletaceae",
    hariritText2: "בישראל רשומים 2 מינים, אך אחד מוכר וידוע יותר.",
    hariritText3Bold: "חרירית ערמונית - Gyrophorus castaneus",
    hariritText4:
      "שייכת לפטריות הספוג, קשיחה ויבשה. הכובע עבה בקוטר עד 10 ס''מ עם כפה חלקה או קטיפתית מעט בצבע ערמוני. הספוג לבן המצהיב מעט בבגרות, בעל נקבוביות עגולות. הבשר לבן שאינו משתנה בחיתוך. הרגל עבה ורחבה יותר בחלקה התחתון, חלולה וצבעה ערמוני.",
    hariritText5: "גדלה בעיקר ביערות אלונים ופחות באורנים.",
    hariritImg1: "© ארנון שדמי",
    hariritImg2: "© יהודה מרטה",
    hariritText6: "*מין נוסף עם תצפית בודדת של פרפ' בנימיני - ",
    hariritText7Bold: "חרירית מכחילה - G.cyanescens",
    hariritText8:
      "בה הבשר מכחיל בחיתוך. על הרגל ניכרים פסי רוחב כטבעות, המבדילות מהמין ערמונית.",
    hariritText9: "אולי שייכת למין זה, הרגל בהירה ועליה ציור טבעות. לא נחתכה.",
    hariritImg3: "© Inaturalist",
    resisit: "רסיסית - Dacrymyces",
    resisitText1: "משפחת הרסיסיתיים Dacrymycetaceae.",
    resisitText2: "בישראל ידוע מין אחד בסוג.",
    resisitText3Bold: "רסיסית נמוגה - (deliquescens) stillatus Dacrymyces",
    resisitText4:
      "גוף הרבייה קרישי הנראה כטיפות כדוריות ג'לטיניות, בצבע צהוב או כתום (באותו מין מופיעים שני צבעים). הקוטר כ 5 מ''מ. באוויר יבש מתכווצת ונראית כקרום ובהשפעת גשם תופחת שוב.",
    resisitText5:
      "דומה לקרישית הגדולה ממנה ולפיטרירית הקטנה ממנה. מופיעה בקבוצה גדולה וצפופה.",
    resisitText6: "גדלה על ענפים יבשים של מגוון עצים במקומות לחים.",
    resisitImg1: "© יהודה מרטה",
    resisitImg2: "© רותי טלמור",
    nartikanit: "נרתיקנית - Volvariella/Volvoluteus",
    nartikanitText1: "משפחת הקטיפניתיים Pluteineae",
    nartikanitText2:
      "פטרייה מרשימה בעלת טבעת ניכרת על רגל גבוהה. הכובע גדול יחסית עבה ובשרני, במין אחד פניו חלקים ודביקים ובאחר פניו שעירים. הדפים חופשיים והפרדת הרגל מהכובע נעשית בקלות.",
    nartikanitText3:
      "כל מין שבסוג גדל במצע שונה, בשדות עשבוניים ופתוחים, בחורש על פני הקרקע או על גזעי עצים. בישראל ידועים 3 מינים. (מין נוסף – V.surrecta בספרו של וואסר,1995 ברוסית)",
    nartikanitText4Bold: "נרתיקנית נאה - volvopluteus gloiocephala",
    nartikanitText5:
      "יש המחלקים את המין לשני תת-מינים נרתיקנית נאה ודביקה, השם המדעי הוחלף מהאחרות.",
    nartikanitText6:
      "בוקעת מתוך קרום לבן כמו מעטה של ביצה, הרגל מזדקרת ועולה, והקרום נשאר כנרתיק העוטף את הבסיס, צרה במעט בחלקה העליון. סמני הזיהוי בולטים וברורים: דפים חופשיים בצבע לבן-ורדרד ההופך לחום עם התבגרותה והכובע ניתק בנקל מהרגל. קוטרו עד 10 ס''מ, הכפה חלקה, מבריקה ורירית, במיוחד בתנאי לחות, עם פיטם זעיר. ריח הפטרייה אופייני ומיוחד.",
    nartikanitText7:
      "גדלה בשטחים עשבוניים שופעי חומר אורגני, בשדות, פרדסים ובצידי דרכים. מופיעה בכמויות ומאוד אהודה על קהל המלקטים, בעיקר בשרון.",
    nartikanitImg1: "© ברוריה גל",
    nartikanitImg2: "© דן רוסק",
    nartikanitText8Bold: "נרתיקנית חורש - Volvariella bombycina",
    nartikanitText9:
      "הגדולה מבין הנרתיקניות, הכובע מגיע עד 20 ס''מ קוטר, מכוסה בשערות זעירות במרקם משי. (תרגום שם המין). רגל ארוכה עד 15 ס''מ בצבע לבן.",
    nartikanitText10:
      "הייחוד שלה מתבטא במקום הגידול, גזעי עצים, חיים או מתים של רחבי –עלים. בארץ אינה שכיחה.",
    nartikanitText11:
      "בארץ נמצאו במין זה פרטים בודדים במופע צהוב. בבדיקה מולקולרית באוניברסיטת. ת.א נקבע שהוא אינו מין נפרד.",
    nartikanitImg3: "© ברוריה גל",
    nartikanitImg4: "© מופע צהוב. ארנון שדמי.",
    nartikanitText12Bold: "נרתיקנית קטנה - Volvariella murinella",
    nartikanitText13:
      "כשמה כן היא, הקטנה בסוג (בישראל), קוטר הכובע כ 6 ס''מ, הגוון לבן-אפרפר. הרגל בגבה עד 8 ס''מ, בצבע הכובע. בארץ נחשבת נדירה.",
    nartikanitImg5: "© ניצן אלסר",
    collectionImg1: "הדפס-נבגים",
    leshonit: "משפחת הלשוניתיים - Geoglossuaceae",
    leshonitText1:
      "שם הפטרייה נגזר מצורתה, מאורכת ושטוחה. נחשבת נדירה. אורכה 1-4 ס''מ.",
    leshonitText2: "חיה בבית גידול לח עם צמחיית טחבים.",
    leshonitText3: "דומה מאוד לסוג עציונית-Xylaria ,ראה הסוג באתר.",
    leshonitText4:
      "בארץ יש מעט תצפיות ופרטים בודדים נמסרו לבדיקה מולקולרית. עם קבלת הזיהוי נשלים כאן את המידע.",
    leshonitImg1: "© Freenatureimages",
    gachonit: "גחונית - Hypholoma",
    gachonitText1: "משפחת האבנטיים Strophariaceae.",
    gachonitText2:
      "הכינוי – Brick cap וגם Chesnut mushroom שם נרדף לסוג - Naematoloma.",
    gachonitText3:
      "פטרייה נדירה בישראל, פרט בודד באוסף אוניברסיטת ת.א ותצפיות בודדות בלבד. דומה מאוד לשברירית צעיפית ולנירנית. יתכן שטועים בזיהוי ולכן לא תועדה מספיק.",
    gachonitText4: "המין היחיד שזוהה ותועד בישראל הוא –",
    gachonitText5Bold: "גחונית ערמונית Hypholoma lateritium / sublateritium -",
    gachonitText6:
      "פטרייה בגודל בינוני עד גדול, הכובע בקוטר עד 10 ס''מ ,כפה חלקה בצבע בריק (חום אדמדם). הדפים נוגעים, צפופים בגוון בריק-אפרפר. הרגל בגבה כ 10 ס''מ, בהירה עד ערמונית. 'צוארון ' בהיר על הרגל בחיבור לכובע. גדלה בצרורות על גדמי עצים.",
    gachonitImg1: "© פרט צעיר - דליה בונס",
    dfufit: "דפופית / פתיתית - Gyrophragmium / Montagnites",
    dfufitText1:
      "משפחת הפקועתיים – Agaricaceae ,בעבר - הפומיתיים, מפטריות הכרס.",
    dfufitText2:
      "הדפופית היתה נפרדת מהסוג פתיתית ובבדיקות עכשוויות הסתבר שהן אותה פטרייה שבספרות מופיעה בכמה שמות מדעיים. המבנה והדפים השחורים תמיד הזכירו את הפקועה או הדיואית והכנוי היה 'דיואית מדברית'.",
    dfufitText3: "בישראל ידוע מין אחד בסוג:",
    dfufitText4Bold: "דפופית חולות – Montagnites dunalii/arenaria",
    dfufitText5: "גם המין מופיע בכמה שמות נרדפים.",
    dfufitText6:
      "פטרייה יבשה, הכובע בגוון בז' וקוטרו כ 5 ס''מ. השכבה הפורייה דמוית דפים ובהבשלה משחירה מאוד מצבע הנבגים, בדומה לדיואית או פקועה. הרגל בגובה עד 5 ס''מ, קשקשית, נוקשה ויבשה. בסיס הרגל בעל בולבוס ובהצצה מהקרקע מבקיעה את שכבת החול, יוצרת סדק בקרום ומכאן נובעת הטעות של ציידי הכמהין האוספים אותה. במבט קפדני ניכר ההבדל ביניהן במבנה הבולבוס.",
    dfufitText7: "הפטרייה גדלה ומצויה למדי בשטחי חולות, בעקר בנגב.",
    dfufitImg1: "© דליה בונס",
    dfufitImg2: "© רון פרומקין",
    dfufitImg3: "© ברוריה גל. התפתחות הבולבוס.",
    yehuda: "פטריות בהרי יהודה",
    yehudaText1:
      "הרי יהודה הוא האזור המשתרע בין השפלה ממערב ומדבר יהודה במזרח, חלקו נקרא הרי ירושלים. האזור הררי הבנוי מסלעי גיר ומכוסה ביערות טבעיים ונטועים. הגבה בין 700 ל-1000 מ' מעל פני הים.",
    yehudaText2:
      "ליקוט פטריות ידוע בין העיר בית שמש ממערב, בפארק ארה''ב, עד פארק בגין הגבוה במזרח. הצומח הטבעי שייך לחברת האלה-אלון. עיקר העצים נטועים ע''י האדם, שהעיקריים הם אלון מצוי, מעט אלון תולע, אורן ירושלים, אורן ברוטי, מעט אורן הצנובר {שם קודם -אורן הסלע} ומעט קטלבים.",
    yehudaText3:
      "כמובן שבחלקות יער בהן מעורבים מיני העצים – נמצא יותר מינים מאשר בחלקות של מין אחד. מגוון הפטריות דומה למיגוון בכרמל. לקרחות-יער או לשולי היער, בשטח החשוף, יש חדירת קרני שמש מה שמשפיע על הטמפרטורה הגבוהה במקצת מאשר בסבך. כיון שכל תפטיר של מין פטרייה זקוק לטמפרטורה מסוימת לגדל גופי פרי, יהיה הבדל בהופעתם בנישות הספציפיות. מהתצפיות שריכזנו באזור שנים רבות אפשר ללמוד מהי העדיפות. לדוגמא:",
    yehudaText4Bold: "בצל הסבך:",
    yehudaText4:
      "אורנייה, אמנית ביצתית, אמנית כוזבת, נטופה ערבה, נטופה דורית, משפכנית כחלחלה, משפכנית ריחנית, ישעורית, פקועה יערית, פטרת האיצטרובל, חריפית, גושית צהבהבה, גושית מעורקת ועוד.",
    yehudaText5Bold: "בשטח מעט מואר:",
    yehudaText5: "סיבית, אבנטית, אחלמית, פקועת השדה, דיואית מצויצת ועוד.",
    yehudaImg1: "© אחלמית ערומה. אראלה הרי",
    yehudaImg2: "© אמנית כוזבת. עירית צוק",
    yehudaImg3: "© משפכנית כחלחלה. טל גזית",
    pchusit: "פחוסית - disciseda",
    pchusitText1: "משפחת הפקועתיים ,Agaricaceae בעבר - אבקתיים.",
    pchusitText2: "בישראל מצוי מין יחיד בסוג:",
    pchusitText3Bold: "פחוסית  עגולה - D.bovista",
    pchusitText4:
      "הפטרייה דמוית כדור פחוס בגבה 2 ס''מ וקוטר כ 3.5 ס''מ. המעטה דק בצבע חום אפרפר ובמרכזו נמצא הפתח לשחרור הנבגים בעת ההבשלה. השיכבה הפורייה (גלבה) במרכז הכדור בצבע חום. הכדור יושב על מעטה עבה כצלחת לא סימטרית המכוסה בחול.",
    pchusitText5: "הפחוסית צמודה לקרקע חולית, גדלה באזורים יבשים וחשופים.",
    pchusitText6:
      "דומה מאוד לאבקית, נחשבת נדירה, ובארצות מסוימות נכללת ברשימה האדומה של הפטריות. (מחויבת שמירה).",
    pchusitImg1: "© P. Anton",
    shcharcharit: "שחרחרית - Melanoleuca",
    shcharcharitText1: "משפחת הישעוריתיים –Tricholomataceae.",
    shcharcharitText2: "שם הסוג נקבע על פי המין הנפוץ, בעל כפה שחורה.",
    shcharcharitText3:
      "הפטרייה שייכת לפטריות הדפים, גדלות על הקרקע ביערות, גנים ופארקים, בין צמחים ועצים מסוגים שונים. מופיעה ביחידות או בקבוצות קטנות.",
    shcharcharitText4:
      "גודל השחרחרית בינוני, מבנה הכובע והרגל שונה בין המינים ומהווה סימן לזיהוי.",
    shcharcharitText5:
      "הכובע שטוח, עפ''ר דק בשר, בקוטר 3-8 ס''מ. פניו חלקים או מאובקים, ובחלק מהמינים יש פיטם במרכז. הצבעים במינים השונים: בז', אפרפר, חום ושחור. כמות הלחות באוויר משפיעה על הגוון המתבהר ככל שהלחות גבוהה. הדפים צפופים, בחלק יושבים, בחלק מפורצים ואחרים גולשים במעט על הרגל. צבע הדפים מלבן צחור ועד גווני הצהוב. ",
    shcharcharitText6:
      "הרגל בעובי דק עד בינוני, ארוכה או קצרה, אטומה או חלולה. בחלק מהמינים הרגל מעובה בבסיס.",
    shcharcharitText7:
      "את כל המינים והסימנים המבדילים כתבנו בקיצור בטבלת אקסל המצורפת כאן בקישור:",
    shcharcharitImg1: "© שחרחרית שחרחרה. טלמור",
    shcharcharitImg2: "© שחרחרית קצרת –רגל. עירית צוק",
    shcharcharitImg3: "© שחרחרית חוורת. ברוריה גל",
    shcharcharitImg4: "© שחרחרית מפוספסת רגל. וילבאוט",
    hinoma: "הינומה - Cortinarius",
    hinomaText1: "משפחת ההינומתיים - Cortinariacaea.",
    hinomaText2:
      "סוג ההינומה כולל הרבה מאוד מינים וביניהם דומים במראה, מה שמקשה על הזיהוי. בשלב זה לא נוכל לכתוב על כולם, נוסיף בהמשך ואפשר להיעזר באינטרנט.",
    hinomaText3:
      "במעבדה המולקולרית של המוזיאון לטבע זוהו עוד מינים שנאספו, נבדקו אך טרם פורסמו בישראל (2014), נכניסם לאתר בקרוב, לאחר שיפורסמו בכתב העת המדעי הבינלאומי.",
    hinomaText4:
      "ההינומה שייכת לפטריות הדפים בעלת גוף פרי גדול, בשרני, עבה וצבעוני. מופיעה בישראל רק בין עצי אלון. כל המינים רעילים, בחלקם מצוי הרעלן בשם קורטינרין או גם אורלאנין. ",
    hinomaText5:
      "בשלב הגידול ה'צעיף החלקי' נקרע בצורה ייחודית ומשאיר קורים רבים התלויים בשולי הכובע ועל פני הרגל. צורה זו דמוית הינומה –Cortina  (מכסה את פני הכלה בטקס החופה) ומכאן שמה. במינים מסוימים הקורים יושבים על הרגל בצורת טבעת או חגורה. הקף הכובע מ- 8 עד 12 ס''מ, כיפתי ועפ''ר אינו מתיישר לגמרי. לעיתים הכפה רירית ודביקה בעקר בלחות אוויר גבוהה. הכפה בצבעים: לבן, צהוב, ירקרק, ארגמן, חום וכל הגוונים שביניהם. הדפים עבים ודלילים בצבעים שונים, בדומה לכתוב בצבעי הכיפה. הרגל אופיינית לכל מין ולפי המבנה משייכים אותו לקבוצות שבסוג: רגל ישרה שווה ברוחבה, רגל דמוית אלה, רגל עם בולבוס בבסיסה, רגל עם בולבוס קטוע (דמוי מדרגה) ורגל ללא שרידי קורטינה.",
    hinomaText51:
      "לאחרונה נאספו 3 מינים נוספים של הינומה, נבדקו מולקולרית ופורסמו בכתב עת מדעי. מצויים בפונגריום של המוזיאון לטבע באוניברסיטת ת.א.",
    hinomaText52: "הינומה לבנה - Cortinarius aleuriosmus -",
    hinomaText521: " נגלתה בגולן ע''י יאיר אור בשנת 2018. ",
    hinoma52Img: "הינומה לבנה - יאיר אור",
    hinomaText53: "הינומה זהובה - Phlegmacium /Cortinarius auriliciis -",
    hinomaText531: " נגלתה בכרמל ע''י ארנון שדמי ב  2023. ",
    hinoma53Img: "הינומה זהובה -ארנון שדמי",
    hinomaText54: "הינומה ממוגפת - Phlegmacium /Cortinarius caligatum -",
    hinomaText541: " נאספה במערב הגליל ע'י דליה בונס וברוריה גל בשנת 2023. ",
    hinoma54Img: "הינומה ממוגפת - ברוריה גל",
    hinomaText6:
      "את המינים העיקריים והסימנים המבדילים כתבנו בקיצור בטבלת אקסל המצורפת כאן בקישור:",
    hinomaImg1: "© הינומה סגולת–דפים. ניצן אלסר",
    hinomaImg2: "© הינומה קרועה. ברוריה גל",
    hinomaImg3: "© הינומה גפורה. אראלה הרי",
    hinomaImg4: "© הינומה כותנתית. עירית צוק",
    hinomaImg5: "© הינומה יפיפיה. אישי טלמון",
    hinomaImg6: "© הינומה סגלגלה. ברוריה גל",
    hinomaImg7: "© הינומה ב.מ. ספי הרי",
    hinomaImg8: "© הינומה ירוקה. וילבאוט",
    avukit: "אבוקית - Fomes",
    avukitText1: "משפחת הנקבובניתיים – Polyporaceae.",
    avukitText2:
      "שייכת ל 'פטריות המדף' שבין 'הפטריות העציות'. הן גדלות בתוך גזעי עצים, ניזונות מרקמות הגזע ומזיקות להתפתחות העץ ויכולות לגרום למותו. גוף הפרי מתפתח על הקליפה ונראה כמדף מעוגל, מעוצה ועבה. ",
    avukitText3: "בסוג ידוע מין אחד -",
    avukitText4Bold: "אבוקית דליקה – Fomes fomentarius",
    avukitText5:
      "הכינויים של האבוקית מבטאים את צורתה - 'פרסת הסוס' ואת השימוש בה – 'חומר בערה'. השימוש ידוע מלפני אלפי שנים כחומר להבערת אש שאת הניצוץ הראשון עושים באמצעות ברזל או פלדה.",
    avukitText6: "היתרון לשימוש בחומר שכזה הוא תכונתו לשמור חום לזמן ממושך.",
    avukitText7:
      "קוטר הפטרייה עד 30 ס''מ, הגבה והרוחב עד 20 ס''מ. הצבע בגיל הצעיר – חום בהיר, אפרפר, אדמדם, ומשתנה עם הגיל לאפור כהה עד שחור.",
    avukitText8:
      "האבוקית רב שנתית, גדלה על עצים מסוגים ומינים שונים של רחבי עלים ומעט על מחטניים. נחשבת נדירה בישראל.",
    avukitImg1: "© על עץ אפרסק. ברוריה גל",
    avukitImg2: "© על עץ חרוב. אראלה הרי",
    afarkadanit: "אפרקדנית - Resupinatus",
    afarkadanitText1: "משפחת הישעוריתיים - Tricholomataceae.",
    afarkadanitText2: "בישראל ידוע מין אחד בסוג –",
    afarkadanitText3Bold: "אפרקדנית שעירה – Resopinaceae trichotis",
    afarkadanitText4:
      "הפטרייה קטנה בקוטר 2 ס''מ. דומה לדרדסית אך שוכבת במצב הפוך, ומכאן שמה. הכפה מכוסה בשערות עדינות, הדפים דלילים באורכים שונים. גדלה על גזעי עצים חלשים מסוגים שונים.",
    afarkadanitImg1: "© וילבאוט",
    afarkadanitImg2: "© ארנון שדמי",
    aforit: "אפורית - Lyophyllum / Tephrocybe",
    aforitText1: "משפחת הדפוניתיים - Lyophyllaceae.",
    aforitText2: "בשנים האחרונות הוחלף שם הסוג ושמות המינים.",
    aforitText3:
      "האפורית אינה מוכרת מספיק בארצנו, אולי מהסיבה שדומה לאסימונית ולא נבדקה מספיק, או שנדירה.",
    aforitText4:
      "האפורית גדלה בין עצים, על הקרקע. פטרייה קטנה בקוטר כ 5 ס''מ. צבע הכיפה  חום-אפור-שחור ומרכזה שקוע. שולי הכובע מחורצים. הדפים דלילים בצבע לבן-אפרפר.",
    aforitText5: "בישראל ידועים 2 מינים:",
    aforitText6Bold:
      "א.פחומה - Lyophyllum (Tephrocybe) anthracophila (carbonaria)",
    aforitText7:
      "פטרייה קטנה, הכובע בקוטר 2.5 ס''מ וניכר שקע במרכזו. שוליי הכובע מחורצים וצבע הכפה חום כהה. הדפים צפופים, יושבים וצבעם בהיר. הבשר דק והריח קימחי. הרגל ארוכה מקוטר הכובע, בגוון חום. גדלה בקבוצות קטנות, ביערות, על קרקע שעברה שריפה.",
    aforitText8Bold:
      "א.נטושה - Sagaranella (Tephrocybe) tylicolors {tesquorum}",
    aforitText9:
      "פטרייה זעירה, הכובע בקוטר 1.5 ס''מ וניכר פיטם קטן במרכזו. הכפה חלקה בגוון חום אדמדם בהיר. הדפים רחבים, דלילים ויושבים על הרגל. גדלה בין עצי אלון ואקליפטוס בקרקע טחבית או ברקבובית.",
    aforitImg1: "© מרטה",
    adumit: "אדומית – Entoloma / Rhodophyllus",
    adumitText1: "משפחת האדומיתיים - Entolomataceae.",
    adumitText2: "שם הסוג המדעי הוחלף ל Entoloma, השם העברי נשאר.",
    adumitText3:
      "הסוג שייך לקבוצת פטריות הדפים, גודל בינוני, הכובע בקוטר מ 2 ועד 15 ס''מ. מספר המינים בעולם גדול מאוד.",
    adumitText4: "בסוג ידועים בישראל כ- 10 מינים, נפרט אודות הנפוצים יותר:",
    adumitText5Bold: "אדומית שעירת רגל – Entoloma hirtipes",
    adumitText6:
      "הפטרייה עדינה, בעלת כובע בקוטר עד 5 ס''מ, דק-בשר, בצורת חרוט הנפרש למצב שטוח. הכפה בצבע חום כהה ובמרכזה פיטם קטן.",
    adumitText7:
      "הדפים חפשיים, בגוון אדמדם המתכהה בהבשלה. הרגל בגבה עד 9 ס''מ והבסיס מכוסה במעין צמר לבן. הנבגים בצבע אדמדם המהווה סימן ברור לזיהוי המין.",
    adumitText8: "גדלה ביערות מעורבים ומופיעה בקבוצות קטנות.",
    adumitImg1: "© אראלה הרי",
    adumitText9Bold: "אדומית משיית - Entoloma sericeus",
    adumitText10:
      "הכובע בקוטר 6 ס''מ עם פיטם קטן. צבע הכפה חום שוקולדי או אפור, במצב יבש הכפה מקבלת מירקם משי מבריק בגוון בהיר יותר. השוליים גליים בגיל צעיר ועם ההבשלה מתיישרים. הדפים נוגעים, בעלי מפרץ, בגוונים חומים עד אדמדמים. הרגל בגבה 4 ס''מ בגוון חום אפרפר.",
    adumitText11: "גדלה בשטח עשבוני, מדשאות וקרחות יער.",
    adumitImg2: "© ניצן אלסר",
    adumitText12Bold: "אדומית מגן - Entoloma clypeatum",
    adumitText13:
      "הכובע בקוטר עד 12 ס''מ עם פיטם קטן, הכפה בצבע חום או אפור זיתני. השוליים גליים ומתיישרים בהמשך הימים. הדפים צפופים מעט, בעלי מפרץ בגוון בשרי או אפרפר.",
    adumitText14:
      " גדלה בשולי חורשות, ביערות שונים ובגנים. נחשבת נדירה בישראל.",
    adumitImg3: "© וילבאוט",
    adumitText15: "מינים נוספים:",
    adumitText16:
      "א. דלה – E.proletarius, א.פטמטתית – E.mammosus, א.מחוספסת – E.asprellus, א.סרטנית – E.neglectum, א.הברושים – E.rhodocylix.",
    adumitText17: "*בישראל נמצאו עוד מינים המחכים לבדיקה מולקולרית ולפרסום.",
    gushit: "גושית - Boletus",
    gushitText1: "משפחת הגושיתיים - Boletaceae.",
    gushitText2: "השם גושית נובע מהמבנה העבה והמגושם שמאפיין את המינים הרבים.",
    gushitText3:
      "הגושית שייכת לפטריות הספוג, נחשבת למיוחדת ומעניינת מאוד את כל אוכלוסיות בני האדם בעולם.",
    gushitText4:
      "חשוב להבהיר שלא מעט מיקולוגים עוסקים בחקר ולימוד הגושיות והתוצאה - פיצול הסוג לכמה סוגים עם שמות לועזיים חדשים. נשתדל לעקוב באתר זה אחר החידושים ולעדכן ברשימתנו.",
    gushitText5:
      "הסוג כולל מינים מרשימים מאוד בגודל, בצבעים עזים, בשנויי צבע בעת חיתוך, בטיב למאכל, ומנגד - ברעילות מסוכנת. כדוגמא - ידוע מין נחשק למאכל –בשם גושית נאכלת, בשמה העממי פורצ'יני, ומצד שני יש מין מסוכן בשם גושית השטן. גושיות ממינים רבים מתאימים למאכל אך חובה לטפל ולבשל אותן כתנאי למאכל.",
    gushitText6:
      "הכובע עבה ובשרני, בחלקו התחתון מתפתחת הרקמה הפורייה, הבנויה מצינוריות שבתוכן גדלים הנבגים המתפזרים מהפתחים הזעירים המכונים נקבוביות. צבעי הכפה שונים ומגוונים: לבן, וורוד, אדום, חום, אפור וצהבהב. צבע הספוג מסוים בכל מין ומהווה סימן לזיהוי. הרגל עבה ורחבה, במינים מסוימים יש עיבוי באמצע הגובה, באחרים העיבוי בחלק תחתון ובחלקם העובי שווה לכל האורך.",
    gushitText7:
      "יש מינים שעל פני הרגל ניכרים מעין קורים הנראים כרשת עורקים. במינים אחרים ניכרות נקודות.",
    gushitText8:
      "תופעה מיוחדת נכרת בחלק ממיני הגושיות - כאשר נחתוך את הכובע או הרגל ייחשף לפתע שנוי בצבע הבשר לכחול או לירוק. מהירות השנוי שונה בין המינים ויש מינים שאצלם לא חל שינוי כלל.  הסיבה נובעת ממפגש של חמצן עם החומר שברקמות הגושית בעזרת אנזים בשם ליקאז. לצורך זיהוי הפטרייה רצוי לחתוך בבשרה ולהתבונן בצבע המתקבל, או שנשאר כשהיה.",
    gushitText9:
      "את כל המינים והסימנים המבדילים כתבנו בקיצור בטבלת אקסל המצורפת כאן בקישור.:",
    gushitImg1: "© גושית אדומת רגל. ברוריה גל",
    gushitImg2: "© גושית השטן. גב מירקין",
    gushitImg3: "© גושית וורודת-פס. ברוריה גל",
    gushitImg4: "© גושית זאב. דליה בונס",
    gushitImg5: "© גושית חוורת. ניצן אלסר",
    gushitImg6: "© גושית לבנונית. עירית צוק",
    gushitImg7: "© גושית מעורקת. ארנון שדמי",
    gushitImg8: "© גושית מפוארת/ אראלה הרי",
    gushitImg9: "© גושית ססגונית. ניצן אלסר",
    gushitImg10: "© גושית צהבהבה. יורם גולדרינג",
    gushitImg11: "© גושית קלט. ארנון שדמי",
    ktifanit: "קטיפנית - Pluteus",
    ktifanitText1: "משפחת הקטיפתיים - Pluteaceae.",
    ktifanitText2: "שם הפטרייה נובע מכסות הכובע במירקם קטיפה.",
    ktifanitImg1: "© דליה בונס",
    ktifanitText3:
      "הקטיפנית שייכת לקבוצת פטריות הדפים, גודלה קטן עד בינוני. הכובע פעמוני עד שטוח, בקוטר 2.5 – 15 ס''מ. הדפים בצבע לבן עד אדמדם, חופשיים – סיבה שקל לנתק את הכובע מהרגל. צבעי הכפה אפרפר, לבן, בז' וורוד. הרגל דקה עם התעבות קלה בבסיס, אורכה עד 12 ס''מ ובחלק מהמינים יש על פניה סיבים עדינים. מופיעה בצבעים מלבן ועד צהוב עז.",
    ktifanitText4:
      "הסוג קטיפנית כולל מינים רעילים ומסוכנים, נדרשת זהירות משמוש למאכל. הזיהוי מטעה כי דומה לסוגים אחרים.",
    ktifanitText5:
      "מקום-חיים של מיני הקטיפנית הינו על חלקי עץ, גזעים, גדמים ועל הקרקע. מופיעה עפ''ר בקבוצות.",
    ktifanitText6:
      "בישראל ידועים 6 מינים ויתכן שבבדיקות מולקולריות יזוהו מינים נוספים:",
    ktifanitText7Bold: "קטיפנית הדורה - Pluteus petasatus",
    ktifanitText8:
      "הגדולה והמרשימה מבין המינים בסוג. קוטר הכובע מגיע ל 15 ס''מ, הצבע לבן עכור ומרכז הכפה כהה יותר. גדלה על גזעי עצים כרותים או חלשים.",
    ktifanitImg2: "© ניצן אלסר",
    ktifanitText9Bold: "קטיפנית מעורקת - Pluteus phlebophorus",
    ktifanitText10:
      "הכובע חום עד חום כהה, מכוסה קשקשים עדינים ופיטם זעיר במרכזו. קוטר הכובע עד 5 ס''מ. הדפים חופשיים בצבע לבן ועד וורוד. הרגל בצבע לבן, הגבה 6 ס''מ. נחשבת נדירה.",
    ktifanitImg3: "© וילבוט",
    ktifanitText11Bold: "קטיפנית אפורה - Pluteus godeyi",
    ktifanitText12:
      "פטרייה קטנה, הכובע בקוטר עד 4 ס''מ, בצבעי חום אפרפר עם שוליים מפוספסים. גדלה בין אלונים, נחשבת נדירה.",
    ktifanitImg4: "© דליה בונס",
    ktifanitText13Bold: "קטיפנית צהובת-רגל - Pluteus romelii (lutescens)",
    ktifanitText14:
      "הכובע בקוטר עד 5 ס''מ בצבע חום עם שוליים דהויים. הדפים חופשיים בגוון צהוב בהיר. הרגל בולטת מאוד בצבעה הצהוב, צבע יחיד בסוג. גובהה כ 5 ס''מ. הקטיפנית גדלה על הקרקע ביערות אלונים העשירים ברקבובית.",
    ktifanitImg5: "© ניצן אלסר",
    ktifanitText15Bold: "קטיפנית גמדית - Pluteus nanus",
    ktifanitText16:
      "הכובע בקוטר עד 4.5 ס''מ, צבעו חום בהיר עד כהה, במרכזו ניכר פיטם בגוון כהה מהכפה. הדפים חופשיים בצבע לבן עד וורוד. הרגל בגובה 4 ס''מ וצבעה לבן. גדלה על הקרקע בין עצים רחבי-עלים.",
    ktifanitText17Bold: "קטיפנית מחווירה - (Satur) Pluteus palescens",
    ktifanitText18:
      "שם המין נובע מהעובדה שבתנאי יובש צבע הפטרייה מחוויר. פטרייה קטנה, קוטר הכובע כ 3 ס''מ בגוון בז' עד חום בהיר ובמרכז גוון כהה יותר. הרגל בגבה 5 ס''מ בגוון לבן עכור. מין זה נחשב נדיר בארץ.",
    ktifanitImg6: "© מכאלי",
    ktifanitText19: "מינים נוספים - טרם בדיקה:",
    ktifanitImg7: "*בבדיקה. ברוריה גל ©",
    ktifanitImg8: "*בבדיקה. יואב סילברט ©",
    ravpumit: "רבפומית - Myriostoma",
    ravpumitText1: "משפחת הכוכבניתיים - Geastreraceae.",
    ravpumitText2: "השם נובע מכמה פומיות על פני גוף הפרי הכדורי.",
    ravpumitText3: "בישראל מצוי מין אחד:",
    ravpumitText4Bold: "רבפומית חומה - M.coliforme",
    ravpumitText5:
      "פטרייה מרשימה ביופייה, צורתה ככדור בקוטר עד 10 ס''מ היושב בתוך תחתית כוכבנית ובראשו מספר פתחים. צבע גוף הפרי חום בהיר. המעטה נפתח ככל שהפטרייה מתבגרת, בעל עד 10 אונות או קרניים, המתקפלות כלפי מטה. יושבת צמוד לקרקע על בסיס קצר החבוי מתחת למעטה.",
    ravpumitText6:
      "הרבפומית אינה שכיחה וגדלה בחורשים ויערות שונים במרכז ובצפון הארץ. מופיעה בחלק הפתוח בין העצים. דומה לאסתרית בעלת פומית אחת ויותר קרניים.",
    ravpumitImg1: "משה גלעדי ©",
    ravpumitImg2: "ברוריה גל ©",
    pumit: "פומית - Tulostoma",
    pumitText1:
      "משפחת הפקועתיים - Agaricaceae. בעבר הייתה במשפחת הפומיתאים Tulostomataceae.",
    pumitText2:
      "שמה של הפומית נובע מהמילה פה (בסגול) שמקורה מארמית, המדמה את הפתח שבגוף הפרי דרכו נפוצים הנבגים. הכנויים לפומית – Stalked puffballs, Stalked balls.",
    pumitText3:
      "גוף הרבייה במבנה כדורי כמו שק נבגים העוטה קרום. ראש הכדור בעל פתח עגול דרכו יפוצו הנבגים בעת ההבשלה. קוטר הכדור כ 2 ס''מ וצבעו לבן עד בג'. הכדור יושב על רגל עבה בגבה 2-6 ס''מ. הרגל חלקה או קשקשית ובבסיסה ניכר בולבוס קטן.",
    pumitText4:
      "הפומית גדלה באזורים חמים, בחולות בהם יש צמחייה אך אינה במדבריות צחיחים נטולי צמחים. בישראל תועדו וזוהו כמה מינים גם באזור חקלאי בשרון בשדרת ברושים. (פורסם במאמר של פרופ' בנימיני בשנת 1986). ידועה דעה שאולי היא חיה במיקוריזה עם ברוש, אך הדבר לא הוכח. הפומית ניזונה משאריות חומר אורגני של צמחים ושורשים. בארץ מצויה בנגב ובמישור החוף.",
    pumitText5: "מעניינת העובדה שנמצאו מאובנים של פומית מלפני 13 מליון שנה.",
    pumitText6:
      "בישראל ידועים 4 מינים דומים וקשים לזיהוי. נציין כאן את הסימנים המבדילים. בעתיד יבדקו ויזוהו מינים נוספים שנצפו וצולמו.",
    pumitText7Bold: "פומית מצויצת - fimbriatum T",
    pumitText8:
      "המין הנפוץ מבין המינים בארצנו. גוף הפרי בצבע חום בהיר עד אפרפר, פניו חלקים, היקפו עד 2 ס''מ. הרקמה הפורייה-גלבה, ממלאה את הכדור בנבגים הנראים כאבקה בצבע  חלודי בעת ההבשלה. הרגל בגבה עד 4 ס''מ, בגוון חום אדמדם.",
    pumitImg1: "ניצן אלסר ©",
    pumitText9Bold: "פומית מעוגלת - cyclophorum T",
    pumitText10: "הכדור בצבע אפרפר עטוי קשקשים. הרגל ערמונית.",
    pumitText11Bold: "פומית מתחזה - simulans T",
    pumitText12: "מין שהפתיע את המגלים בארץ מהסיבה שידוע מיבשת אמריקה.",
    pumitText13:
      "הכדור קטן בקוטר כ 2 ס''מ וגבה 1 ס''מ בצבע לבן מלוכלך עד חום, עטוי בקשקשים. הפתח קטן מאוד. הגלבה בגוון חום. הרגל דקה באורך כ 2 ס'מ ורוחב 4 מ''מ, בצבע חום או אפור ומכוסה בקשקשים. בבסיס הרגל ניכר בולבוס הקבור באדמה.",
    pumitText14:
      "תועדה באזור השרון בין עצי אלון בשטחים חקלאיים. נחשבת נדירה בארצנו. דומה מאוד למין אחר ונבדלת בצורת הנבגים.",
    pumitText15Bold: "פומית שחומה - subfuscum T",
    pumitText16:
      "פטרייה זעירה, קוטר הכדור 8-13 מ''מ וגובה 9 מ''מ. הצבע כתום בהיר. הפתח 1 ס''מ מוקף בציצית חומה. הגלבה חומה. הרגל בגובה 2-3 ס''מ. דומה לאחרות ונבדלת בצורת הנבגים.",
    pumitImg2: ".מורי חן. בערבה ©",
    pumitText17Bold: "מין שהחלף שמו ",
    pumitText17:
      "- לעמודנית מפוספסת – Schizostoma kaceratum החליפו שם הסוג ל – Tulostoma.",
    pumitText18Bold: "מין שטרם נבדק - ",
    pumitText18:
      "נאסף באזור אילת בשטח גינון מושקה- שם זמני- 'פומית הערבה'. צבע הכדור לבן ומכוסה קשקשים גדולים יחסית. הרגל רחבה  בעלת קשקשים.",
    pumitImg3: ".בני שלמון. אזור אילת ©",
    pumitImg4: "בני שלמון ©",
    pumitText19Bold: "מיני פומית ללא זיהוי ודאי:",
    pumitImg5: ".מורי חן. בערבה ©",
    pumitImg6: " כנראה פ.הערבה. יואב סילברט - נחל נימרה ©",
    pumitImg7: ".ענת צפריר - הר הנגב ©",
    terms: "מילון מונחים בעולם הפטריות",
    termsText1Bold: "מונחים במבנה הפטרייה",
    termsText2:
      "Ascus – נאדית - תא מיוחד, בקבוצת פטריות הנאדית בו נוצרים הנבגים.",
    termsText3:
      "Basidium - בסיסה – תא בו חלה התלכדות הגרעינים ונוצרים הנבגים עד להבשלה.",
    termsText4:
      "Carpophorm- גוף-פרי/גוף רבייה – האבר בו נוצרים ומתפתחים נבגים.",
    termsText5:
      "Gills – דפים - רקמה בצורת דפים עליה מתפתחים הנבגים בפטריות כובע.",
    termsText6: "Gleba - רקמת גידול הנבגים שבתוך מעטה, בעיקר בפטריות הכרס.",
    termsText7:
      "Mycelium – תפטיר - רשת קורים רב תאיים מתחת לקרקע, הוא הגוף העיקרי ממנו מתפתח גוף הרבייה.",
    termsText8: "Ring – טבעת - שאריות הצעיף החלקי הנשארים סביב הרגל.",
    termsText9:
      "Spore - נבג – תא רבייה בפטריות, אצות וצמחים ירודים, ממנו גדל מין חדש.",
    termsText10:
      "Velum universale - צעיף חיצוני/כללי – קרום העוטה את הפטרייה בשלביה הראשונים.",
    termsText11:
      "Velum partiale  - צעיפית/ צעיף חלקי – קרום העוטה את הכובע לפני פתיחתו. שאריותיו ניכרות כטבעת סביב הרגל.",
    termsText12: "Volva – נרתיק – שאריות הצעיף החיצוני העוטפים את בסיס הרגל.",
    termsText13Bold: "צורות ומירקם של הכובע",
    termsText14: "גלדני – קשה כגלד או עור.",
    termsText15: "לבדי – בעל כסות עדינה של שיער על הכובע או הרגל.",
    termsText16: "טבורי – שקע במרכז הכובע.",
    termsText17: "מפרץ – מגרעת בחיבור הדף לרגל.	",
    termsText18: "פיטם – בליטה במרכז הכובע.",
    termsText19: "פתיתי – מכוסה קורים קצרים מפוזרים.",
    termsText20: "קטיפתי – בעל כסות רכה של שערות צפופות.",
    termsText21: "קמחי – מכוסה קורים קצרים הנראים כקמח.",
    termsText22: "קשקשי – מכוסה קשקשים.",
    teardropInMushrooms: "קיראו ובכו: דמיעה (גוטציה) בפטריות עילאיות",
    teardropInMushroomsText1:
      "תומצת ותורגם ע'י אור בן דור, הגהה – ברוריה גל 1.2022, מתוך:",
    teardropInMushroomsTextLink: "Read It and Weep: Fungal Guttation",
    teardropInMushroomsText2: " - Jan Thornhill, Ontario, Canada - 24.8.2014",
    teardropInMushroomsImg1:
      "איור  1  Fomitopsis pinicola צעירה עם טיפות דמיעה",
    teardropInMushroomsText3:
      "בפטריות מסוימות ניכרת תופעה הנקראת דמיעה (Guttation) - הפרשת טיפות נוזל. מינים כמו Fomitopsis pinicola  {בסוג אבוקית} מייצרים נוזל רב הדומה להזעה. מינים אחרים מייצרים טיפות בעלות פיגמנטים המזכירים חלב, זפת ואפילו דם.",
    teardropInMushroomsText4:
      "דמיעה ידועה יותר בצמחים וסוקולריים. במהלך הלילה, כאשר מופסק אידוי המים מפיוניות הצמח, מים עודפים בשורשים עולים וגורמים להיווצרות טיפות לשד היוצאות ממבנים מיוחדים בשולי העלים.",
    teardropInMushroomsImg2: "איור 2 טיפות דמיעה על עלה של תות שדה",
    teardropInMushroomsText5:
      "בפטריות מנגנון הדמיעה אינו מובן מספיק. במיני פטריות רבים, במיוחד בזמנים של צמיחה מהירה, כאשר הטמפרטורה והלחות מיטיבים, מבחינים בטיפות נוזל אלה. המין Hydnellum peckii (בסוג שינונית) למשל, 'מדמם' לעתים קרובות מאוד בשלבי הצמיחה המוקדמים, וקיבל כינויים מבעיתים, כולל 'פטריית השן המדממת' ו-'שן השטן'. מחקר משנת 1965  מצא תרכובת בגוף הפרי של H. peckii בעלת תכונות נוגדות קרישה דומות לאלה של התרופה הפרין העלולה לגרום לדימום פנימי ואף למוות.",
    teardropInMushroomsImg3:
      "איור 3 טיפות דמיעה דמויות דם בזמן צמיחה מהירה היא תופעה מוכרת במין Hydnellum peckii",
    teardropInMushroomsText6:
      "לפני כמה שבועות נתקלתי במין Inonotus glomeratus (בסוג קישוטית) על גזע עץ מייפל. את המין הזה השייך לנקבובניתיים, מצאתי כמה פעמים ובאחת מיד אחרי פיזור הנבגים שכיסו את כל קרקעית היער בצבע צהוב גופרית. בקיץ הזה מצאתי באותו מקום פרט צעיר מאוד שבמקום לפזר נבגים, הוא דמע טיפות גדולות דמויות 'זפת' שיצרו שלוליות קטנות שחורות ומבריקות על קרקעית היער. שלא כמו הדמיעה המיימית האופיינית לפטריות, הנוזל הזה היה סמיך ודביק עד כדי הכתמת ידי בצבע חום כהה. הדמיעה יוצאת הדופן הזו, למרבה הפלא, לא מוזכרת בספרות המחקר. למרות שכתבתי מאמר שלם על פטרייה זו וייחודה, היא איננה הפטרייה היחידה שמייצגת את תופעת הדמיעה הזו. התופעה נפוצה גם במינים Suillus americanus (בסוג אורנייה) ו - Rhodotus palmatusthat.",
    teardropInMushroomsImg4:
      "איור 4 טיפות דמיעה שחורות של המין Inonotus glomeratus",
    teardropInMushroomsText7:
      "דמיעה גם יכולה לקרות ברמה המיקרוסקופית. במהלך סקר בטורונטו, באביב האחרון (2014), נמצאו כמה פרטים של Lachnum subvirgineum (מפטריות השק/נאדיות) אשר היו מכוסים בטיפות קטנות,  כמו שאר המינים שבסוג.",
    teardropInMushroomsImg5:
      "איור 5 המין Lachnum subvirgineum קטן מחצי מ״מ והטיפות קטנות בהתאם",
    teardropInMushroomsText8:
      "רק אתמול מצאתי ascomycete (מהנאדיות) עם אותן טיפות, הפעם זו היתה Incrucipulum ciliare, פטרייה ממשפחת Hyaloscyphaceae, המייצרת טיפות קטנות אף מאלה של L. subvirgineum.",
    teardropInMushroomsText9:
      "פטרייה קטנה נוספת אשר 'דומעת' נקראת Pilobolus crystallinus (בקבוקנית), בתרגום 'זורקת הכובע' או 'תותח הגללים' מכיוון שתפוצתה על ידי מעבר בקיבת אוכלי עשב וגדלה על גלליהם. למרות גודלה הזעיר, הפצת הנבגים יכולה להגיע לטווח של 2 מטר עקב לחץ הנוצר בתוך הפטרייה, דבר המעיף את הנבג בתאוצה של כ 20 אלף כוח g!!",
    teardropInMushroomsImg6:
      "איור 6 המין Pilobilus crystallinus על בית גידול טיפוסי",
    teardropInMushroomsText10:
      "למרות שמעט מאוד ידוע על דמיעה בגופי פרי של פטריות בר, זוהי תופעה נפוצה בתפטירים שנצפו במעבדה. מספר מחקרים נערכו כדי לקבוע מה תכולת טיפות אלה. פניצילין לדוגמה, נמצא בטיפות דמיעה המיוצרות על ידי מיני Penicillium בריכוזים דומים לזה שנמצא בתרופות, ואילו המינרל גליוטוקסין (gliotoxin), אשר לו איכויות מדכאות חיסון, נמצא בטיפות הדמיעה של Aspergillus fumigatus. האם פטריות אלה משתמשות בנוזל זה כבמאגרים עבור תוצרי לוואי מטבוליים, או אולי כמקור לאחסון מים? ",
    teardropInMushroomsText11:
      "או האם מינים שונים התפתחו כדי לייצר טיפות דמיעה למטרות שונות? Suillus bovinus (בסוג ארנייה) למשל הוכח במעבדה כי יכולה לספוח מחדש חומרי הזנה מטיפות הדמיעה שלה, תוך כדי השארת חומרים פחות שימושיים כגון תוצרי לוואי כמו חומצה אוקסלית (כמו בחמציץ) אז אולי הדמיעה התפתחה כשיטה יעילה לסילוק פסולת עבור פטריות מסוימות?",
    teardropInMushroomsText12:
      "האם זה מה שקורה במקרה של Inonotus glomeratus (קישוטית)? האם הנוזל הצמיג והשחור הזה הנו רק אוסף של תוצרי לוואי מטבוליים דחויים? אם מישהו רוצה לנתח את זה ויש לו את האמצעים, יש לי דגימה מיובשת שאשמח לשלוח לו!",
    teardropInMushroomsImg7:
      "איור 7 המין Inonotus dryadeus ידוע בדמיעה החומה כתומה",
    teardropInMushroomsImg8:
      "איור 8 המין Fomitopsis pinicola ביצור טיפות דמיעה, יכול ליצר טיפות במשך קיץ שלם כ 3 חודשים",
    teardropInMushroomsText13: "רשימת מקורות:",
    teardropInMushroomsText14:
      "- Erast Parmasto, Andrus Voitk, (2010). Why Do Mushrooms Weep? Fungi, Vol. 3:4",
    teardropInMushroomsText15:
      "- N.B. In my original post, relying on the above article, I had repeated that Fomitopsis pinicola does not produce guttation drops in Newfoundland. Andrus Voitk has since kindly informed me that, in fact, they regularly do, as he notes in Omphalina Vol. III, No. 3.",
    teardropInMushroomsText16:
      "- Hutwimmer, S., Wang, H., Strasser, H., Burgstaller, W. (2010) Formation of exudate droplets by Metarhizium anisopliae and the presence of destruxins.Mycologia, Vol. 102 no. 1, 1-10",
    teardropInMushroomsText17:
      "- Gerhard Saueracker. On the Exudates of Polypore Fungi. Fungimap Newsletter 48, Jan. 2013",
    teardropInMushroomsText18: "קישור לנושא דמיעה בפטריות",
    asimonit: "אסימונית - Collybia / Gymnopus / Rhodocollybia",
    asimonitText1: "משפחת המשפכניתיים - Clitocybaceae.",
    asimonitText2:
      "הסוג עבר שנויים רבים בטקסונומיה, שנוי המשפחה מהישעוריתיים ופיצול הסוג לאחרים. העדכון הכתוב כאן נכון ל- 2024. שם הסוג נובע מהגודל הקטן יחסית.",
    asimonitText3:
      "פטריית דפים קטנה בעלת כובע קמור עד שטוח בצבעים אפרפר, חום אדמוני, חום כתמתם וחום. קוטר הכובע  3-7 ס''מ. בחלק מהמינים ניכר פיטם. הבשר במרכז הכובע.השוליים מקופלים בצעירותה, הדפים צרים, נוגעים או יושבים וציבעם מלבן עד אפרפר. צבע הנבגים לבן או ורדרד. הרגל דקה וגמישה, פניה חלקים או עם פסים ויש מינים עם זיפים או שערות. צבעי הרגל בגוונים כמפורט בצבעי הכובע.",
    asimonitText4:
      "מיני האסימונית גדלים בסוגים שונים של עצים ובחלקות חשופות בחורשות ויערות, ביחידים או בקבוצות קטנות.",
    asimonitText5:
      "בישראל ידועים 4 מינים בוודאות ויתכנו נוספים לאחר בדיקות מעבדה. בעבר כולם היו בעלי שם הסוג Collybia.",
    asimonitText6Bold: "אסימונית אלון / יערית - Gymnopus dryophilus",
    asimonitText7:
      "הכובע בקוטר עד 6 ס''מ ,צבעו בז' עד כתמתם ושוליו בהירים יותר. הדפים צפופים, נוגעים או יושבים בצבעים בהירים וכן גם הנבגים. הרגל חלקה בחלקה התחתון והגוון כמו הכובע.",
    asimonitImg1: "© רותי טלמור",
    asimonitText8Bold: "אסימונית חמאה - Rhodocollybia butyracea",
    asimonitText9:
      "הכובע בקוטר עד 8 ס''מ וצבעיו מחום אדמוני ועד חום-צהבהב, תלוי ביובש האויר .במרכז הכובע ניכר פיטם נמוך.הדפים לבנים. הרגל כצבע הכובע, צרה בחלקה העליון ובחלקה התחתון מתרחבת ונכרת פלומה.",
    asimonitText10:
      "במין זה ידוע תת-מין בשם R.b.var asema  א. חמאה –אפורה. נבדלת בצבע הכובע.",
    asimonitImg2: "© גבי אדם",
    asimonitImg3: "© אסימונית חמאה אפורה. ברוריה גל",
    asimonitText11: "מינים נוספים הנבדלים מעט ולא קל לזהותם:",
    asimonitText12:
      " אסימונית מאוגדת – G.fusipes. סימן מיוחד הוא בסיס הרגל המחודד וצמודים לו גופי פרי נוספים היוצרים אגד פטריות.",
    asimonitText13:
      "אסימונית ממוגפת - Collybiopsis peronataסימן מיוחד מופיע בחלק תחתון של הרגל, כסוי של שערות צהובות.",
    largeBrown: "חומות הגדלות בקבוצות",
    largeWhite: "לבנות גדולות",
    sandAndDesertMushrooms: "פטריות החולות והמדבר",
    tznumit: "צנומית – Marasmiellus",
    tznumitText1:
      "בארץ ידוע מין אחד בסוג ש'זכה' לעבור שרשרת שנויים, עבר לסוג פטרה ועבר גם משפחה. אנו מסתמכים על אתר מיקובנק בשנת 2023.",
    tznumitText2Bold: "צנומית לבנה - M.candidus",
    tznumitText3:
      "פטרייה קטנה עם כובע דק, כפתי ומפוספס בשוליים. הצבע משתנה בהתאם ללחות מלבן לבז'.  הדפים דלילים בצבע לבן-צהבהב. רגל דקה וחלולה, כהה בחלק התחתון, בהירה קמחית בחלקה העליון. גדלה בדשא או עשב.",
    shalhevet: "שלהבת - Pyronema",
    shalhevetText1: "משפחת השלהביתיים - Pyronemataceae.",
    shalhevetText2:
      "שייכת לפטריות הנאדית (בהן תא האם היוצר את הנבגים ונראה כשקית –Asco ) גוף הפרי כצלוחית זעירה בגודל חצי ס''מ וצבעו כתום לוהב. הפטרייה גדלה על קרקע או על עץ שעברו שריפה ומכסה שטח נרחב. התופעה מעניינת ונבדקת השאלה האם ניזונה ספציפית מהאפר שלאחר השריפה.",
    shalhevetText3:
      "כדי להבין כיצד השלהבת שורדת יש להבין שהחום בטמפרטורה הגבוהה אינו חודר לעומק הקרקע והתפטיר אינו נפגע. *ראה במדור מידע, כאן באתר - 'פטריות לאחר שריפה'.",
    shalhevetText4: "המין הידוע בישראל:",
    shalhevetText5Bold: "שלהבת טבורנית - Pyronema omphalodes",
    shalhevetText6:
      "השלהבת ידועה בישראל החל מ 1976 עת פורסמה במאמר של פרופ' הירשנזון וחנה נמליך כראשונה בישראל. החשיפה המשמעותית לחובבי הפטריות הייתה בסיורים בשטחים השרופים לאחר השריפה בכרמל שקרתה ב 2010. מאז נראו פעמים נוספות במקומות שונים.",
    shalhevetText7:
      "*כהשראה משם הסוג קיבל גם זן של הצמח פפריקה הצבעוני שטופח בקבוץ להב את השם 'שלהבת'.",
    shalhevetImg1: "© אמיר בלבן",
    shalhevetImg2: "© אמיר בלבן",
    shalhevetImg3: "© צביה אדלר",
    fungiAndMold: "ההבדל בין פטריות ופיטריריות/ריריות",
    fungiAndMoldText1: "Slime molds - באנגלית.",
    fungiAndMoldText2:
      "אורגניזמים קטנטנים, גדלים על עצים או עלים נרקבים, האם הם בעלי חיים, צמחים או פטריות? האם זו הפרשה או קיא של בע''ח, האם רוק של אדם או קצף של חרקים?    שאלה זו מטרידה את ההולכים ביער עם עיניים סקרניות הסוקרות את המצוי על הקרקע, וגם את הבוטנאים והמיקולוגים.",
    fungiAndMoldText3:
      "רירית נראית לנו כגוש ריר פלזמטי צמוד לענף נרקב - כך נראה השלב הראשוני של ה'יצור המוזר' שמהווה את גופה של הפטרירית / רירית. בהשוואה לגוף הפטרייה המכונה תפטיר- הריר נקרא פלסמודיון ואינו בנוי מקורים של תאים עם דופן. הוא נע על פני המצע הרטוב, סופג מזון נוזלי וגם חלקיקים צקים בדומה לבע''ח ירודים כמו אמבות למשל.",
    fungiAndMoldText4:
      "בשלב הבא בהתפתחותו יופיעו אברי הרבייה – המינבגים, כדורונים עם או בלי עמודונים, בצורות יפיפיות כמו נרות צבעוניים, כסיכות תפירה או חרוזים. הנבגים יפוצו כפי שקורה בצמחים ירודים, טחבים שרכים או פטריות. כדי לבדוק ולהתרשם - יש להצטייד בזכוכית מגדלת פי 10 לפחות, ובבינוקולר בבית או במעבדה.",
    fungiAndMoldText5:
      "בעבר היו ששייכו קבוצה חריגה זו לחד-תאיים וכינוה 'בעלי חיים דמויי צמחים' – מיקסטוזואה. כיום הסיווג הוא קבוצה  Myxomycetes. קבוצה זו גרמה חודשים רבים ב 2012 לוויכוחים בעיתונות, עת פורסם המאמר ב'כלכליסט' בשם מה פטריות חושבות' על שום תנועתן לכוון חומרים כימיים מסוימים, כדוגמת בועתית רב-קודקודית '- Physarum polycephalum מ21 סוגים הספר המיוחד לקבוצה זו 'הפטריריות בישראל' מ 1992, נכתב ע''י פרופ' ניסן בנימיני, מונה 70 מינים בארצנו. וניתנו להם שמות עבריים",
    fungiAndMoldImg1: "© אראלה הרי",
    fungiAndMoldImg2: "© ארנון שדמי ",
    harifit: "חריפית - Russula",
    harifitText1: "משפחת החריפיתיים - Russulaceae.",
    harifitText2: "מקור השם המדעי הוא הפירוש לצבע האדמדם - Russ.",
    harifitText3:
      "הסוג שייך לפטריות הדפים, כולל מאות מינים, מרשים בגודלו, במגוון מקומות-חיים, בכמויות גדולות, בצבעים, בטעמים ובהתאמה למאכל. הכובע גדול ובשרני בקוטר מ 3  ועד 18 ס''מ, עפ''ר יבש ושביר. מופיע בצבעים לבן, קרם, בז', אפרפר, ירקרק, ורוד, אדום וסגול, לעיתים מעורב בכתמים. הדפים יושבים, צפופים עד גולשים במעט, בצבעים לבן עד צהבהב. אבקת הנבגים בצבע לבן, צהוב ותפוזי, הרגל עבה ובשרנית באורך 3-7 ס''מ. הטעם והריח  אופייניים לכל מין ומין ומהווים סימן לזיהוי. טעם מר, חריף מעט, חריף מאוד ועד עדין. בחריפיות אין רעלנים, רובן אכילות אך נדרש טיפול מושקע להפגת המרירות.  ",
    harifitText4:
      "בישראל רשומים מעל 25 מינים, הדגשנו את הנפוצים והוודאיים לזהוי. נעדכן ונוסיף בהמשך. לאחרונה חוקרים הוסיפו לסוג חריפית את כרסנית הגליל שנגלתה ותוארה לראשונה בישראל. ראה במפתח מינים כאן באתר (השם העברי לא מוחלף). מין נוסף נגלה בישראל ונחשב 'טייפ' (כלומר -נמצא ותואר לראשונה בישראל). ניתן לו שם ע''י מוזר, הירשנזון ובנימיני שגילו בכרמל ותיארו אותו למדע. שמו -  חריפית כרמלית - Russula carmelensis.",
    harifitText5:
      "את רשימת המינים, התיאור וסימני הזיהוי הכנסנו לטבלה המצורפת בקישור:",
    harifitImg0: "מידע מקורי מאוסף בנימיני",
    harifitImg1: "© ח.וורודת-רגל. דליה בונס",
    harifitImg2: "© ח. נאה. מירי ארליך",
    harifitImg3: "© ח.מחוטבת. אראלה הרי",
    harifitImg4: "© ח.כרמלית. ברוריה גל",
    harifitImg5: "© ח. מררית. ברוריה גל",
    harifitImg6: "© ח. מררית. ברוריה גל",
    harifitImg7: "© ח. יבשה/חרבה. דליה בונס",
    harifitImg8: "© ח. תכולה/סגלגלה. ברוריה גל",
    harifitImg9: "© ח.תכולה /סגלגלה. וילבאוט",
    harifitImg10: "© ח. אפורה. וילבאוט",
    parasiticPlantsOnFungi:
      "צמחים טפילים על פטריות - Mycoheterophs או Epiparasites",
    parasiticPlantsOnFungiText1:
      "אנו מכירים מקרים רבים מאוד שפטריות טפילות על צמחים, גורמות למחלות ונזקים. והנה נכיר תופעה הפוכה: צמחים חסרי עלים וכלורופיל הניזונים אך ורק מתפטיר פטריות.",
    parasiticPlantsOnFungiText2:
      'ידועים צמחים מכמה סוגים בני משפחות שונות הגדלים בסביבה השופעת בפטריות מכמה מיני פטריות כובע. הביוטופ חשוך, במעבי יערות והרי אינו זקוק לאור כי אינו מטמיע. הפטרייה למעשה משמשת גשר להעברת חמרי מזון – העץ מייצר, הפטרייה במיקוריזה "לוקחת" והצמח "גוזל" ממנה.',
    parasiticPlantsOnFungiText3:
      "*לא מצאתי מידע אם לפטרייה יש גמול, וזה מוכיח שהצמח הינו טפיל מובהק.",
    parasiticPlantsOnFungiText4: "להלן שתי דוגמאות:",
    parasiticPlantsOnFungiTextList1: "Epipogium aphyllum .1",
    parasiticPlantsOnFungiTextList1Text1:
      "מין של סחלב נדיר ביותר, נטול עלים וכלורופיל הניזון רק מתפטיר של פטריות.",
    parasiticPlantsOnFungiTextList1Text2:
      "באמצעות מיקוריזה מתפתח צמח על תפטיר במינים שונים של פטריות החיות בשותפות עם עצים מחטניים, ואינו נכלל עם הספרופיטים אלא עם הפרזיטים.",
    parasiticPlantsOnFungiTextList1Text3:
      "הסחלב חי רוב חדשי השנה מתחת לפני הקרקע ומצמיח קבוצת פרחים רק בעונת הקיץ בביוטופ לח. תפוצתו בעולם רחבה אך לא ידוע באזור הים תיכוני.",
    parasiticImg1: "סקסיפרג ©",
    parasiticImg2: "סקסיפרג ©",
    parasiticPlantsOnFungiTextList2: "Monotropa hypotytis .2",
    parasiticPlantsOnFungiTextList2Text1:
      "הכנוי – Indian pipe. הצמח נדיר ביותר, ממשפחת האברשיים, בעל רקמה בשרנית בגוון צהבהב, נחשב אפיפרזיט ,ביוון נצפו רק מעט פרטים בכמה אזורים. נחקר רבות באזור נפאל וההימלאיה, שם ידועים עוד 29 מינים בעלי התופעה, חלקם אינדמים וביניהם יש המשמשים לרפואה.",
    parasiticPlantsOnFungiTextList2Text2:
      "הפטריות העיקריות עליהן ישב היו ממשפ' החריפיות והנטופות.",
    parasiticImg3: "דליה בונס - בצפון יוון ©",
    parasiticPlantsOnFungiText6: "קישורים למאמרים -",
    parasiticPlantsOnFungiArticle1: "Epipogium aphyllum - Ghost Orchid",
    parasiticPlantsOnFungiArticle2: "Epipogium aphyllum",
    sporeSpreading: "הפצת נבגים בפטריות",
    sporeSpreadingText1:
      "פטרייה, כמו כל אורגניזם, חפצה להתרבות ולהפיץ למרחק את תאי הרבייה – הנבגים. בכל גוף פרי של פטריית כובע, כרס או נאדית, מתפתחים אלפי נבגים ברקמה הנקראת גלבה.",
    sporeSpreadingText2:
      "ידועים לנו 'תכסיסים' רבים שמייצרים צמחים ופירותיהם, כדי למשוך את היצורים שיהוו גורם הפצה. כך גם עושות פטריות. כדי להבין את דרכי ההפצה חשוב קודם שנדע אודות האיברים בהם מתפתחים הנבגים:",
    sporeSpreadingText3:
      "ממלכת הפטריות נחלקת לסדרות ומשפחות על פי דרכי גידול הנבגים. נתמקד בדרכים החשובות בהן נוכל להתבונן:",
    sporeSpreadingText4Bold: "פטריות כובע ",
    sporeSpreadingText4:
      "– הנבגים מתפתחים על דפים, בתוך צינורות, זיזים או שיניים.",
    sporeSpreadingText5Bold: "פטריות כרס ",
    sporeSpreadingText5:
      "– הנבגים מתפתחים בתוך חלל המכוסה בקרומי הגנה ובעת ההבשלה נוצר בהם פתח או מספר פתחים. בחלק מהסוגים המעטה נקרע ומסת הנבגים מתפזרת.",
    sporeSpreadingText6Bold: "פטריות נאדית ",
    sporeSpreadingText6:
      "- הנבגים מצויים במעיין שקית, בד''כ שקועים במצע. יוצאות דופן הן הכמהין שעיקר חייהן הוא מתחת לפני הקרקע.",
    sporeSpreadingText7Bold: "פטריות עציות ",
    sporeSpreadingText7:
      "– הנבגים מתפתחים בשכבה הפורייה היושבת בצד התחתון של המדף הקשיח, בתוך צינוריות עם נקבים בקצה.",
    sporeSpreadingText8Bold: "דרכי הפצה:",
    sporeSpreadingText9Bold: "מעוף החוצה ",
    sporeSpreadingText9:
      "- תפוצה מיוחדת חלה בחלק מפטריות הנאדית בהן נוצר טורגור והלחץ האוסמוטי מעיף את הנבגים. הם עטופים בטיפה של תמיסה המדביקה את הנבג על המצע עליו נפל. המראה של אלפי נבגים פורצים מעלה – נראה לנו כעשן.",
    sporeSpreadingText10Bold: "זרמי אויר ומים ",
    sporeSpreadingText10:
      "- לאחר שטיפת גשם או ברד מכים על האבקית - הנבגים נישאים ברוח, או נשטפים בזרם המים על פני הקרקע.",
    sporeSpreadingText11Bold: "העברה ע''י בע''ח",
    sporeSpreadingText11:
      "- כמהין אינן עולות מעל הקרקע ורק בע''ח הנמשך לריח – חופר ומוציא למטרת אכילה. הנבגים מופצים בהפרשות.",
    sporeSpreadingText12Bold: "בעזרת חרקים",
    sporeSpreadingText12:
      "– בעת ההבשלה הפטרייה מייצרת נוזל בעל ריח חזק של בשר רקוב אליו נמשכים חרקים שונים. הנבגים נדבקים לרגלי החרק ומועברים למרחק. דוגמא נפלאה רואים במשפחת הפיניות.",
    sporeSpreadingText13Bold: "כל גוף הפרי ניתק ומתגלגל",
    sporeSpreadingText13:
      "– בכדורנית ופחוסית לדוגמא. לא כל הנבגים מתפזרים יחדיו ובכך מובטח שיגיעו למקומות שונים ובתנאי גשם מתאימים.",
    sporeSpreadingLinksBold: "קישורים:",
    sporeSpreadingLink: "פטריות מושכות זבובים - חרקים - עולם קטן בגדול",
    toxicWhiteMushrooms: "פטריות לבנות רעילות",
    absorb: "פטריות סופגות חומרים מסוכנים",
    absorbText1:
      "ספיגה רדיואקטיביות ע''י פטריות ידועה ומסוכנת בעקר לאחר אסון צ'רנוביל ב 1987 .הקרינה נדדה בענני טיפות מים לכוון ארצות אירופה וחדרה לקרקע במספר ארצות.",
    absorbText2:
      "תפטיר הפטרייה החי לאורך שנים קולט מהחומרים המסוכנים, אוגר ומעבירם לגוף-הפרי אותו בני האדם ובע''ח אוהבים לאכול.",
    absorbText3:
      "נטופה ערבה ולבדית זהובת בשר, הידועות לנו, נבדקו בצרפת 15 שנים לאחר אסון צ'רנוביל ונמצאות בראש רשימת הסיכון.",
    absorbText4:
      "בצרפת פרסמו לציבור מתוך רשימת הפטריות האכילות את המינים שנבדקו ונאסר לאוכלם. כ''כ דאגו לפרסם גם את אלה שאינן בסיכון.",
    absorbText5:
      "בשוויץ פירסם איגוד הציידים הוראה לא לאכול מבשר חזירי הבר הנוהגים לאכול פטריות רבות.",
    oznit: "אזנית - Pleurotus",
    oznitText1: "משפחת האזניתיים - Pleurotaceae.",
    oznitText2:
      "הסוג אזנית שייך לפטריות הדפים הגדולות בעל חשיבות בתרבות הקולינרית והרפואית לאדם בכל העולם. התכונות המיוחדות הן גודל, בשרניות הכובע, טעם, הצלחה בגידול תרבותי והמצע המגוון עליו חיה. ",
    oznitText3:
      "האזנית טופחה ע''י  מיקולוגים שיצרו ממנה זנים משובחים למאכל לסקטור המסחרי - כלכלי, בעיקר מאזנית צדף ואזנית הכלך המשמשת גם לרפואה. *ראה באתר זה מידע בנושא גידול פטריות למאכל.",
    oznitText4:
      "הכובע בקוטר עד 22 ס''מ, אינו סימטרי, בצבעים בז', חום בהיר, אפור וכחלחל. הדפים לבנים או צהבהבים, גולשים כלפי מטה על בסיס הכובע חסר הרגל, או במינים מסוימים קיימת רגל קצרה. כובעו של גוף הפרי צמוד לקליפת הצמחים והעצים ונראה כקונכייה או כאפרכסת של אוזן.",
    oznitText5:
      "האזנית ניזונה מחלקי עץ נרקבים כולל שורשים של צמחים ועצים ממינים שונים, מפרקת את הליגנין שבהם. מירב המינים גדלים על גזעים ויש הגדלים על שרשים ואז גוף הפרי ניכר על פני האדמה. מופיעה בקבוצות צפופות או דלילות.",
    oznitText6: "האזנית אוהבת חום וידועה באזור סובטרופי כמו אגן הים התיכון.",
    oznitText7: "בסוג אזנית ידועים בישראל 5 מינים:",
    oznitText8Bold: "אזנית צדף - Pleurotus ostreatus",
    oznitText9:
      "במין זה מזוהה תת-מין בשם אזנית ערבתית – P.salignus ויש שמחשיבים אותו כמין נפרד. הזן המטופח למאכל מכונה 'פטריית ירדן', 'פטריית יער' או 'פטרייה כחולה'.",
    oznitText10:
      "הכובע בקוטר עד 22 ס''מ, פניו חלקים ומבריקים בצבע אפור-כחלחל או אפור כהה עם שוליים מעוגלים כלפי פנים בצעירותו. הצורה נראית כצדף ומכאן נובע שמה.",
    oznitText11: "בישראל אינה שכיחה וצומחת על עצי ערבה ועוד רחבי עלים.",
    oznitText12:
      "מעט תצפיות של מין זה גרמו להפתעה כשאגודה של גופי פרי יצאה מהאדמה במרחק מגזע העץ. הסתבר שצמחו משורש או גדם עץ מתים הטמונים בתוך האדמה. ראה תמונה מחורף 2023-4 בעיר ירוחם.",
    oznitImg1: "© על הקרקע בירוחם עמית כץ.",
    oznitImg2: "© על גזע. ארנון שדמי",
    oznitText13Bold: "אזנית כלך - Pleurotus eryngii",
    oznitText14:
      "השם המדעי ניתן בשם הצמח חרחבינה - Eryngium עליו נמצא ותואר המין לראשונה במדע, בארץ גדל בעיקר על כלך ובמעט תצפיות נמצא על חרחבינה.  בארץ נפוץ על כלך תת המין בשם P. eryngii var ferulae מהגולן ועד צפון הנגב. בחרמון נאספו לאוניברסיטת ת.א אזניות על חרחבינה ממין ח. מגובבת  ובבדיקת ד.נ.א לא זוהה כמין או ווריאנט שונה.",
    oznitText15:
      "הכובע בגוונים צהבהבים עד חומים ולכן נגלית לעיננו כאבן שטוחה בין האבנים המקומיות.",
    oznitText16:
      "אזנית הכלך אוהבת חום, מתפתחת בשטחים גלויים לשמש. לא בכל שנה מופיעים גופי פרי במקום שהכרנו שנה קודם לכן מהסיבה שהתנאי להופעתם הוא מידת טמפרטורה שלא תרד מ7 עד 10 מעלות וירד גשם בכמות ובזמן הנכון.",
    oznitText17:
      "הפטרייה ניזונה מחלקי הצמח המתים הנמצאים בקרקע מעונות קודמות, והרי הכלך הינו צמח רב שנתי המייבש את חלקיו הירוקים למשך הקיץ ומתעורר עם בוא הגשמים. לעיתים רואים פטרייה מבלי שגלוי צמח כלך חי וירוק. הכלך אינו נאכל ע''י צאן ובקר בגלל חומרי הרעל שמכיל, וכך שורד ומתרבה בקלות.",
    oznitText18:
      "בזכותה ניתן פרסום מיוחד להרי הגלבוע, בו גדלה בכמויות גדולות ונחשב כאתר מיוחד לאיסוף פטריות. שם הגלבוע בערבית הוא ג'בל פקוע – הר הפטריות.",
    oznitImg3: "© על חרחבינה בחרמון. דליה בונס",
    oznitImg4: "© ליד כלך. יהודה מרטה",
    oznitImg5: "© ליד חרחבינה בחרמון. מנדי פאלק.",
    oznitText19Bold: "אזנית פלפלון - Pleurotus cystidiosus",
    oznitText20:
      "הכובע בקוטר עד 18 ס''מ, פניו חלקים או סדוקים מיובש והשוליים מעוגלים פנימה. הצבע בז', אפרפר או חום בהיר. גדלה על עצים רחבי עלים. השם פלפלון על פי העץ שמישהי גילתה אותה עליו. ידועה יותר על עצי פיקוס.",
    oznitImg6: "© עירית צוק",
    oznitText21Bold: "אזנית קרנית - Pleurotus cornueopiae",
    oznitText22:
      "הכובע בקוטר עד 12 ס''מ, אינו סימטרי וצבעו בהיר, מצהוב ועד חום בהיר. גדלה על גזעי עצים מסוגים שונים. בישראל נחשבת נדירה.",
    oznitImg7: "© עירית צוק",
    oznitText23:
      "*קיים מין נוסף ששם הסוג בלועזית  היה Pleurotus והוחלף ב 2022  ל Clitopilus mutilus .בעברית נקרא אזנית חגרת. פטרייה קטנה ואינה מוכרת, גדלה בעשבייה בשטחים פתוחים.",
    oznitTextLink: "מאמר על הצמח כלך והאזנית שעליו. אלינער שביט 2009",
    kishutit: "קשוטית - Inonotus / Inocutis",
    kishutitText1: "משפחת הזיפניתיים - Hymenochaetaceae.",
    kishutitText2:
      "שייכת לקבוצת הפטריות העציות בצורת מדף מעוגל (על פי הצורה האופקית והשטוחה שמופיעה על הגזע) שקוטרו מגיע עד כ40 ס''מ ועובי עד 15 ס''מ.",
    kishutitText3:
      "הפטרייה מתפתחת בתוך רקמות הגזע של עצים רחבי-עלים לאחר שנבג נובט בחריץ, מתפתח תפטיר הניזון מחומרי העץ הפנימיים. בשלב מסוים מתפתח.",
    kishutitText4:
      "גוף פרי היוצא וגדל מעבר לקליפתו. בחלק התחתון גדלה השכבה הפורייה הכוללת צינוריות קצרות עם פתחים כנקבים עגולים או מצולעים, בהן גדלים הנבגים.",
    kishutitText5:
      "בסוף העונה גוף הפרי מתייבש ומשחיר ונשאר על הגזע כמדף נוקשה.",
    kishutitText6:
      "תופעה מיוחדת בשם 'דמיעה' מופיעה למספר ימים בצד התחתון של המדף. *ראה הסבר באתר,במדור מידע בנושא תופעות.",
    kishutitText7:
      "הקשוטית נחשבת פרזיטית הגורמת למחלת 'רקבון לבן' ותוך מספר שנים גורמת לנפילתם ומותם של העצים.",
    kishutitText8: "בישראל ידועים 4-5 מינים:",
    kishutitText9Bold: "קשוטית 'חלקה' - Inocutis (Inonotus) levis",
    kishutitText10:
      "הזיהוי התקבל בבדיקה מולקולרית עם שם זה, סוג חדש. גדלה בעיקר על גזעים של עצי צפצפה, בוואדיות, נחלים, פארקים וגנים. באזור נחל צין התפשטה ופגעה בעצים רבים. דומה לקשוטית שעירה – Inonotus hispidus שכך הכרנו אותה בעבר.",
    kishutitImg1: "© אבנר רינות",
    kishutitImg10: "© לאה דרום",
    kishutitText11Bold: "קשוטית נוטפת - Inonotus dryadeus",
    kishutitText12:
      "גדלה על גזעי עצים שונים, צבעה צהוב – כתום והטיפות זולגות כטיפות דבש או ענבר.",
    kishutitImg2: "© פרטים צעירים. ברוריה גל",
    kishutitImg3: "© על עץ שיטה. ברוריה גל",
    kishutitText13Bold: "קשוטית האשל - Inonotus tamaricis",
    kishutitText14:
      "צבע גוף הפרי חום-כתום ומשתנה עם התפתחותו לגווני של חום, אפרפר או ארגמן. גדלה על עצי אשל בלבד, נפוצה בכל אזורי הארץ.",
    kishutitImg4: "© זלמן באומל",
    kishutitImg5: "© רז קדמון",
    kishutitText15Bold: "קשוטית צמודה - Inonotus rheades",
    kishutitText16: "צבע גוף הפרי חום חלודה. גדלה על עצים שונים.",
    importanceAndRoleLinks: "קישורים:",
    importanceAndRoleLink1:
      "קישור - פטריות גורמות למחלות בצמחים - פורסם ב Forntiers for young Minds",
    importanceAndRoleLink2: "מאמר להורדה - לחסל מכת מדינה",
    importanceAndRoleLink3: "מאמר להורדה - פונגה - תורגם ע''י אור בן דור.",
    importanceAndRoleLink4:
      "קובץ להורדה - הנחיות להגשת פטריות שמפיניון לכלבים.",
    gviit: "גביעית - (Paxina) Helvella, Dissingia",
    gviitText1: "משפחת המרדעיתיים - Helvellaceae.",
    gviitText2:
      "הסוג עבר שנוי טקסונומי ושמו המדעי הצטרף לשם המרדעית. בעברית נשאר כשהיה.",
    gviitText3:
      "*יש לשים לב לדמיון לשם גביעונית שהינה סוג אחר. במראה יש דמיון לסוג שקועית.",
    gviitText4:
      "הגביעית הינה סוג קטן היושב צמוד לקרקע, גוף פרי דמוי כוס או גביע שדפנותיו מקומטות, מחורצות ובלתי סימטריות, מכוסות בשערות עדינות כלבד. בהמשך ההתפתחות הכוסית נפרשת ונפתחת. הרגל קצרה עם תלמים או חסרה. גדלה ביחידים או בקבוצות קטנות ביערות וחורשות.",
    gviitText5: "בסוג ידועים בישראל 2 מינים:",
    gviitText6Bold: "גביעית מעורקת - Helvella (Paxina) acetabulum",
    gviitText7:
      "גוף הפרי בקוטר 4 ס''מ וגבה 7 ס''מ, צבעו חום והרגל הקצרה בגוון בהיר, עליה ניכרים מעין עורקים המתחברים וממשיכים לגביע.",
    gviitText8Bold:
      "גביעית שחרחרה - Paxina leucomelas)) Dissingia leucomelaena",
    gviitText9:
      "גוף הפרי בגוון חום-שחרחר בגובה 3-4 ס''מ וגם הקוטר 3-4 ס''מ. הצבע חום ,חום בהיר עד אפרפר. האונות פתוחות יותר מאשר במעורקת. הרגל קצרה ושקועה בקרקע, בהירה עם קמטים וקפלים בלתי סימטריים.",
    gviitImg1: "© וילבוט",
    gviitImg2: "© נעה זילברמן",
    mardait: "מרדעית - ( Helvella ( Leptopodia",
    mardaitText1: "משפחת המרדעיתיים - Helvellaceae, מסדרת הפזיזתיים Pezizales.",
    mardaitText2: "שם הסוג נובע מצורתו כאוכף = מרדע.",
    mardaitText3:
      "הסוג עבר שינויים טקסונומים, הופרד או שצורפו אליו אחרים. בעברית השם יישאר כשהיה.",
    mardaitText4:
      "הסוג שייך לפטריות הנאדית / השק וקרוב לגמצוצית ולגביעית. גוף הפרי קטן בגבה עד 10 ס''מ ועובי עד 5 ס''מ. המבנה כבסיס מאורך במירקם מחורץ וגמיש, או דומה יותר לרגל של פטריית כובע, חלולה או אטומה.  מעליו נמצא 'דמויי כובע' העשוי אונות מקומטות, מעוגלות ובלתי סימטריות. בתוכן הרקמה הפורייה המגדלת נבגים. הצבעים של מיני המרדעית לבן, חום, אפרפר ושחור.",
    mardaitText5:
      "מרדעית גדלה ביחידים או בקבוצות קטנות, בחורש ויער של סוגי עצים שונים, ויש מין הגדל בעשבייה ובשטח טחוב.",
    mardaitText6: "בישראל ידועים כ 7 מינים בסוג:",
    mardaitText7Bold: "מרדעית לבנה - Helvella crispa",
    mardaitText8:
      "גובהה כ 12 ס''מ, הרוחב כ 5 ס''מ. הצבע לבן או לבן עכור. האונות מקופלות ומתולתלות מאוד והבסיס רחב וחלול.",
    mardaitImg1: "© איילה מאיר",
    mardaitText9Bold: "מרדעית גמישה - Helvella (Leptopodia) elastica",
    mardaitText10:
      "גובהה כ 12 ס''מ, הצבע אפרפר. האונות מעוגלות או שטוחות יושבות בצורת אוכף. הבסיס במין זה נראה כרגל צרה יחסית למינים האחרים רוחבו כ1.5 ס''מ.",
    mardaitImg2: "© ברוריה גל",
    mardaitText11Bold: "מרדעית חלולה - Helvella lacunosa",
    mardaitText12:
      "דומה למרדעית לבנה אך צבע האונות כהה עד שחור והבסיס לבן עד אפור, רחב בחלקו התחתון.",
    mardaitImg3: "© רותי טלמור",
    mardaitText13Bold: "מרדעית מחורצת - Helvella sulcata",
    mardaitText14:
      "פורסמה ב1972 במאמר של פרפ' הירשנזון. נחשבה תת-מין של מ.חלולה, הצבע בז' עד חום. הגבה 5.5 ס''מ, האונות מקופלות וצפופות כגוש מקומט. גדלה בין עצי אורן ואלון.",
    mardaitImg4: "© ברוריה גל",
    mardaitText15Bold: "מרדעית 'פזיזית' - Helvella (Leptopodia) pezizoides",
    mardaitText16:
      "הפטרייה קטנה בגבה עד 6 ס''מ, האונות מקופלות כקעריות צפופות במראה של גוש מקומט. הצבע אפור- שחור  והבסיס  כרגל חלקה בהירה. נמצאה בין עשבים או טחבים.",
    mardaitText17Bold: "מרדעית מאפירה - Helvella solitaria (Queletii)",
    mardaitText18:
      "פורסמה ע'י פרופ' הירשנזון 1972. גוף הפרי בגובה עד 6.5 ס''מ, ורוחבו כ 3 ס''מ. צבעו אפרפר בגוון זיתי. הבסיס צר בצבע עשן, רוחבו כ1 ס''מ.",
    mardaitImg5: "© י.מרטה",
    mardaitText19Bold: "מרדעית שחורה - Helvella (leptopodia) atra",
    mardaitText20:
      "פטרייה בגבה עד 8 ס''מ, ורוחב כ3 ס''מ. דומה למרדעית חלולה אך קטנה וכהה ממנה.",
    mardaitText21Bold: "הערה:",
    mardaitText22:
      "שם הסוג של גביעית שחרחרה וגביעית מעורקת קיבלו שם מדעי כמו מרדעית, ראה בנפרד לפי השם העברי.",
    shchumit: "שחומית - Melanogaster",
    shchumitText1: "משפחת השחומיתיים - Melanogastraceae.",
    shchumitText2: "בישראל - מין יחיד בסוג -",
    shchumitText3Bold: "שחומית משתנה - Melanogaster broomeianus",
    shchumitText4:
      "פטרייה כדורית חסרת רגל דומה לפקעית ונבדלת בצבעי המעטה והבשר- הגלבה. קוטר גוף הפרי 3-5 ס''מ. המעטה בצבע חום-צהוב בצעירותה ומשתנה לחום כהה-בורדו בבגרותה, מכוסה במעין קטיפה. בחתך ניכר צבע חום-שחור במירקם כעורקים בהירים, בהיר יותר בצעירה. השחומית גדלה ברקבובית של עצי אלון.",
    shchumitImg1: "© ניצן אלסר",
    pkait: "פקעית - Rizopogon",
    pkaitText1: "משפחת הפקעיתיים - Rhizopogonaceae.",
    pkaitText2:
      "הסוג דומה לכמהה קטנה והכינוי ניתן לה - ''כמהה כוזבת''. צורתו ככדור מעט פחוס, חסר בסיס או רגל, עטוי בקרום בצבעים של וורוד, צהוב עד חום. החלק הפנימי הינו גוש של רקמה בשרנית בשם גלבה היוצרת את הנבגים, צבעה בהיר המתכהה בשלבי ההבשלה. הפקעית שקועה באדמה ומעט בולטת מעליה. בעלי חיים, להם חוש ריח מפותח, חופרים ניזונים ממנה. לנו הטעם לא מלבב. מופיעה בקבוצות בנות עד 10 פרטים וגדלה בשוליים או ביערות של עצים שונים, ידועה בעקר באורנים. הפקעית מקיימת חיי שותפות בשם 'מיקוריזה חיצונית', בעקר עם עצי אורן. ",
    pkaitText3:
      "*פטריות הדומות לפקעית, קטנות וכדוריות ידועות מכמה סוגים כמו כמהין Tuber-,היסטרית ושחומית. כדי לזהותן יש לחתוך ולבדוק את הצבע והצורה של הרקמה הפורייה-גלבה.",
    pkaitText4: "בישראל ידועים 2 מינים בוודאות ונוספים שטרם נבדקו גנטית:",
    pkaitText5Bold: "פקעית מצהיבה - Rhizopogon luteolus",
    pkaitText6:
      "גוף הפרי בקוטר עד 4 ס''מ, צבע המעטה צהוב ועליו קורים דקים. בחתך ניכרת הגלבה בצבע בהיר המתכהה בהבשלה.",
    pkaitImg1: "© אראלה הרי",
    pkaitImg2: "© ניצן אלסר",
    pkaitText7Bold: "פקעית ורודה - Rizopogon roseolus",
    pkaitText8:
      "קוטר גוף הפרי עד 5 ס''מ. צבע המעטה החיצוני לבנבן או בז' ובהמשך התפתחותו מקבל גוון ורדרד. בחתך ניכרת השכבה הפורייה בצבע בהיר המשתנה בהבשלה לחום בהיר עד כהה.",
    pkaitImg3: "© פ.צהובה מימין, וורדה משמאל. ברוריה גל",
    pkaitText9:
      "* באוסף בנימיני מצוי פרט שנאסף בינואר 1997באזור השרון בשם Rhizopogon occidentalis מין זה דומה מאוד לפקעית הצהובה ונבדל רק בגודל ובצורת הנבגים הקטנים יותר. ברור שאיננו מסוגלים לזהותו אלא בבדיקת מעבדה. אינו גדל במערב אירופה אלא בארצות הים-תיכון.",
    taburit: "טבורית - Omphalotus",
    taburitText1: "משפחת הטבוריתיים - Omphalotaceae.",
    taburitText2: "בישראל מין אחד בסוג:",
    taburitText3Bold: "טבורית הזית - Omphalotus olearius",
    taburitText4:
      "פטרייה מרשימה השייכת לפטריות הדפים ושמה נובע מצורת הכובע השטוח שבמרכזו שקע ניכר. גוף הפרי בשרני בצבע חלודי עד כתום, בקוטר עד 15 ס''מ. הדפים גולשים מאוד על הרגל. הרגל באורך כ 6 ס''מ בצבע הכובע.",
    taburitText5:
      "גדלה על גזעים ובסיסי גזעים של זית, אלון ועוד מעצים רחבי-עלים. (נקראת בשם הזית מהסיבה שעליו תוארה לראשונה). הפטרייה רעילה, מכילה רעלן בשם מוסקרין וגורמת להרעלה קשה. בארץ היו מיקרים רבים בגלל הדמיון לפטרייה הידועה כטובה למאכל בברית המועצות והטעות בזיהוי ע''י הלקטים ה'עולים חדשים'.",
    taburitText6:
      "במין זה ידועה תופעה מעניינת של זוהר בלילה. *ראה הסבר במדור מידע באתר, בנושא תופעות ->",
    taburitText7Link: "'זוהר בפטריות'.",
    taburitImg1: "© ניצן אלסר",
    taburitImg2: "© אראלה הרי",
    harutit: "חרוטית - Conocybe",
    harutitText1: "שם הסוג רשום גם כ - Pholiotina.",
    harutitText2: "משפחת הגלליתיים - Bolbitiaceae (בעבר – הדיואיתיים).",
    harutitText3:
      "פטרייה קטנה ועדינה מקבוצת פטריות הדפים, דומה מאוד והזיהוי מבלבל בין פעמונית, סוככית, צבעונית וגללית.",
    harutitText4:
      "הכובע בצורת חרוט שאינו נפתח גם בבגרותו. מופיעה בצבעים בז', חום בהיר, חום תפוזי וחום כהה. שולי הכובע באותו גוון או מפוספסים. בעולם יש מינים עם טבעת צרה על הרגל, בארץ נצפתה אחת אך טרם פורסמה מדעית ואיננו כוללים אותה בשלב זה. הרגל דקה וארוכה ביחס לכובע, חלקה או מכוסה בפתיתים, ניכרת התעבות קלה בבסיס.",
    harutitText5:
      "מינים מסוימים נחקרים במעבדות העוסקות בחומרים פסיכואקטיביים לשימוש רפואי.",
    harutitText6:
      "החרוטית גדלה על הקרקע בחלקי עץ יבשים או נרקבים וחלק מהמינים בשטחים פתוחים או בחורשות. בישראל ידועים 6 מינים שזוהו בוודאות ועוד שטרם נבדקו ופורסמו במעבדה מולקולרית:",
    harutitText7Bold: "חרוטית חומה - Conocybe microspora / brunneola",
    harutitText8:
      "קוטר הכובע כ 1 ס''מ, צבעו חום תפוזי עם שוליים מפוספסים. הדפים דלילים בצבע חום עם קצוות בהירים. הרגל באורך 5 ס''מ, חלקה חומה יותר בחלקה התחתון. נחשבת נדירה, גדלה בשטחים עשבוניים או בין עצים.",
    harutitImg1: "© אראלה הרי",
    harutitText9Bold: "חרוטית חולית - Conocybe siliginea",
    harutitText10:
      "קוטר הכובע כ1.5 ס''מ, צבעו בז' – צהבהב, הדפים דלילים. הרגל באורך כ 4 ס''מ בגוון לבן עכור. אינה נפוצה, גדלה בצידי דרכים, במדשאות ובשולי חורשות",
    harutitImg2: "© דליה בונס",
    harutitText11Bold: "חרוטית חלבית - Conocybe lactea",
    harutitText12:
      "קוטר הכובע כ 3 ס''מ, צבעו חום בהיר המשתנה ללבנבן בתנאי יובש, עם שוליים מפוספסים. הרגל לבנבנה ומכוסה בפתיתים בחלקה העליון. אינה נפוצה, גדלה בשטחים חוליים או במדשאות.",
    harutitText13Bold: "חרוטית לבדית - Conocybe pubescens",
    harutitText14:
      "קוטר הכובע עד 3 ס''מ, צבעו מחום תפוזי ועד חום-בורדו. הרגל בגבה 4 ס''מ, מפוספסת בהתבגרותה. גדלה בין עצי אורן או במדשאות.",
    harutitText15Bold: "חרוטית משתנה - Conocybe ambigua",
    harutitText16:
      "קוטר הכובע כ 3 ס''מ ואורכו 1.5 ס''מ. הצבע חום אדמוני וביובש בגווני צהוב עם שוליים מפוספסים. הרגל בגובה עד 5 ס'מ, מכוסה פתיתים זעירים. גדלה בין עצי אורן.",
    harutitImg3: "© איילת דג",
    harutitText17Bold: "חרוטית עדינה - Conocybe tenera",
    harutitText18:
      "*ידוע תת-מין ח.עדינה רכה C.t.tenella קוטר הכובע כ 2 ס''מ, צבעו חלודי עם פספוס בשוליים. גדלה בשטחים עשבוניים.",
    harutitImg4: "© יורם גולדרינג",
    matriyanit: "מטריינית - Lepiota, Chamaemyces",
    matriyanitText1: "משפחת הפקועיתיים - Agaricaceae.",
    matriyanitText2:
      "שייכת לפטריות הכובע הקטנות בעלות דפים. קוטר הכובע 2-7 ס''מ, במבנה קמור שנעשה שטוח. הצבע ברוב המינים שבסוג הינו לבן ובכפה יש צבעים בגווני אדום, אפור וחום. כסות הכפה חלקה או בעלת  קשקשים כהים יותר ובחלק ניכר פיטם נמוך.",
    matriyanitText3:
      "הרגל ישרה או עם בסיס מעובה, חלקה או מכוסה פתיתים ועליה טבעת דקה שבחלק מהמינים נושרת. עלינו להתייחס בזהירות ללבנות הללו, בין המינים יש הטובים למאכל ויש רעילים עד ממיתים. חלק גדול מהמינים נדירים, גדלים בין עצים מסוגים שונים.",
    matriyanitText4: "בישראל ידועים מעל 18 מינים, נפרט אודות הנפוצים מביניהם:",
    matriyanitText5Bold: "מטריינית אגוזים – Lepiota naucina",
    matriyanitText6:
      "שמה המדעי הוחלף ללבקנית האגוזים – Leucoagaricus leucothites.",
    matriyanitText7:
      "הכובע בקוטר עד 9 ס''מ, חלק, חסר פיטם, הדפים בגוון לבן ובהמשך ההתפתחות משתנה לוורדרד. הרגל לבנה באורך עד 10 ס''מ, מתרחבת בחלקה התחתון עד היווצרות בולבוס בבסיסה. בעלת טבעת צרה ולבנה. הריח נעים.",
    matriyanitText8:
      "גדלה בעיקר במדשאות ונחשבת טובה למאכל. יש לשים לב בזיהוי לעומת מינים לבנים דומים הגדלים בקרבת בתינו, כמו מטריינית ארגמנית או הסוג 'ירוקת דפים קיצית' הידועה כרעילה, בה הכפה בעלת קשקשים והדפים הופכים מלבנים לירוקים בהתבגרותה.",
    matriyanitImg1: "© ברוריה גל",
    matriyanitImg2: "© אמיר פרלברג",
    matriyanitText9Bold: "מטריינית ארגמנית - Lepiota brunneo-incarnata",
    matriyanitText10: "שמה המדעי הוחלף ל Chlorophyllum bruneum.",
    matriyanitText11:
      "הכובע בקוטר עד 7 ס''מ, חסר פיטם, בהיקף ניכרים קשקשים כהים. הדפים בצבע לבן עד ורדרד. סימן ההיכר הוא ברגל המכוסה פתיתים בצבע ארגמני, אורכה עד 5 ס''מ עם טבעת צרה הנושרת ולא נראית. הפטרייה רעילה מאוד וגורמת למוות!",
    matriyanitImg3: "© וילבאוט",
    matriyanitText12Bold: "מטריינית וורודת רגל - Lepiota lilacea",
    matriyanitText13:
      "הכובע בקוטר עד 5 ס''מ, הכפה מכוסה קשקשים חומים-ארגמניים. הרגל באורך כ 5 ס''מ, צבע החלק התחתון מוורוד עד סגלגל. הטבעת צרה ונעלמת. אינה שכיחה ומאוד מסוכנת למאכל!",
    matriyanitImg4: "© ברוריה גל",
    matriyanitText14Bold: "מטריינית זיפנית - Lepiota echinella/setulosa",
    matriyanitText15:
      "קוטר הכובע עד 3 ס''מ, בעל פיטם נמוך בצבע חום במרכז הכפה המכוסה זיפים קטנים אפרפרים. הרגל באורך כ 4 ס''מ, בהירה בגוון ורדרד עם פתיתים חומים בחלקה התחתון וטבעת חלקית. נחשבת נדירה.",
    matriyanitImg5: "© וילבאוט",
    matriyanitText16Bold: "מטריינית זעירה - Lepiota micropholis",
    matriyanitText17:
      "פטרייה קטנה, קוטר הכובע 1.5 ס''מ, הכפה עם קשקשים קטנים בגוון חום ובמרכז פיטם כהה ונמוך. הרגל ורדרדה בחלקה התחתון באורך עד 3 ס''מ.",
    matriyanitText18Bold: "מטריינית ערמונית - Lepiota castanea",
    matriyanitText19:
      "קוטר הכובע עד 4 ס''מ, הכפה מכוסה קשקשים בצבע ערמוני ובמרכזה פיטם נמוך. שולי הכובע  סדוקים. הדפים לבנים עם כתמים אדמדמים. הרגל באורך 4 ס''מ, צבעה ערמוני ולארכה קשקשים כשני שליש מהאורך. הפטרייה רעילה!",
    matriyanitImg6: "© דליה בונס",
    matriyanitText20Bold: "מטריינית מגן - Lepiota clypeolaria",
    matriyanitText21:
      "קוטר הכובע עד 7 ס''מ, צבעו בז' והמרכז כהה יותר. מהשוליים יורדים דבלולים שנשארו מהצעיף. הכפה מכוסה קשקשים צהבהבים. הרגל באורך כ 8 ס''מ מכוסה בקשקשים גדולים יחסית ועליה טבעת צרה. הפטרייה רעילה!",
    matriyanitText201Bold: "מטריינית כוזבת - Chamaemyces fracidus",
    matriyanitText202: "Lepiota irrorata - שם קודם (החלף ב 1962)",
    matriyanitText203:
      "מין זה נחשב נדיר בישראל, נתגלה רק בשנים האחרונות. (באוניברסיטת חיפה רשומים שניים נוספים לסוג זה).",
    matriyanitText204:
      "הרגל מיוחדת עם סימן ניכר לזהוי: גובהה כקוטר הכובע. החלק התחתון עם כסוי קשקשים, בחלקה העליון שרידי טבעת בגוון חום בהיר ומעליה הרגל לבנה וחלקה מעין צווארון רחב. בגיל צעיר מופיעות לעיתים טיפות של נוזל זהוב על פני הרגל.",
    matriyanitImg61: "© סקסיפרגה",
    matriyanitImg7: "© ידענטבע",
    matriyanitText22Bold: "מינים נוספים:",
    matriyanitText23ListBullet: "מ. לבנה - L.erminea/alba",
    matriyanitText24ListBullet: "מ. קפודית - L.echinacea",
    matriyanitText25ListBullet: "מ. חיוורת  L.helveola  ",
    matriyanitText26ListBullet: "מ.נסורת - L. scobinella/sabincarnata",
    matriyanitText27ListBullet: "מ. בהירה - L. serena/sericifera",
    matriyanitText28ListBullet: "מ.לילכית - L. brunneolilaceae",
    matriyanitText29ListBullet: "מ.צמרית - L.oreadiformis/laevigata",
    matriyanitText30ListBullet: "טרם פורסמה - L.elseae",
    diskanit: "דיסקנית קינמונית - Discina perlata",
    diskanitText1:
      'שם נוסף לסוג – Gyromitra ולמין ancilis מקובל ע"י חלק מהמיקולוגים, עד כה לא סוכם בוודאות. משפחת הדיסקניתיים -  Discinaceae, שייכת לסדרת הפזיזאיים ונחשבה שנים רבות כפזיזה.',
    diskanitText2:
      "גוף הפרי כצלחת או דיסק מקומט ובלתי סימטרי בעל כנוי 'אזן חזיר' בקוטר עד 9 ס''מ. החלק התחתון בהיר. רגל מאוד זעירה עד בלתי ניכרת. גדלה ברקבובית של עצי מחט.",
    diskanitText3:
      "נחשבת נדירה בישראל אך אולי מהסיבה שהתייחסו אליה כמין בסוג פזיזה.",
    diskanitImg1: "© ארנון שדמי",
    diskanitImg2: "© ארנון שדמי",
    shinonit: "שינונית - Hydnellum",
    shinonitText1: "משפחת Bankeraceae (על שם המיקולוג בנקר).",
    shinonitText2:
      "הסוג דומה מאוד לשיננית - Hydnum ושייך למשפחה שונה ממנו. יש לשים לב לכתיב הדומה של השם. סמני הזיהוי העיקריים הם מבנה וגודל השיניים, לכן יש להעזר בזכוכית מגדלת או בבינוקולר.",
    shinonitText3:
      " *בעת הזו עדיין החוקרים עסוקים בבדיקות מולקולריות של הסוגים הדומים כמו סרקודון, בנקרה ועוד בעלי שיניים והטקסונומיה תעבור שנויים. נצרף מידע לכשיתפרסמו. 2024.",
    shinonitText4: "מין אחד זוהה בוודאות בישראל:",
    shinonitText5Bold: "שינונית שחומה - Hydnellum ferrugineum",
    shinonitText6:
      "הכובע בקוטר עד 6 ס''מ, בעל שיניים בצבע חום אדמוני. השן באורך כ 3 מ''מ. שכבת השיניים גולשת מאוד על פני הרגל והכובע מקבל צורת גביע.",
    shinonitText7:
      "השינונית מופיעה בקבוצות צפופות על הקרקע ביערות אורנים. מרשימה מאוד היא תופעת ה'דמיעה' של טיפות אדומות החלה מהכובע בתנאים של לחות גבוהה. (ראה הסבר במדור",
    shinonitText8Link: " מידע מעולם הפטריות -> תופעות שונות).",
    shinonitImg1: "© וילבאוט",
    shinonitText9Bold: "שינונית שקדית - Hydnellum/Sarcodon amygdaliolens",
    shinonitText10:
      "מין זה נאסף , נבדק מולקולרית ופורסם לראשונה בישראל בכתב-עת מדעי ע''י הפונגריום במוזיאון הטבע שבאוניברסיטת ת.א. בו מצוי המדגם. נמצאה בהרי יהודה ע''י ניצן אלסר.",
    shinonitText11:
      "הפטרייה נבדלת בריח השקדים המאפיין אותה, ומכאן שמה. הכובע נוקשה בקוטר כ 6 ס''מ בגוון חום אפרפר ומתחתיו השיניים בהירות . הרגל בגבה 5 ס''מ מעובה במרכזה ומחודדת בבסיסה.",
    shinonitText12:
      "נחשבת נדירה, כנראה מהסיבה שלא בולטת בין מחטי האורנים ולא קיבלה תשומת לב  מהלקטים.",
    shinonitImg2: "ניצן אילסר",
    shinanit: "שיננית - Hydnum",
    shinanitText1: "משפחת השינניתיים - Hydnaceae.",
    shinanitText2: "בישראל זוהו 2 מינים:",
    shinanitText3Bold: "שיננית שטוחה - Hydnum repandum",
    shinanitText4:
      "השיננית בעלת שיניים בצד תחתון של הכובע. (בשונה מבעלות נקבים או ספוג במשפחות אחרות.) הכובע בקוטר עד 15 ס''מ, צורתו אינה סימטרית והשוליים גליים(מקור שם המין). צבע הכפה לבן עכור  עד בז'. שכבת השיניים גולשת מעט על הרגל, בעלת גוון לבן המשתנה בהתבגרותה לחום אדמוני. אורך השן כ6 מ''מ (מידה זו חשובה כקובעת את ההבדל בין הסוגים הדומים בעלי שיניים). הבשר בצבע לבן-קרם. הרגל קצרה ועבה באורך עד 9 ס''מ וברוחב כ 3 ס''מ.",
    shinanitText5: "בישראל אינה שכיחה, גדלה ביער מעורב, אורן או אלון.",
    shinanitImg1: "© ארנון שדמי",
    shinanitImg2: "© עידית שטיגל",
    shinanitText6Bold: "שיננית אדמונית - Hydnum ufescens ",
    shinanitText7:
      "דומה ל'אחותה' ונבדלת בגודל ובצבעים. קוטר הכובע עד 7 ס''מ, הכפה בצבע אדום-כתום ולעיתים ניכר שקע במרכזה. השיניים באורך עד 5 מ''מ.",
    shinanitImg3: "© Naturfree",
    arrhenia: "ארהניה Arrhenia (Omphalina)",
    arrheniaText1:
      "משפחת הלחלחתיים - Hygophoraceae. בעבר ישעוריתיים (במיקובנק השם אחר).",
    arrheniaText2:
      "הסוג הופרד מהקורקבנית –Omphalina. באנגלית הכנוי שלה - טבור הטחב.",
    arrheniaText3:
      "פטרייה זעירה וחביבה הצומחת בין אצות ובעיקר בין טחבים, במקומות לחים ובקבוצות קטנות. גודלה עד 3 ס''מ, צורתה כגביע או ככנפיים / אונות בלתי סימטריות בגוונים לבן, בז', חום בהיר, ארגמן ואפרפר. בחלק מהמינים ניכרים מעין דפים רחבים הגולשים מאוד על הרגל.",
    arrheniaText4: "בישראל זוהה בוודאות מין אחד בסוג. (במאמר בנימיני)",
    arrheniaText5Bold: "ארהניה ארגמנית - Arrhenia (Omphalina) rustica",
    arrheniaText6:
      "הכובע באורך 2 ס''מ, צורתו כגביע עם שוליים מעוגלים כלפי חוץ. בזמן לחות גבוהה הוא נפרש ונעשה מעט שטוח. הצבע חום – ארגמני. הרגל והכובע בקו ממשיך.",
    arrheniaImg1: "© יהודה מרטה",
    arrheniaText7:
      "*בשלב זה לא נפרט עוד שמות מינים ונחכה לפירסום המעבדה המלקולרית.(2024).",
    arrheniaImg2: "© רותי טלמור",
    arrheniaImg3: "© יאיר אור",
    arrheniaImg4: "© רותי טלמור",
    etzionit: "עציונית - Xylaria",
    etzionitText1: "משפחת עציוניתיים - Xylariaceae.",
    etzionitText2:
      "בישראל נצפו מינים בודדים אך זוהה בוודאות רק אחד ונוסף נבדק וממתין לפרסום מדעי.",
    etzionitText3Bold: "עציונית שחרחרה - Xylaria hypoxylon",
    etzionitText4: "הכנוי – 'פתיל הנר' או 'קרן יעל'.",
    etzionitText5:
      "פטרייה השייכת לפטריות הנאדית, דמוית קרן דקה וזקופה, מסועפת למעלה. האורך עד 6 ס''מ ורוחב 5 מ''מ. בחלק התחתון המבנה צינורי בצבע שחור ובעליון פחוס בצבע לבן. גדלה בקבוצות על חלקי עץ מתים הטמונים בקרקע.",
    etzionitImg1: "© Biopix-Drozd",
    etzionitImg2: "© מ. קרן",
    gmishanit: "גמישנית - Lentinus",
    gmishanitText1: "משפחת הנקבובניתיים - Polyporaceae.",
    gmishanitText2: "בסוג זוהה בישראל מין אחד בשם המתורגם מהשם הלועזי:",
    gmishanitText3Bold: "גמישנית מנומרת - Lentinus tigrinus",
    gmishanitText4:
      "שם הסוג הוחלף מספר פעמים, הקודם היה Panus. שייכת לפטריות הכובע בעלות דפים, רכה, גמישה ומתקשה בהתבגרותה. (לא מובן לי הקשר המשפחתי).",
    gmishanitText5:
      "הכובע בצבע לבן-קרם בקוטר עד 8 ס''מ, שטוח ונעשה משפכי עם הגיל, כך שהשוליים מופשלים כלפי מעלה. הכפה מכוסה קשקשים או כתמים כהים, מכך נובע השם מנומרת, ובמרכזה הגוון כהה יותר. הדפים צפופים באורך שונה וגולשים על פני הרגל. הרגל באורך עד 5 ס''מ, מרכזית או צדדית בדומה לפטרייה אזנית. הצבע לבן-קרם והבסיס נעשה צר, צבעו כהה ונעוץ בקליפת העץ.",
    gmishanitText6:
      "גדלה בקבוצות קטנות סמוך למקורות מים, על גזעי עצים כרותים ועל שורשים של עצי צפצפה, ערבה ועוד רחבי עלים.",
    gmishanitText7:
      "מסוג זה פותחה הפטרייה המוכרת על מדפי החנויות גם במצב מיובש ושמה שיטאקי – Lentinus edodes אותה מגדלים בבתי צמיחה בעולם.",
    gmishanitText8:
      "בעת הזיהוי חשוב להבחין בדמיון לפטרייה נירנית הצפצפה הגדלה באותה סביבה ודומה לה בצורה ובצבע. אינה שכיחה בארצנו, ידועה בגדות הירדן והבניאס.",
    gmishanitImg1: "© דן רוסק",
    gmishanitImg2: "© ניצן אלסר",
    yashurit: "ישעורית - Tricholoma",
    yashuritText1: "משפחת הישעוריתיים - Tricholomataceae.",
    yashuritText2:
      "השם בעברית נובע מכסות השערות שעל הכובע ברוב המינים. המשפחה עשירה מאוד בסוגים והסוג רב מינים. שייך לפטריות הדפים בגדלים בינוניים וגדולים.",
    yashuritText3:
      "הכובע בשרני בקוטר 5 עד 12 ס''מ, פניו בכסות סיבים, קשקשים, שעירים או חלקים. הצבעים אפור, שחרחר, ערמוני, בז' וצהוב. הדפים לבנים ומצהיבים בהבשלה, מפורצים בחיבור לרגל. הרגל מרכזית, עבה ובחלק מהמינים ניכר עיבוי בבסיס וגם עם גוון אדמדם.",
    yashuritText4:
      " לאחרונה נמצאו מינים בצבע לבן. בדקנו במוזיאון ד.נ.א לדעת האם זו אלבינית והריצוף קבע שזו ישעורית אפורה. גם בכרמל נמצאה וטרם נבדקה. ראה באתר במדור מידע, בנושא תופעות.",
    yashuritText5: "את המידע והפירוט של המינים ריכזנו בטבלה - ראה ",
    yashuritText5Link: " בקישור. ",
    yashuritImg1: "© י. אדומת בסיס. ארנון שדמי",
    yashuritImg2: "© י. אפורה. יהודה מרטה",
    yashuritImg3: "© י. כהת קשקשים. ברוריה גל",
    yashuritImg4: "© י. גפורה. דליה בונס ",
    yashuritImg5: "© י. ממוגפת. יהודה מרטה",
    yashuritImg6: "© י. מרה. ברוריה גל",
    yashuritImg7: "© י. סבונית. ברוריה גל",
    yashuritImg8: "© י. סדוקה. וילבאוט",
    mashpachanit: "משפכנית - Clitocybe, Infundibulicybe",
    mashpachanitText1: "משפחת הישעוריתיים - Tricholomataceae.",
    mashpachanitText2:
      "שם הסוג נובע מצורתו כמשפך, ממרכז הכובע מתרוממת שכבת הדפים ממצב קמור כלפי מעלה והשוליים מקופלים פנימה ומתיישרים עם הגיל.",
    mashpachanitText3:
      "הסוג משפכנית שייך לפטריות הדפים, רבת מינים, גדולות בקוטר עד 16 ס''מ, בינוניות כ 8 ס''מ וקטנות כ 4 ס''מ. שכבת הבשר עבה או דקה, כמעט בכולן הדפים גולשים על הרגל באופן מובהק או במעט. פני הכובע יבשים, חלקים, קמחיים או שעירים במקצת. צבע הכובע לבן חלבי, לבן עכור, בז', כחלחל וחום אפרפר. הגוונים משתנים בהתאם לתנאי הלחות. הבשר והנבגים בצבע לבן. הרגל מרכזית, חלקה, קמחית או סיבית בעיקר בבסיס, נראית כמחוברת לכובע. אורך הרגל דומה לקוטר הכובע. גדלה בבודדות או בקבוצות, בין עצי אלון, שיטה ואורן.",
    mashpachanitText4:
      "מינים בסוג זה, בעקר הקטנים, מכילים רעלנים כמו מוסקארין ובנזלדהיד הפוגעים קשות במי שאכל מהן. גם אם בין הגדולות יש טובות למאכל – מומלץ לא להסתכן.",
    mashpachanitText5: "הפרטים אודות המינים הוכנסו לטבלה - ",
    mashpachanitText6Link: "להורדת הטבלה",
    mashpachanitText7Bold: "תמונות מינים של משפכנית:",
    mashpachanitImg1: "© משפכנית כחלחלה. אראלה הרי",
    mashpachanitImg2: "© מ. גדולה. ברוריה גל",
    mashpachanitImg3: "© מ. לבנה. עירית צוק",
    mashpachanitImg4: "© מ. מלבינה. ברוריה גל",
    mashpachanitImg5: "© מ. צריחית. שלמה ויגודני",
    mashpachanitImg6: "© מ. רחבי עלים. דליה בונס",
    mashpachanitImg7: "© מ. ריחנית. יהודה מרטה",
    news: "מה חדש ?",
    capMushroomParts: "צורות וחלקי פטריות הכובע, צורות כובע ורגל",
    capMushroomPartsImg1: "© ציירה - טייסי דסקלוב",
    kamronit: "קמרונית - Chroogomphus / Gomphidius",
    kamronitText1: "משפחת קמרוניתיים - Gomphidiaceae.",
    kamronitText2:
      "שייכת לפטריות הדפים בגודל בינוני, בעלת כובע בקוטר עד 8 ס''מ המתחיל בצורה מקומרת סגורה ונפתח למצב פתוח יותר. צבע הכובע חום ערמוני במין אחד וחום אפרפר במין שני. סימן מיוחד ניכר בכיפה הדביק מהריר המכסה אותה ובנוסף - הדפים המרווחים ועבים, הגולשים מאוד על הרגל. הרגל זקופה בצבע בהיר יותר מאשר צבע הכובע, צרה יותר בחלקה התחתון. בבסיס הרגל מופיע גוון צהוב או לבן. בחלק העליון ניכר 'צוארון' בהיר הנושק לדפים.",
    kamronitText3: "בישראל מצויים שני מינים:",
    kamronitText4Bold: "קמרונית אדמדמה - Chroogomphus rutinus",
    kamronitText5:
      "צבע הכובע והדפים חום ערמוני, הרגל בגוון יותר בהיר. בבישול מתקבל בסיר צבע עז סגלגל-ארגמני.",
    kamronitImg1: "© דליה בונס",
    kamronitText6Bold: "קמרונית דביקה - Gomphidius glutinosus",
    kamronitText7:
      "נבדלת מהאדמדמה בגוון החום-אפרפר של הכובע והדפים הלבנים. בשוליים ניכרים שרידי הצעיף החלקי. בסיס הרגל בצבע צהוב.",
    kamronitImg2: "© Free images",
    shasuit: "שסועית - Schizophyllum",
    shasuitText1: "משפחת השסועיתיים - Schizophyllaceae",
    shasuitText2: "בישראל קיים בסוג מין אחד -",
    shasuitText3Bold: "שסועית מצויה - S.commune",
    shasuitText4:
      "בעבר שמה היה שסועה. שייכת לפטריות הדפים הקטנות חסרות רגל. קוטר הכובע 1-4 ס''מ, מורכב מאונות רבות דמויי מניפה בגדלים שונים ובעובי דק. פני הכובע שעירים, הצבע לבן –קרם – אפרפר. הדפים במבנה מיוחד עם פיצול / שסע לשניים בקצוות, הצבע אפרפר ולעיתים בגוון אדמדם. צבע הנבגים לבן.",
    shasuitText5: "נפוצה וגדלה ב'מושבות' על ענפים או גזעים כרותים.",
    shasuitImg1: "© רותי טלמור",
    shasuitImg2: "© רותי טלמור",
    tzitzanit: "ציצנית - Hebeloma",
    tzitzanitText1: "משפחת האבנטיים - Strophariaceae",
    tzitzanitText2: "שייכת לפטריות הדפים, הגודל בינוני, חסרת טבעת ונרתיק.",
    tzitzanitText3:
      "הכובע קמור ועם הגיל נעשה שטוח, קוטרו עד 11 ס''מ. הכיפה חלקה ובתנאי לחות מתכסה בריר. צבעיה חום בהיר, אפרפר, ערמוני או בז'. הדפים צפופים, רחבים או צרים בצבע לבן עכור או בגוון אפרפר. יש הגולשים מעט על הרגל ויש בעלי מפרץ. הרגל שונה בין המינים ומהווה עבורנו סימן זיהוי. בחלק מהמינים ניכרים קשקשים, פתיתים או כסוי קמחי, אורך הרגל מ6 עד 11 ס''מ.",
    tzitzanitText4:
      "לציצנית יש מינים בעלי טעם מר ויש עם ריח אופייני של צנון. גדלה בעיקר בין עצי אלון בצפון הארץ, שכיחה במיוחד ביערות אלונים בגולן.",
    tzitzanitText5:
      "בישראל ידועים 3 מינים בוודאות ועוד המצפים לפרסום לאחר שנעשתה בדיקה מולקולרית (נדווח כאן).",
    tzitzanitText6Bold: "ציצנית חרדלית - H. sinapizans",
    tzitzanitText7:
      "הכובע בקוטר עד 10 ס''מ, השוליים צרים. הכיפה מזוגגת בגוון חום-ערמוני, דביק בתנאי לחות והדפים רחבים. הרגל באורך כ 10 ס''מ בצבע בז' ובעלת קשקשים בחלקה העליון. מיוחד לה - ריח צנון.",
    tzitzanitImg1: "© יהודה מרטה",
    tzitzanitText8Bold: "ציצנית שטוחה - H.crustuliniforme",
    tzitzanitText9:
      "הכובע בקוטר עד 6 ס''מ בגוון צהבהב-חום-אפרפר, דביק מעט בתנאי לחות. הרגל באורך עד 8 ס''מ, מעובה מעט בבסיס עם פתיתים בחלק העליון. גדלה ברקבובית העלים ביער. גם למין זה ניכר ריח צנון וטעם מר. נחשבת רעילה למאכל.",
    tzitzanitImg2: "© אראלה הרי",
    tzitzanitText10Bold: "ציצנית ארוכת-רגל   H. longcaudum",
    tzitzanitText11:
      "הכובע בקוטר עד 8 ס''מ בגוון חום בהיר ובמרכז הכיפה הגוון כהה יותר. הדפים בגוון אפרפר או בשרי. הרגל באורך עד 11 ס''מ עם בסיס צר, לבנבנה עם גרגרים בחלקה העליון.",
    tzitzanitImg3: "© ברוריה גל",
    tzitzanitText12Bold: "ציצנית מפותלת/גלית – Hebeloma subtortum",
    tzitzanitText13:
      "משפחה – Strophariaceae (בעבר –Hymenogastraceae, Cortinariaceae)",
    tzitzanitText14: "המתאר – Karsten 1889",
    tzitzanitText15:
      "תרגום שם המין – מעט מפותלת/גלית, כנראה הכוונה לרגל. שם נרדף – H.sordida. הפטרייה דומה למינים נוספים וקשה היה לזהותה ביער, אלא בבדיקה גנטית שבוצעה במוזאון הטבע ופורסמה לראשונה בישראל. הכובע בקוטר 7 ס''מ בגוון בז', כהה יותר במרכז. רגל מעוקמת מעט, בגוון קרם. ידועה בעקר מדרום אירופה. נאספה ביער אודם בגולן ע''י דליה בונס, ב14.1.2018 ומספרה באוסף -18.017.",
    tzitzanitText16: " *חסרה בידינו תמונה ספציפית של הפרט הנאסף.",
    lavkanit: "לבקנית - Leucoagaricus",
    lavkanitText1: "משפחת הפקועיתיים - Agaricaceae.",
    lavkanitText2:
      "הלבקנית שייכת לפטריות הדפים. בעשור האחרון חלים שינויים רבים ותוספות בסוג זה. מבין פטריות מהסוג מטריינית-Lepiota החליפו ללבקנית. (אנו נאמנים לטקסונומיה המתעדכנת באתר המיקולוגי הבינלאומי מיקובנק.) הכובע בשרני, דק או עבה, בקוטר עד 15 ס''מ.  הגוון לבן, לבן עכור, אפור או בז', חלק או עם קשקשים. הדפים חופשיים, צפופים עם דפי ביניים בגוון לבנבן, אפרפר או ורדרד. הרגל באורך כקוטר הכובע או יותר, עבה או צרה או מחודדת בבסיס הטמון באדמה. בעלת טבעת ניכרת. גדלה עפ''ר ביחידות בחולות, עשבייה וכן ביערות וחורשות.",
    lavkanitText3: "המינים הידועים בישראל:",
    lavkanitText4Bold: "לבקנית אגוזים – L. leucothites",
    lavkanitText5:
      "במעבדת פרופ' וואסר בחיפה החליפו את השם של מטריינית אגוזים Lepista naucina - וכך כתוב עם פרוט, כאן באתר. פרוש שם המין החדש – 'הנאכלת הלבנה הקטנה'.",
    lavkanitText6Bold: "לבקנית בארסיי - L.barsii",
    lavkanitText7:
      "נקראת על שם הבוטנאי פרופ' בארסיי. קוטר הכובע כ 10 ס''מ, צבעו לבן-אפרפר, כהה יותר במרכז, בעל קשקשים בולטים. הדפים בצבע קרם. הרגל באורך כ 10 ס''מ, לבנה עם בסיס מחודד ועם טבעת צרה. ריח פטרייתי חזק. חיה באדמה חולית או בדיונות מכוסות צמחיה.",
    lavkanitText8Bold: "לבקנית בהירה - L. serenus",
    lavkanitText9:
      "שם קודם לסוג – מטריינית Lepiota. פטרייה קטנה יחסית למינים בסוג, קוטר הכובע עד 4 ס''מ, הכיפה לבנה, משיית חלקה עם מעט שיער במרכזה. הדפים והנבגים לבנים. הרגל ארוכה מקוטר הכובע בצבע לבן, כמו גם הטבעת. חיה במקומות-חיים שונים ומגוונים.",
    lavkanitText10Bold: "לבקנית עשן - L. cinerascens",
    lavkanitText11:
      "שם קודם לסוג – מטריינית Lepiota הכובע בקוטר עד 8 ס''מ, פניו סדוקים עם קשקשיים וצבעו אפור כהה עם מרכז כמעט שחור. הדפים בגוון קרם והנבגים בגוון בהיר עד וורוד. הרגל באורך כקוטר הכובע, בצבע בז' עם טבעת צרה. הריח פטרייתי חזק. חיה בשטח חולי או בדיונות מכוסות צמחייה. נחשבת נדירה, ידועה בעקר באזור הים-תיכוני.",
    lavkanitImg1: "© וילבאוט",
    lavkanitText12Bold: "המינים בברור ובבדיקות:",
    lavkanitText13Bold: "לבקנית חומת-כפה - Leucoagaricus cupresseus",
    lavkanitText15:
      "משפחת הפקועיתיים - Agaricaceae. מין זה תואר לראשונה ב 2001.",
    lavkanitText16:
      "תרגום השם - ל. הברושים, כי נמצאה ליד עצי ברוש, אך בישראל נמצאה גם בין אלונים.",
    lavkanitText17:
      "נבדלת בצבע הכפה - חום בהיר עד כהה. הרגל מעובה בבסיסה, מאדימה מעט בשפשוף. הטבעת צרה הנושרת בהמשך הצמיחה.",
    lavkanitText18:
      "נבדקה גנטית ופורסמה לראשונה בישראל במוזיאון לטבע, מפרט באוסף, מספר 23.147 שנאסף ביער אלונים בהסוללים, ב 30/12/2023 בסיור עם קבוצת הפטריותים של ברוריה גל, ע''י יאיר אור.",
    lavkanitText19:
      "קיימת תצפית נוספת מקבוץ נצר סירני, מתחת לעץ ברוש ע''י אייל פאר, משני מקומות בקבוץ ב9.1.2024 וב 5.2.24",
    lavkanitText20: "הפטרייה נדירה בארץ, ומידע חדש יחסית ידוע בעולם.",
    lavkanitImg10: "אייל פאר ©",
    lavkanitImg11: "אייל פאר ©",
    lavkanitImg12: "יאיר אור ©",
    lavkanitImg13: "ברוריה גל ©",
    lavkanitText14Bullet: "L. littoralis",
    lavkanitText15Bullet: "L. rimosovelatus",
    lavkanitText16Bullet: "L.carneifolius",
    bakbukanit: "בקבוקנית - Pilobolus",
    bakbukanitText1:
      "שייכת לקבוצה קטנה בממלכת הפטריות ששמה – זיגומיקוטה – Zigomycetes.",
    bakbukanitText2:
      "נצפתה וצולמה בארץ פעמים בודדות, הכינוי Pin molds וגם Hat throwers.",
    bakbukanitText3:
      "מבנה גוף הפרי כבקבוקון שקוף המכיל נוזל היושב על גבעולון באורך כ 4 ס''מ. בראשו יושב המינבג הכהה. הפצת הנבגים מתקיימת בדרך מיוחדת ונדירה. הצטברות הנוזל בבקבוקון מתגברת, יוצרת לחץ וגורמת לבקבוק להתנפץ בעוצמה כבירה המעיפה את המנבג למרחק רב מאוד ונצמד לעלי הצמחים.",
    bakbukanitText4:
      "מחזור חייה מעניין בכך שחייבת לעבור את מערכת העיכול של בע''ח אוכלי עשב ובהפרשות שלהם מצויים הנבגים המתפתחים על הגללים לתפטיר וממנו גוף פרי חדש.",
    bakbukanitText5: "*השם הנ''ל הינו הצעה של ברוריה גל.",
    bakbukanitText6: "קישור למידע על הפטריה בויקיפדיה:",
    bakbukanitImg1: "© אלכס ט.",
    golshanit: "גולשנית – Rhodocybe / Lulesia",
    golshanitText1: "משפחת אדומיתיים - Entolomataceae.",
    golshanitText2:
      "הסוג עובר שנויים רבים במעבדות הטקסונומיה ועד כה עדיין לא התייצב. קיימים תת-סוגים השונים בצבעי הכובע, כמו Rufobrunnea שצבעו חום אדמדם, אך המאפיין בכל המינים הוא הכובע בעל שוליים גליים. עדכון השמות נעשה על פי מיקובנק 2025. *ראה מאמר מדעי של המוזיאון לטבע בקישור באתר 'פטרידע'.",
    golshanitText3: "המינים שנבדקו בישראל:",
    golshanitText4Bold: "גולשנית חוסאני – Rhodocybe asanii",
    golshanitText5:
      "נקראת על שם המתאר מטורקיה ופורסמה בשותפות עם ויזיני ב 2017.",
    golshanitText6:
      "בישראל נאספה, נבדקה במוזיאון הטבע ופורסמה לראשונה בכתב עת בינלאומי. המין מוכר מעט בארופה.",
    golshanitText7:
      "קוטר הכובע 5 עד ס''מ, צבעו חום אדמדם, תלוי בלחות באויר, בעל שוליים גליים. צבע הדפים בהירים מהכפה והנבגים בצבע ורדרד. הרגל בגבה 4 ס''מ ורוחבה 1.5 ס''מ, מעובה מעט בבסיס ומכוסה סיבים עדינים.",
    golshanitImg1: "© ברוריה גל",
    golshanitText8Bold: "גולשנית מאפירה – Lulesia nigrecsens",
    golshanitText9: "בעבר היו שמות הסוג Clitocella, Rhodocybe, Rhodopaxillus.",
    golshanitText10:
      "זיהוי אחרון ופרסום מדעי נערך ע''י המיקולוג ויזיני ושותפיו ב 2023. בישראל נבדקה במוזיאון הטבע ופורסמה לראשונה בכתב עת בינלאומי. מין זה אינו נפוץ בארץ, רק מעט תצפיות נרשמו.",
    golshanitText11:
      "גוף הפרי בקוטר כ 7 ס''מ, בעל שוליים גליים, מכאן מקור השם. הכפה של פטרייה בוגרת בצבע חולי, צהבהב-אפרפר. בין הדפים ניכרים דפי ביניים, צפופים, גולשים על הרגל. צבע הנבגים ורוד. הבשר בצבע לבן המאפיר בחיתוכו. הרגל בגבה 7 ס''מ וברוחב 1 ס''מ, צבעה כצבע הכובע. ",
    golshanitImg2: "© inaturalist",
    golshanitText12Bold: "גולשנית אסאייה – Rhodocybe asyae",
    golshanitText13:
      "נקראת על שם בתו של המתאר Asya Sesli , פורסמה למדע ע''י ססלי וויזיני ב 2017. בישראל נבדקה במוזיאון הטבע ופורסמה לראשונה בכתב עת בינלאומי.",
    golshanitText14:
      "קוטר הכובע 4 ס''מ, צבעו חום אדמדם, כפה חלקה, דפים בצבע בז'. השוליים גולשים על הרגל והבשר דק. הרגל בגבה 5 ס''מ וצבעה חום בהיר.",
    golshanitText15: "מינים נוספים:",
    golshanitText16: "Clitopilus prunulus / truncate גולשנית השזיף.",
    golshanitText17: "Clitopilus/Omphalina  mutilus  גלשנית קטומה.",
    golshanitText18: "Rhhodocybe/ Clitopilus gemina (דומה לג.אפורה.)",
    golshanitArticle: "למאמר על הסוג גולשנית",
    monza: "© מועדון מונזה",
    marzevit: "מרזבית - Hoenbuelia",
    marzevitText1: "משפחת אזניתיים – Pleurotaceae (בעבר –ישעוריתיים).",
    marzevitText2:
      "שייכת לפטריות הדפים, כובע דמוי משפך שאינו סימטרי ונראה כחצוי לאורכו ומכאן שמה מרזבית. רוחב הכובע עד 12 ס''מ, הדפים גולשים מאוד על הרגל. כסות הכובע קמחית. הפטרייה עבת-בשר שצבעו בהיר. הרגל עבה, צידית, קצרה או ארוכה.",
    marzevitText3:
      "המינים בסוג עוברים לאחרונה שנויים בעולם ונתגלו גם חדשים למדע. *נתייחס לחידושים עם קבלת ההחלטות מהמעבדות הגנטיות. בישראל ידועים 2 מינים:",
    marzevitText4Bold: "מרזבית חיגרת - H.petaloides (geogenius)",
    marzevitText5:
      "(שם נוסף למין - האדמה או גם עבה. שם מדעי חדש נוסף – H. bonii). הכובע דמוי צדפה ברוחב עד 12 ס''מ, הצבע חום אדמדם או כתמתם עד חום כהה. השוליים מקופלים כלפי פנים. הדפים צפופים בצבע קרם. ריח וטעם – קימחיים. גדלה ביערות על פני קרקע עם רקבובית, כ 2-4 גופי פרי צמודים.",
    marzevitImg1: "© אראלה הרי",
    marzevitImg2: "© עירית צוק",
    marzevitText6Bold: "מרזבית ארוכת רגל - H. longipes",
    marzevitText7:
      "*המין עובר בדיקות בעולם, נעדכן לכשיפורסם. הכובע קטן מהחיגרת, ברוחב עד 5 ס''מ מאורך ומרזבי ממנה והרגל ארוכה בהרבה. נחשבת נדירה בישראל.",
    kshichit: "קשיחית - Stereum",
    kshichitText1: "משפחת הקשיחיתיים - Stereaceae.",
    kshichitText2:
      "הפטרייה שייכת לפטריות העציות, נראית כפטריית מדף קטנה חסרת רגל הגדלה בקבוצה צפופה כמו מניפות אחת מעל השנייה. רוחב גוף הפרי 2-5 ס''מ, אינו סימטרי והשוליים גליים ומקופלים. מופיע בצבעים צהוב, כתום, אדמדם ועד חום עם שוליים בהירים יותר. הסוג דומה לדפדפנית המחטניים.",
    kshichitText3:
      "בישראל ידועים 2 מינים שנבדקו גנטית. (מינים נוספים רשומים ויש לברר מאמר מוסמך).",
    kshichitText4Bold: "קשיחית שעירה – Stereum  hirsutum",
    kshichitText5:
      "קוטר גוף הפרי עד 5 ס''מ, חלקו העליון שעיר, הצבע כתמתם – אפרפר והשוליים צהבהבים. הבשר גמיש בצעירותו וקשיח בסוף הגידול. מין נפוץ הגדל על עצים ממינים שונים ורבים.",
    kshichitImg1: "© ניצן אלסר",
    kshichitText6Bold: "קשיחית כיפתית - Stereum / Xylobolus subpileatum",
    kshichitText7:
      "שם הסוג השתנה ב1958 , ע''פ מיקובנק. גופי הפרי מאורכים, רוחבם עד 3 ס''מ, צמודים לגזע ובעלי כסוי צמרי. הצבע חום בהיר  או כתמתם –אפרפר. נדיר בישראל, נמצא על עץ אלון.",
    kshichitImg2: "© בנימיני",
    kearit: "קערית - Sarcosphaera coronaria",
    kearitText1: "משפחת Pezizaceae.",
    kearitText2:
      "גוף הרבייה מתחיל חייו בצורת כוסית השקועה מעט בקרקע ובהמשך מבשיל ונפתח לצורת לוע ההופך לקערה עם קשוות מחודדות מעל פני הקרקע.",
    kearitText3: "בישראל ידוע מין אחד:",
    kearitText4Bold: "קערית נאה - Sarcosphaera",
    kearitText5:
      "גוף הפרי בקוטר עד 8 ס''מ, החלק הפנימי שהוא השכבה הפורייה, במרקם חלק בצבע סגול והחיצוני לבן קרם. הקשוות בעובי 3 מ''מ. הפטרייה גדלה כיחידה או בקבוצה קטנה. לעיתים דומה בצורתה למינים מבני משפחתה.",
    kearitImg1: "© ברוריה גל",
    kaarurit: "קערורית - Marcelleina",
    kaaruritText1: "משפחת Pezizaceae.",
    kaaruritText2: "בישראל ידוע מין אחד:",
    kaaruritText3Bold: "קערורית סגולה - M.atroviolacea",
    kaaruritText4:
      "גוף הרבייה קטן בקוטר כ 1.5 ס''מ דמוי קערה שטוחה וצבעו סגול - שחור. השוליים משוננים מעט. גדלה בקבוצות בקרקע חולית.",
    kaaruritImg1: "© בנימיני",
    menifatit: "מניפתית - Thelephora - Hymenochaete",
    menifatitText1: "משפחת המניפתיים - Thelephoraceae.",
    menifatitText2:
      "* השם העברי - היה נכון לאמר מניפנית אך כיון שיש לטאה בשם זה נכתב השם בסמיכות-מניפתית.",
    menifatitText3:
      "* השם המדעי עבר שנוי והחלף בשם מין אחד. בנימיני פירסם בספרו בשם עברי זיפנית, אך כיון שיש שם זהה בפטריות כובע – נשאירו בשם המקורי.",
    menifatitText4:
      "הסוג שייך לסדרת הפטריות העציות, גדל על ענפים וגזעי עצים יבשים בקבוצה צפופה. גוף הפרי דמוי מניפה ומכאן שמו, אחד מעל או בצד השני. הצבע ערמוני, חום כהה וגוון סגול המצוירים בדורים דורים. רוחב המניפה עד 6 ס''מ והעובי עד 1.5 מ''מ.",
    menifatitText5:
      "בישראל ידועים 2 מינים: (יש מין נוסף באוסף אוניברסיטת ת.א ללא אסמכתא)",
    menifatitText6Bold: "מניפתית האורן - Thelephora terrestris",
    menifatitText7:
      "גוף הפרי שטוח ושעיר ברוחב עד 6 ס''מ, גבה עד 4 ס''מ ועובי 2 מ''מ. הצבעים חום כהה עם כתמים בגוון סגול. צעירותה השוליים בהירים. גדלה במיקוריזה בעיקר עם עצי מחט.",
    menifatitImg1: "© וילבאוט",
    menifatitText8Bold:
      "מניפתית (זיפנית) קינמונית - Hymenochaete (Theleophora) cinnamomea",
    menifatitText9:
      "גוף הפרי רחב, בגווני חום אדמדם כצבע הקינמון עם שוליים בהירים. העובי דק. נחשבת נדירה בארץ.",
    menifatitImg2: "© וילבאוט",
    kufsit: "קופסית - Geopyxis",
    kufsitText1: "משפחת - Pyronemataceae.",
    kufsitText2: "בישראל נבדק וידוע מין אחד:",
    kufsitText3Bold: "קופסית פחומה - G. carbonaria",
    kufsitText4:
      "פטרייה קטנה דמוית כוסית או גביע חסרת רגל, צמודה לקרקע עם מעין שורשון קטן. גוף הפרי הצעיר סגור ככדור ובהמשך נפתח. פניו חלקים, הקוטר עד 3 ס''מ וכך גם הגבה. הצבע צהוב בהיר והחלק הפנימי (השכבה הפורייה) נוטה לכתום. השוליים בהירים ומעט מחורצים.",
    kufsitText5: "הקופסית גדלה בקבוצות רבות-פרטים על קרקע חרוכה.",
    kufsitImg1: "© בנימיני",
    shkuit: "שקועית - Geopora",
    shkuitText1: "משפחת - Pyronemataceae.",
    shkuitText2: "בעבר השם המדעי של הסוג היה .Lachnea, Sepultaria",
    shkuitText3:
      "שייכת לקבוצת הפטריות דמויות כוסית או קערית. צמודה ושקועה בקרקע, באזור חולות וגם בחורשות. גוף הפרי יוצא בחלקו מעל פני הקרקע מצורת כדור סגור ובהמשך ההבשלה נפתח עם לוע או קשוות הנפרשות לצדדים, לבסוף מתקבלת צורת קערה. מופיעה בבודדים או בקבוצות קטנות.קוטר גוף השקועית עד 4 ס''מ. השכבה החיצונית מכוסה בשערות אליהן נצמדים גרגרי חול או אדמה.קל מאוד לטעות בזיהוי עם מינים של סוגים אחרים כמו פזיזה, קופסית, גביעית ועוד.",
    shkuitText4: "בישראל נבדקו וידועים עד כה 2 מינים בסוג:",
    shkuitText5Bold: "שקועית ארנים - G.arenicola",
    shkuitText6:
      "גוף הפרי בקוטר עד 4 ס''מ. החלק הפנימי - ההינומית (רקמת הרבייה), בצבע בז' או חום בהיר והשכבה החיצונית כהה יותר. גדלה בחורשות אורנים ובין טחבים.",
    shkuitImg1: "© רותי טלמור",
    shkuitText7Bold: "שקועית חולות - G. arenoza",
    shkuitText8: "דומה מאוד לשקועית הארנים אלא שגודלה קטן וגדלה בחולות.",
    shkuitImg2: "© יואב סילברט",
    altit: "אלתית - Clavaria, Clavulina, Ramaria",
    altitText1: "משפחת האלתיים , Clavulinaceae, Gomphaceae - Clavariaceae.",
    altitText2:
      "סוג זה עבר שנויים בהגדרה הגנטית, בו השתנו השמות המדעיים ושמות המשפחה. בשפה העברית נשאר כיום השם המקורי. (יתכן שבעתיד יכנס חוקר, מיקולוג בישראל לחקור סוגים אלה ויציע שנויים גם בעברית). השם אלתית נובע מהצורה של גוף הפרי דמוי מקבץ של אלות או זרועות המחוברות לבסיס אחד ונראה כאלמוג זקוף.",
    altitText3:
      "הסוג כולל מינים רבים, חלקם גמישים וחלקם עציים ושבירים. יש בעלי מקבץ גדול ורחב ויש שהוא צר עם מעט זרועות. המבנה רב צורות: יש עם זרועות עבות, דקות, מעובות, מסועפות, עם קצוות מחודדים או מעוגלים. המינים בסוג מופיעים בצבעים שונים: לבן צחור, לבן עכור, צהבהב, צהוב, בג' וחום. הזיהוי בין המינים דורש לעיתים בדיקה גנטית משום ההבדל הקטן ביניהם. רוב המינים גדלים על הקרקע בחורש ויער ומעט על ענפים נרקבים או בשטח עשבוני. חלקם מצויים יותר וחלקם פחות.",
    altitText4: "להלן נפרט חלק מהמינים הידועים בארץ:",
    altitText5Bold: "אלתית סגלגלה - Clavaria amethystine",
    altitText6:
      "צורת וצבע גוף הפרי דומה למינים נוספים אך בארץ נבדל בגוון הסגול החזק. גוף הפרי בגבה עד 6 ס''מ, מסועף בצורה לא אחידה בעקר בקצוות העליונים המחודדים. בסיס הזרועות עבה והגוון חום-סגול.",
    altitImg1: "© ידענטבע",
    altitText7Bold: "אלתית אדמה - Clavulina cristata",
    altitText8:
      "(שם קודם - Clavulina coralloides) גוף הפרי בגבה וברוחב עד 9 ס''מ, בעל זרועות צפופות מאוד עם קצוות מסועפים וחדים. הגוון קרם, אפרפר או זהוב בתנאי יובש. גדלה בעקר על הקרקע בין עצים שונים, בקבוצה קטנה או בבודדים.",
    altitImg2: "© ידענטבע",
    altitText9Bold: "אלתית אפורה - Clavulina cinerea",
    altitText10:
      "גוף הפרי בגבה עד 12 ס''מ, בעל זרועות מפוצלות בחלק התחתון ושוב בעליון. הצבע אפרפר, בג' ונגיעה בסגול.",
    altitImg3: "© סקסיפרגה",
    altitText11Bold: "אלתית צהבהבת - Clavaria argilacea",
    altitText12:
      "גוף הפרי בגבה עד 8 ס''מ. הזרועות דלילות, מעובות ובלתי מסועפות, הקצוות מעוגלים, או מחודדים מעט. הצבע בג' צהבהב.דומה מאוד לטיפולה.",
    altitImg4: "© וילבאוט",
    altitImg5: "© סקסיפרגה",
    altitText13Bold: "אלתית קורנר - Clavulinopsis corniculata",
    altitText14:
      "שמה על שם החוקר קורנר, הכינוי אלתית אחו. הופרדה מ Clavaria בגלל המבנה הפריך, השביר וההבדל המיקרוסקופי. גוף הפרי בגבה עד 9 ס''מ, בנוי מזרועות עדינות, מסועפות בצבע צהוב. ההסתעפויות מתחילות רק בגבה כ 4 ס''מ מהבסיס. גדלה בעקר בשטח המכוסה בעשבייה וגם בקרחות יער.",
    altitImg6: "© וילבאוט",
    altitText15Bold:
      "אלתית האקליפטוס - Clavaria,Ramaria) decurrens) Phaeoclavulina",
    altitText16:
      "עברה למשפחת Gomphaceae גוף הפרי בגבה עד 10 ס''מ, הזרועות מסועפות ומחודדות בקצה העליון. הצבע קרם עד צהבהב. גדלה על שכבת העלים שעל הקרקע בחורשות אקליפטוס.",
    altitText17:
      "* ברשימות בישראל רשומים עוד בני משפחה מסוגים ומינים המחכים לבדיקות מולקולריות, כגון Typhula.",
    siflonit: "ספלונית - Sarcoscypha",
    siflonitText1: "מופיעה גם בשם סוג Helvella (מיקובנק 2024)",
    siflonitText2: "משפחת הספלוניתיים - Sarcosciphaceae.",
    siflonitText3: "בישראל ידוע מין אחד בסוג:",
    siflonitText4Bold: "ספלונית אדומה - S. coccinea",
    siflonitText5:
      "פטרייה זעירה ומרשימה בצבע האדום הבולט בשטח. צורתה ככוסית בקוטר כ 3 ס''מ, היושבת על רגלית קצרה צמודה בעיקר לענפים דקים של עצי אלון. הגוון החיצוני לבנבן או אדמדם במרקם לבדי והפנימי אדום כדם במרקם חלק. הרגלית באורך עד 3 ס''מ, קצרה יותר בחלקה התחתון וצבעה לבנבן. גדלה בבודדות או בקבוצות קטנות.",
    siflonitText6:
      "בישראל נמצאו פרטים בצבע כתום הנחשב מופע - Forum במין האדום הידוע, או תת-מין ''S.C. aurantiacea''.",
    siflonitImg1: "© דבא מור",
    siflonitImg2: "© רונית פוליצר",
    astarit: "אסתרית - Asteraeus",
    astaritText1: "משפחת - Locystidiaceae.",
    astaritText2: "בעבר נכללה במשפחת האבקיתיים, בסוג כוכבנית.",
    astaritText3: "בישראל ידוע מין אחד מהסוג:",
    astaritText4Bold: "אסתרית ספוגית - A.hygrometricus",
    astaritText5:
      "מקור שם הסוג מההסטוריה  היוונית ושם המין נובע מהתכונה של הפטרייה לספוג לחות מהאויר, להתכווץ ולהפתח. קוטר גוף הפרי במצב סגור כ 5 ס''מ ובמצב פתוח כ 9. דמוי כוכב, כדור המוקף ב'קרניים' (אונות). בשלב צעיר הכדור מכוסה בשכבה עבה וגלדנית ובהמשך הקרום נקרע ל 'קרניים', עד 13 במספר. קרום הכדור דק ובקודקוד נפער חור עגול או קרוע המהווה פתח להפצת הנבגים. צבע הכדור לבן עד בז' וצבע הקרניים פסיפס של שחור ולבן. (סימן חשוב להבדיל מכוכבנית) הגלבה (השכבה הפורייה) בצבע חום שהוא צבע הנבגים. בתנאי יובש הזרועות/קרניים מתכווצות פנימה ומגוננות על שק הנבגים ובשנוי למצב של לחות – נפתחות ומתאפשרת הפצת הנבגים החוצה. צמודה לקרקע, ללא רגל או בסיס.",
    astaritText6:
      "האסתרית נפוצה בתבל אך אינה שכיחה בכמות. גדלה בשטח חשוף שבתוך חורש עצים רחבי עלים ושותפה במיקוריזה עם עצים או שיחים ממינים שונים.",
    astaritImg1: "© עירית צוק",
    astaritImg2: "© אבנר סלפק",
    gushanit: "גושנית - Leccinum",
    gushanitText1: "השם השתנה מהסוג גושית .ראה פרטים בטבלת הסוג גושית Boletus",
    gushanitText2: "השם החדש - גושית מעורקת Leccinum crocipodium",
    tzivonit: "צבעונית - Panaeolus",
    tzivonitText1: "משפחת (Agaricineae) Galeropsidaceae.",
    tzivonitText2:
      "פטרייה קטנה בעלת כובע בצורת פעמון מחודד בצעירותו והופך לקמור. הקוטר ברוחב 2-4 ס''מ, מכוסה בקשקשים זעירים או בלעדיהם. לחלקן השוליים בהירים או עם שרידי צעיף. צבע הכפה מלבן עכור, חום בהיר ועד אפור ושחור, משתנה בהתאם ללחות. הדפים מרווחים בצבעים חום או שחור. הרגל דקה, ארוכה עד כ10 ס''מ. בעלת כסות אבקתית או שערות כקטיפה.",
    tzivonitText3:
      "גדלה בעיקר בקבוצות קטנות על גללי בע''ח, אדמה דשנה במגוון ביוטופים: שדות, גנים או חורשות. מינים בסוג דומים למיני שברירית, ססגונית, חרוטית ועוד.",
    tzivonitText4: "בישראל ידועים עד כה שני מינים:",
    tzivonitText5: "* מין נוסף – צ. ''חצי ביצה'' נמצא בבדיקה.",
    tzivonitText6Bold:
      "צבעונית פעמון - P.papilionaceus (השם בעבר - P.sphinctrinus)",
    tzivonitText7:
      "הכובע בצבע חום עד חום-אפרפר עם שוליים בהירים ולעיתים ניכרים שרידי הצעיף. המירקם חלק בצעירותו ובהמשך-שעיר. הדפים רחבים, נצבעים מהנבגים השחרחרים והקצוות בהירים יותר. הרגל גבוהה ודקה, הגוון בהיר בחלקה העליון וחום-אדמדם בתחתון. מיוחדת במקום הגידול – על גללי בהמות.",
    tzivonitImg1: "© סקסיפרג",
    tzivonitText8Bold: "צבעונית שחורה - P.ater",
    tzivonitText9:
      "נבדלת ע''י המירקם החלק של הכובע וצבעו השחור. הרגל מעט סיבית בגוון אפור-חום עד שחור. נחשבת כנדירה בישראל.",
    tzivonitImg2: "© סקסיפרג",
    yearSummary: "סיכום עונת 2024-25 - פורסם בפייסבוק של השירות המטאורולוגי",
    hadurit: "הדורית - Boletopsis",
    haduritText1: "משפחת Bankeraceae (בעבר – Polyporaceae).",
    haduritText2:
      "שייכת לפטריות בעלות נקבים, השכבה הפורייה גולשת מעט על הרגל. הכובע אינו סימטרי, עב-בשר בקוטר עד 15 ס''מ, עם שוליים דקים וגליים. הכפה מכוסה במעט קשקשים והצבע חום בהיר או אפרפר. הרגל עבה והגבה עד 8 ס''מ.",
    haduritText3:
      "גדלה על הקרקע במיקוריזה עם מיני אורן. נחשבת נדירה ובמספר ארצות נכללת ברשימה האדומה (מוגנת). בארץ ידוע מין אחד:",
    haduritText4Bold: "הדורית קשקשית - Boletopsis subsquamos ",
    haduritText5: "- בספר ובמאמר של פרפ' בנימיני.",
    haduritImg1: "© סקסיפרג",
    torrendia: "טורנדיה נאה - Torrendia  pulchella",
    torrendiaText1:
      "פטרייה מיוחדת שקיבלה זיהוי כפול לסוג וגם למשפחה מאז נתגלתה בשנת 1902. השם הנוסף הינו אמנית טורנדי Amanita torendii (על שם המגלה מפורטוגל ששמו Camille Torrent).",
    torrendiaText2:
      "בגוף הפרי של הטורנדיה חלה תופעה שבהתפתחות האבולוציונית חלה מעין עצירה וניכרת בו רקמת רבייה המזוהה כפטריית כרס בעוד החלק החיצוני בכובע מזוהה כאמנית. הפצת הנבגים נעשית בעוד הכובע חצי פתוח.",
    torrendiaText3:
      "הפטרייה קטנה, קוטר  הכובע 1.5 ס''מ, כדורי, אינו נפתח כמו האמנית ובתוכו מכונסת השכבה הפורייה. שכבת הדפים אינה ברורה. צבעו לבן-קרם. הרגל באורך כ 3 ס''מ , עבה יחסית בעלת קשקשים גסים לכל אורכה. נרתיק מופיעה בקבוצות של 4-5 פרטים, מאוד שבירה ומתפרקת.",
    torrendiaText4:
      "בישראל נמצאה לראשונה ע'י יאיר אור ב2018 בגולן ולאחריו דווח עוד פעמים בודדות באותו אזור. גדלה בעשבייה בין אלונים.",
    torrendiaText5:
      "נאספה וזוהתה לאחר שנבדקה מולקולרית ונמצאת בפונגריום שבמוזיאון הטבע באוניברסיטת ת.א. פורסמה בכתב עת מדעי במאמרי.",
    torrendiaText6:
      "*תופעה דומה ידועה בארץ גם לכרסנית הגליל ולדפופית חולות. גם להן הוחלפה השייכות למשפחה שונה מבעבר. אודות התופעה - ראה באינטרנט ''Secotioid fungi''.",
    torrendiaImg1: "© יאיר אור",
    torrendiaImg2: "© איתי מאירס",
    lachlacha: "לחלחה – Hygrophorus",
    lachlachaText1:
      "משפחת לחלחיתיים. בעבר הסוג עבר שנוי והתפצל לסוג נוסף - לחית – Hygrocybe.",
    lachlachaText2:
      "פטריות בגודל בינוני, הכפה בצבעים - לבן, צהבהב, בז', חום בהיר או אדמדם, בחלקן המרכז שחום. יבשה או רירית, מכאן נובע השם. הכובע שטוח, שקוע או בעל פיטם. הבשר בצבע לבן, קרם ובחלק מאדים בשפשוף. ניכרת בדפים העבים והדלילים המהווים סימן זיהוי ברור, גולשים או יושבים, בעיקר בצבע לבן. הרגל עבה יחסית, מחוברת מאוד לכובע, חלקה או מכוסה קשקשים או פתיתים. הרגל מחודדת בבסיס (ניכר בעקירתה).",
    lachlachaText3:
      "גדלות בקרקע גירית בחורשות ויערות בהם יש לחות, בעקר בין עצי אלון.",
    lachlachaText4:
      "חשוב לציין – רבות הן הפטריות הלבנות בשדה וביער. ביניהן רעילות מאוד, לכן יש להקפיד על זיהוי נכון. בסוג נכללים מינים רבים המזוהים בעקר על פי הצבעים:",
    lachlachaText5Bold: "לחלחת שנהב – H.eburneus",
    lachlachaText6:
      "הכובע בקוטר עד 6 ס''מ, הכפה מעט קמורה עם פיטם זעיר, צבעה קרם כצבע השנהב. הרגל לבנה, קמחית בחלק העליון, צרה בבסיס. דומה למינים נוספים בסוג. גדלה בין עצי אלון בצפון הארץ.",
    lachlachaImg1: "© ספי הרי",
    lachlachaImg2: "© דליה בונס",
    lachlachaText7Bold: "לחלחה חומה – H.poetarum",
    lachlachaText8:
      "הכובע בקוטר עד 15 ס''מ, הכפה מעט קמורה, רירית והצבע בז' עם מרכז כהה יותר והדפים בהירים. שולי הכובע מכונסים פנימה בצעירותה ומתיישרים בהמשך הימים. בעלת ריח ארומטי. הרגל לבנה בעלת פתיתים בחלק העליון. אינה נפוצה, גדלה בין עצי אלון. דומה למינים נוספים בסוג.",
    lachlachaImg3: "© ניר יבגי",
    lachlachaText9Bold: "ל. שחמחמה – H. leucophaeus",
    lachlachaText10:
      "קוטר הכובע עד 7 ס''מ, הכפה שטוחה או מעט שקועה, רירית, בצבע חום צהבהב ובמרכז פיטם קטן כהה יותר. הרגל צרה בבסיסה בעלת פתיתים בחלקה העליון.",
    lachlachaImg4: "© Inaturalist",
    lachlachaText11Bold: "לחלחת שני – H.russula",
    lachlachaText12: "*שם המין לא קשור לסוג חריפית אלא לצבע - russet.",
    lachlachaText13:
      "קוטר כובע עד 12 ס''מ, הכפה שטוחה עד שקועה, מתחילה בגוון לבן ומתפתחת עד צבע שני. הרגל בגוונים מלבן עד וורוד. הדפים לבנים עד ורדרד בחלק התחתון. הבשר מאדים בשפשוף. גדלה באדמות גיריות באזורים חמים יחסית. נצפתה ונרשמה בישראל מאוחר משאר המינים בסוג, משנת  1980  מאחר שבעבר נחשבה ישעורית.",
    lachlachaImg5: "© טליה אורון",
    lachlachaImg6: "© חינמי",
    lachlachaText14Bold: "מינים נוספים שטרם נבדקו ופורסמו:",
    lachlachaText15: "ל. כהת פיטם – H.roseodiscoides באוסף בנימיני",
    lachlachaText16: "ל. כהת כיפה - H.meridionalis בצילום של ניצן אלסר",
    lachlachaText17: "ל. חכלילית - H.nigerescens/puniceus",
    lachlachaText18: "ל. - H.penarius ?",
    lachlachaText19: "ל. דיסקנית - H.discoideus באוסף בנימיני",
    lachlachaImg7: "© Inaturalist",
    lachlachaText20: "ל.כתמתמה - H.pudorinus באוסף בנימיני",
    lachlachaImg8: "© חינמי",
    newSpeciesInIsrael: "מינים שנבדקו גנטית ופורסמו לראשונה בישראל",
    sivit: "סיבית – Inocybe",
    sivitText1: "משפחת סיביתיים.",
    sivitText2:
      "סוג מאוד עשיר במינים, מעל 30 בישראל, מכאן שחובבים מתקשים בלימוד סוג זה ואינם מתאמצים כי אינן משמשות למאכל.",
    sivitText3Bold: "גודל ",
    sivitText4:
      "הסיביות מקטנות עד בינוניות, בעלות דפים. הכובע קמור, פעמוני, סדוק, חלק קימחי, מכוסה בסיבים או קשקשים.",
    sivitText5Bold: "קוטר הכובע ",
    sivitText6:
      "מ 1 ס''מ עד 10 ס''מ. ברוב המינים הכובע יבש. הדפים יושבים או נוגעים, נדיר שגולשים.",
    sivitText7Bold: "צבעי הכיפות ",
    sivitText8: "בסוג רבים למדי, רובן בגוונים מלבן ועד חום יש גם צהוב ואדמדם.",
    sivitText9Bold: "הנבגים ",
    sivitText10: "בצבע מלבן, צהוב ועד חום.",
    sivitText11Bold: "הרגל ",
    sivitText12:
      "זקופה, קצרה או ארוכה מקוטר הכובע, חלקה, קימחית או בעלת סיבים. חלולה או מלאה. בלחיצה תתפרק לאורכה.",
    sivitText13Bold: "מאפיינים ",
    sivitText14:
      "מיוחדים מתבטאים בריחות לא נעימים המהווים סימן חשוב לזיהוי. ריח זרע דוחה לעומת ריח פירות. גדלה בין עצים שונים, בקרחות-יער ועוד. מופיעה בקבוצות. נחשבות כפטריות רעל מסוכנות, שם הרעלן מוסכרין הידוע בריכוזו הגבוה וכן פסילוסיבין. ההמלצה – לא לערב אותן בסל אחד עם פטריות שנאספות למאכל. חשוב! חלקן דומה לישעורית אפורה המצויה באותם שטחי גידול.",
    sivitText15Bold: "רשימת המינים לפי צבע הכובע: ",
    sivitText16:
      "*מודגשים רק הסימנים העיקריים לזיהוי. הגודל מתייחס כהשוואתי בסוג. מומלץ לראות מידע ותמונות בספרות ובאינטרנט.",
    sivitText17Bold: "מינים בגווני קרם, צהוב וצהבהב:",
    sivitText18Right: "ס' אגסית –pyriodora .I",
    sivitText19Left:
      "גדולה. בהירה. דפים לבנים ומשתנים  לקינמונים. רגל קימחית למעלה. ריח פירות. בשר מאדים מעט בחתך. רעילה.",
    sivitText20Right: "ס' דוחה – I. fastigiata",
    sivitText21Left:
      "*שמות הסוג והמין הוחלפו והעדכני מ  2019 - Pseudosperma rimosum גודל בינוני. כפה סיבית עם סדקים רדיאליים ועם פיטם. ריח הבשר דוחה, כריח זרע. נפוצה מאוד. רעילה.",
    sivitText22Right: "ס' שקדית – hirtella .I",
    sivitText23Left:
      "קטנה. כיפה מעט סיבית בעיקר בשוליים. רגל דקה וארוכה עם בולבוס זעיר בבסיס. ריח של שקדים מרים.",
    sivitText24Bold: "מינים בגווני בג', חום בהיר ואפרפר:",
    sivitText25Right: "ס' סדוקה – I. auricoma/descissa",
    sivitText26Left:
      "קטנה. כובע קמור עם פיטם, נסדק בשוליים. בתחילה בצבע חום בהיר ומשתנה לחום. רגל צהבהבה אבקית למעלה. ריח כשל זרע. נדירה.",
    sivitText27Right: "ס' עדינה - fufurea. I",
    sivitText28Left:
      "קטנה. כובע קמור עד שטוח, כפה סיבית עם חריצים. דפים בגוון אדמדם. רגל אבקית, ארוכה מקוטר הכובע. ריח לא נעים. רעילה ונחשבת נדירה.",
    sivitText29Right: "ס' דביקה – I. viscidula",
    sivitText30Left: "קטנה. כיפה בעלת פיטם, רירית/דביקה. נחשבת כנדירה.",
    sivitText31Right: "ס' לבדית – I.flacculosa",
    sivitText32Left:
      "קטנה. כיפה סיבית ושוליים בגוון חיוור. הרגל סיבית בהירה, אבקית למעלה. רעילה.",
    sivitText33Right: "ס' משיינית – I. eutheles",
    sivitText34Left:
      "גודל בינוני. כובע פעמוני עם פיטם, כיפה מעט שעירה במירקם משיי. הרגל קימחית, ארוכה מקוטר הכובע. רעילה, נחשבת כנדירה.",
    sivitText35Right: "ס' בולטון -.boltonii I",
    sivitText36Left:
      "קטנה. כובע קמור עד שטוח עם פיטם. כיפה סיבית בצבע חום עד אדמדם ושוליים בהירים יותר. רגל מכוסה סיבים. נדירה ורעילה.",
    sivitText37Right: "ס' סיגר –pusio I.",
    sivitText38Left:
      "קטנה. כובע חרוטי-קמור עם פיטם. הכיפה  בצבע חום לגווניו השונים מזכיר צבע הסיגר. רגל סיבית בצבע חום בהיר ולמעלה סגלגל. ריח כשל זרע. נדירה. רעילה.",
    sivitText39Right: "ס' קודרת – I.tristis/amblyospora",
    sivitText40Left:
      "קטנה. כובע קמור עד שטוח בצבע חום לגווניו השונים. כיפה סיבית עם שוליים כהים וסדוקים. רגל סיבית, כהה יותר בבסיס. הריח ארומטי חלש. רעילה.",
    sivitText41Right: "ס' עלובה –abjecta  I.",
    sivitText42Left:
      "קטנה. כובע קמור עד שטוח, מכוסה קשקשים, עם פיטם קטן, צבעו בז' עד חלודי ושוליים בהירים. הרגל בהירה, אבקית למעלה. נחשבת כנדירה.",
    sivitText43Right: "ס' טורית –grammata  I.",
    sivitText44Left:
      "קטנה. כובע קמור, בעל פיטם ושוליים מפוספסים. רגל אבקית למעלה ובולבוס בבסיס.",
    sivitText45Bold: "מינים בגווני חום-כתום:",
    sivitText46Right: "ס' קטנת-נבגים –/glabripes I.microspora",
    sivitText47Left:
      "קטנה. כובע קמור עד שטוח בעל פיטם, צבעו חום עד חום-תפוזי, כיפה ליבדית עם שוליים סיביים יותר. הרגל קמחית למעלה, מעט מפוספסת. רעילה.",
    sivitText48Right: "ס' רחבה – I. rimosa/perlata",
    sivitText49Left:
      "גדולה. כיפה עם סיבים בולטים, חריצים ופיטם כהה. רגל גבוהה מקוטר הכובע. הריח דומה לסיבית דוחה ונבדלת ממנה בסיבים ובפיטם.",
    sivitText50Right: "ס' קמחית –praetervisa  I.",
    sivitText51Left:
      "גודל בינוני. הכובע פעמוני ועם הגיל נפרש לשטוח. הכיפה בצבע חום-תפוז מכוסה קשקשים. בסיס הרגל מעט מעובה. בשר בריח קמח. נדירה ורעילה.",
    sivitText52Right: "ס' חבויה –lucifuga  I.",
    sivitText53Left:
      "גודל בינוני. כובע קמור עד שטוח. כיפה צמרית עם פיטם בגוון תפוז-זיתי. בשר בהיר בעל ריח לא נעים. הרגל בהירה, מעט ורדרד למעלה. רעילה.",
    sivitText54Bold: "מינים בגוון חום - ורדרד:",
    sivitText55Right: "ס' צבעונית – I.tricolor",
    sivitText56Left:
      "קטנה, כובע קמור עם פיטם, שולי הכיפה בהירים יותר. רגל גבוהה מקוטר הכובע.בחלקה העליון פתיתית. ריח ארומטי עז. נחשבת נדירה. גדלה בין עצי אלון.",
    sivitText57Bold: "מינים בגווני אדמדם וסגלגל:",
    sivitText58Right: "ס' מאדימה – rhodiolum/ I .jurana",
    sivitText59Left:
      "גדולה, מרשימה מאוד בין שאר המינים. כובע פעמוני עם סדקים ופיטם. רגל עבה. ריח פירות.",
    sivitText60Right: "ס' קינמונית – Inosperma bongardii",
    sivitText61Left:
      "קטנה. כובע פעמוני עד שטוח. כפה עם פיטם. בשר, כיפה ודפים בגוון קינמוני. הרגל בהירה עם סיבים לאורכה. הבשר לבן ומשתנה לכהה. ריח פירות נעים, יש להדגיש שהריח אינו מבטא טיב למאכל. רעילה!",
    sivitText62Right: "ס' סגלגלה – I. geophylla",
    sivitText63Left:
      "קטנה ועדינה. כיפה עם גוון לילכי ויש מופע סגול יותר. רגל ארוכה ודקה. רעילה מאוד.",
    sivitText64Bold: "מינים לברור והגדרה:",
    sivitText65: "סיבית 'קיפודית' - I. impexa",
    sivitText66: "סיבית 'צהבהבה' - I. fibrisa",
    sivitText67: "ס' 'כתומה' – I.erubescens",
    sivitText68: "ס' ביישנית – I. whitei/pudica",
    sivitText69: "ס' מחורצת – I. posterula",
    sivitText70: "ס'  'ברודית' – I. maculate",
    sivitText71: "ס' 'חולות' – I dunensis ?",
    sivitImg1: " © ס' 'קיפודית' - עירית צוק",
    sivitImg2: "© ס' סגולה - אריק",
    sivitImg3: "© ס' מאדימה - רותם רוזן",
    sivitImg4: "© ס' 'צהבהבה' - אראלה הרי",
    sivitImg5: "© ס' רחבה - ירון חפץ",
    sivitImg6: "© ס' דוחה - ברוריה גל",
    sivitImg7: "© ס' חולות - רותי טלמון",
    sochachit: "סוככית – Tubaria",
    sochachitText1:
      "משפחה סוככיתיים – Tubariaceae (בעבר הייתה שייכת לסיביתיים).",
    sochachitText2:
      "הסוג סוככית היא פטרייה קטנה או בינונית, צורת הכובע כיפתי, צבעו בגווני חום, צהבהב עד ערמוני. על הכובע ניכרות שאריות עדינות מהצעיף. הדפים בצבע בהיר של דבש. הבשר דק, הרגל לבנה מכוסה במעט קשקשים והבסיס צימרי. במין אחד בלבד יש טבעת. גדלה על הקרקע או על חלקי עץ.",
    sochachitText3: "בארץ ידועים 5 מינים ונוספים מצפים לבדיקת מעבדה.",
    sochachitText4Bold: "ס' 'מטובעת' – T. confragosa",
    sochachitText5:
      "מין זה הגדול והמיוחד מבין הסוככיות בארץ, קוטר הכובע עד 6 ס''מ, צבעו ערמוני. הרגל מכוסה קשקשים ובחלקה העליון יש טבעת צרה לבנה. הבשר כהה.  מעדיפה אזורי מחייה לחים.",
    sochachitImg1: "© inaturalist",
    sochachitText6Bold: "ס' משיינית – T.dispersa/aulochhthona",
    sochachitText7:
      "פטרייה קטנה, קוטר הכובע עד 3 ס''מ, מירקם הכיפה משיי בצבע לבן-צהבהב.",
    sochachitImg2: "© דליה בונס",
    sochachitText8Bold: "ס' קשקשית – T. furfuracea",
    sochachitText9:
      "פטרייה קטנה, קוטר הכובע עד 2.5 ס''מ, צבע הכיפה חלודי, בשוליים ניכרים שרידי צעיף בהירים, בעיקר בפטריות צעירות. הדפים בגוון חום–כתום. הרגל ארוכה מקוטר הכובע וצבעה כצבע הכיפה. גדלה על בלוטי אלונים וגם על הקרקע.",
    sochachitText10:
      "* תת-מין בעל שוליים בהירים ומסולסלים ,נמצאה על גזעים כרותים ועל הקרקע.",
    sochachitImg3: "© ברוריה גל",
    sochachitText11Bold: "ס' חיוורת-נבגים – T.pallidospora",
    sochachitText12:
      "פטרייה קטנטנה, קוטר הכובע עד 1.7 ס''מ, קמור וקמחי. הדפים בצבע הכפה או תפוזי. נחשבת נדירה. ",
    sochachitText13Bold: "ס' כהה – T.romagnesiana/pelucidaa",
    sochachitText14:
      "פטרייה קטנה, הכובע קמור עד שטוח, לעיתים מעט קעור. הכיפה בגוון קינמון ובצעירתה ניכרים שרידי צעיף בהירים. הדפים והרגל כצבע הכיפה. גדלה בסביבת אורנים ומעדיפה מקומות לחים.",
    sochachitText15:
      "*המין אינו נפוץ ורק מעט מתואר בספרות. נמצא באוסף בנימיני, נאסף עם פרופ' מוזר האוסטרי בביקורו בישראל, בחורשת אקליפטוסים בחדרה.",
    sochachitImg4: "© Mycorun",
    sarcodon: "סרקודון – Sarcodon",
    sarcodonText1: "משפחת Bankeraceae.",
    sarcodonText2:
      "תרגום שם הסוג הינו 'בשרני'. במקור אחד נכתב השם 'בשרנית' אך בעברית זה שם תואר ואינו מתאים לסוג. הסרקודון משתייך לקבוצת הפטריות בעלות שיניים. את קבוצה זו חוקרים לאחרונה הטקסונומים המשנים את המיקום והשיוך של כל סוג וסוג בהתייחס לבדיקות המולקולריות. לכן נמצא בספרות שמות שונים לאותו אחד. בשלב זה המין הידוע הינו אחד ואולי יוחלף לסוג Hydnellum - שינונית. מצפים לפירסום של נוספים בעתיד הקרוב.",
    sarcodonText3Bold: "סרקודון מחוספס – Sarcodon scabrosum",
    sarcodonText4:
      "גוף הפרי בגודל בינוני עד גדול, 5-20 ס''מ קוטר. פניו שטוחים או קעורים בלתי סימטריים. הכיפה מכוסה קשקשים או סיבים עם שוליים גליים בחלקם. הצבע חום לגווניו השונים, אדמדם או אפור. עם הגיל יש שנוי לכוון כהה יותר. השכבת הפורייה בעלת שיניים ואורכן מגיע ל 8 מ''מ. במינים השונים האורך מהווה סימן לזיהוי. בצעירותה הצבע בהיר. הרגל אינה במרכז , אורכה עד 10 ס''מ בצבע חום.",
    sarcodonText5:
      "הפטרייה מופיעה ביחד או בקבוצות קטנות צמודות אחת לשנייה. נסתרת על פני הקרקע בצבעים הדומים. נחשבת נדירה, טעימה למאכל בצעירותה. נהוג לייבש או להחמיץ בצנצנת.",
    sarcodonImg1: "© Free website",
    karnit: "קרנית – Calocera",
    karnitText1: "משפחת רסיסיתיים – Dacrymycetaceae.",
    karnitText2: "מין יחיד בסוג:",
    karnitText3Bold: "קרנית צהבהבה – Calocera cornea",
    karnitText4:
      "פטרייה קטנה דמוית צבר קרניים שחלקן מסועפות בחלקן העליון, באורך עד 12 מ''מ, הצבע צהוב עז או חלש והמירקם קרישי. גדלה על ענפים יבשים של עצים רחבי-עלים.",
    karnitImg1: "© ברוריה גל",
    sruit: "שרועית – Paxillus /Tapinella",
    sruitText1: "משפחת שרועיתיים – Tapinellaceae.",
    sruitText2: "מין יחיד בסוג:",
    sruitText3Bold: "שרועית אפרכסית – T.panuoides",
    sruitText4:
      "גוף הפרי בעל דפים, נראה כמניפה, צדפה או אפרכסת עם שוליים גליים, קוטרו עד 10 ס''מ. הצבע אוקר (מיוונית – אוכרוס = צהבהב, פיגמנט של אדמת טיט טבעי). רגל חסרה, ה'צדפה' מחוברת לתחתית עצים, או חלקי עץ כרותים של עצי מחט כמו אורן. הדפים בצבע דבש גולשים עד הבסיס.",
    sruitText5:
      "יש להיזהר בזיהוי מהסיבה שהיא רעילה ודומה מאוד לאפרכסית צדף – .Panus conchtus",
    sruitImg5: "© ארנון שדמי",
    sruitImg2: "© ברוריה גל",
    psifasit: "פסיפסית – Pisolithus",
    psifasitText1: "משפחת עוריתיים - Sclerodermataceae.",
    psifasitText2: "בסוג מין יחיד:",
    psifasitText3Bold: "פ' חולות - P. tinctorius",
    psifasitText4:
      "מקור שם הסוג בעברית הוא צורת הרקמה הפורייה בצעירותה, בחתך אורך בחלק התחתון, הנראית כפסיפס צבעוני של המינבגים. פרוש שם המין בלועזית - משמש להפקת צבע ( שם קודם היה P. arhisus). בעברית ניתן השם בעת גילוי ראשוני של הפטרייה באזור חולות אך גדלה במגוון רחב של מקומות ובארץ ידועה בעיקר בחורשות אקליפטוס. הכינוי העממי הוא ''פצצת עשן'' על שום המצב בו פוגעים בפטרייה עם הרגל ועולה ענן חום של נבגים.",
    psifasitText5:
      "גוף הפרי בצורת כדור בקוטר עד 20 ס''מ, העומד בראש בסיס רחב מעין רגל שאורכו קצר או בינוני וצבעו חום כהה. הרקמה הפורייה ממלאת את כל הכדור שבהבשלתו הקרום נסדק ומיליוני נבגים מתפזרים כאבקה או עשן החוצה, בצבע חום קינמוני.",
    psifasitImg1: "© פטרייה בשלה, רותי טלמור",
    psifasitImg2: "© פטרייה צעירה בחתך, רותי טלמור",
    kmehat: "כמהת-יער - Tuber",
    kmehatText1: "משפחת כמהת יער - Tuberaceae.",
    kmehatText2: "השם נובע מהיותה מתחת לפני האדמה וכמהה לאור.",
    kmehatText3:
      "עד  שנת 2024 כל סוגי הכמהין קיבלו שם סוג אחד בעברית שכלל למעשה כמה שמות מדעיים שונים. הביטוי ברבים כמהין וביחיד כמהה. התבקש הצורך להפריד בין הסוגים ובוועדת השמות של האקדמיה ללשון הוחלט לא לוותר על השם כמהה המופיע במקורות ולהפרידם לכמהת–יער וכמהת-חולות.(באופן חריג שם הסוג כולל שתי מילים).",
    kmehatText4:
      "בתלמוד הירושלמי נכתב ''יצאו כמהין ופטריות שאינן נזרעות ומצמיחות''. הן אינן נחשבות גידולי קרקע לכן מעמדן ההילכתי ביהדות שונה, ואין מברכים עליהן בירכת בורא פרי האדמה.",
    kmehatText5:
      "הסוג כולל מינים רבים החיים מתחת לפני הקרקע ולעיתים מבצבצים לגבה פני הקרקע. חיים בשיתוף מיקוריזה עם עצים מסוימים (ראה נושא מיקוריזה באתר). הכמהין נחשבות מאוד בתרבות הגסטרונומיה ומחירן יקר ביותר, נחשקות בגלל הריח החזק והטעם המיוחד.",
    kmehatText6:
      "תיעוד ראשון בארץ מופיע במאמרו של רייכרט בשנת 1944 ובכתבה של טשרנה רייס שכתבו ספר 'כמהין ופטריות'.",
    kmehatText7:
      "גידול בישראל החל בניסויים של מכון וולקני ובשנת 2013 הדביקו שתילי אלונים בתפטיר מצרפת ביער ברעם ובמשתלת קק'ל באשתאול. לאחר זמן הניסוי הופסק, השטח הוזנח וחלק מהשתילים נמסרו לעובדים לביתם. בשנים האחרונות נמצאו גופי פרי בברעם, באותו מקום, וזה עורר חוקרים צעירים לחזור ולהמשיך במחקר יישומי המתקיים כיום במי'גל עם מכללת תל-חי. הגידול מתבצע בגולן בחורשות של עצי אלון ועצי פקאן. בשלב זה קשה לקבוע מי גדל באופן טבעי ומי נקלט מחלקות הניסוי.",
    kmehatText8:
      "תאור – פטריות תת-אדמתיות דמויות פקעת המכוסה במעטה חלק או בעל בליטות. המסה הפנימית- גלבה נראית בחתך כפסיפס עם עורקים, ורידים או כתמים בגוונים שונים. קוטר 1-10 ס''מ והצורה אינה רגולרית.",
    kmehatText9:
      "ריח וטעם - יחודיים מאוד ומשפיעים על המחיר היקר והפרסום הרב ומכאן שהכנוי לשחורות הוא'' יהלום המטבח''.",
    kmehatText10:
      "גדלות בקבוצות בעומק עד 5 ס''מ ולעיתים מבצבצות מעל קרום הקרקע. לאחרונה, עם התפשטות חזירי הבר- קל לגלות כמהין בגומות החפירה של חזיר המגלה ואוכל בעזרת חוש הריח המפותח. הקושי בגילוי ואיסוף פיתח תרבות של אילוף כלבים (בעבר חזירים) ובעזרתם מגלים ואוספים.",
    kmehatText11:
      "*כיון שסוג זה מעניין במיוחד – לא נוכל להרחיב מדי בקטע זה וממליצים לקרוא בויקיפדיה בערך 'כמהין' ובקישורים הכתובים בו.",
    kmehatText12Bold: "המינים בצבע שחור:",
    kmehatText13: "כמהת-יער קיצית - Tuber aestivum - ",
    kmehatText14:
      "(burgundy). קוטר גוף הפרי 3-6 ס''מ, המעטה בעל גבשושים בולטים והמסה הפנימית בצבע בז' עד חום, עם עורקים בהירים. מין זה הנחקר העיקרי בארץ. מעניין שהפטריות מהאלון עברו לפקאן למרחק של כמה ק''מ. נבדקה גנטית ע''י ירון שטרית.",
    kmehatText15: "כמהת-יער חורפית - T.melanosporum - ",
    kmehatText16:
      "שם נוסף – .T.nigrum קוטר עד 7 ס''מ המעטה בעל שיכים בולטים והצבע  הפנימי מתחיל בהיר ומתבגר עד כהה. מנסים לגדל אותה גם על אגוז מלך. נבדקה גנטית ע''י עידן פרמן.",
    kmehatText17: "כמהת-יער - T.pulchrosporum - ",
    kmehatText18:
      "קוטר גוף הפרי כ 1 ס''מ, אינו רדיאלי. המירקם החיצוני חום אדמדם, מאוד מחוספס והפנימי נראה כפסיפס כהה עם עורקים בהירים. מין זה תואר לראשונה ביוון ולאחר מכן נמצא גם בארצות נוספות. נדירה בישראל, נבדקה גנטית ע''י עידן פרמן.",
    kmehatText19Bold: "המינים בצבע בהיר:",
    kmehatText20:
      "פטריות קטנות הגדלות בקבוצות רבות-פרטים. המינים נבדלים בעיקר במירקם הפנימי הניכר בחתך. הריח חלש עד חזק. אינן נחשבות בגודלן ובאיכותן למטרת מאכל לעומת השחורות.",
    kmehatText21:
      "*דומות מאוד לסוג פקעית –Rhizopogon - מסדרה שונה, לסוג כמוהה – ,Hydnocystis ל Stephensia ולסוג Picoa.",
    kmehatText22: "כמהת-יער מבריקה - T.nitidum/rufum - ",
    kmehatText23:
      "יש המשייכים מין זה כווריאנט של T.rufum .קוטר הפטרייה עד 4 ס''מ וצורתה גבנוני. המעטה במירקם חלק בצבע צהוב-כתמתם והפנימי מתחיל בלבן ומתבגר עד חום בהיר. שזורים בו מעין ורידים עדינים מתפתלים.",
    kmehatText24: "כמהת-יער אסא - T. asa - ",
    kmehatText25:
      "הכינוי בולבוסית אסא. קוטר הפטרייה 2-5 ס''מ, פניה אינם רדיאלים, צבע חיצוני צהוב-זיתי והפנימי בז' עד אפרפר, מצויר בפסים עקלקלים. פורסם במאמר של גיאנה, אוניב. חיפה.",
    kmehatText26: "כמהת-יער פורטוגלית - T.lusitanicum - ",
    kmehatText27:
      " פטרייה קטנה בקוטר 2 ס''מ כפקעת שאינה רדיאלית. הצבע החיצוני צהבהב מעט מבריק והפנימי חום בהיר. נבדקה גנטית ופורסמה לראשונה בישראל במוזיאון הטבע אוניב. ת.א.",
    kmehatText28: "כמהת-יער אורנים - T.oligospermum -",
    kmehatText29:
      "רשומה בעבר כסוג Terfezia או גם Delastriopsis והמין – דלת-נבגים. קוטר  2-4 ס''מ, הצבע החיצוני בז' והפנימי מתחיל בהיר ומתבגר לכהה יותר. בעלת ערך תזונתי. גדלה בעצי אורן. פורסמה לראשונה ע''י רייכרט בבי''ס בן שמן – בפלסטינה - א''י.",
    kmehatText30: "כמהת-יער משוישת - T.maculatum - ",
    kmehatText31:
      "פטרייה בקוטר עד 5 ס''מ ,צבע חיצוני בהיר ומתבגר לכהה יותר, בעל כתמים בגוון חום. צבע הרקמה הפנימית נראה כפסיפס לא סימטרי בגווני חום ולבן. נבדקה גנטית ע''י עידן פרמן.",
    kmehatText32:
      "מינים נוספים נבדקו גנטית ע''י צוות חוקרים במכללת תל-חי ומחכים לפרסום מדעי וקבלת שם עברי (T.aff.zambonelliae, T.lyonii, T.aff.excavatum, T.borchii, T. magnatum)",
    kmehatText33:
      "סוג חדש Reddellomyces נמצא בישראל מאותה משפחה ונבדק ע''י צוות תל-חי. תואר לראשונה ב1992 באוסטרליה ע''י Castellano&Malajczu ידועה מעט באזור הים תיכון. יש סברה שהגיעה לישראל עם איקלום עצי האקליפטוס. עד כה ידועים בעולם 4 מינים בסוג.",
    kmehatText34Bold: "תצפיות חשובות, שלא מצפון הארץ:",
    kmehatText35:
      "כ' קיצית, יער יודפת, דקלה בולדו,5.2015 .נבדקה ע'י ירון שטרית.",
    kmehatText36:
      "כ' שחורה, בית זית, שרון שללוסברג בגינתה מתחת לאלון, כנראה נשתל ממחקר באשתאול.",
    kmehatText37: "כ' שחורה, קבוץ מענית, משפ' ליבנה, 4.2020.",
    kmehatText38: "כ' שחורה, בית שמש, באלונים, ערן צוקרמן 3.2019.",
    kmehatText39:
      "כ' שחורה, פארק אלונה, ניצן אלסר,4.2021. זיו בן הוטה. 3.2023.",
    kmehatText40Bold: "תמונות של כ' שחורות:",
    kmehatImg1: "© דיקלה בולדו",
    kmehatImg2: "© כ' קיצית. חנוך סייף",
    kmehatImg3: "© משפ' ליבנה",
    kmehatText41Bold: "תמונות של כ' בהירות:",
    kmehatImg4: "© כ' פורטוגלית. ניצן אילסר",
    kmehatImg5: "© כ' מבריקה. ארנון שדמי",
    kmehatImg6: "© כ' אורנים. ע. מלכה",
    kmehatImg7: "© כ' אסא. ד.שחק",
    kmehatText42: "קישור - תקציר הרצאה (של עידן פרמן)",
    kmehatHolot: "כמהת חולות – Terfesia, Tirmania",
    kmehatHolotText1: "שם נוסף – כמהין מדבר.",
    kmehatHolotText2: "משפחת כמהתיים - Terfeziaceae.",
    kmehatHolotText3:
      "עד  שנת 2024 כל סוגי הכמהין (ביחיד -כמהה), נקראו בעברית בשם אחד- כמהה. התבקש הצורך להפריד בין הסוגים ובוועדת השמות של האקדמיה ללשון הוחלט לא לוותר על השם כמהה המופיע במקורות ולהפריד לכמהת–יער וכמהת-חולות / מדבר. *ראה מידע נוסף בסוג כמהות-יער שבאתר ובקישורים המומלצים.",
    kmehatHolotText4:
      "הסוגים כוללים מספר מינים  החיים מתחת לפני הקרקע החולית במיקוריזה (ראה פרק באתר), בישראל עם צמח השמשון-Helianthemum.",
    kmehatHolotText5:
      "גדלה  באזור חולות הנגב: בהר הנגב בערוצים, על שמשון ליפי ושמשון הדור. בקו רוחב מדימונה עד רביבים, צאלים וגבול רצועת עזה - על שמשון יושב. בחולות חדרה-קיסריה על שמשון סגלגל. באזור ערד, נמצאה על שמשון הדור. מופיעה בחודשים מרץ ואפריל בהתאם למועד וכמות הגשמים, שלא יורדים כל שנה.",
    kmehatHolotText6:
      "רבייה - הפצת הנבגים נעשית ע''י בעלי חיים המריחים וחופרים לצורך מאכל. אין הפצה באוויר כמו בפטריות כובע ועילאיות לכן איסוף הפטרייה בשלמותה, ע''י בני האדם, מקטין מאוד את פוטנציאל הרבייה.",
    kmehatHolotText7:
      "גילוי כמהה מתחת לפני הקרקע מהווה אתגר לחדי-עין בזיהוי חריץ הנגרם מהפטרייה המתפתחת ועולה ומבקיעה את הקרום. החפירה גורמת לחדירת יובש הפוגע במערכת השורשים של הצמח והתפטיר הצמוד אליהם, לכן חשוב לכסות את הגומה שנוצרה באיסוף.",
    kmehatHolotText8:
      "כמהין החולות נחשבות מאוד לאורך ההיסטוריה, ידועות בתרבות הגסטרונומיה בארצות ערב והמזרח התיכון ומחירן יקר ביותר. גם בפולקלור ידועים סיפורים מעניינים.",
    kmehatHolotText9:
      "בארצות השונות ניתנו לכמהין שמות שונים: במרוקו – טורמה או טרפס. בעיראק – סובאידי. במפרץ הפרסי – פאגה. בקבוצה זו ידועים מספר סוגים ומינים:",
    kmehatHolotText10Bold: "כמהת השמשון – Terfezia budieri/leonis/arenaria -",
    kmehatHolotText11:
      "הנפוצה מבין הכמהין בקבוצה. במיקוריזה עם הצמח שמשון יושב ושמשון סגלגל. קוטר עד 7 ס''מ. מצויה בעיקר באזור מרכז הנגב ומופיעה בשנים עם כמות גשם מתאימה.",
    kmehatHolotText12Bold: "כמהית צחורה/ אפריקנית – Tirmania nivea/Africana - ",
    kmehatHolotText13:
      "חיה במיקוריזה עם שמשון יושב באזור מרכז הנגב. הגדולה בקבוצה, קוטר עד 10 ס''מ ,יחידה בצבע לבן והמועדפת מבינהן. ידוע שניסו למכור אותה ככמהת-יער הלבנה הארופאית, היקרה מכולן.",
    kmehatHolotText14Bold: "כמהה דמוית אלה - Terfezia -",
    kmehatHolotText15:
      "Terfezia claveryi חיה במיקוריזה על שמשון ליפי בחולות הר הנגב. דומה לכ' השמשון בגודל ובצבע אך אינה סימטרית.",
    kmehatHolotText16:
      "*ידועים סוגים נוספים שנקראים בשם כמהה שאינם מאותה משפחה (לא מתאים ולא רישמי).",
    kmehatHolotText17:
      "לסיכום – הנושא מרתק ומפורסם, מומלץ לקרוא בקישורים הבאים:",
    kmehatHolotLink1: "כתבה של רחל עינב - לחץ להורדת הקובץ",
    kmehatHolotLink2: "כתבה של אלינוער שביט - לחץ להורדת הקובץ",
    kmehatHolotLink3: "כתבה עם ירון שטרית - לחץ להורדת הקובץ",
    kmehatHolotLink4: "פודקאסט ''שמשון יושב על כמהת שמשון'' - לחץ להאזנה",
    kmehatHolotImg1: "© כמהית צחורה. ברוריה גל",
    kmehatHolotImg2: "© כמהת השמשון. ברוריה גל",
    kmehatHolotImg3: "© כמהה דמוית אלה. ברוריה גל",
    kmehatHolotImg4: "© בקע בקרום הקרקע. ברוריה גל.",
    kmehatHolotImg5: "© חפירות הצייד - נזק! ברוריה גל",
    kmehatHolotImg6: "© מכירה בשוק בבאר שבע. ברוריה גל.",
    seirit: "שעירית - Tricholomella",
    seiritText1: "משפחת דפוניתיים.",
    seiritText2:
      "מין יחיד בסוג – שעירית ליבנת ראש - Tricholomella constricta. שם קודם- Calocybe leucocephala",
    seiritText3:
      "פטרייה בשרנית, קוטר הכובע עד 8 ס''מ, פניו חלקים בצבע לבן ובמרכז בז' אפרפר. הדפים מפורצים, לבנים עד צהבהבים. הרגל לבנה באורך כ 5 ס''מ עם טבעת צרה היושבת בחלקה העליון ונושרת בנקל, הבסיס מחודד. ריח קמחי חזק.",
    seiritText4:
      "נגלתה לראשונה בעולם ב 1979 ופורסמה ב 1992. נחשבת נדירה. בישראל נגלתה ברמת הגולן ע''י לירן טויטו .ב12.2022 במטע ליד חרשת אלונים. שנה אחרי נמצאה באותו מקום. דגימה נבדקה במכון וולקני ע'י מתן גולן.",
    seiritImg1: "לירן טוויטו",
    seiritImg2: "לירן טוויטו",
    sidit: "סידית - Limacella",
    siditText1: "משפ' אמניתיים.",
    siditText2: "השם העברי – תרגום מהמדעי.",
    siditText3:
      "בישראל הסוג טרם פורסם ממעבדה גנטית, אך אושר לנו מתמונות ומתיאור ע''י מיקולוג מאטליה. (אולי לאחר כתיבה זו יהיה עדכון). בעבר הסוג היה נחשב בעולם כאמנית או כמטריינית, ב 1975 תאר אותו סינגר וכעבור כ20 שנה, עם תחילת בדיקות הד.נ.א, פורסם בשם זה. כיום ידועים כעשרה מינים בסוג. לא ידוע האם היא מיקוריטית או ספרופיטית. בשלב זה נחכה לתוצאות מבדיקות ואז נתייחס לשמות המינים שנצפו בארץ, כנראה L.illinata ו L.furnacea.",
    siditText5:
      "בידינו תיעוד של פרטים בודדים החל מ 12.2014 והרי תאורם: פטריה בגודל בינוני, קוטר הכובע 8 ס''מ, הכיפה לבנה ועם הגיל מקבלת גוון בז' אפרפר, הדפים לבנים וצפופים והבשר דק. הרגל ארוכה מקוטר הכובע, לבנה, מכוסה קשקשים ובעלת טבעת בחלקה העליון. בחלק מהפרטים ניכר עיקול / זווית בקצה הרגל. הריח קימחי ובהתבגרותה הופך לבלתי נעים, כריח דגים.",
    siditImg1: "© ברוריה גל",
    siditImg2: "© וילבאוט (באירופה)",
    siditImg3: "© ברוריה גל",
    siditImg4: "© ברוריה גל",
    panachit: "פנכית - Pulvinula / Barlaea",
    panachitText1: "משפחת Pyronemataceae.",
    panachitText2: "בארץ קיים בסוג מין אחד:",
    panachitText3Bold: "פנכית הענפים - Pulvinula constellation / Barlaaea",
    panachitText4: "*שמות הסוג הוחלפו מספר פעמים כולל פזיזה.",
    panachitText5:
      "פטרייה קטנה דמוית חרוז בצעירותה ונפתחת לצורת צלוחית שקועה. הקוטר עד 8 מ''מ בצבע צהוב-כתום. גדלה בקבוצות צפופות על פני הקרקע או על ענפים יבשים. דומה לנאדנית. צלוחית, רסיסית ועוד.",
    panachitImg1: "Free image",
    doranit: "דורנית - Mycenastrum",
    doranitText1: "משפחת הפקועתיים, בעבר האבקיתיים.",
    doranitText2: "בסוג קיים בישראל מין אחד:",
    doranitText3Bold: "דורנית גלדנית – M. corium",
    doranitText4:
      "שייך לקבוצת דמויות-כדור, גוף הפרי בקוטר עד 12 ס''מ, עטוף בשכבה דקה בצבע לבן או לבן עכור ושכבה פנימית חלקה וגלדנית. הרקמה הפנימית –גלבה, בה מתפתחים הנבגים, בצבע בהיר עד חום כהה בהבשלה. צורת פיזור הנבגים נעשית ע''י קריעת המעטה בחלקו העליון ופתיחה במעין אונות / קרניים שמספרן עד 6.",
    doranitText5:
      "אינה שכיחה וגדלה בקרקע העשירה בחומר אורגני. דומה בגודלה לכדורית ובצורתה לכדורנית, הקטנה ממנה בהרבה.",
    doranitText6: "*השמות בקבוצה דומים ויש להקפיד בכיתוב ובקריאת האותיות.",
    doranitImg1: "© רותי טלמור",
    doranitImg2: "© אראלה הרי",
    solyanit: "סוליינית - Coriolopsis",
    solyanitText1: "משפחת הנקבובניתיים – Polyporaceae.",
    solyanitText2:
      "שייכת לסדרת העציות, לפטריות המדף הגדלות על גזעי עצים, חלשים או מתים.",
    solyanitText3: "בישראל ידוע מין אחד:",
    solyanitText4Bold: "סוליינית גמישה – C. gallica",
    solyanitText5:
      "גוף הפרי שטוח בקוטר עד 10 ס''מ ועובי כ-3 ס''מ. השפה מעוגלת, קשה בצבע חום, אפרפר עד חום-אדמוני ומכוסה בשערות או זיפים. בצידו התחתון מפותחת הרקמה הפורייה בעלת צינוריות עם נקבים מצולעים או עגולים. בצעירותו השוליים בהירים בגוון לבן עכור. הפטרייה דומה למדפיות נוספות שבמשפחה, נפוצה וגדלה בצמידות לגזעי או ענפי עצים ממינים שונים. אורך חייה מספר שנים, עם הזמן הולכת ומתקשה.",
    solyanitTextImg1: "© בן ריטנר",
    solyanitTextImg2: "© בן ריטנר",
    nevuvit: "נבובית – Macrocystidia",
    nevuvitText1: "משפחת נבוביתיים – Macrocystidiaceae.",
    nevuvitText2:
      "בישראל הסוג כולל מין אחד המחולק לתת-מינים הנבדלים בעיקר בצבעים ובגודל:",
    nevuvitText3Bold: "נבובית מלפפון – Mcrocystidia cuccumis",
    nevuvitText4:
      "פטרייה קטנה בקוטר כובע עד 6 ס''מ, קמור עד שטוח, עליו ניכר לעיתים פיטם זעיר ושוליים מפוספסים. הכיפה בצבעים מחום עד ארגמני, תלוי במצב הלחות. צבע הדפים צהבהב בז'. הרגל נבובה/חלולה ארוכה מקוטר הכובע, מתרחבת ומתבהרת כלפי החלק העליון, כשהתחתון בגוון חום כהה. גדלה על הקרקע, על ענפים או זרדים. הריח ניכר כריח מלפפון ומכאן שמה. דומה מאוד למיני צנומה וזה כנראה הגורם לכך שפחות מזהים אותה בשטח.",
    nevuvitImg1: "Nature free",
    nevuvitText5: "המין כולל:",
    nevuvitText6Bold: "תת-מין נ.מ. רחבת דפים M.c. var latifolia - ",
    nevuvitText7:
      "נבדל בפספוס על הכיפה ובגוון הבהיר בסמוך לחיבור לכובע. גדלה גם בשטחים פתוחים.",
    nevuvitText8Bold: "תת-מין נ.מ. קטנה M.c.var minor - ",
    nevuvitText9: "טרם נבדק ופורסם בארץ, נבדל  בגודלו הקטן יותר.",
    afarkasit: "אפרכסית - Panus",
    afarkasitText1: "משפחת – Panaceae.",
    afarkasitText2: "בישראל ידוע מין יחיד, שם נרדף –Lentinopanus.",
    afarkasitText3Bold: "אפרכסית צדף – Panus conchatus",
    afarkasitText4:
      "פטריית דפים הגולשים על גוף הפרי שאינו רדיאלי, צורתו כצדף וקוטרו עד 12 ס''מ בצבע בז'. עם הגיל לעיתים משתנה צורתו הדומה לסוגים אזנית ושרועית. הנבגים בצבע לבן. הרגל קצרה למדי, אינה ניכרת ואינה מרכזית. גדלה על ענפים חלשים או על גדמי עצים. ",
    afarkasitText5:
      "זיהוי האפרכסית עבר שנויים ע'י מיקולוגים שונים ולכן מופיעה בכמה שמות מדעיים.(הנוכחי מעודכן לפי מיקובנק 2016).",
    afarkasitImg1: "© יאיר אור",
    afarkasitImg2: "© ידענטבע",
    kruha: "קרוחה - Deconica, Psilocybe",
    kruhaText1: "משפחת אבנטיים - Strophariaceae.",
    kruhaText2: "*שם הסוג בלועזית עבר פיצול ב 2009 לשניים נפרדים.",
    kruhaText3:
      'פטרייה קטנה, כובע חרוטי עד כפתי במרקם מבריק, צבע הכפה חום-אדמוני או חום צהבהב עם שוליים מפוספסים בלבן. רגל דקה באורך 2 או 5 ס"מ. טעם וריח –עמילני. מיוחדת במצע הגידול המיוחד – גללים וזבל של אוכלי עשב בתוך שטח עזבוני, ויותר מיוחדת בשימוש לרפואה - ראו בקישור מטה.',
    kruhaText4: "בישראל ידועים 2 מינים הנבדלים בגודלם ובצבעם:",
    kruhaText5Bold: "קרוחת זבל – Deconica (Psilocybe) merdaria",
    kruhaText6: "קוטר הכובע עד 5 ס''מ. צבעו חום-צהבהב.",
    kruhaImg1: "© יעל אורגד",
    kruhaText7Bold: "קרוחת גללים – Psilocybe coprophila",
    kruhaText8: "קוטר כובע עד 2.5 ס''מ. צבען חום כהה אדמוני.",
    kruhaImg2: "© משה גלעדי",
    kruhaText9: "קישור לקריאה - קרוחה בשימוש הרפואה",
    maklaanit: "מקלענית - Sphaerobolus",
    maklaanitText1: "סדרת כוכבניתיים – ,Geastrales משפחת Sphaerobolaceae.",
    maklaanitText2: "בישראל ידוע המין:",
    maklaanitText3Bold: "מקלענית כוכבית – Sphaerobolus stellatus",
    maklaanitText4:
      "פטרייה קטנטנה, אינה בולטת, יפה ומעניינת. הכנוי שלה 'פטריית התותח'. באנגלית - Cannonball fungus. קוטר גוף הפרי עד 2.5 מ''מ. בשלב ראשון הוא דמויי כדור ואח''כ נקרע/מתפקע לצורת כוכב בעל כ 8 אונות. המעטה החיצוני צהבהב או כצבע קש הבנוי ממספר שכבות ולקראת בגרות מצהיב. בהמשך מתפתחת בבסיסו השכבה הפורייה/גלבה, בצבע חום לגידול הנבגים.",
    maklaanitText5:
      "מכאן ואילך מתבצעת פעולה מתוחכמת לפיזור הנבגים שהעניקה לה את השם מקלענית: עם הבשלת הנבגים נוצר לחץ אוסמוטי, השכבה מתנפחת לכדור ואז האנרגיה גורמת ליריית הגלבה למרחק של כ 5 מטרים !",
    maklaanitText6:
      "תופעה זו ידועה בטבע, אך כאן מבנה השכבות, המהירות והמרחק, ביחס לגודלה, מרשימים ביותר. המקלענית מופיעה בקבוצות על ענפים, גדמים וחומר אורגני נרקב.",
    maklaanitImg1: "© Alfred Dh",
    maklaanitImg2: "© Alfred Dh",
    pachit: "פכית - Scutellinia",
    pachitText1: "משפ' Pyronemataceae.",
    pachitText2:
      "פטרייה קטנה, קעורה, בקוטר עד 1 ס''מ עם שוליים תמימים או שעירים. הצבע אדום-כתום הבולט מאוד ביער. גדלה על ענפים וחלקי עץ נרקבים או מתים. מופיעה בקבוצות קטנות. הסוג דומה לשפתנית, ספלונית ופנכית.",
    pachitText3:
      "למינים בישראל חסר זיהוי מדעי והידוע מביניהם, בעל סימנים מורפולוגים הוא:",
    pachitText4Bold: "פכית ריסנית – S.scutellata",
    pachitText5:
      "הכינוי באנגלית – Eyelash fungus ובעברית המין תורגם לריסנית. שולי הקערית מכוסים בריסים ארוכים וכהים המהווים סימן טוב לזהוי המין. דומה לשפתנית (הגדלה על גללי בהמות).",
    pachitImg1: "© ריטה רם",
    pachitText6:
      "מינים אחרים שמוזכרים בארץ, נבדלים בסימנים אנטומיים הדורשים בדיקות גנטיות:",
    pachitText7: "פכית מחספסת-נבג – S.trechispora",
    pachitText8: "S.armatospora",
    pachitText9: "S. crinite",
    sfatanit: "שפתנית – Cheilymenia",
    sfatanitText1: "משפ' Pyronemataceae.",
    sfatanitText2: "המין היחיד בסוג, הידוע בישראל -",
    sfatanitText3Bold: "שפתנית ורודה – C. fimicola",
    sfatanitText4: "*השם ורודה אינו מתאים לפטרייה הכתומה/ ב.ג.",
    sfatanitText5:
      "פטרייה קטנה דמוית כוסית הנפתחת לצורת צלוחית ובשוליה שיער קצר ודק. הצבע כתום לוהט ולעיתים צהוב. הקוטר פחות מסנטימטר אחד. מקום חיים – על גללי בהמות, סימן המבדיל בזהוי. דומה מאוד לספלונית ולפכית.",
    sfatanitImg1: "© ידענטבע",
    tamanit: "תמנית – Octospora",
    tamanitText1: "משפחת שלהבתיים Pyronemataceae.",
    tamanitText2:
      "שם הסוג נובע מהמספר, 8 שהוא מספר הנבגים בתוך כל תא רבייה. (ניקוד השם – פתח באות ת'). שמות נרדפים – Humarina ,Humaria. הכינוי – 'שפתיים לוהטות'.",
    tamanitText3:
      "התמנית שייכת לקבוצה בסדרת הפזיזאים בשם – Bryoparesitic הנחשבת טפילה על טחבים. גוף הפרי קטנטן, דמויי צלוחית, חסרת רגלית, בקוטר כחצי סנטימטר ובצבע צהוב-כתום. גדלה בשטחים לחים על טחבים.",
    tamanitImg1: "© אוהד בה – איינטורליסט. (מין לא נבדק)",
    tamanitText4: " באוסף בנימיני נמצא מין מ 1975 בשם תמנית טחובית O.humosa –",
    tamanitImg2: "© מחו''ל - Free image",
    amudanit: "עמודנית – Schizostoma",
    amudanitText1: "משפחת הפקועתיים Agaricaceae, בעבר פומיתיים.",
    amudanitText2: "בישראל ידוע מין אחד:",
    amudanitText3Bold: "עמודנית מפספסת –S.laceratum",
    amudanitText4:
      "פטרייה אופיינית לאזור חולי ויבש המגדלת גוף פרי לאחר עונה גשומה. נחשבת נדירה (כנראה מסיבה זו). הכובע דמוי כדור בצבע בז' באורך כ 2.5 ס''מ, היושב על רגל דקה וקשה באורך עד 7 ס''מ, מכוסה בקשקשים. מעטה הכובע מפוספס ולעיתים חלקו נשאר תלוי על הרגל. בהבשלתו נקרע לאונות ומפזר את הנבגים שצבעם חום ענברי. העמודנית נחשבת נדירה, בישראל גדלה בנגב ובערבה.",
    amudanitText5:
      "הזיהוי של סוג זה דומה וגורם לטעויות עם כלונסית ופומית, נבדל ברגל ארוכה ודקה.",
    amudanitImg1: "© ידענטבע",
    pamotit: "פמוטית –Phellorinia",
    pamotitText1: "משפ' פקועתיים - Agaricaceae (בעבר היתה פומיתיים).",
    pamotitText2:
      "פטרייה אופיינית לאזור חולי ויבש המגדלת גוף פרי לאחר עונה גשומה. נחשבת נדירה (כנראה מסיבה זו).גוף הפרי מאורך, עד 20 ס''מ גבה, כדורי דמוי אגס בחלקו העליון וצבעו לבן המשתנה לחום בהיר בהבשלתו. הבסיס דמוי רגל עבה וקשה. המעטה החיצוני בעל קשקשים גדולים הנושרים בחלקם. בעת ההבשלה הפטרייה נסדקת, נפתחת, ורקמת הרבייה / גלבה מפזרת מליוני נבגים בצבע חום אדמוני.",
    pamotitText3:
      "בעולם ידוע מין אחד P.herculeana - בסוג הנחשב מונוטייפ. נחלק לשני תת-מינים, קשקשית P.h.herculeana ומצויצת P.h.strobilina, הנבדלים בעוביים, המצויצת צרה וגבוהה מהקשקשית. הזיהוי של סוג זה דומה וגורם לטעויות עם סדנית פומית ועמודנית.",
    pamotitImg1: "© מורי חן",
    sandAndDesertMushroomsText1:
      "לאחר רדת גשמים, בשטחים נמוכים, התנקזו כמויות מים גדולות יותר מאשר על הגבעות. האדמה רטובה ותפטיר פטריות שהיה רדום זמן ממושך בתוך הקרקע מתעורר לחיים. תאי הרבייה מצמיחים גופי פרי העולים מעל קרום הקרקע ומזדרזים להפיץ תאי רבייה בשם נבגים, שיספיקו להיטמן בקרקע הרטובה ולהישמר לעונת הגשמים הבאה.",
    sandAndDesertMushroomsText2:
      "הסוגים הידועים לנו בארץ בחבל המדברי או בחולות מישור החוף אינם רבים ומעניין שיש דמיון מורפולוגי ביניהם. מעניין שכולן בצבע בהיר, מלבן ועד בג' או חום בהיר ומסת הנבגים בגוון כהה חום או חום אדמוני. נציין כאן את הבדלי הסוגים:",
    sandAndDesertMushroomsText3: "א. דפופית מול פתיתית.",
    sandAndDesertMushroomsText4: "ב. פמוטית מול סדנית ועמודנית.",
    sandAndDesertMushroomsText5: "ג. פומית מול כלונסית.",
    sandAndDesertMushroomsText6:
      "ד. פתיתית בעלת רגל צרה וארוכה בהשוואה לדפופית.",
    sandAndDesertMushroomsText7:
      "ה. פמוטית בעלת ראש כדורי רחב עם קשקשים גדולים והרגל עבה  בהשוואה לסדנית. העמודנית קטנה,רגל דקה והכובע נקרע בצורת אונות לא סימטריות.",
    sandAndDesertMushroomsText8:
      "ו. פומית עדינה, קטנה, בעלת נקב בראש הכובע דרכו נפוצים הנבגים, בהשוואה לכלונסית.",
    sandAndDesertMushroomsText9: "*כל סוגים אלה מופיעים באתר עם תיאור ותמונות.",
  },
};
